/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 11);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	* jQuery JavaScript Library v3.4.1
	* https://jquery.com/
	*
	* Includes Sizzle.js
	* https://sizzlejs.com/
	*
	* Copyright JS Foundation and other contributors
	* Released under the MIT license
	* https://jquery.org/license
	*
	* Date: 2019-05-01T21:04Z
	*/
   ( function( global, factory ) {
   
	   "use strict";
   
	   if (  true && typeof module.exports === "object" ) {
   
		   // For CommonJS and CommonJS-like environments where a proper `window`
		   // is present, execute the factory and get jQuery.
		   // For environments that do not have a `window` with a `document`
		   // (such as Node.js), expose a factory as module.exports.
		   // This accentuates the need for the creation of a real `window`.
		   // e.g. var jQuery = require("jquery")(window);
		   // See ticket #14549 for more info.
		   module.exports = global.document ?
			   factory( global, true ) :
			   function( w ) {
				   if ( !w.document ) {
					   throw new Error( "jQuery requires a window with a document" );
				   }
				   return factory( w );
			   };
	   } else {
		   factory( global );
	   }
   
   // Pass this if window is not defined yet
   } )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
   
   // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
   // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
   // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
   // enough that all such attempts are guarded in a try block.
   "use strict";
   
   var arr = [];
   
   var document = window.document;
   
   var getProto = Object.getPrototypeOf;
   
   var slice = arr.slice;
   
   var concat = arr.concat;
   
   var push = arr.push;
   
   var indexOf = arr.indexOf;
   
   var class2type = {};
   
   var toString = class2type.toString;
   
   var hasOwn = class2type.hasOwnProperty;
   
   var fnToString = hasOwn.toString;
   
   var ObjectFunctionString = fnToString.call( Object );
   
   var support = {};
   
   var isFunction = function isFunction( obj ) {
   
		 // Support: Chrome <=57, Firefox <=52
		 // In some browsers, typeof returns "function" for HTML <object> elements
		 // (i.e., `typeof document.createElement( "object" ) === "function"`).
		 // We don't want to classify *any* DOM node as a function.
		 return typeof obj === "function" && typeof obj.nodeType !== "number";
	 };
   
   
   var isWindow = function isWindow( obj ) {
		   return obj != null && obj === obj.window;
	   };
   
   
   
   
	   var preservedScriptAttributes = {
		   type: true,
		   src: true,
		   nonce: true,
		   noModule: true
	   };
   
	   function DOMEval( code, node, doc ) {
		   doc = doc || document;
   
		   var i, val,
			   script = doc.createElement( "script" );
   
		   script.text = code;
		   if ( node ) {
			   for ( i in preservedScriptAttributes ) {
   
				   // Support: Firefox 64+, Edge 18+
				   // Some browsers don't support the "nonce" property on scripts.
				   // On the other hand, just using `getAttribute` is not enough as
				   // the `nonce` attribute is reset to an empty string whenever it
				   // becomes browsing-context connected.
				   // See https://github.com/whatwg/html/issues/2369
				   // See https://html.spec.whatwg.org/#nonce-attributes
				   // The `node.getAttribute` check was added for the sake of
				   // `jQuery.globalEval` so that it can fake a nonce-containing node
				   // via an object.
				   val = node[ i ] || node.getAttribute && node.getAttribute( i );
				   if ( val ) {
					   script.setAttribute( i, val );
				   }
			   }
		   }
		   doc.head.appendChild( script ).parentNode.removeChild( script );
	   }
   
   
   function toType( obj ) {
	   if ( obj == null ) {
		   return obj + "";
	   }
   
	   // Support: Android <=2.3 only (functionish RegExp)
	   return typeof obj === "object" || typeof obj === "function" ?
		   class2type[ toString.call( obj ) ] || "object" :
		   typeof obj;
   }
   /* global Symbol */
   // Defining this global in .eslintrc.json would create a danger of using the global
   // unguarded in another place, it seems safer to define global only for this module
   
   
   
   var
	   version = "3.4.1",
   
	   // Define a local copy of jQuery
	   jQuery = function( selector, context ) {
   
		   // The jQuery object is actually just the init constructor 'enhanced'
		   // Need init if jQuery is called (just allow error to be thrown if not included)
		   return new jQuery.fn.init( selector, context );
	   },
   
	   // Support: Android <=4.0 only
	   // Make sure we trim BOM and NBSP
	   rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
   
   jQuery.fn = jQuery.prototype = {
   
	   // The current version of jQuery being used
	   jquery: version,
   
	   constructor: jQuery,
   
	   // The default length of a jQuery object is 0
	   length: 0,
   
	   toArray: function() {
		   return slice.call( this );
	   },
   
	   // Get the Nth element in the matched element set OR
	   // Get the whole matched element set as a clean array
	   get: function( num ) {
   
		   // Return all the elements in a clean array
		   if ( num == null ) {
			   return slice.call( this );
		   }
   
		   // Return just the one element from the set
		   return num < 0 ? this[ num + this.length ] : this[ num ];
	   },
   
	   // Take an array of elements and push it onto the stack
	   // (returning the new matched element set)
	   pushStack: function( elems ) {
   
		   // Build a new jQuery matched element set
		   var ret = jQuery.merge( this.constructor(), elems );
   
		   // Add the old object onto the stack (as a reference)
		   ret.prevObject = this;
   
		   // Return the newly-formed element set
		   return ret;
	   },
   
	   // Execute a callback for every element in the matched set.
	   each: function( callback ) {
		   return jQuery.each( this, callback );
	   },
   
	   map: function( callback ) {
		   return this.pushStack( jQuery.map( this, function( elem, i ) {
			   return callback.call( elem, i, elem );
		   } ) );
	   },
   
	   slice: function() {
		   return this.pushStack( slice.apply( this, arguments ) );
	   },
   
	   first: function() {
		   return this.eq( 0 );
	   },
   
	   last: function() {
		   return this.eq( -1 );
	   },
   
	   eq: function( i ) {
		   var len = this.length,
			   j = +i + ( i < 0 ? len : 0 );
		   return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	   },
   
	   end: function() {
		   return this.prevObject || this.constructor();
	   },
   
	   // For internal use only.
	   // Behaves like an Array's method, not like a jQuery method.
	   push: push,
	   sort: arr.sort,
	   splice: arr.splice
   };
   
   jQuery.extend = jQuery.fn.extend = function() {
	   var options, name, src, copy, copyIsArray, clone,
		   target = arguments[ 0 ] || {},
		   i = 1,
		   length = arguments.length,
		   deep = false;
   
	   // Handle a deep copy situation
	   if ( typeof target === "boolean" ) {
		   deep = target;
   
		   // Skip the boolean and the target
		   target = arguments[ i ] || {};
		   i++;
	   }
   
	   // Handle case when target is a string or something (possible in deep copy)
	   if ( typeof target !== "object" && !isFunction( target ) ) {
		   target = {};
	   }
   
	   // Extend jQuery itself if only one argument is passed
	   if ( i === length ) {
		   target = this;
		   i--;
	   }
   
	   for ( ; i < length; i++ ) {
   
		   // Only deal with non-null/undefined values
		   if ( ( options = arguments[ i ] ) != null ) {
   
			   // Extend the base object
			   for ( name in options ) {
				   copy = options[ name ];
   
				   // Prevent Object.prototype pollution
				   // Prevent never-ending loop
				   if ( name === "__proto__" || target === copy ) {
					   continue;
				   }
   
				   // Recurse if we're merging plain objects or arrays
				   if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					   ( copyIsArray = Array.isArray( copy ) ) ) ) {
					   src = target[ name ];
   
					   // Ensure proper type for the source value
					   if ( copyIsArray && !Array.isArray( src ) ) {
						   clone = [];
					   } else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						   clone = {};
					   } else {
						   clone = src;
					   }
					   copyIsArray = false;
   
					   // Never move original objects, clone them
					   target[ name ] = jQuery.extend( deep, clone, copy );
   
				   // Don't bring in undefined values
				   } else if ( copy !== undefined ) {
					   target[ name ] = copy;
				   }
			   }
		   }
	   }
   
	   // Return the modified object
	   return target;
   };
   
   jQuery.extend( {
   
	   // Unique for each copy of jQuery on the page
	   expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
   
	   // Assume jQuery is ready without the ready module
	   isReady: true,
   
	   error: function( msg ) {
		   throw new Error( msg );
	   },
   
	   noop: function() {},
   
	   isPlainObject: function( obj ) {
		   var proto, Ctor;
   
		   // Detect obvious negatives
		   // Use toString instead of jQuery.type to catch host objects
		   if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			   return false;
		   }
   
		   proto = getProto( obj );
   
		   // Objects with no prototype (e.g., `Object.create( null )`) are plain
		   if ( !proto ) {
			   return true;
		   }
   
		   // Objects with prototype are plain iff they were constructed by a global Object function
		   Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		   return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	   },
   
	   isEmptyObject: function( obj ) {
		   var name;
   
		   for ( name in obj ) {
			   return false;
		   }
		   return true;
	   },
   
	   // Evaluates a script in a global context
	   globalEval: function( code, options ) {
		   DOMEval( code, { nonce: options && options.nonce } );
	   },
   
	   each: function( obj, callback ) {
		   var length, i = 0;
   
		   if ( isArrayLike( obj ) ) {
			   length = obj.length;
			   for ( ; i < length; i++ ) {
				   if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					   break;
				   }
			   }
		   } else {
			   for ( i in obj ) {
				   if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					   break;
				   }
			   }
		   }
   
		   return obj;
	   },
   
	   // Support: Android <=4.0 only
	   trim: function( text ) {
		   return text == null ?
			   "" :
			   ( text + "" ).replace( rtrim, "" );
	   },
   
	   // results is for internal usage only
	   makeArray: function( arr, results ) {
		   var ret = results || [];
   
		   if ( arr != null ) {
			   if ( isArrayLike( Object( arr ) ) ) {
				   jQuery.merge( ret,
					   typeof arr === "string" ?
					   [ arr ] : arr
				   );
			   } else {
				   push.call( ret, arr );
			   }
		   }
   
		   return ret;
	   },
   
	   inArray: function( elem, arr, i ) {
		   return arr == null ? -1 : indexOf.call( arr, elem, i );
	   },
   
	   // Support: Android <=4.0 only, PhantomJS 1 only
	   // push.apply(_, arraylike) throws on ancient WebKit
	   merge: function( first, second ) {
		   var len = +second.length,
			   j = 0,
			   i = first.length;
   
		   for ( ; j < len; j++ ) {
			   first[ i++ ] = second[ j ];
		   }
   
		   first.length = i;
   
		   return first;
	   },
   
	   grep: function( elems, callback, invert ) {
		   var callbackInverse,
			   matches = [],
			   i = 0,
			   length = elems.length,
			   callbackExpect = !invert;
   
		   // Go through the array, only saving the items
		   // that pass the validator function
		   for ( ; i < length; i++ ) {
			   callbackInverse = !callback( elems[ i ], i );
			   if ( callbackInverse !== callbackExpect ) {
				   matches.push( elems[ i ] );
			   }
		   }
   
		   return matches;
	   },
   
	   // arg is for internal usage only
	   map: function( elems, callback, arg ) {
		   var length, value,
			   i = 0,
			   ret = [];
   
		   // Go through the array, translating each of the items to their new values
		   if ( isArrayLike( elems ) ) {
			   length = elems.length;
			   for ( ; i < length; i++ ) {
				   value = callback( elems[ i ], i, arg );
   
				   if ( value != null ) {
					   ret.push( value );
				   }
			   }
   
		   // Go through every key on the object,
		   } else {
			   for ( i in elems ) {
				   value = callback( elems[ i ], i, arg );
   
				   if ( value != null ) {
					   ret.push( value );
				   }
			   }
		   }
   
		   // Flatten any nested arrays
		   return concat.apply( [], ret );
	   },
   
	   // A global GUID counter for objects
	   guid: 1,
   
	   // jQuery.support is not used in Core but other projects attach their
	   // properties to it so it needs to exist.
	   support: support
   } );
   
   if ( typeof Symbol === "function" ) {
	   jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
   }
   
   // Populate the class2type map
   jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
   function( i, name ) {
	   class2type[ "[object " + name + "]" ] = name.toLowerCase();
   } );
   
   function isArrayLike( obj ) {
   
	   // Support: real iOS 8.2 only (not reproducible in simulator)
	   // `in` check used to prevent JIT error (gh-2145)
	   // hasOwn isn't used here due to false negatives
	   // regarding Nodelist length in IE
	   var length = !!obj && "length" in obj && obj.length,
		   type = toType( obj );
   
	   if ( isFunction( obj ) || isWindow( obj ) ) {
		   return false;
	   }
   
	   return type === "array" || length === 0 ||
		   typeof length === "number" && length > 0 && ( length - 1 ) in obj;
   }
   var Sizzle =
   /*!
	* Sizzle CSS Selector Engine v2.3.4
	* https://sizzlejs.com/
	*
	* Copyright JS Foundation and other contributors
	* Released under the MIT license
	* https://js.foundation/
	*
	* Date: 2019-04-08
	*/
   (function( window ) {
   
   var i,
	   support,
	   Expr,
	   getText,
	   isXML,
	   tokenize,
	   compile,
	   select,
	   outermostContext,
	   sortInput,
	   hasDuplicate,
   
	   // Local document vars
	   setDocument,
	   document,
	   docElem,
	   documentIsHTML,
	   rbuggyQSA,
	   rbuggyMatches,
	   matches,
	   contains,
   
	   // Instance-specific data
	   expando = "sizzle" + 1 * new Date(),
	   preferredDoc = window.document,
	   dirruns = 0,
	   done = 0,
	   classCache = createCache(),
	   tokenCache = createCache(),
	   compilerCache = createCache(),
	   nonnativeSelectorCache = createCache(),
	   sortOrder = function( a, b ) {
		   if ( a === b ) {
			   hasDuplicate = true;
		   }
		   return 0;
	   },
   
	   // Instance methods
	   hasOwn = ({}).hasOwnProperty,
	   arr = [],
	   pop = arr.pop,
	   push_native = arr.push,
	   push = arr.push,
	   slice = arr.slice,
	   // Use a stripped-down indexOf as it's faster than native
	   // https://jsperf.com/thor-indexof-vs-for/5
	   indexOf = function( list, elem ) {
		   var i = 0,
			   len = list.length;
		   for ( ; i < len; i++ ) {
			   if ( list[i] === elem ) {
				   return i;
			   }
		   }
		   return -1;
	   },
   
	   booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
   
	   // Regular expressions
   
	   // http://www.w3.org/TR/css3-selectors/#whitespace
	   whitespace = "[\\x20\\t\\r\\n\\f]",
   
	   // http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	   identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
   
	   // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	   attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		   // Operator (capture 2)
		   "*([*^$|!~]?=)" + whitespace +
		   // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		   "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		   "*\\]",
   
	   pseudos = ":(" + identifier + ")(?:\\((" +
		   // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		   // 1. quoted (capture 3; capture 4 or capture 5)
		   "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		   // 2. simple (capture 6)
		   "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		   // 3. anything else (capture 2)
		   ".*" +
		   ")\\)|)",
   
	   // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	   rwhitespace = new RegExp( whitespace + "+", "g" ),
	   rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
   
	   rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	   rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	   rdescend = new RegExp( whitespace + "|>" ),
   
	   rpseudo = new RegExp( pseudos ),
	   ridentifier = new RegExp( "^" + identifier + "$" ),
   
	   matchExpr = {
		   "ID": new RegExp( "^#(" + identifier + ")" ),
		   "CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		   "TAG": new RegExp( "^(" + identifier + "|[*])" ),
		   "ATTR": new RegExp( "^" + attributes ),
		   "PSEUDO": new RegExp( "^" + pseudos ),
		   "CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			   "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			   "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		   "bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		   // For use in libraries implementing .is()
		   // We use this for POS matching in `select`
		   "needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			   whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	   },
   
	   rhtml = /HTML$/i,
	   rinputs = /^(?:input|select|textarea|button)$/i,
	   rheader = /^h\d$/i,
   
	   rnative = /^[^{]+\{\s*\[native \w/,
   
	   // Easily-parseable/retrievable ID or TAG or CLASS selectors
	   rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
   
	   rsibling = /[+~]/,
   
	   // CSS escapes
	   // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	   runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	   funescape = function( _, escaped, escapedWhitespace ) {
		   var high = "0x" + escaped - 0x10000;
		   // NaN means non-codepoint
		   // Support: Firefox<24
		   // Workaround erroneous numeric interpretation of +"0x"
		   return high !== high || escapedWhitespace ?
			   escaped :
			   high < 0 ?
				   // BMP codepoint
				   String.fromCharCode( high + 0x10000 ) :
				   // Supplemental Plane codepoint (surrogate pair)
				   String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	   },
   
	   // CSS string/identifier serialization
	   // https://drafts.csswg.org/cssom/#common-serializing-idioms
	   rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	   fcssescape = function( ch, asCodePoint ) {
		   if ( asCodePoint ) {
   
			   // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			   if ( ch === "\0" ) {
				   return "\uFFFD";
			   }
   
			   // Control characters and (dependent upon position) numbers get escaped as code points
			   return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		   }
   
		   // Other potentially-special ASCII characters get backslash-escaped
		   return "\\" + ch;
	   },
   
	   // Used for iframes
	   // See setDocument()
	   // Removing the function wrapper causes a "Permission Denied"
	   // error in IE
	   unloadHandler = function() {
		   setDocument();
	   },
   
	   inDisabledFieldset = addCombinator(
		   function( elem ) {
			   return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		   },
		   { dir: "parentNode", next: "legend" }
	   );
   
   // Optimize for push.apply( _, NodeList )
   try {
	   push.apply(
		   (arr = slice.call( preferredDoc.childNodes )),
		   preferredDoc.childNodes
	   );
	   // Support: Android<4.0
	   // Detect silently failing push.apply
	   arr[ preferredDoc.childNodes.length ].nodeType;
   } catch ( e ) {
	   push = { apply: arr.length ?
   
		   // Leverage slice if possible
		   function( target, els ) {
			   push_native.apply( target, slice.call(els) );
		   } :
   
		   // Support: IE<9
		   // Otherwise append directly
		   function( target, els ) {
			   var j = target.length,
				   i = 0;
			   // Can't trust NodeList.length
			   while ( (target[j++] = els[i++]) ) {}
			   target.length = j - 1;
		   }
	   };
   }
   
   function Sizzle( selector, context, results, seed ) {
	   var m, i, elem, nid, match, groups, newSelector,
		   newContext = context && context.ownerDocument,
   
		   // nodeType defaults to 9, since context defaults to document
		   nodeType = context ? context.nodeType : 9;
   
	   results = results || [];
   
	   // Return early from calls with invalid selector or context
	   if ( typeof selector !== "string" || !selector ||
		   nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
   
		   return results;
	   }
   
	   // Try to shortcut find operations (as opposed to filters) in HTML documents
	   if ( !seed ) {
   
		   if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			   setDocument( context );
		   }
		   context = context || document;
   
		   if ( documentIsHTML ) {
   
			   // If the selector is sufficiently simple, try using a "get*By*" DOM method
			   // (excepting DocumentFragment context, where the methods don't exist)
			   if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
   
				   // ID selector
				   if ( (m = match[1]) ) {
   
					   // Document context
					   if ( nodeType === 9 ) {
						   if ( (elem = context.getElementById( m )) ) {
   
							   // Support: IE, Opera, Webkit
							   // TODO: identify versions
							   // getElementById can match elements by name instead of ID
							   if ( elem.id === m ) {
								   results.push( elem );
								   return results;
							   }
						   } else {
							   return results;
						   }
   
					   // Element context
					   } else {
   
						   // Support: IE, Opera, Webkit
						   // TODO: identify versions
						   // getElementById can match elements by name instead of ID
						   if ( newContext && (elem = newContext.getElementById( m )) &&
							   contains( context, elem ) &&
							   elem.id === m ) {
   
							   results.push( elem );
							   return results;
						   }
					   }
   
				   // Type selector
				   } else if ( match[2] ) {
					   push.apply( results, context.getElementsByTagName( selector ) );
					   return results;
   
				   // Class selector
				   } else if ( (m = match[3]) && support.getElementsByClassName &&
					   context.getElementsByClassName ) {
   
					   push.apply( results, context.getElementsByClassName( m ) );
					   return results;
				   }
			   }
   
			   // Take advantage of querySelectorAll
			   if ( support.qsa &&
				   !nonnativeSelectorCache[ selector + " " ] &&
				   (!rbuggyQSA || !rbuggyQSA.test( selector )) &&
   
				   // Support: IE 8 only
				   // Exclude object elements
				   (nodeType !== 1 || context.nodeName.toLowerCase() !== "object") ) {
   
				   newSelector = selector;
				   newContext = context;
   
				   // qSA considers elements outside a scoping root when evaluating child or
				   // descendant combinators, which is not what we want.
				   // In such cases, we work around the behavior by prefixing every selector in the
				   // list with an ID selector referencing the scope context.
				   // Thanks to Andrew Dupont for this technique.
				   if ( nodeType === 1 && rdescend.test( selector ) ) {
   
					   // Capture the context ID, setting it first if necessary
					   if ( (nid = context.getAttribute( "id" )) ) {
						   nid = nid.replace( rcssescape, fcssescape );
					   } else {
						   context.setAttribute( "id", (nid = expando) );
					   }
   
					   // Prefix every selector in the list
					   groups = tokenize( selector );
					   i = groups.length;
					   while ( i-- ) {
						   groups[i] = "#" + nid + " " + toSelector( groups[i] );
					   }
					   newSelector = groups.join( "," );
   
					   // Expand context for sibling selectors
					   newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						   context;
				   }
   
				   try {
					   push.apply( results,
						   newContext.querySelectorAll( newSelector )
					   );
					   return results;
				   } catch ( qsaError ) {
					   nonnativeSelectorCache( selector, true );
				   } finally {
					   if ( nid === expando ) {
						   context.removeAttribute( "id" );
					   }
				   }
			   }
		   }
	   }
   
	   // All others
	   return select( selector.replace( rtrim, "$1" ), context, results, seed );
   }
   
   /**
	* Create key-value caches of limited size
	* @returns {function(string, object)} Returns the Object data after storing it on itself with
	*	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	*	deleting the oldest entry
	*/
   function createCache() {
	   var keys = [];
   
	   function cache( key, value ) {
		   // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		   if ( keys.push( key + " " ) > Expr.cacheLength ) {
			   // Only keep the most recent entries
			   delete cache[ keys.shift() ];
		   }
		   return (cache[ key + " " ] = value);
	   }
	   return cache;
   }
   
   /**
	* Mark a function for special use by Sizzle
	* @param {Function} fn The function to mark
	*/
   function markFunction( fn ) {
	   fn[ expando ] = true;
	   return fn;
   }
   
   /**
	* Support testing using an element
	* @param {Function} fn Passed the created element and returns a boolean result
	*/
   function assert( fn ) {
	   var el = document.createElement("fieldset");
   
	   try {
		   return !!fn( el );
	   } catch (e) {
		   return false;
	   } finally {
		   // Remove from its parent by default
		   if ( el.parentNode ) {
			   el.parentNode.removeChild( el );
		   }
		   // release memory in IE
		   el = null;
	   }
   }
   
   /**
	* Adds the same handler for all of the specified attrs
	* @param {String} attrs Pipe-separated list of attributes
	* @param {Function} handler The method that will be applied
	*/
   function addHandle( attrs, handler ) {
	   var arr = attrs.split("|"),
		   i = arr.length;
   
	   while ( i-- ) {
		   Expr.attrHandle[ arr[i] ] = handler;
	   }
   }
   
   /**
	* Checks document order of two siblings
	* @param {Element} a
	* @param {Element} b
	* @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	*/
   function siblingCheck( a, b ) {
	   var cur = b && a,
		   diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			   a.sourceIndex - b.sourceIndex;
   
	   // Use IE sourceIndex if available on both nodes
	   if ( diff ) {
		   return diff;
	   }
   
	   // Check if b follows a
	   if ( cur ) {
		   while ( (cur = cur.nextSibling) ) {
			   if ( cur === b ) {
				   return -1;
			   }
		   }
	   }
   
	   return a ? 1 : -1;
   }
   
   /**
	* Returns a function to use in pseudos for input types
	* @param {String} type
	*/
   function createInputPseudo( type ) {
	   return function( elem ) {
		   var name = elem.nodeName.toLowerCase();
		   return name === "input" && elem.type === type;
	   };
   }
   
   /**
	* Returns a function to use in pseudos for buttons
	* @param {String} type
	*/
   function createButtonPseudo( type ) {
	   return function( elem ) {
		   var name = elem.nodeName.toLowerCase();
		   return (name === "input" || name === "button") && elem.type === type;
	   };
   }
   
   /**
	* Returns a function to use in pseudos for :enabled/:disabled
	* @param {Boolean} disabled true for :disabled; false for :enabled
	*/
   function createDisabledPseudo( disabled ) {
   
	   // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	   return function( elem ) {
   
		   // Only certain elements can match :enabled or :disabled
		   // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		   // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		   if ( "form" in elem ) {
   
			   // Check for inherited disabledness on relevant non-disabled elements:
			   // * listed form-associated elements in a disabled fieldset
			   //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			   //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			   // * option elements in a disabled optgroup
			   //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			   // All such elements have a "form" property.
			   if ( elem.parentNode && elem.disabled === false ) {
   
				   // Option elements defer to a parent optgroup if present
				   if ( "label" in elem ) {
					   if ( "label" in elem.parentNode ) {
						   return elem.parentNode.disabled === disabled;
					   } else {
						   return elem.disabled === disabled;
					   }
				   }
   
				   // Support: IE 6 - 11
				   // Use the isDisabled shortcut property to check for disabled fieldset ancestors
				   return elem.isDisabled === disabled ||
   
					   // Where there is no isDisabled, check manually
					   /* jshint -W018 */
					   elem.isDisabled !== !disabled &&
						   inDisabledFieldset( elem ) === disabled;
			   }
   
			   return elem.disabled === disabled;
   
		   // Try to winnow out elements that can't be disabled before trusting the disabled property.
		   // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		   // even exist on them, let alone have a boolean value.
		   } else if ( "label" in elem ) {
			   return elem.disabled === disabled;
		   }
   
		   // Remaining elements are neither :enabled nor :disabled
		   return false;
	   };
   }
   
   /**
	* Returns a function to use in pseudos for positionals
	* @param {Function} fn
	*/
   function createPositionalPseudo( fn ) {
	   return markFunction(function( argument ) {
		   argument = +argument;
		   return markFunction(function( seed, matches ) {
			   var j,
				   matchIndexes = fn( [], seed.length, argument ),
				   i = matchIndexes.length;
   
			   // Match elements found at the specified indexes
			   while ( i-- ) {
				   if ( seed[ (j = matchIndexes[i]) ] ) {
					   seed[j] = !(matches[j] = seed[j]);
				   }
			   }
		   });
	   });
   }
   
   /**
	* Checks a node for validity as a Sizzle context
	* @param {Element|Object=} context
	* @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	*/
   function testContext( context ) {
	   return context && typeof context.getElementsByTagName !== "undefined" && context;
   }
   
   // Expose support vars for convenience
   support = Sizzle.support = {};
   
   /**
	* Detects XML nodes
	* @param {Element|Object} elem An element or a document
	* @returns {Boolean} True iff elem is a non-HTML XML node
	*/
   isXML = Sizzle.isXML = function( elem ) {
	   var namespace = elem.namespaceURI,
		   docElem = (elem.ownerDocument || elem).documentElement;
   
	   // Support: IE <=8
	   // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	   // https://bugs.jquery.com/ticket/4833
	   return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
   };
   
   /**
	* Sets document-related variables once based on the current document
	* @param {Element|Object} [doc] An element or document object to use to set the document
	* @returns {Object} Returns the current document
	*/
   setDocument = Sizzle.setDocument = function( node ) {
	   var hasCompare, subWindow,
		   doc = node ? node.ownerDocument || node : preferredDoc;
   
	   // Return early if doc is invalid or already selected
	   if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		   return document;
	   }
   
	   // Update global variables
	   document = doc;
	   docElem = document.documentElement;
	   documentIsHTML = !isXML( document );
   
	   // Support: IE 9-11, Edge
	   // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	   if ( preferredDoc !== document &&
		   (subWindow = document.defaultView) && subWindow.top !== subWindow ) {
   
		   // Support: IE 11, Edge
		   if ( subWindow.addEventListener ) {
			   subWindow.addEventListener( "unload", unloadHandler, false );
   
		   // Support: IE 9 - 10 only
		   } else if ( subWindow.attachEvent ) {
			   subWindow.attachEvent( "onunload", unloadHandler );
		   }
	   }
   
	   /* Attributes
	   ---------------------------------------------------------------------- */
   
	   // Support: IE<8
	   // Verify that getAttribute really returns attributes and not properties
	   // (excepting IE8 booleans)
	   support.attributes = assert(function( el ) {
		   el.className = "i";
		   return !el.getAttribute("className");
	   });
   
	   /* getElement(s)By*
	   ---------------------------------------------------------------------- */
   
	   // Check if getElementsByTagName("*") returns only elements
	   support.getElementsByTagName = assert(function( el ) {
		   el.appendChild( document.createComment("") );
		   return !el.getElementsByTagName("*").length;
	   });
   
	   // Support: IE<9
	   support.getElementsByClassName = rnative.test( document.getElementsByClassName );
   
	   // Support: IE<10
	   // Check if getElementById returns elements by name
	   // The broken getElementById methods don't pick up programmatically-set names,
	   // so use a roundabout getElementsByName test
	   support.getById = assert(function( el ) {
		   docElem.appendChild( el ).id = expando;
		   return !document.getElementsByName || !document.getElementsByName( expando ).length;
	   });
   
	   // ID filter and find
	   if ( support.getById ) {
		   Expr.filter["ID"] = function( id ) {
			   var attrId = id.replace( runescape, funescape );
			   return function( elem ) {
				   return elem.getAttribute("id") === attrId;
			   };
		   };
		   Expr.find["ID"] = function( id, context ) {
			   if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				   var elem = context.getElementById( id );
				   return elem ? [ elem ] : [];
			   }
		   };
	   } else {
		   Expr.filter["ID"] =  function( id ) {
			   var attrId = id.replace( runescape, funescape );
			   return function( elem ) {
				   var node = typeof elem.getAttributeNode !== "undefined" &&
					   elem.getAttributeNode("id");
				   return node && node.value === attrId;
			   };
		   };
   
		   // Support: IE 6 - 7 only
		   // getElementById is not reliable as a find shortcut
		   Expr.find["ID"] = function( id, context ) {
			   if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				   var node, i, elems,
					   elem = context.getElementById( id );
   
				   if ( elem ) {
   
					   // Verify the id attribute
					   node = elem.getAttributeNode("id");
					   if ( node && node.value === id ) {
						   return [ elem ];
					   }
   
					   // Fall back on getElementsByName
					   elems = context.getElementsByName( id );
					   i = 0;
					   while ( (elem = elems[i++]) ) {
						   node = elem.getAttributeNode("id");
						   if ( node && node.value === id ) {
							   return [ elem ];
						   }
					   }
				   }
   
				   return [];
			   }
		   };
	   }
   
	   // Tag
	   Expr.find["TAG"] = support.getElementsByTagName ?
		   function( tag, context ) {
			   if ( typeof context.getElementsByTagName !== "undefined" ) {
				   return context.getElementsByTagName( tag );
   
			   // DocumentFragment nodes don't have gEBTN
			   } else if ( support.qsa ) {
				   return context.querySelectorAll( tag );
			   }
		   } :
   
		   function( tag, context ) {
			   var elem,
				   tmp = [],
				   i = 0,
				   // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				   results = context.getElementsByTagName( tag );
   
			   // Filter out possible comments
			   if ( tag === "*" ) {
				   while ( (elem = results[i++]) ) {
					   if ( elem.nodeType === 1 ) {
						   tmp.push( elem );
					   }
				   }
   
				   return tmp;
			   }
			   return results;
		   };
   
	   // Class
	   Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		   if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			   return context.getElementsByClassName( className );
		   }
	   };
   
	   /* QSA/matchesSelector
	   ---------------------------------------------------------------------- */
   
	   // QSA and matchesSelector support
   
	   // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	   rbuggyMatches = [];
   
	   // qSa(:focus) reports false when true (Chrome 21)
	   // We allow this because of a bug in IE8/9 that throws an error
	   // whenever `document.activeElement` is accessed on an iframe
	   // So, we allow :focus to pass through QSA all the time to avoid the IE error
	   // See https://bugs.jquery.com/ticket/13378
	   rbuggyQSA = [];
   
	   if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		   // Build QSA regex
		   // Regex strategy adopted from Diego Perini
		   assert(function( el ) {
			   // Select is set to empty string on purpose
			   // This is to test IE's treatment of not explicitly
			   // setting a boolean content attribute,
			   // since its presence should be enough
			   // https://bugs.jquery.com/ticket/12359
			   docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				   "<select id='" + expando + "-\r\\' msallowcapture=''>" +
				   "<option selected=''></option></select>";
   
			   // Support: IE8, Opera 11-12.16
			   // Nothing should be selected when empty strings follow ^= or $= or *=
			   // The test attribute must be unknown in Opera but "safe" for WinRT
			   // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			   if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				   rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			   }
   
			   // Support: IE8
			   // Boolean attributes and "value" are not treated correctly
			   if ( !el.querySelectorAll("[selected]").length ) {
				   rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			   }
   
			   // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			   if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				   rbuggyQSA.push("~=");
			   }
   
			   // Webkit/Opera - :checked should return selected option elements
			   // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			   // IE8 throws error here and will not see later tests
			   if ( !el.querySelectorAll(":checked").length ) {
				   rbuggyQSA.push(":checked");
			   }
   
			   // Support: Safari 8+, iOS 8+
			   // https://bugs.webkit.org/show_bug.cgi?id=136851
			   // In-page `selector#id sibling-combinator selector` fails
			   if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				   rbuggyQSA.push(".#.+[+~]");
			   }
		   });
   
		   assert(function( el ) {
			   el.innerHTML = "<a href='' disabled='disabled'></a>" +
				   "<select disabled='disabled'><option/></select>";
   
			   // Support: Windows 8 Native Apps
			   // The type and name attributes are restricted during .innerHTML assignment
			   var input = document.createElement("input");
			   input.setAttribute( "type", "hidden" );
			   el.appendChild( input ).setAttribute( "name", "D" );
   
			   // Support: IE8
			   // Enforce case-sensitivity of name attribute
			   if ( el.querySelectorAll("[name=d]").length ) {
				   rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			   }
   
			   // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			   // IE8 throws error here and will not see later tests
			   if ( el.querySelectorAll(":enabled").length !== 2 ) {
				   rbuggyQSA.push( ":enabled", ":disabled" );
			   }
   
			   // Support: IE9-11+
			   // IE's :disabled selector does not pick up the children of disabled fieldsets
			   docElem.appendChild( el ).disabled = true;
			   if ( el.querySelectorAll(":disabled").length !== 2 ) {
				   rbuggyQSA.push( ":enabled", ":disabled" );
			   }
   
			   // Opera 10-11 does not throw on post-comma invalid pseudos
			   el.querySelectorAll("*,:x");
			   rbuggyQSA.push(",.*:");
		   });
	   }
   
	   if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		   docElem.webkitMatchesSelector ||
		   docElem.mozMatchesSelector ||
		   docElem.oMatchesSelector ||
		   docElem.msMatchesSelector) )) ) {
   
		   assert(function( el ) {
			   // Check to see if it's possible to do matchesSelector
			   // on a disconnected node (IE 9)
			   support.disconnectedMatch = matches.call( el, "*" );
   
			   // This should fail with an exception
			   // Gecko does not error, returns false instead
			   matches.call( el, "[s!='']:x" );
			   rbuggyMatches.push( "!=", pseudos );
		   });
	   }
   
	   rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	   rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
   
	   /* Contains
	   ---------------------------------------------------------------------- */
	   hasCompare = rnative.test( docElem.compareDocumentPosition );
   
	   // Element contains another
	   // Purposefully self-exclusive
	   // As in, an element does not contain itself
	   contains = hasCompare || rnative.test( docElem.contains ) ?
		   function( a, b ) {
			   var adown = a.nodeType === 9 ? a.documentElement : a,
				   bup = b && b.parentNode;
			   return a === bup || !!( bup && bup.nodeType === 1 && (
				   adown.contains ?
					   adown.contains( bup ) :
					   a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			   ));
		   } :
		   function( a, b ) {
			   if ( b ) {
				   while ( (b = b.parentNode) ) {
					   if ( b === a ) {
						   return true;
					   }
				   }
			   }
			   return false;
		   };
   
	   /* Sorting
	   ---------------------------------------------------------------------- */
   
	   // Document order sorting
	   sortOrder = hasCompare ?
	   function( a, b ) {
   
		   // Flag for duplicate removal
		   if ( a === b ) {
			   hasDuplicate = true;
			   return 0;
		   }
   
		   // Sort on method existence if only one input has compareDocumentPosition
		   var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		   if ( compare ) {
			   return compare;
		   }
   
		   // Calculate position if both inputs belong to the same document
		   compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			   a.compareDocumentPosition( b ) :
   
			   // Otherwise we know they are disconnected
			   1;
   
		   // Disconnected nodes
		   if ( compare & 1 ||
			   (!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
   
			   // Choose the first element that is related to our preferred document
			   if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				   return -1;
			   }
			   if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				   return 1;
			   }
   
			   // Maintain original order
			   return sortInput ?
				   ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				   0;
		   }
   
		   return compare & 4 ? -1 : 1;
	   } :
	   function( a, b ) {
		   // Exit early if the nodes are identical
		   if ( a === b ) {
			   hasDuplicate = true;
			   return 0;
		   }
   
		   var cur,
			   i = 0,
			   aup = a.parentNode,
			   bup = b.parentNode,
			   ap = [ a ],
			   bp = [ b ];
   
		   // Parentless nodes are either documents or disconnected
		   if ( !aup || !bup ) {
			   return a === document ? -1 :
				   b === document ? 1 :
				   aup ? -1 :
				   bup ? 1 :
				   sortInput ?
				   ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				   0;
   
		   // If the nodes are siblings, we can do a quick check
		   } else if ( aup === bup ) {
			   return siblingCheck( a, b );
		   }
   
		   // Otherwise we need full lists of their ancestors for comparison
		   cur = a;
		   while ( (cur = cur.parentNode) ) {
			   ap.unshift( cur );
		   }
		   cur = b;
		   while ( (cur = cur.parentNode) ) {
			   bp.unshift( cur );
		   }
   
		   // Walk down the tree looking for a discrepancy
		   while ( ap[i] === bp[i] ) {
			   i++;
		   }
   
		   return i ?
			   // Do a sibling check if the nodes have a common ancestor
			   siblingCheck( ap[i], bp[i] ) :
   
			   // Otherwise nodes in our document sort first
			   ap[i] === preferredDoc ? -1 :
			   bp[i] === preferredDoc ? 1 :
			   0;
	   };
   
	   return document;
   };
   
   Sizzle.matches = function( expr, elements ) {
	   return Sizzle( expr, null, null, elements );
   };
   
   Sizzle.matchesSelector = function( elem, expr ) {
	   // Set document vars if needed
	   if ( ( elem.ownerDocument || elem ) !== document ) {
		   setDocument( elem );
	   }
   
	   if ( support.matchesSelector && documentIsHTML &&
		   !nonnativeSelectorCache[ expr + " " ] &&
		   ( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		   ( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
   
		   try {
			   var ret = matches.call( elem, expr );
   
			   // IE 9's matchesSelector returns false on disconnected nodes
			   if ( ret || support.disconnectedMatch ||
					   // As well, disconnected nodes are said to be in a document
					   // fragment in IE 9
					   elem.document && elem.document.nodeType !== 11 ) {
				   return ret;
			   }
		   } catch (e) {
			   nonnativeSelectorCache( expr, true );
		   }
	   }
   
	   return Sizzle( expr, document, null, [ elem ] ).length > 0;
   };
   
   Sizzle.contains = function( context, elem ) {
	   // Set document vars if needed
	   if ( ( context.ownerDocument || context ) !== document ) {
		   setDocument( context );
	   }
	   return contains( context, elem );
   };
   
   Sizzle.attr = function( elem, name ) {
	   // Set document vars if needed
	   if ( ( elem.ownerDocument || elem ) !== document ) {
		   setDocument( elem );
	   }
   
	   var fn = Expr.attrHandle[ name.toLowerCase() ],
		   // Don't get fooled by Object.prototype properties (jQuery #13807)
		   val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			   fn( elem, name, !documentIsHTML ) :
			   undefined;
   
	   return val !== undefined ?
		   val :
		   support.attributes || !documentIsHTML ?
			   elem.getAttribute( name ) :
			   (val = elem.getAttributeNode(name)) && val.specified ?
				   val.value :
				   null;
   };
   
   Sizzle.escape = function( sel ) {
	   return (sel + "").replace( rcssescape, fcssescape );
   };
   
   Sizzle.error = function( msg ) {
	   throw new Error( "Syntax error, unrecognized expression: " + msg );
   };
   
   /**
	* Document sorting and removing duplicates
	* @param {ArrayLike} results
	*/
   Sizzle.uniqueSort = function( results ) {
	   var elem,
		   duplicates = [],
		   j = 0,
		   i = 0;
   
	   // Unless we *know* we can detect duplicates, assume their presence
	   hasDuplicate = !support.detectDuplicates;
	   sortInput = !support.sortStable && results.slice( 0 );
	   results.sort( sortOrder );
   
	   if ( hasDuplicate ) {
		   while ( (elem = results[i++]) ) {
			   if ( elem === results[ i ] ) {
				   j = duplicates.push( i );
			   }
		   }
		   while ( j-- ) {
			   results.splice( duplicates[ j ], 1 );
		   }
	   }
   
	   // Clear input after sorting to release objects
	   // See https://github.com/jquery/sizzle/pull/225
	   sortInput = null;
   
	   return results;
   };
   
   /**
	* Utility function for retrieving the text value of an array of DOM nodes
	* @param {Array|Element} elem
	*/
   getText = Sizzle.getText = function( elem ) {
	   var node,
		   ret = "",
		   i = 0,
		   nodeType = elem.nodeType;
   
	   if ( !nodeType ) {
		   // If no nodeType, this is expected to be an array
		   while ( (node = elem[i++]) ) {
			   // Do not traverse comment nodes
			   ret += getText( node );
		   }
	   } else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		   // Use textContent for elements
		   // innerText usage removed for consistency of new lines (jQuery #11153)
		   if ( typeof elem.textContent === "string" ) {
			   return elem.textContent;
		   } else {
			   // Traverse its children
			   for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				   ret += getText( elem );
			   }
		   }
	   } else if ( nodeType === 3 || nodeType === 4 ) {
		   return elem.nodeValue;
	   }
	   // Do not include comment or processing instruction nodes
   
	   return ret;
   };
   
   Expr = Sizzle.selectors = {
   
	   // Can be adjusted by the user
	   cacheLength: 50,
   
	   createPseudo: markFunction,
   
	   match: matchExpr,
   
	   attrHandle: {},
   
	   find: {},
   
	   relative: {
		   ">": { dir: "parentNode", first: true },
		   " ": { dir: "parentNode" },
		   "+": { dir: "previousSibling", first: true },
		   "~": { dir: "previousSibling" }
	   },
   
	   preFilter: {
		   "ATTR": function( match ) {
			   match[1] = match[1].replace( runescape, funescape );
   
			   // Move the given value to match[3] whether quoted or unquoted
			   match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
   
			   if ( match[2] === "~=" ) {
				   match[3] = " " + match[3] + " ";
			   }
   
			   return match.slice( 0, 4 );
		   },
   
		   "CHILD": function( match ) {
			   /* matches from matchExpr["CHILD"]
				   1 type (only|nth|...)
				   2 what (child|of-type)
				   3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				   4 xn-component of xn+y argument ([+-]?\d*n|)
				   5 sign of xn-component
				   6 x of xn-component
				   7 sign of y-component
				   8 y of y-component
			   */
			   match[1] = match[1].toLowerCase();
   
			   if ( match[1].slice( 0, 3 ) === "nth" ) {
				   // nth-* requires argument
				   if ( !match[3] ) {
					   Sizzle.error( match[0] );
				   }
   
				   // numeric x and y parameters for Expr.filter.CHILD
				   // remember that false/true cast respectively to 0/1
				   match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				   match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
   
			   // other types prohibit arguments
			   } else if ( match[3] ) {
				   Sizzle.error( match[0] );
			   }
   
			   return match;
		   },
   
		   "PSEUDO": function( match ) {
			   var excess,
				   unquoted = !match[6] && match[2];
   
			   if ( matchExpr["CHILD"].test( match[0] ) ) {
				   return null;
			   }
   
			   // Accept quoted arguments as-is
			   if ( match[3] ) {
				   match[2] = match[4] || match[5] || "";
   
			   // Strip excess characters from unquoted arguments
			   } else if ( unquoted && rpseudo.test( unquoted ) &&
				   // Get excess from tokenize (recursively)
				   (excess = tokenize( unquoted, true )) &&
				   // advance to the next closing parenthesis
				   (excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
   
				   // excess is a negative index
				   match[0] = match[0].slice( 0, excess );
				   match[2] = unquoted.slice( 0, excess );
			   }
   
			   // Return only captures needed by the pseudo filter method (type and argument)
			   return match.slice( 0, 3 );
		   }
	   },
   
	   filter: {
   
		   "TAG": function( nodeNameSelector ) {
			   var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			   return nodeNameSelector === "*" ?
				   function() { return true; } :
				   function( elem ) {
					   return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				   };
		   },
   
		   "CLASS": function( className ) {
			   var pattern = classCache[ className + " " ];
   
			   return pattern ||
				   (pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				   classCache( className, function( elem ) {
					   return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				   });
		   },
   
		   "ATTR": function( name, operator, check ) {
			   return function( elem ) {
				   var result = Sizzle.attr( elem, name );
   
				   if ( result == null ) {
					   return operator === "!=";
				   }
				   if ( !operator ) {
					   return true;
				   }
   
				   result += "";
   
				   return operator === "=" ? result === check :
					   operator === "!=" ? result !== check :
					   operator === "^=" ? check && result.indexOf( check ) === 0 :
					   operator === "*=" ? check && result.indexOf( check ) > -1 :
					   operator === "$=" ? check && result.slice( -check.length ) === check :
					   operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					   operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					   false;
			   };
		   },
   
		   "CHILD": function( type, what, argument, first, last ) {
			   var simple = type.slice( 0, 3 ) !== "nth",
				   forward = type.slice( -4 ) !== "last",
				   ofType = what === "of-type";
   
			   return first === 1 && last === 0 ?
   
				   // Shortcut for :nth-*(n)
				   function( elem ) {
					   return !!elem.parentNode;
				   } :
   
				   function( elem, context, xml ) {
					   var cache, uniqueCache, outerCache, node, nodeIndex, start,
						   dir = simple !== forward ? "nextSibling" : "previousSibling",
						   parent = elem.parentNode,
						   name = ofType && elem.nodeName.toLowerCase(),
						   useCache = !xml && !ofType,
						   diff = false;
   
					   if ( parent ) {
   
						   // :(first|last|only)-(child|of-type)
						   if ( simple ) {
							   while ( dir ) {
								   node = elem;
								   while ( (node = node[ dir ]) ) {
									   if ( ofType ?
										   node.nodeName.toLowerCase() === name :
										   node.nodeType === 1 ) {
   
										   return false;
									   }
								   }
								   // Reverse direction for :only-* (if we haven't yet done so)
								   start = dir = type === "only" && !start && "nextSibling";
							   }
							   return true;
						   }
   
						   start = [ forward ? parent.firstChild : parent.lastChild ];
   
						   // non-xml :nth-child(...) stores cache data on `parent`
						   if ( forward && useCache ) {
   
							   // Seek `elem` from a previously-cached index
   
							   // ...in a gzip-friendly way
							   node = parent;
							   outerCache = node[ expando ] || (node[ expando ] = {});
   
							   // Support: IE <9 only
							   // Defend against cloned attroperties (jQuery gh-1709)
							   uniqueCache = outerCache[ node.uniqueID ] ||
								   (outerCache[ node.uniqueID ] = {});
   
							   cache = uniqueCache[ type ] || [];
							   nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							   diff = nodeIndex && cache[ 2 ];
							   node = nodeIndex && parent.childNodes[ nodeIndex ];
   
							   while ( (node = ++nodeIndex && node && node[ dir ] ||
   
								   // Fallback to seeking `elem` from the start
								   (diff = nodeIndex = 0) || start.pop()) ) {
   
								   // When found, cache indexes on `parent` and break
								   if ( node.nodeType === 1 && ++diff && node === elem ) {
									   uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									   break;
								   }
							   }
   
						   } else {
							   // Use previously-cached element index if available
							   if ( useCache ) {
								   // ...in a gzip-friendly way
								   node = elem;
								   outerCache = node[ expando ] || (node[ expando ] = {});
   
								   // Support: IE <9 only
								   // Defend against cloned attroperties (jQuery gh-1709)
								   uniqueCache = outerCache[ node.uniqueID ] ||
									   (outerCache[ node.uniqueID ] = {});
   
								   cache = uniqueCache[ type ] || [];
								   nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								   diff = nodeIndex;
							   }
   
							   // xml :nth-child(...)
							   // or :nth-last-child(...) or :nth(-last)?-of-type(...)
							   if ( diff === false ) {
								   // Use the same loop as above to seek `elem` from the start
								   while ( (node = ++nodeIndex && node && node[ dir ] ||
									   (diff = nodeIndex = 0) || start.pop()) ) {
   
									   if ( ( ofType ?
										   node.nodeName.toLowerCase() === name :
										   node.nodeType === 1 ) &&
										   ++diff ) {
   
										   // Cache the index of each encountered element
										   if ( useCache ) {
											   outerCache = node[ expando ] || (node[ expando ] = {});
   
											   // Support: IE <9 only
											   // Defend against cloned attroperties (jQuery gh-1709)
											   uniqueCache = outerCache[ node.uniqueID ] ||
												   (outerCache[ node.uniqueID ] = {});
   
											   uniqueCache[ type ] = [ dirruns, diff ];
										   }
   
										   if ( node === elem ) {
											   break;
										   }
									   }
								   }
							   }
						   }
   
						   // Incorporate the offset, then check against cycle size
						   diff -= last;
						   return diff === first || ( diff % first === 0 && diff / first >= 0 );
					   }
				   };
		   },
   
		   "PSEUDO": function( pseudo, argument ) {
			   // pseudo-class names are case-insensitive
			   // http://www.w3.org/TR/selectors/#pseudo-classes
			   // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			   // Remember that setFilters inherits from pseudos
			   var args,
				   fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					   Sizzle.error( "unsupported pseudo: " + pseudo );
   
			   // The user may use createPseudo to indicate that
			   // arguments are needed to create the filter function
			   // just as Sizzle does
			   if ( fn[ expando ] ) {
				   return fn( argument );
			   }
   
			   // But maintain support for old signatures
			   if ( fn.length > 1 ) {
				   args = [ pseudo, pseudo, "", argument ];
				   return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					   markFunction(function( seed, matches ) {
						   var idx,
							   matched = fn( seed, argument ),
							   i = matched.length;
						   while ( i-- ) {
							   idx = indexOf( seed, matched[i] );
							   seed[ idx ] = !( matches[ idx ] = matched[i] );
						   }
					   }) :
					   function( elem ) {
						   return fn( elem, 0, args );
					   };
			   }
   
			   return fn;
		   }
	   },
   
	   pseudos: {
		   // Potentially complex pseudos
		   "not": markFunction(function( selector ) {
			   // Trim the selector passed to compile
			   // to avoid treating leading and trailing
			   // spaces as combinators
			   var input = [],
				   results = [],
				   matcher = compile( selector.replace( rtrim, "$1" ) );
   
			   return matcher[ expando ] ?
				   markFunction(function( seed, matches, context, xml ) {
					   var elem,
						   unmatched = matcher( seed, null, xml, [] ),
						   i = seed.length;
   
					   // Match elements unmatched by `matcher`
					   while ( i-- ) {
						   if ( (elem = unmatched[i]) ) {
							   seed[i] = !(matches[i] = elem);
						   }
					   }
				   }) :
				   function( elem, context, xml ) {
					   input[0] = elem;
					   matcher( input, null, xml, results );
					   // Don't keep the element (issue #299)
					   input[0] = null;
					   return !results.pop();
				   };
		   }),
   
		   "has": markFunction(function( selector ) {
			   return function( elem ) {
				   return Sizzle( selector, elem ).length > 0;
			   };
		   }),
   
		   "contains": markFunction(function( text ) {
			   text = text.replace( runescape, funescape );
			   return function( elem ) {
				   return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			   };
		   }),
   
		   // "Whether an element is represented by a :lang() selector
		   // is based solely on the element's language value
		   // being equal to the identifier C,
		   // or beginning with the identifier C immediately followed by "-".
		   // The matching of C against the element's language value is performed case-insensitively.
		   // The identifier C does not have to be a valid language name."
		   // http://www.w3.org/TR/selectors/#lang-pseudo
		   "lang": markFunction( function( lang ) {
			   // lang value must be a valid identifier
			   if ( !ridentifier.test(lang || "") ) {
				   Sizzle.error( "unsupported lang: " + lang );
			   }
			   lang = lang.replace( runescape, funescape ).toLowerCase();
			   return function( elem ) {
				   var elemLang;
				   do {
					   if ( (elemLang = documentIsHTML ?
						   elem.lang :
						   elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
   
						   elemLang = elemLang.toLowerCase();
						   return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					   }
				   } while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				   return false;
			   };
		   }),
   
		   // Miscellaneous
		   "target": function( elem ) {
			   var hash = window.location && window.location.hash;
			   return hash && hash.slice( 1 ) === elem.id;
		   },
   
		   "root": function( elem ) {
			   return elem === docElem;
		   },
   
		   "focus": function( elem ) {
			   return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		   },
   
		   // Boolean properties
		   "enabled": createDisabledPseudo( false ),
		   "disabled": createDisabledPseudo( true ),
   
		   "checked": function( elem ) {
			   // In CSS3, :checked should return both checked and selected elements
			   // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			   var nodeName = elem.nodeName.toLowerCase();
			   return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		   },
   
		   "selected": function( elem ) {
			   // Accessing this property makes selected-by-default
			   // options in Safari work properly
			   if ( elem.parentNode ) {
				   elem.parentNode.selectedIndex;
			   }
   
			   return elem.selected === true;
		   },
   
		   // Contents
		   "empty": function( elem ) {
			   // http://www.w3.org/TR/selectors/#empty-pseudo
			   // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			   //   but not by others (comment: 8; processing instruction: 7; etc.)
			   // nodeType < 6 works because attributes (2) do not appear as children
			   for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				   if ( elem.nodeType < 6 ) {
					   return false;
				   }
			   }
			   return true;
		   },
   
		   "parent": function( elem ) {
			   return !Expr.pseudos["empty"]( elem );
		   },
   
		   // Element/input types
		   "header": function( elem ) {
			   return rheader.test( elem.nodeName );
		   },
   
		   "input": function( elem ) {
			   return rinputs.test( elem.nodeName );
		   },
   
		   "button": function( elem ) {
			   var name = elem.nodeName.toLowerCase();
			   return name === "input" && elem.type === "button" || name === "button";
		   },
   
		   "text": function( elem ) {
			   var attr;
			   return elem.nodeName.toLowerCase() === "input" &&
				   elem.type === "text" &&
   
				   // Support: IE<8
				   // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				   ( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		   },
   
		   // Position-in-collection
		   "first": createPositionalPseudo(function() {
			   return [ 0 ];
		   }),
   
		   "last": createPositionalPseudo(function( matchIndexes, length ) {
			   return [ length - 1 ];
		   }),
   
		   "eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			   return [ argument < 0 ? argument + length : argument ];
		   }),
   
		   "even": createPositionalPseudo(function( matchIndexes, length ) {
			   var i = 0;
			   for ( ; i < length; i += 2 ) {
				   matchIndexes.push( i );
			   }
			   return matchIndexes;
		   }),
   
		   "odd": createPositionalPseudo(function( matchIndexes, length ) {
			   var i = 1;
			   for ( ; i < length; i += 2 ) {
				   matchIndexes.push( i );
			   }
			   return matchIndexes;
		   }),
   
		   "lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			   var i = argument < 0 ?
				   argument + length :
				   argument > length ?
					   length :
					   argument;
			   for ( ; --i >= 0; ) {
				   matchIndexes.push( i );
			   }
			   return matchIndexes;
		   }),
   
		   "gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			   var i = argument < 0 ? argument + length : argument;
			   for ( ; ++i < length; ) {
				   matchIndexes.push( i );
			   }
			   return matchIndexes;
		   })
	   }
   };
   
   Expr.pseudos["nth"] = Expr.pseudos["eq"];
   
   // Add button/input type pseudos
   for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	   Expr.pseudos[ i ] = createInputPseudo( i );
   }
   for ( i in { submit: true, reset: true } ) {
	   Expr.pseudos[ i ] = createButtonPseudo( i );
   }
   
   // Easy API for creating new setFilters
   function setFilters() {}
   setFilters.prototype = Expr.filters = Expr.pseudos;
   Expr.setFilters = new setFilters();
   
   tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	   var matched, match, tokens, type,
		   soFar, groups, preFilters,
		   cached = tokenCache[ selector + " " ];
   
	   if ( cached ) {
		   return parseOnly ? 0 : cached.slice( 0 );
	   }
   
	   soFar = selector;
	   groups = [];
	   preFilters = Expr.preFilter;
   
	   while ( soFar ) {
   
		   // Comma and first run
		   if ( !matched || (match = rcomma.exec( soFar )) ) {
			   if ( match ) {
				   // Don't consume trailing commas as valid
				   soFar = soFar.slice( match[0].length ) || soFar;
			   }
			   groups.push( (tokens = []) );
		   }
   
		   matched = false;
   
		   // Combinators
		   if ( (match = rcombinators.exec( soFar )) ) {
			   matched = match.shift();
			   tokens.push({
				   value: matched,
				   // Cast descendant combinators to space
				   type: match[0].replace( rtrim, " " )
			   });
			   soFar = soFar.slice( matched.length );
		   }
   
		   // Filters
		   for ( type in Expr.filter ) {
			   if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				   (match = preFilters[ type ]( match ))) ) {
				   matched = match.shift();
				   tokens.push({
					   value: matched,
					   type: type,
					   matches: match
				   });
				   soFar = soFar.slice( matched.length );
			   }
		   }
   
		   if ( !matched ) {
			   break;
		   }
	   }
   
	   // Return the length of the invalid excess
	   // if we're just parsing
	   // Otherwise, throw an error or return tokens
	   return parseOnly ?
		   soFar.length :
		   soFar ?
			   Sizzle.error( selector ) :
			   // Cache the tokens
			   tokenCache( selector, groups ).slice( 0 );
   };
   
   function toSelector( tokens ) {
	   var i = 0,
		   len = tokens.length,
		   selector = "";
	   for ( ; i < len; i++ ) {
		   selector += tokens[i].value;
	   }
	   return selector;
   }
   
   function addCombinator( matcher, combinator, base ) {
	   var dir = combinator.dir,
		   skip = combinator.next,
		   key = skip || dir,
		   checkNonElements = base && key === "parentNode",
		   doneName = done++;
   
	   return combinator.first ?
		   // Check against closest ancestor/preceding element
		   function( elem, context, xml ) {
			   while ( (elem = elem[ dir ]) ) {
				   if ( elem.nodeType === 1 || checkNonElements ) {
					   return matcher( elem, context, xml );
				   }
			   }
			   return false;
		   } :
   
		   // Check against all ancestor/preceding elements
		   function( elem, context, xml ) {
			   var oldCache, uniqueCache, outerCache,
				   newCache = [ dirruns, doneName ];
   
			   // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			   if ( xml ) {
				   while ( (elem = elem[ dir ]) ) {
					   if ( elem.nodeType === 1 || checkNonElements ) {
						   if ( matcher( elem, context, xml ) ) {
							   return true;
						   }
					   }
				   }
			   } else {
				   while ( (elem = elem[ dir ]) ) {
					   if ( elem.nodeType === 1 || checkNonElements ) {
						   outerCache = elem[ expando ] || (elem[ expando ] = {});
   
						   // Support: IE <9 only
						   // Defend against cloned attroperties (jQuery gh-1709)
						   uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
   
						   if ( skip && skip === elem.nodeName.toLowerCase() ) {
							   elem = elem[ dir ] || elem;
						   } else if ( (oldCache = uniqueCache[ key ]) &&
							   oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
   
							   // Assign to newCache so results back-propagate to previous elements
							   return (newCache[ 2 ] = oldCache[ 2 ]);
						   } else {
							   // Reuse newcache so results back-propagate to previous elements
							   uniqueCache[ key ] = newCache;
   
							   // A match means we're done; a fail means we have to keep checking
							   if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								   return true;
							   }
						   }
					   }
				   }
			   }
			   return false;
		   };
   }
   
   function elementMatcher( matchers ) {
	   return matchers.length > 1 ?
		   function( elem, context, xml ) {
			   var i = matchers.length;
			   while ( i-- ) {
				   if ( !matchers[i]( elem, context, xml ) ) {
					   return false;
				   }
			   }
			   return true;
		   } :
		   matchers[0];
   }
   
   function multipleContexts( selector, contexts, results ) {
	   var i = 0,
		   len = contexts.length;
	   for ( ; i < len; i++ ) {
		   Sizzle( selector, contexts[i], results );
	   }
	   return results;
   }
   
   function condense( unmatched, map, filter, context, xml ) {
	   var elem,
		   newUnmatched = [],
		   i = 0,
		   len = unmatched.length,
		   mapped = map != null;
   
	   for ( ; i < len; i++ ) {
		   if ( (elem = unmatched[i]) ) {
			   if ( !filter || filter( elem, context, xml ) ) {
				   newUnmatched.push( elem );
				   if ( mapped ) {
					   map.push( i );
				   }
			   }
		   }
	   }
   
	   return newUnmatched;
   }
   
   function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	   if ( postFilter && !postFilter[ expando ] ) {
		   postFilter = setMatcher( postFilter );
	   }
	   if ( postFinder && !postFinder[ expando ] ) {
		   postFinder = setMatcher( postFinder, postSelector );
	   }
	   return markFunction(function( seed, results, context, xml ) {
		   var temp, i, elem,
			   preMap = [],
			   postMap = [],
			   preexisting = results.length,
   
			   // Get initial elements from seed or context
			   elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
   
			   // Prefilter to get matcher input, preserving a map for seed-results synchronization
			   matcherIn = preFilter && ( seed || !selector ) ?
				   condense( elems, preMap, preFilter, context, xml ) :
				   elems,
   
			   matcherOut = matcher ?
				   // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				   postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
   
					   // ...intermediate processing is necessary
					   [] :
   
					   // ...otherwise use results directly
					   results :
				   matcherIn;
   
		   // Find primary matches
		   if ( matcher ) {
			   matcher( matcherIn, matcherOut, context, xml );
		   }
   
		   // Apply postFilter
		   if ( postFilter ) {
			   temp = condense( matcherOut, postMap );
			   postFilter( temp, [], context, xml );
   
			   // Un-match failing elements by moving them back to matcherIn
			   i = temp.length;
			   while ( i-- ) {
				   if ( (elem = temp[i]) ) {
					   matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				   }
			   }
		   }
   
		   if ( seed ) {
			   if ( postFinder || preFilter ) {
				   if ( postFinder ) {
					   // Get the final matcherOut by condensing this intermediate into postFinder contexts
					   temp = [];
					   i = matcherOut.length;
					   while ( i-- ) {
						   if ( (elem = matcherOut[i]) ) {
							   // Restore matcherIn since elem is not yet a final match
							   temp.push( (matcherIn[i] = elem) );
						   }
					   }
					   postFinder( null, (matcherOut = []), temp, xml );
				   }
   
				   // Move matched elements from seed to results to keep them synchronized
				   i = matcherOut.length;
				   while ( i-- ) {
					   if ( (elem = matcherOut[i]) &&
						   (temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
   
						   seed[temp] = !(results[temp] = elem);
					   }
				   }
			   }
   
		   // Add elements to results, through postFinder if defined
		   } else {
			   matcherOut = condense(
				   matcherOut === results ?
					   matcherOut.splice( preexisting, matcherOut.length ) :
					   matcherOut
			   );
			   if ( postFinder ) {
				   postFinder( null, results, matcherOut, xml );
			   } else {
				   push.apply( results, matcherOut );
			   }
		   }
	   });
   }
   
   function matcherFromTokens( tokens ) {
	   var checkContext, matcher, j,
		   len = tokens.length,
		   leadingRelative = Expr.relative[ tokens[0].type ],
		   implicitRelative = leadingRelative || Expr.relative[" "],
		   i = leadingRelative ? 1 : 0,
   
		   // The foundational matcher ensures that elements are reachable from top-level context(s)
		   matchContext = addCombinator( function( elem ) {
			   return elem === checkContext;
		   }, implicitRelative, true ),
		   matchAnyContext = addCombinator( function( elem ) {
			   return indexOf( checkContext, elem ) > -1;
		   }, implicitRelative, true ),
		   matchers = [ function( elem, context, xml ) {
			   var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				   (checkContext = context).nodeType ?
					   matchContext( elem, context, xml ) :
					   matchAnyContext( elem, context, xml ) );
			   // Avoid hanging onto element (issue #299)
			   checkContext = null;
			   return ret;
		   } ];
   
	   for ( ; i < len; i++ ) {
		   if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			   matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		   } else {
			   matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
   
			   // Return special upon seeing a positional matcher
			   if ( matcher[ expando ] ) {
				   // Find the next relative operator (if any) for proper handling
				   j = ++i;
				   for ( ; j < len; j++ ) {
					   if ( Expr.relative[ tokens[j].type ] ) {
						   break;
					   }
				   }
				   return setMatcher(
					   i > 1 && elementMatcher( matchers ),
					   i > 1 && toSelector(
						   // If the preceding token was a descendant combinator, insert an implicit any-element `*`
						   tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					   ).replace( rtrim, "$1" ),
					   matcher,
					   i < j && matcherFromTokens( tokens.slice( i, j ) ),
					   j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					   j < len && toSelector( tokens )
				   );
			   }
			   matchers.push( matcher );
		   }
	   }
   
	   return elementMatcher( matchers );
   }
   
   function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	   var bySet = setMatchers.length > 0,
		   byElement = elementMatchers.length > 0,
		   superMatcher = function( seed, context, xml, results, outermost ) {
			   var elem, j, matcher,
				   matchedCount = 0,
				   i = "0",
				   unmatched = seed && [],
				   setMatched = [],
				   contextBackup = outermostContext,
				   // We must always have either seed elements or outermost context
				   elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				   // Use integer dirruns iff this is the outermost matcher
				   dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				   len = elems.length;
   
			   if ( outermost ) {
				   outermostContext = context === document || context || outermost;
			   }
   
			   // Add elements passing elementMatchers directly to results
			   // Support: IE<9, Safari
			   // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			   for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				   if ( byElement && elem ) {
					   j = 0;
					   if ( !context && elem.ownerDocument !== document ) {
						   setDocument( elem );
						   xml = !documentIsHTML;
					   }
					   while ( (matcher = elementMatchers[j++]) ) {
						   if ( matcher( elem, context || document, xml) ) {
							   results.push( elem );
							   break;
						   }
					   }
					   if ( outermost ) {
						   dirruns = dirrunsUnique;
					   }
				   }
   
				   // Track unmatched elements for set filters
				   if ( bySet ) {
					   // They will have gone through all possible matchers
					   if ( (elem = !matcher && elem) ) {
						   matchedCount--;
					   }
   
					   // Lengthen the array for every element, matched or not
					   if ( seed ) {
						   unmatched.push( elem );
					   }
				   }
			   }
   
			   // `i` is now the count of elements visited above, and adding it to `matchedCount`
			   // makes the latter nonnegative.
			   matchedCount += i;
   
			   // Apply set filters to unmatched elements
			   // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			   // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			   // no element matchers and no seed.
			   // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			   // case, which will result in a "00" `matchedCount` that differs from `i` but is also
			   // numerically zero.
			   if ( bySet && i !== matchedCount ) {
				   j = 0;
				   while ( (matcher = setMatchers[j++]) ) {
					   matcher( unmatched, setMatched, context, xml );
				   }
   
				   if ( seed ) {
					   // Reintegrate element matches to eliminate the need for sorting
					   if ( matchedCount > 0 ) {
						   while ( i-- ) {
							   if ( !(unmatched[i] || setMatched[i]) ) {
								   setMatched[i] = pop.call( results );
							   }
						   }
					   }
   
					   // Discard index placeholder values to get only actual matches
					   setMatched = condense( setMatched );
				   }
   
				   // Add matches to results
				   push.apply( results, setMatched );
   
				   // Seedless set matches succeeding multiple successful matchers stipulate sorting
				   if ( outermost && !seed && setMatched.length > 0 &&
					   ( matchedCount + setMatchers.length ) > 1 ) {
   
					   Sizzle.uniqueSort( results );
				   }
			   }
   
			   // Override manipulation of globals by nested matchers
			   if ( outermost ) {
				   dirruns = dirrunsUnique;
				   outermostContext = contextBackup;
			   }
   
			   return unmatched;
		   };
   
	   return bySet ?
		   markFunction( superMatcher ) :
		   superMatcher;
   }
   
   compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	   var i,
		   setMatchers = [],
		   elementMatchers = [],
		   cached = compilerCache[ selector + " " ];
   
	   if ( !cached ) {
		   // Generate a function of recursive functions that can be used to check each element
		   if ( !match ) {
			   match = tokenize( selector );
		   }
		   i = match.length;
		   while ( i-- ) {
			   cached = matcherFromTokens( match[i] );
			   if ( cached[ expando ] ) {
				   setMatchers.push( cached );
			   } else {
				   elementMatchers.push( cached );
			   }
		   }
   
		   // Cache the compiled function
		   cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
   
		   // Save selector and tokenization
		   cached.selector = selector;
	   }
	   return cached;
   };
   
   /**
	* A low-level selection function that works with Sizzle's compiled
	*  selector functions
	* @param {String|Function} selector A selector or a pre-compiled
	*  selector function built with Sizzle.compile
	* @param {Element} context
	* @param {Array} [results]
	* @param {Array} [seed] A set of elements to match against
	*/
   select = Sizzle.select = function( selector, context, results, seed ) {
	   var i, tokens, token, type, find,
		   compiled = typeof selector === "function" && selector,
		   match = !seed && tokenize( (selector = compiled.selector || selector) );
   
	   results = results || [];
   
	   // Try to minimize operations if there is only one selector in the list and no seed
	   // (the latter of which guarantees us context)
	   if ( match.length === 1 ) {
   
		   // Reduce context if the leading compound selector is an ID
		   tokens = match[0] = match[0].slice( 0 );
		   if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				   context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
   
			   context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			   if ( !context ) {
				   return results;
   
			   // Precompiled matchers will still verify ancestry, so step up a level
			   } else if ( compiled ) {
				   context = context.parentNode;
			   }
   
			   selector = selector.slice( tokens.shift().value.length );
		   }
   
		   // Fetch a seed set for right-to-left matching
		   i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		   while ( i-- ) {
			   token = tokens[i];
   
			   // Abort if we hit a combinator
			   if ( Expr.relative[ (type = token.type) ] ) {
				   break;
			   }
			   if ( (find = Expr.find[ type ]) ) {
				   // Search, expanding context for leading sibling combinators
				   if ( (seed = find(
					   token.matches[0].replace( runescape, funescape ),
					   rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				   )) ) {
   
					   // If seed is empty or no tokens remain, we can return early
					   tokens.splice( i, 1 );
					   selector = seed.length && toSelector( tokens );
					   if ( !selector ) {
						   push.apply( results, seed );
						   return results;
					   }
   
					   break;
				   }
			   }
		   }
	   }
   
	   // Compile and execute a filtering function if one is not provided
	   // Provide `match` to avoid retokenization if we modified the selector above
	   ( compiled || compile( selector, match ) )(
		   seed,
		   context,
		   !documentIsHTML,
		   results,
		   !context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	   );
	   return results;
   };
   
   // One-time assignments
   
   // Sort stability
   support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
   
   // Support: Chrome 14-35+
   // Always assume duplicates if they aren't passed to the comparison function
   support.detectDuplicates = !!hasDuplicate;
   
   // Initialize against the default document
   setDocument();
   
   // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
   // Detached nodes confoundingly follow *each other*
   support.sortDetached = assert(function( el ) {
	   // Should return 1, but returns 4 (following)
	   return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
   });
   
   // Support: IE<8
   // Prevent attribute/property "interpolation"
   // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
   if ( !assert(function( el ) {
	   el.innerHTML = "<a href='#'></a>";
	   return el.firstChild.getAttribute("href") === "#" ;
   }) ) {
	   addHandle( "type|href|height|width", function( elem, name, isXML ) {
		   if ( !isXML ) {
			   return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		   }
	   });
   }
   
   // Support: IE<9
   // Use defaultValue in place of getAttribute("value")
   if ( !support.attributes || !assert(function( el ) {
	   el.innerHTML = "<input/>";
	   el.firstChild.setAttribute( "value", "" );
	   return el.firstChild.getAttribute( "value" ) === "";
   }) ) {
	   addHandle( "value", function( elem, name, isXML ) {
		   if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			   return elem.defaultValue;
		   }
	   });
   }
   
   // Support: IE<9
   // Use getAttributeNode to fetch booleans when getAttribute lies
   if ( !assert(function( el ) {
	   return el.getAttribute("disabled") == null;
   }) ) {
	   addHandle( booleans, function( elem, name, isXML ) {
		   var val;
		   if ( !isXML ) {
			   return elem[ name ] === true ? name.toLowerCase() :
					   (val = elem.getAttributeNode( name )) && val.specified ?
					   val.value :
				   null;
		   }
	   });
   }
   
   return Sizzle;
   
   })( window );
   
   
   
   jQuery.find = Sizzle;
   jQuery.expr = Sizzle.selectors;
   
   // Deprecated
   jQuery.expr[ ":" ] = jQuery.expr.pseudos;
   jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
   jQuery.text = Sizzle.getText;
   jQuery.isXMLDoc = Sizzle.isXML;
   jQuery.contains = Sizzle.contains;
   jQuery.escapeSelector = Sizzle.escape;
   
   
   
   
   var dir = function( elem, dir, until ) {
	   var matched = [],
		   truncate = until !== undefined;
   
	   while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		   if ( elem.nodeType === 1 ) {
			   if ( truncate && jQuery( elem ).is( until ) ) {
				   break;
			   }
			   matched.push( elem );
		   }
	   }
	   return matched;
   };
   
   
   var siblings = function( n, elem ) {
	   var matched = [];
   
	   for ( ; n; n = n.nextSibling ) {
		   if ( n.nodeType === 1 && n !== elem ) {
			   matched.push( n );
		   }
	   }
   
	   return matched;
   };
   
   
   var rneedsContext = jQuery.expr.match.needsContext;
   
   
   
   function nodeName( elem, name ) {
   
	 return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
   
   };
   var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
   
   
   
   // Implement the identical functionality for filter and not
   function winnow( elements, qualifier, not ) {
	   if ( isFunction( qualifier ) ) {
		   return jQuery.grep( elements, function( elem, i ) {
			   return !!qualifier.call( elem, i, elem ) !== not;
		   } );
	   }
   
	   // Single element
	   if ( qualifier.nodeType ) {
		   return jQuery.grep( elements, function( elem ) {
			   return ( elem === qualifier ) !== not;
		   } );
	   }
   
	   // Arraylike of elements (jQuery, arguments, Array)
	   if ( typeof qualifier !== "string" ) {
		   return jQuery.grep( elements, function( elem ) {
			   return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		   } );
	   }
   
	   // Filtered directly for both simple and complex selectors
	   return jQuery.filter( qualifier, elements, not );
   }
   
   jQuery.filter = function( expr, elems, not ) {
	   var elem = elems[ 0 ];
   
	   if ( not ) {
		   expr = ":not(" + expr + ")";
	   }
   
	   if ( elems.length === 1 && elem.nodeType === 1 ) {
		   return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	   }
   
	   return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		   return elem.nodeType === 1;
	   } ) );
   };
   
   jQuery.fn.extend( {
	   find: function( selector ) {
		   var i, ret,
			   len = this.length,
			   self = this;
   
		   if ( typeof selector !== "string" ) {
			   return this.pushStack( jQuery( selector ).filter( function() {
				   for ( i = 0; i < len; i++ ) {
					   if ( jQuery.contains( self[ i ], this ) ) {
						   return true;
					   }
				   }
			   } ) );
		   }
   
		   ret = this.pushStack( [] );
   
		   for ( i = 0; i < len; i++ ) {
			   jQuery.find( selector, self[ i ], ret );
		   }
   
		   return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	   },
	   filter: function( selector ) {
		   return this.pushStack( winnow( this, selector || [], false ) );
	   },
	   not: function( selector ) {
		   return this.pushStack( winnow( this, selector || [], true ) );
	   },
	   is: function( selector ) {
		   return !!winnow(
			   this,
   
			   // If this is a positional/relative selector, check membership in the returned set
			   // so $("p:first").is("p:last") won't return true for a doc with two "p".
			   typeof selector === "string" && rneedsContext.test( selector ) ?
				   jQuery( selector ) :
				   selector || [],
			   false
		   ).length;
	   }
   } );
   
   
   // Initialize a jQuery object
   
   
   // A central reference to the root jQuery(document)
   var rootjQuery,
   
	   // A simple way to check for HTML strings
	   // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	   // Strict HTML recognition (#11290: must start with <)
	   // Shortcut simple #id case for speed
	   rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
   
	   init = jQuery.fn.init = function( selector, context, root ) {
		   var match, elem;
   
		   // HANDLE: $(""), $(null), $(undefined), $(false)
		   if ( !selector ) {
			   return this;
		   }
   
		   // Method init() accepts an alternate rootjQuery
		   // so migrate can support jQuery.sub (gh-2101)
		   root = root || rootjQuery;
   
		   // Handle HTML strings
		   if ( typeof selector === "string" ) {
			   if ( selector[ 0 ] === "<" &&
				   selector[ selector.length - 1 ] === ">" &&
				   selector.length >= 3 ) {
   
				   // Assume that strings that start and end with <> are HTML and skip the regex check
				   match = [ null, selector, null ];
   
			   } else {
				   match = rquickExpr.exec( selector );
			   }
   
			   // Match html or make sure no context is specified for #id
			   if ( match && ( match[ 1 ] || !context ) ) {
   
				   // HANDLE: $(html) -> $(array)
				   if ( match[ 1 ] ) {
					   context = context instanceof jQuery ? context[ 0 ] : context;
   
					   // Option to run scripts is true for back-compat
					   // Intentionally let the error be thrown if parseHTML is not present
					   jQuery.merge( this, jQuery.parseHTML(
						   match[ 1 ],
						   context && context.nodeType ? context.ownerDocument || context : document,
						   true
					   ) );
   
					   // HANDLE: $(html, props)
					   if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						   for ( match in context ) {
   
							   // Properties of context are called as methods if possible
							   if ( isFunction( this[ match ] ) ) {
								   this[ match ]( context[ match ] );
   
							   // ...and otherwise set as attributes
							   } else {
								   this.attr( match, context[ match ] );
							   }
						   }
					   }
   
					   return this;
   
				   // HANDLE: $(#id)
				   } else {
					   elem = document.getElementById( match[ 2 ] );
   
					   if ( elem ) {
   
						   // Inject the element directly into the jQuery object
						   this[ 0 ] = elem;
						   this.length = 1;
					   }
					   return this;
				   }
   
			   // HANDLE: $(expr, $(...))
			   } else if ( !context || context.jquery ) {
				   return ( context || root ).find( selector );
   
			   // HANDLE: $(expr, context)
			   // (which is just equivalent to: $(context).find(expr)
			   } else {
				   return this.constructor( context ).find( selector );
			   }
   
		   // HANDLE: $(DOMElement)
		   } else if ( selector.nodeType ) {
			   this[ 0 ] = selector;
			   this.length = 1;
			   return this;
   
		   // HANDLE: $(function)
		   // Shortcut for document ready
		   } else if ( isFunction( selector ) ) {
			   return root.ready !== undefined ?
				   root.ready( selector ) :
   
				   // Execute immediately if ready is not present
				   selector( jQuery );
		   }
   
		   return jQuery.makeArray( selector, this );
	   };
   
   // Give the init function the jQuery prototype for later instantiation
   init.prototype = jQuery.fn;
   
   // Initialize central reference
   rootjQuery = jQuery( document );
   
   
   var rparentsprev = /^(?:parents|prev(?:Until|All))/,
   
	   // Methods guaranteed to produce a unique set when starting from a unique set
	   guaranteedUnique = {
		   children: true,
		   contents: true,
		   next: true,
		   prev: true
	   };
   
   jQuery.fn.extend( {
	   has: function( target ) {
		   var targets = jQuery( target, this ),
			   l = targets.length;
   
		   return this.filter( function() {
			   var i = 0;
			   for ( ; i < l; i++ ) {
				   if ( jQuery.contains( this, targets[ i ] ) ) {
					   return true;
				   }
			   }
		   } );
	   },
   
	   closest: function( selectors, context ) {
		   var cur,
			   i = 0,
			   l = this.length,
			   matched = [],
			   targets = typeof selectors !== "string" && jQuery( selectors );
   
		   // Positional selectors never match, since there's no _selection_ context
		   if ( !rneedsContext.test( selectors ) ) {
			   for ( ; i < l; i++ ) {
				   for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
   
					   // Always skip document fragments
					   if ( cur.nodeType < 11 && ( targets ?
						   targets.index( cur ) > -1 :
   
						   // Don't pass non-elements to Sizzle
						   cur.nodeType === 1 &&
							   jQuery.find.matchesSelector( cur, selectors ) ) ) {
   
						   matched.push( cur );
						   break;
					   }
				   }
			   }
		   }
   
		   return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	   },
   
	   // Determine the position of an element within the set
	   index: function( elem ) {
   
		   // No argument, return index in parent
		   if ( !elem ) {
			   return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		   }
   
		   // Index in selector
		   if ( typeof elem === "string" ) {
			   return indexOf.call( jQuery( elem ), this[ 0 ] );
		   }
   
		   // Locate the position of the desired element
		   return indexOf.call( this,
   
			   // If it receives a jQuery object, the first element is used
			   elem.jquery ? elem[ 0 ] : elem
		   );
	   },
   
	   add: function( selector, context ) {
		   return this.pushStack(
			   jQuery.uniqueSort(
				   jQuery.merge( this.get(), jQuery( selector, context ) )
			   )
		   );
	   },
   
	   addBack: function( selector ) {
		   return this.add( selector == null ?
			   this.prevObject : this.prevObject.filter( selector )
		   );
	   }
   } );
   
   function sibling( cur, dir ) {
	   while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	   return cur;
   }
   
   jQuery.each( {
	   parent: function( elem ) {
		   var parent = elem.parentNode;
		   return parent && parent.nodeType !== 11 ? parent : null;
	   },
	   parents: function( elem ) {
		   return dir( elem, "parentNode" );
	   },
	   parentsUntil: function( elem, i, until ) {
		   return dir( elem, "parentNode", until );
	   },
	   next: function( elem ) {
		   return sibling( elem, "nextSibling" );
	   },
	   prev: function( elem ) {
		   return sibling( elem, "previousSibling" );
	   },
	   nextAll: function( elem ) {
		   return dir( elem, "nextSibling" );
	   },
	   prevAll: function( elem ) {
		   return dir( elem, "previousSibling" );
	   },
	   nextUntil: function( elem, i, until ) {
		   return dir( elem, "nextSibling", until );
	   },
	   prevUntil: function( elem, i, until ) {
		   return dir( elem, "previousSibling", until );
	   },
	   siblings: function( elem ) {
		   return siblings( ( elem.parentNode || {} ).firstChild, elem );
	   },
	   children: function( elem ) {
		   return siblings( elem.firstChild );
	   },
	   contents: function( elem ) {
		   if ( typeof elem.contentDocument !== "undefined" ) {
			   return elem.contentDocument;
		   }
   
		   // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		   // Treat the template element as a regular one in browsers that
		   // don't support it.
		   if ( nodeName( elem, "template" ) ) {
			   elem = elem.content || elem;
		   }
   
		   return jQuery.merge( [], elem.childNodes );
	   }
   }, function( name, fn ) {
	   jQuery.fn[ name ] = function( until, selector ) {
		   var matched = jQuery.map( this, fn, until );
   
		   if ( name.slice( -5 ) !== "Until" ) {
			   selector = until;
		   }
   
		   if ( selector && typeof selector === "string" ) {
			   matched = jQuery.filter( selector, matched );
		   }
   
		   if ( this.length > 1 ) {
   
			   // Remove duplicates
			   if ( !guaranteedUnique[ name ] ) {
				   jQuery.uniqueSort( matched );
			   }
   
			   // Reverse order for parents* and prev-derivatives
			   if ( rparentsprev.test( name ) ) {
				   matched.reverse();
			   }
		   }
   
		   return this.pushStack( matched );
	   };
   } );
   var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
   
   
   
   // Convert String-formatted options into Object-formatted ones
   function createOptions( options ) {
	   var object = {};
	   jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		   object[ flag ] = true;
	   } );
	   return object;
   }
   
   /*
	* Create a callback list using the following parameters:
	*
	*	options: an optional list of space-separated options that will change how
	*			the callback list behaves or a more traditional option object
	*
	* By default a callback list will act like an event callback list and can be
	* "fired" multiple times.
	*
	* Possible options:
	*
	*	once:			will ensure the callback list can only be fired once (like a Deferred)
	*
	*	memory:			will keep track of previous values and will call any callback added
	*					after the list has been fired right away with the latest "memorized"
	*					values (like a Deferred)
	*
	*	unique:			will ensure a callback can only be added once (no duplicate in the list)
	*
	*	stopOnFalse:	interrupt callings when a callback returns false
	*
	*/
   jQuery.Callbacks = function( options ) {
   
	   // Convert options from String-formatted to Object-formatted if needed
	   // (we check in cache first)
	   options = typeof options === "string" ?
		   createOptions( options ) :
		   jQuery.extend( {}, options );
   
	   var // Flag to know if list is currently firing
		   firing,
   
		   // Last fire value for non-forgettable lists
		   memory,
   
		   // Flag to know if list was already fired
		   fired,
   
		   // Flag to prevent firing
		   locked,
   
		   // Actual callback list
		   list = [],
   
		   // Queue of execution data for repeatable lists
		   queue = [],
   
		   // Index of currently firing callback (modified by add/remove as needed)
		   firingIndex = -1,
   
		   // Fire callbacks
		   fire = function() {
   
			   // Enforce single-firing
			   locked = locked || options.once;
   
			   // Execute callbacks for all pending executions,
			   // respecting firingIndex overrides and runtime changes
			   fired = firing = true;
			   for ( ; queue.length; firingIndex = -1 ) {
				   memory = queue.shift();
				   while ( ++firingIndex < list.length ) {
   
					   // Run callback and check for early termination
					   if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						   options.stopOnFalse ) {
   
						   // Jump to end and forget the data so .add doesn't re-fire
						   firingIndex = list.length;
						   memory = false;
					   }
				   }
			   }
   
			   // Forget the data if we're done with it
			   if ( !options.memory ) {
				   memory = false;
			   }
   
			   firing = false;
   
			   // Clean up if we're done firing for good
			   if ( locked ) {
   
				   // Keep an empty list if we have data for future add calls
				   if ( memory ) {
					   list = [];
   
				   // Otherwise, this object is spent
				   } else {
					   list = "";
				   }
			   }
		   },
   
		   // Actual Callbacks object
		   self = {
   
			   // Add a callback or a collection of callbacks to the list
			   add: function() {
				   if ( list ) {
   
					   // If we have memory from a past run, we should fire after adding
					   if ( memory && !firing ) {
						   firingIndex = list.length - 1;
						   queue.push( memory );
					   }
   
					   ( function add( args ) {
						   jQuery.each( args, function( _, arg ) {
							   if ( isFunction( arg ) ) {
								   if ( !options.unique || !self.has( arg ) ) {
									   list.push( arg );
								   }
							   } else if ( arg && arg.length && toType( arg ) !== "string" ) {
   
								   // Inspect recursively
								   add( arg );
							   }
						   } );
					   } )( arguments );
   
					   if ( memory && !firing ) {
						   fire();
					   }
				   }
				   return this;
			   },
   
			   // Remove a callback from the list
			   remove: function() {
				   jQuery.each( arguments, function( _, arg ) {
					   var index;
					   while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						   list.splice( index, 1 );
   
						   // Handle firing indexes
						   if ( index <= firingIndex ) {
							   firingIndex--;
						   }
					   }
				   } );
				   return this;
			   },
   
			   // Check if a given callback is in the list.
			   // If no argument is given, return whether or not list has callbacks attached.
			   has: function( fn ) {
				   return fn ?
					   jQuery.inArray( fn, list ) > -1 :
					   list.length > 0;
			   },
   
			   // Remove all callbacks from the list
			   empty: function() {
				   if ( list ) {
					   list = [];
				   }
				   return this;
			   },
   
			   // Disable .fire and .add
			   // Abort any current/pending executions
			   // Clear all callbacks and values
			   disable: function() {
				   locked = queue = [];
				   list = memory = "";
				   return this;
			   },
			   disabled: function() {
				   return !list;
			   },
   
			   // Disable .fire
			   // Also disable .add unless we have memory (since it would have no effect)
			   // Abort any pending executions
			   lock: function() {
				   locked = queue = [];
				   if ( !memory && !firing ) {
					   list = memory = "";
				   }
				   return this;
			   },
			   locked: function() {
				   return !!locked;
			   },
   
			   // Call all callbacks with the given context and arguments
			   fireWith: function( context, args ) {
				   if ( !locked ) {
					   args = args || [];
					   args = [ context, args.slice ? args.slice() : args ];
					   queue.push( args );
					   if ( !firing ) {
						   fire();
					   }
				   }
				   return this;
			   },
   
			   // Call all the callbacks with the given arguments
			   fire: function() {
				   self.fireWith( this, arguments );
				   return this;
			   },
   
			   // To know if the callbacks have already been called at least once
			   fired: function() {
				   return !!fired;
			   }
		   };
   
	   return self;
   };
   
   
   function Identity( v ) {
	   return v;
   }
   function Thrower( ex ) {
	   throw ex;
   }
   
   function adoptValue( value, resolve, reject, noValue ) {
	   var method;
   
	   try {
   
		   // Check for promise aspect first to privilege synchronous behavior
		   if ( value && isFunction( ( method = value.promise ) ) ) {
			   method.call( value ).done( resolve ).fail( reject );
   
		   // Other thenables
		   } else if ( value && isFunction( ( method = value.then ) ) ) {
			   method.call( value, resolve, reject );
   
		   // Other non-thenables
		   } else {
   
			   // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			   // * false: [ value ].slice( 0 ) => resolve( value )
			   // * true: [ value ].slice( 1 ) => resolve()
			   resolve.apply( undefined, [ value ].slice( noValue ) );
		   }
   
	   // For Promises/A+, convert exceptions into rejections
	   // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	   // Deferred#then to conditionally suppress rejection.
	   } catch ( value ) {
   
		   // Support: Android 4.0 only
		   // Strict mode functions invoked without .call/.apply get global-object context
		   reject.apply( undefined, [ value ] );
	   }
   }
   
   jQuery.extend( {
   
	   Deferred: function( func ) {
		   var tuples = [
   
				   // action, add listener, callbacks,
				   // ... .then handlers, argument index, [final state]
				   [ "notify", "progress", jQuery.Callbacks( "memory" ),
					   jQuery.Callbacks( "memory" ), 2 ],
				   [ "resolve", "done", jQuery.Callbacks( "once memory" ),
					   jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				   [ "reject", "fail", jQuery.Callbacks( "once memory" ),
					   jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			   ],
			   state = "pending",
			   promise = {
				   state: function() {
					   return state;
				   },
				   always: function() {
					   deferred.done( arguments ).fail( arguments );
					   return this;
				   },
				   "catch": function( fn ) {
					   return promise.then( null, fn );
				   },
   
				   // Keep pipe for back-compat
				   pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					   var fns = arguments;
   
					   return jQuery.Deferred( function( newDefer ) {
						   jQuery.each( tuples, function( i, tuple ) {
   
							   // Map tuples (progress, done, fail) to arguments (done, fail, progress)
							   var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
   
							   // deferred.progress(function() { bind to newDefer or newDefer.notify })
							   // deferred.done(function() { bind to newDefer or newDefer.resolve })
							   // deferred.fail(function() { bind to newDefer or newDefer.reject })
							   deferred[ tuple[ 1 ] ]( function() {
								   var returned = fn && fn.apply( this, arguments );
								   if ( returned && isFunction( returned.promise ) ) {
									   returned.promise()
										   .progress( newDefer.notify )
										   .done( newDefer.resolve )
										   .fail( newDefer.reject );
								   } else {
									   newDefer[ tuple[ 0 ] + "With" ](
										   this,
										   fn ? [ returned ] : arguments
									   );
								   }
							   } );
						   } );
						   fns = null;
					   } ).promise();
				   },
				   then: function( onFulfilled, onRejected, onProgress ) {
					   var maxDepth = 0;
					   function resolve( depth, deferred, handler, special ) {
						   return function() {
							   var that = this,
								   args = arguments,
								   mightThrow = function() {
									   var returned, then;
   
									   // Support: Promises/A+ section 2.3.3.3.3
									   // https://promisesaplus.com/#point-59
									   // Ignore double-resolution attempts
									   if ( depth < maxDepth ) {
										   return;
									   }
   
									   returned = handler.apply( that, args );
   
									   // Support: Promises/A+ section 2.3.1
									   // https://promisesaplus.com/#point-48
									   if ( returned === deferred.promise() ) {
										   throw new TypeError( "Thenable self-resolution" );
									   }
   
									   // Support: Promises/A+ sections 2.3.3.1, 3.5
									   // https://promisesaplus.com/#point-54
									   // https://promisesaplus.com/#point-75
									   // Retrieve `then` only once
									   then = returned &&
   
										   // Support: Promises/A+ section 2.3.4
										   // https://promisesaplus.com/#point-64
										   // Only check objects and functions for thenability
										   ( typeof returned === "object" ||
											   typeof returned === "function" ) &&
										   returned.then;
   
									   // Handle a returned thenable
									   if ( isFunction( then ) ) {
   
										   // Special processors (notify) just wait for resolution
										   if ( special ) {
											   then.call(
												   returned,
												   resolve( maxDepth, deferred, Identity, special ),
												   resolve( maxDepth, deferred, Thrower, special )
											   );
   
										   // Normal processors (resolve) also hook into progress
										   } else {
   
											   // ...and disregard older resolution values
											   maxDepth++;
   
											   then.call(
												   returned,
												   resolve( maxDepth, deferred, Identity, special ),
												   resolve( maxDepth, deferred, Thrower, special ),
												   resolve( maxDepth, deferred, Identity,
													   deferred.notifyWith )
											   );
										   }
   
									   // Handle all other returned values
									   } else {
   
										   // Only substitute handlers pass on context
										   // and multiple values (non-spec behavior)
										   if ( handler !== Identity ) {
											   that = undefined;
											   args = [ returned ];
										   }
   
										   // Process the value(s)
										   // Default process is resolve
										   ( special || deferred.resolveWith )( that, args );
									   }
								   },
   
								   // Only normal processors (resolve) catch and reject exceptions
								   process = special ?
									   mightThrow :
									   function() {
										   try {
											   mightThrow();
										   } catch ( e ) {
   
											   if ( jQuery.Deferred.exceptionHook ) {
												   jQuery.Deferred.exceptionHook( e,
													   process.stackTrace );
											   }
   
											   // Support: Promises/A+ section 2.3.3.3.4.1
											   // https://promisesaplus.com/#point-61
											   // Ignore post-resolution exceptions
											   if ( depth + 1 >= maxDepth ) {
   
												   // Only substitute handlers pass on context
												   // and multiple values (non-spec behavior)
												   if ( handler !== Thrower ) {
													   that = undefined;
													   args = [ e ];
												   }
   
												   deferred.rejectWith( that, args );
											   }
										   }
									   };
   
							   // Support: Promises/A+ section 2.3.3.3.1
							   // https://promisesaplus.com/#point-57
							   // Re-resolve promises immediately to dodge false rejection from
							   // subsequent errors
							   if ( depth ) {
								   process();
							   } else {
   
								   // Call an optional hook to record the stack, in case of exception
								   // since it's otherwise lost when execution goes async
								   if ( jQuery.Deferred.getStackHook ) {
									   process.stackTrace = jQuery.Deferred.getStackHook();
								   }
								   window.setTimeout( process );
							   }
						   };
					   }
   
					   return jQuery.Deferred( function( newDefer ) {
   
						   // progress_handlers.add( ... )
						   tuples[ 0 ][ 3 ].add(
							   resolve(
								   0,
								   newDefer,
								   isFunction( onProgress ) ?
									   onProgress :
									   Identity,
								   newDefer.notifyWith
							   )
						   );
   
						   // fulfilled_handlers.add( ... )
						   tuples[ 1 ][ 3 ].add(
							   resolve(
								   0,
								   newDefer,
								   isFunction( onFulfilled ) ?
									   onFulfilled :
									   Identity
							   )
						   );
   
						   // rejected_handlers.add( ... )
						   tuples[ 2 ][ 3 ].add(
							   resolve(
								   0,
								   newDefer,
								   isFunction( onRejected ) ?
									   onRejected :
									   Thrower
							   )
						   );
					   } ).promise();
				   },
   
				   // Get a promise for this deferred
				   // If obj is provided, the promise aspect is added to the object
				   promise: function( obj ) {
					   return obj != null ? jQuery.extend( obj, promise ) : promise;
				   }
			   },
			   deferred = {};
   
		   // Add list-specific methods
		   jQuery.each( tuples, function( i, tuple ) {
			   var list = tuple[ 2 ],
				   stateString = tuple[ 5 ];
   
			   // promise.progress = list.add
			   // promise.done = list.add
			   // promise.fail = list.add
			   promise[ tuple[ 1 ] ] = list.add;
   
			   // Handle state
			   if ( stateString ) {
				   list.add(
					   function() {
   
						   // state = "resolved" (i.e., fulfilled)
						   // state = "rejected"
						   state = stateString;
					   },
   
					   // rejected_callbacks.disable
					   // fulfilled_callbacks.disable
					   tuples[ 3 - i ][ 2 ].disable,
   
					   // rejected_handlers.disable
					   // fulfilled_handlers.disable
					   tuples[ 3 - i ][ 3 ].disable,
   
					   // progress_callbacks.lock
					   tuples[ 0 ][ 2 ].lock,
   
					   // progress_handlers.lock
					   tuples[ 0 ][ 3 ].lock
				   );
			   }
   
			   // progress_handlers.fire
			   // fulfilled_handlers.fire
			   // rejected_handlers.fire
			   list.add( tuple[ 3 ].fire );
   
			   // deferred.notify = function() { deferred.notifyWith(...) }
			   // deferred.resolve = function() { deferred.resolveWith(...) }
			   // deferred.reject = function() { deferred.rejectWith(...) }
			   deferred[ tuple[ 0 ] ] = function() {
				   deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				   return this;
			   };
   
			   // deferred.notifyWith = list.fireWith
			   // deferred.resolveWith = list.fireWith
			   // deferred.rejectWith = list.fireWith
			   deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		   } );
   
		   // Make the deferred a promise
		   promise.promise( deferred );
   
		   // Call given func if any
		   if ( func ) {
			   func.call( deferred, deferred );
		   }
   
		   // All done!
		   return deferred;
	   },
   
	   // Deferred helper
	   when: function( singleValue ) {
		   var
   
			   // count of uncompleted subordinates
			   remaining = arguments.length,
   
			   // count of unprocessed arguments
			   i = remaining,
   
			   // subordinate fulfillment data
			   resolveContexts = Array( i ),
			   resolveValues = slice.call( arguments ),
   
			   // the master Deferred
			   master = jQuery.Deferred(),
   
			   // subordinate callback factory
			   updateFunc = function( i ) {
				   return function( value ) {
					   resolveContexts[ i ] = this;
					   resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					   if ( !( --remaining ) ) {
						   master.resolveWith( resolveContexts, resolveValues );
					   }
				   };
			   };
   
		   // Single- and empty arguments are adopted like Promise.resolve
		   if ( remaining <= 1 ) {
			   adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				   !remaining );
   
			   // Use .then() to unwrap secondary thenables (cf. gh-3000)
			   if ( master.state() === "pending" ||
				   isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
   
				   return master.then();
			   }
		   }
   
		   // Multiple arguments are aggregated like Promise.all array elements
		   while ( i-- ) {
			   adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		   }
   
		   return master.promise();
	   }
   } );
   
   
   // These usually indicate a programmer mistake during development,
   // warn about them ASAP rather than swallowing them by default.
   var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
   
   jQuery.Deferred.exceptionHook = function( error, stack ) {
   
	   // Support: IE 8 - 9 only
	   // Console exists when dev tools are open, which can happen at any time
	   if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		   window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	   }
   };
   
   
   
   
   jQuery.readyException = function( error ) {
	   window.setTimeout( function() {
		   throw error;
	   } );
   };
   
   
   
   
   // The deferred used on DOM ready
   var readyList = jQuery.Deferred();
   
   jQuery.fn.ready = function( fn ) {
   
	   readyList
		   .then( fn )
   
		   // Wrap jQuery.readyException in a function so that the lookup
		   // happens at the time of error handling instead of callback
		   // registration.
		   .catch( function( error ) {
			   jQuery.readyException( error );
		   } );
   
	   return this;
   };
   
   jQuery.extend( {
   
	   // Is the DOM ready to be used? Set to true once it occurs.
	   isReady: false,
   
	   // A counter to track how many items to wait for before
	   // the ready event fires. See #6781
	   readyWait: 1,
   
	   // Handle when the DOM is ready
	   ready: function( wait ) {
   
		   // Abort if there are pending holds or we're already ready
		   if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			   return;
		   }
   
		   // Remember that the DOM is ready
		   jQuery.isReady = true;
   
		   // If a normal DOM Ready event fired, decrement, and wait if need be
		   if ( wait !== true && --jQuery.readyWait > 0 ) {
			   return;
		   }
   
		   // If there are functions bound, to execute
		   readyList.resolveWith( document, [ jQuery ] );
	   }
   } );
   
   jQuery.ready.then = readyList.then;
   
   // The ready event handler and self cleanup method
   function completed() {
	   document.removeEventListener( "DOMContentLoaded", completed );
	   window.removeEventListener( "load", completed );
	   jQuery.ready();
   }
   
   // Catch cases where $(document).ready() is called
   // after the browser event has already occurred.
   // Support: IE <=9 - 10 only
   // Older IE sometimes signals "interactive" too soon
   if ( document.readyState === "complete" ||
	   ( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
   
	   // Handle it asynchronously to allow scripts the opportunity to delay ready
	   window.setTimeout( jQuery.ready );
   
   } else {
   
	   // Use the handy event callback
	   document.addEventListener( "DOMContentLoaded", completed );
   
	   // A fallback to window.onload, that will always work
	   window.addEventListener( "load", completed );
   }
   
   
   
   
   // Multifunctional method to get and set values of a collection
   // The value/s can optionally be executed if it's a function
   var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	   var i = 0,
		   len = elems.length,
		   bulk = key == null;
   
	   // Sets many values
	   if ( toType( key ) === "object" ) {
		   chainable = true;
		   for ( i in key ) {
			   access( elems, fn, i, key[ i ], true, emptyGet, raw );
		   }
   
	   // Sets one value
	   } else if ( value !== undefined ) {
		   chainable = true;
   
		   if ( !isFunction( value ) ) {
			   raw = true;
		   }
   
		   if ( bulk ) {
   
			   // Bulk operations run against the entire set
			   if ( raw ) {
				   fn.call( elems, value );
				   fn = null;
   
			   // ...except when executing function values
			   } else {
				   bulk = fn;
				   fn = function( elem, key, value ) {
					   return bulk.call( jQuery( elem ), value );
				   };
			   }
		   }
   
		   if ( fn ) {
			   for ( ; i < len; i++ ) {
				   fn(
					   elems[ i ], key, raw ?
					   value :
					   value.call( elems[ i ], i, fn( elems[ i ], key ) )
				   );
			   }
		   }
	   }
   
	   if ( chainable ) {
		   return elems;
	   }
   
	   // Gets
	   if ( bulk ) {
		   return fn.call( elems );
	   }
   
	   return len ? fn( elems[ 0 ], key ) : emptyGet;
   };
   
   
   // Matches dashed string for camelizing
   var rmsPrefix = /^-ms-/,
	   rdashAlpha = /-([a-z])/g;
   
   // Used by camelCase as callback to replace()
   function fcamelCase( all, letter ) {
	   return letter.toUpperCase();
   }
   
   // Convert dashed to camelCase; used by the css and data modules
   // Support: IE <=9 - 11, Edge 12 - 15
   // Microsoft forgot to hump their vendor prefix (#9572)
   function camelCase( string ) {
	   return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
   }
   var acceptData = function( owner ) {
   
	   // Accepts only:
	   //  - Node
	   //    - Node.ELEMENT_NODE
	   //    - Node.DOCUMENT_NODE
	   //  - Object
	   //    - Any
	   return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
   };
   
   
   
   
   function Data() {
	   this.expando = jQuery.expando + Data.uid++;
   }
   
   Data.uid = 1;
   
   Data.prototype = {
   
	   cache: function( owner ) {
   
		   // Check if the owner object already has a cache
		   var value = owner[ this.expando ];
   
		   // If not, create one
		   if ( !value ) {
			   value = {};
   
			   // We can accept data for non-element nodes in modern browsers,
			   // but we should not, see #8335.
			   // Always return an empty object.
			   if ( acceptData( owner ) ) {
   
				   // If it is a node unlikely to be stringify-ed or looped over
				   // use plain assignment
				   if ( owner.nodeType ) {
					   owner[ this.expando ] = value;
   
				   // Otherwise secure it in a non-enumerable property
				   // configurable must be true to allow the property to be
				   // deleted when data is removed
				   } else {
					   Object.defineProperty( owner, this.expando, {
						   value: value,
						   configurable: true
					   } );
				   }
			   }
		   }
   
		   return value;
	   },
	   set: function( owner, data, value ) {
		   var prop,
			   cache = this.cache( owner );
   
		   // Handle: [ owner, key, value ] args
		   // Always use camelCase key (gh-2257)
		   if ( typeof data === "string" ) {
			   cache[ camelCase( data ) ] = value;
   
		   // Handle: [ owner, { properties } ] args
		   } else {
   
			   // Copy the properties one-by-one to the cache object
			   for ( prop in data ) {
				   cache[ camelCase( prop ) ] = data[ prop ];
			   }
		   }
		   return cache;
	   },
	   get: function( owner, key ) {
		   return key === undefined ?
			   this.cache( owner ) :
   
			   // Always use camelCase key (gh-2257)
			   owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	   },
	   access: function( owner, key, value ) {
   
		   // In cases where either:
		   //
		   //   1. No key was specified
		   //   2. A string key was specified, but no value provided
		   //
		   // Take the "read" path and allow the get method to determine
		   // which value to return, respectively either:
		   //
		   //   1. The entire cache object
		   //   2. The data stored at the key
		   //
		   if ( key === undefined ||
				   ( ( key && typeof key === "string" ) && value === undefined ) ) {
   
			   return this.get( owner, key );
		   }
   
		   // When the key is not a string, or both a key and value
		   // are specified, set or extend (existing objects) with either:
		   //
		   //   1. An object of properties
		   //   2. A key and value
		   //
		   this.set( owner, key, value );
   
		   // Since the "set" path can have two possible entry points
		   // return the expected data based on which path was taken[*]
		   return value !== undefined ? value : key;
	   },
	   remove: function( owner, key ) {
		   var i,
			   cache = owner[ this.expando ];
   
		   if ( cache === undefined ) {
			   return;
		   }
   
		   if ( key !== undefined ) {
   
			   // Support array or space separated string of keys
			   if ( Array.isArray( key ) ) {
   
				   // If key is an array of keys...
				   // We always set camelCase keys, so remove that.
				   key = key.map( camelCase );
			   } else {
				   key = camelCase( key );
   
				   // If a key with the spaces exists, use it.
				   // Otherwise, create an array by matching non-whitespace
				   key = key in cache ?
					   [ key ] :
					   ( key.match( rnothtmlwhite ) || [] );
			   }
   
			   i = key.length;
   
			   while ( i-- ) {
				   delete cache[ key[ i ] ];
			   }
		   }
   
		   // Remove the expando if there's no more data
		   if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
   
			   // Support: Chrome <=35 - 45
			   // Webkit & Blink performance suffers when deleting properties
			   // from DOM nodes, so set to undefined instead
			   // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			   if ( owner.nodeType ) {
				   owner[ this.expando ] = undefined;
			   } else {
				   delete owner[ this.expando ];
			   }
		   }
	   },
	   hasData: function( owner ) {
		   var cache = owner[ this.expando ];
		   return cache !== undefined && !jQuery.isEmptyObject( cache );
	   }
   };
   var dataPriv = new Data();
   
   var dataUser = new Data();
   
   
   
   //	Implementation Summary
   //
   //	1. Enforce API surface and semantic compatibility with 1.9.x branch
   //	2. Improve the module's maintainability by reducing the storage
   //		paths to a single mechanism.
   //	3. Use the same single mechanism to support "private" and "user" data.
   //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
   //	5. Avoid exposing implementation details on user objects (eg. expando properties)
   //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
   
   var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	   rmultiDash = /[A-Z]/g;
   
   function getData( data ) {
	   if ( data === "true" ) {
		   return true;
	   }
   
	   if ( data === "false" ) {
		   return false;
	   }
   
	   if ( data === "null" ) {
		   return null;
	   }
   
	   // Only convert to a number if it doesn't change the string
	   if ( data === +data + "" ) {
		   return +data;
	   }
   
	   if ( rbrace.test( data ) ) {
		   return JSON.parse( data );
	   }
   
	   return data;
   }
   
   function dataAttr( elem, key, data ) {
	   var name;
   
	   // If nothing was found internally, try to fetch any
	   // data from the HTML5 data-* attribute
	   if ( data === undefined && elem.nodeType === 1 ) {
		   name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		   data = elem.getAttribute( name );
   
		   if ( typeof data === "string" ) {
			   try {
				   data = getData( data );
			   } catch ( e ) {}
   
			   // Make sure we set the data so it isn't changed later
			   dataUser.set( elem, key, data );
		   } else {
			   data = undefined;
		   }
	   }
	   return data;
   }
   
   jQuery.extend( {
	   hasData: function( elem ) {
		   return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	   },
   
	   data: function( elem, name, data ) {
		   return dataUser.access( elem, name, data );
	   },
   
	   removeData: function( elem, name ) {
		   dataUser.remove( elem, name );
	   },
   
	   // TODO: Now that all calls to _data and _removeData have been replaced
	   // with direct calls to dataPriv methods, these can be deprecated.
	   _data: function( elem, name, data ) {
		   return dataPriv.access( elem, name, data );
	   },
   
	   _removeData: function( elem, name ) {
		   dataPriv.remove( elem, name );
	   }
   } );
   
   jQuery.fn.extend( {
	   data: function( key, value ) {
		   var i, name, data,
			   elem = this[ 0 ],
			   attrs = elem && elem.attributes;
   
		   // Gets all values
		   if ( key === undefined ) {
			   if ( this.length ) {
				   data = dataUser.get( elem );
   
				   if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					   i = attrs.length;
					   while ( i-- ) {
   
						   // Support: IE 11 only
						   // The attrs elements can be null (#14894)
						   if ( attrs[ i ] ) {
							   name = attrs[ i ].name;
							   if ( name.indexOf( "data-" ) === 0 ) {
								   name = camelCase( name.slice( 5 ) );
								   dataAttr( elem, name, data[ name ] );
							   }
						   }
					   }
					   dataPriv.set( elem, "hasDataAttrs", true );
				   }
			   }
   
			   return data;
		   }
   
		   // Sets multiple values
		   if ( typeof key === "object" ) {
			   return this.each( function() {
				   dataUser.set( this, key );
			   } );
		   }
   
		   return access( this, function( value ) {
			   var data;
   
			   // The calling jQuery object (element matches) is not empty
			   // (and therefore has an element appears at this[ 0 ]) and the
			   // `value` parameter was not undefined. An empty jQuery object
			   // will result in `undefined` for elem = this[ 0 ] which will
			   // throw an exception if an attempt to read a data cache is made.
			   if ( elem && value === undefined ) {
   
				   // Attempt to get data from the cache
				   // The key will always be camelCased in Data
				   data = dataUser.get( elem, key );
				   if ( data !== undefined ) {
					   return data;
				   }
   
				   // Attempt to "discover" the data in
				   // HTML5 custom data-* attrs
				   data = dataAttr( elem, key );
				   if ( data !== undefined ) {
					   return data;
				   }
   
				   // We tried really hard, but the data doesn't exist.
				   return;
			   }
   
			   // Set the data...
			   this.each( function() {
   
				   // We always store the camelCased key
				   dataUser.set( this, key, value );
			   } );
		   }, null, value, arguments.length > 1, null, true );
	   },
   
	   removeData: function( key ) {
		   return this.each( function() {
			   dataUser.remove( this, key );
		   } );
	   }
   } );
   
   
   jQuery.extend( {
	   queue: function( elem, type, data ) {
		   var queue;
   
		   if ( elem ) {
			   type = ( type || "fx" ) + "queue";
			   queue = dataPriv.get( elem, type );
   
			   // Speed up dequeue by getting out quickly if this is just a lookup
			   if ( data ) {
				   if ( !queue || Array.isArray( data ) ) {
					   queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				   } else {
					   queue.push( data );
				   }
			   }
			   return queue || [];
		   }
	   },
   
	   dequeue: function( elem, type ) {
		   type = type || "fx";
   
		   var queue = jQuery.queue( elem, type ),
			   startLength = queue.length,
			   fn = queue.shift(),
			   hooks = jQuery._queueHooks( elem, type ),
			   next = function() {
				   jQuery.dequeue( elem, type );
			   };
   
		   // If the fx queue is dequeued, always remove the progress sentinel
		   if ( fn === "inprogress" ) {
			   fn = queue.shift();
			   startLength--;
		   }
   
		   if ( fn ) {
   
			   // Add a progress sentinel to prevent the fx queue from being
			   // automatically dequeued
			   if ( type === "fx" ) {
				   queue.unshift( "inprogress" );
			   }
   
			   // Clear up the last queue stop function
			   delete hooks.stop;
			   fn.call( elem, next, hooks );
		   }
   
		   if ( !startLength && hooks ) {
			   hooks.empty.fire();
		   }
	   },
   
	   // Not public - generate a queueHooks object, or return the current one
	   _queueHooks: function( elem, type ) {
		   var key = type + "queueHooks";
		   return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			   empty: jQuery.Callbacks( "once memory" ).add( function() {
				   dataPriv.remove( elem, [ type + "queue", key ] );
			   } )
		   } );
	   }
   } );
   
   jQuery.fn.extend( {
	   queue: function( type, data ) {
		   var setter = 2;
   
		   if ( typeof type !== "string" ) {
			   data = type;
			   type = "fx";
			   setter--;
		   }
   
		   if ( arguments.length < setter ) {
			   return jQuery.queue( this[ 0 ], type );
		   }
   
		   return data === undefined ?
			   this :
			   this.each( function() {
				   var queue = jQuery.queue( this, type, data );
   
				   // Ensure a hooks for this queue
				   jQuery._queueHooks( this, type );
   
				   if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					   jQuery.dequeue( this, type );
				   }
			   } );
	   },
	   dequeue: function( type ) {
		   return this.each( function() {
			   jQuery.dequeue( this, type );
		   } );
	   },
	   clearQueue: function( type ) {
		   return this.queue( type || "fx", [] );
	   },
   
	   // Get a promise resolved when queues of a certain type
	   // are emptied (fx is the type by default)
	   promise: function( type, obj ) {
		   var tmp,
			   count = 1,
			   defer = jQuery.Deferred(),
			   elements = this,
			   i = this.length,
			   resolve = function() {
				   if ( !( --count ) ) {
					   defer.resolveWith( elements, [ elements ] );
				   }
			   };
   
		   if ( typeof type !== "string" ) {
			   obj = type;
			   type = undefined;
		   }
		   type = type || "fx";
   
		   while ( i-- ) {
			   tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			   if ( tmp && tmp.empty ) {
				   count++;
				   tmp.empty.add( resolve );
			   }
		   }
		   resolve();
		   return defer.promise( obj );
	   }
   } );
   var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
   
   var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
   
   
   var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
   
   var documentElement = document.documentElement;
   
   
   
	   var isAttached = function( elem ) {
			   return jQuery.contains( elem.ownerDocument, elem );
		   },
		   composed = { composed: true };
   
	   // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	   // Check attachment across shadow DOM boundaries when possible (gh-3504)
	   // Support: iOS 10.0-10.2 only
	   // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	   // leading to errors. We need to check for `getRootNode`.
	   if ( documentElement.getRootNode ) {
		   isAttached = function( elem ) {
			   return jQuery.contains( elem.ownerDocument, elem ) ||
				   elem.getRootNode( composed ) === elem.ownerDocument;
		   };
	   }
   var isHiddenWithinTree = function( elem, el ) {
   
		   // isHiddenWithinTree might be called from jQuery#filter function;
		   // in that case, element will be second argument
		   elem = el || elem;
   
		   // Inline style trumps all
		   return elem.style.display === "none" ||
			   elem.style.display === "" &&
   
			   // Otherwise, check computed style
			   // Support: Firefox <=43 - 45
			   // Disconnected elements can have computed display: none, so first confirm that elem is
			   // in the document.
			   isAttached( elem ) &&
   
			   jQuery.css( elem, "display" ) === "none";
	   };
   
   var swap = function( elem, options, callback, args ) {
	   var ret, name,
		   old = {};
   
	   // Remember the old values, and insert the new ones
	   for ( name in options ) {
		   old[ name ] = elem.style[ name ];
		   elem.style[ name ] = options[ name ];
	   }
   
	   ret = callback.apply( elem, args || [] );
   
	   // Revert the old values
	   for ( name in options ) {
		   elem.style[ name ] = old[ name ];
	   }
   
	   return ret;
   };
   
   
   
   
   function adjustCSS( elem, prop, valueParts, tween ) {
	   var adjusted, scale,
		   maxIterations = 20,
		   currentValue = tween ?
			   function() {
				   return tween.cur();
			   } :
			   function() {
				   return jQuery.css( elem, prop, "" );
			   },
		   initial = currentValue(),
		   unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
   
		   // Starting value computation is required for potential unit mismatches
		   initialInUnit = elem.nodeType &&
			   ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			   rcssNum.exec( jQuery.css( elem, prop ) );
   
	   if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
   
		   // Support: Firefox <=54
		   // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		   initial = initial / 2;
   
		   // Trust units reported by jQuery.css
		   unit = unit || initialInUnit[ 3 ];
   
		   // Iteratively approximate from a nonzero starting point
		   initialInUnit = +initial || 1;
   
		   while ( maxIterations-- ) {
   
			   // Evaluate and update our best guess (doubling guesses that zero out).
			   // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			   jQuery.style( elem, prop, initialInUnit + unit );
			   if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				   maxIterations = 0;
			   }
			   initialInUnit = initialInUnit / scale;
   
		   }
   
		   initialInUnit = initialInUnit * 2;
		   jQuery.style( elem, prop, initialInUnit + unit );
   
		   // Make sure we update the tween properties later on
		   valueParts = valueParts || [];
	   }
   
	   if ( valueParts ) {
		   initialInUnit = +initialInUnit || +initial || 0;
   
		   // Apply relative offset (+=/-=) if specified
		   adjusted = valueParts[ 1 ] ?
			   initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			   +valueParts[ 2 ];
		   if ( tween ) {
			   tween.unit = unit;
			   tween.start = initialInUnit;
			   tween.end = adjusted;
		   }
	   }
	   return adjusted;
   }
   
   
   var defaultDisplayMap = {};
   
   function getDefaultDisplay( elem ) {
	   var temp,
		   doc = elem.ownerDocument,
		   nodeName = elem.nodeName,
		   display = defaultDisplayMap[ nodeName ];
   
	   if ( display ) {
		   return display;
	   }
   
	   temp = doc.body.appendChild( doc.createElement( nodeName ) );
	   display = jQuery.css( temp, "display" );
   
	   temp.parentNode.removeChild( temp );
   
	   if ( display === "none" ) {
		   display = "block";
	   }
	   defaultDisplayMap[ nodeName ] = display;
   
	   return display;
   }
   
   function showHide( elements, show ) {
	   var display, elem,
		   values = [],
		   index = 0,
		   length = elements.length;
   
	   // Determine new display value for elements that need to change
	   for ( ; index < length; index++ ) {
		   elem = elements[ index ];
		   if ( !elem.style ) {
			   continue;
		   }
   
		   display = elem.style.display;
		   if ( show ) {
   
			   // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			   // check is required in this first loop unless we have a nonempty display value (either
			   // inline or about-to-be-restored)
			   if ( display === "none" ) {
				   values[ index ] = dataPriv.get( elem, "display" ) || null;
				   if ( !values[ index ] ) {
					   elem.style.display = "";
				   }
			   }
			   if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				   values[ index ] = getDefaultDisplay( elem );
			   }
		   } else {
			   if ( display !== "none" ) {
				   values[ index ] = "none";
   
				   // Remember what we're overwriting
				   dataPriv.set( elem, "display", display );
			   }
		   }
	   }
   
	   // Set the display of the elements in a second loop to avoid constant reflow
	   for ( index = 0; index < length; index++ ) {
		   if ( values[ index ] != null ) {
			   elements[ index ].style.display = values[ index ];
		   }
	   }
   
	   return elements;
   }
   
   jQuery.fn.extend( {
	   show: function() {
		   return showHide( this, true );
	   },
	   hide: function() {
		   return showHide( this );
	   },
	   toggle: function( state ) {
		   if ( typeof state === "boolean" ) {
			   return state ? this.show() : this.hide();
		   }
   
		   return this.each( function() {
			   if ( isHiddenWithinTree( this ) ) {
				   jQuery( this ).show();
			   } else {
				   jQuery( this ).hide();
			   }
		   } );
	   }
   } );
   var rcheckableType = ( /^(?:checkbox|radio)$/i );
   
   var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
   
   var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
   
   
   
   // We have to close these tags to support XHTML (#13200)
   var wrapMap = {
   
	   // Support: IE <=9 only
	   option: [ 1, "<select multiple='multiple'>", "</select>" ],
   
	   // XHTML parsers do not magically insert elements in the
	   // same way that tag soup parsers do. So we cannot shorten
	   // this by omitting <tbody> or other required elements.
	   thead: [ 1, "<table>", "</table>" ],
	   col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	   tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	   td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
   
	   _default: [ 0, "", "" ]
   };
   
   // Support: IE <=9 only
   wrapMap.optgroup = wrapMap.option;
   
   wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
   wrapMap.th = wrapMap.td;
   
   
   function getAll( context, tag ) {
   
	   // Support: IE <=9 - 11 only
	   // Use typeof to avoid zero-argument method invocation on host objects (#15151)
	   var ret;
   
	   if ( typeof context.getElementsByTagName !== "undefined" ) {
		   ret = context.getElementsByTagName( tag || "*" );
   
	   } else if ( typeof context.querySelectorAll !== "undefined" ) {
		   ret = context.querySelectorAll( tag || "*" );
   
	   } else {
		   ret = [];
	   }
   
	   if ( tag === undefined || tag && nodeName( context, tag ) ) {
		   return jQuery.merge( [ context ], ret );
	   }
   
	   return ret;
   }
   
   
   // Mark scripts as having already been evaluated
   function setGlobalEval( elems, refElements ) {
	   var i = 0,
		   l = elems.length;
   
	   for ( ; i < l; i++ ) {
		   dataPriv.set(
			   elems[ i ],
			   "globalEval",
			   !refElements || dataPriv.get( refElements[ i ], "globalEval" )
		   );
	   }
   }
   
   
   var rhtml = /<|&#?\w+;/;
   
   function buildFragment( elems, context, scripts, selection, ignored ) {
	   var elem, tmp, tag, wrap, attached, j,
		   fragment = context.createDocumentFragment(),
		   nodes = [],
		   i = 0,
		   l = elems.length;
   
	   for ( ; i < l; i++ ) {
		   elem = elems[ i ];
   
		   if ( elem || elem === 0 ) {
   
			   // Add nodes directly
			   if ( toType( elem ) === "object" ) {
   
				   // Support: Android <=4.0 only, PhantomJS 1 only
				   // push.apply(_, arraylike) throws on ancient WebKit
				   jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
   
			   // Convert non-html into a text node
			   } else if ( !rhtml.test( elem ) ) {
				   nodes.push( context.createTextNode( elem ) );
   
			   // Convert html into DOM nodes
			   } else {
				   tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
   
				   // Deserialize a standard representation
				   tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				   wrap = wrapMap[ tag ] || wrapMap._default;
				   tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
   
				   // Descend through wrappers to the right content
				   j = wrap[ 0 ];
				   while ( j-- ) {
					   tmp = tmp.lastChild;
				   }
   
				   // Support: Android <=4.0 only, PhantomJS 1 only
				   // push.apply(_, arraylike) throws on ancient WebKit
				   jQuery.merge( nodes, tmp.childNodes );
   
				   // Remember the top-level container
				   tmp = fragment.firstChild;
   
				   // Ensure the created nodes are orphaned (#12392)
				   tmp.textContent = "";
			   }
		   }
	   }
   
	   // Remove wrapper from fragment
	   fragment.textContent = "";
   
	   i = 0;
	   while ( ( elem = nodes[ i++ ] ) ) {
   
		   // Skip elements already in the context collection (trac-4087)
		   if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			   if ( ignored ) {
				   ignored.push( elem );
			   }
			   continue;
		   }
   
		   attached = isAttached( elem );
   
		   // Append to fragment
		   tmp = getAll( fragment.appendChild( elem ), "script" );
   
		   // Preserve script evaluation history
		   if ( attached ) {
			   setGlobalEval( tmp );
		   }
   
		   // Capture executables
		   if ( scripts ) {
			   j = 0;
			   while ( ( elem = tmp[ j++ ] ) ) {
				   if ( rscriptType.test( elem.type || "" ) ) {
					   scripts.push( elem );
				   }
			   }
		   }
	   }
   
	   return fragment;
   }
   
   
   ( function() {
	   var fragment = document.createDocumentFragment(),
		   div = fragment.appendChild( document.createElement( "div" ) ),
		   input = document.createElement( "input" );
   
	   // Support: Android 4.0 - 4.3 only
	   // Check state lost if the name is set (#11217)
	   // Support: Windows Web Apps (WWA)
	   // `name` and `type` must use .setAttribute for WWA (#14901)
	   input.setAttribute( "type", "radio" );
	   input.setAttribute( "checked", "checked" );
	   input.setAttribute( "name", "t" );
   
	   div.appendChild( input );
   
	   // Support: Android <=4.1 only
	   // Older WebKit doesn't clone checked state correctly in fragments
	   support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
   
	   // Support: IE <=11 only
	   // Make sure textarea (and checkbox) defaultValue is properly cloned
	   div.innerHTML = "<textarea>x</textarea>";
	   support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
   } )();
   
   
   var
	   rkeyEvent = /^key/,
	   rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	   rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
   
   function returnTrue() {
	   return true;
   }
   
   function returnFalse() {
	   return false;
   }
   
   // Support: IE <=9 - 11+
   // focus() and blur() are asynchronous, except when they are no-op.
   // So expect focus to be synchronous when the element is already active,
   // and blur to be synchronous when the element is not already active.
   // (focus and blur are always synchronous in other supported browsers,
   // this just defines when we can count on it).
   function expectSync( elem, type ) {
	   return ( elem === safeActiveElement() ) === ( type === "focus" );
   }
   
   // Support: IE <=9 only
   // Accessing document.activeElement can throw unexpectedly
   // https://bugs.jquery.com/ticket/13393
   function safeActiveElement() {
	   try {
		   return document.activeElement;
	   } catch ( err ) { }
   }
   
   function on( elem, types, selector, data, fn, one ) {
	   var origFn, type;
   
	   // Types can be a map of types/handlers
	   if ( typeof types === "object" ) {
   
		   // ( types-Object, selector, data )
		   if ( typeof selector !== "string" ) {
   
			   // ( types-Object, data )
			   data = data || selector;
			   selector = undefined;
		   }
		   for ( type in types ) {
			   on( elem, type, selector, data, types[ type ], one );
		   }
		   return elem;
	   }
   
	   if ( data == null && fn == null ) {
   
		   // ( types, fn )
		   fn = selector;
		   data = selector = undefined;
	   } else if ( fn == null ) {
		   if ( typeof selector === "string" ) {
   
			   // ( types, selector, fn )
			   fn = data;
			   data = undefined;
		   } else {
   
			   // ( types, data, fn )
			   fn = data;
			   data = selector;
			   selector = undefined;
		   }
	   }
	   if ( fn === false ) {
		   fn = returnFalse;
	   } else if ( !fn ) {
		   return elem;
	   }
   
	   if ( one === 1 ) {
		   origFn = fn;
		   fn = function( event ) {
   
			   // Can use an empty set, since event contains the info
			   jQuery().off( event );
			   return origFn.apply( this, arguments );
		   };
   
		   // Use same guid so caller can remove using origFn
		   fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	   }
	   return elem.each( function() {
		   jQuery.event.add( this, types, fn, data, selector );
	   } );
   }
   
   /*
	* Helper functions for managing events -- not part of the public interface.
	* Props to Dean Edwards' addEvent library for many of the ideas.
	*/
   jQuery.event = {
   
	   global: {},
   
	   add: function( elem, types, handler, data, selector ) {
   
		   var handleObjIn, eventHandle, tmp,
			   events, t, handleObj,
			   special, handlers, type, namespaces, origType,
			   elemData = dataPriv.get( elem );
   
		   // Don't attach events to noData or text/comment nodes (but allow plain objects)
		   if ( !elemData ) {
			   return;
		   }
   
		   // Caller can pass in an object of custom data in lieu of the handler
		   if ( handler.handler ) {
			   handleObjIn = handler;
			   handler = handleObjIn.handler;
			   selector = handleObjIn.selector;
		   }
   
		   // Ensure that invalid selectors throw exceptions at attach time
		   // Evaluate against documentElement in case elem is a non-element node (e.g., document)
		   if ( selector ) {
			   jQuery.find.matchesSelector( documentElement, selector );
		   }
   
		   // Make sure that the handler has a unique ID, used to find/remove it later
		   if ( !handler.guid ) {
			   handler.guid = jQuery.guid++;
		   }
   
		   // Init the element's event structure and main handler, if this is the first
		   if ( !( events = elemData.events ) ) {
			   events = elemData.events = {};
		   }
		   if ( !( eventHandle = elemData.handle ) ) {
			   eventHandle = elemData.handle = function( e ) {
   
				   // Discard the second event of a jQuery.event.trigger() and
				   // when an event is called after a page has unloaded
				   return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					   jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			   };
		   }
   
		   // Handle multiple events separated by a space
		   types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		   t = types.length;
		   while ( t-- ) {
			   tmp = rtypenamespace.exec( types[ t ] ) || [];
			   type = origType = tmp[ 1 ];
			   namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
   
			   // There *must* be a type, no attaching namespace-only handlers
			   if ( !type ) {
				   continue;
			   }
   
			   // If event changes its type, use the special event handlers for the changed type
			   special = jQuery.event.special[ type ] || {};
   
			   // If selector defined, determine special event api type, otherwise given type
			   type = ( selector ? special.delegateType : special.bindType ) || type;
   
			   // Update special based on newly reset type
			   special = jQuery.event.special[ type ] || {};
   
			   // handleObj is passed to all event handlers
			   handleObj = jQuery.extend( {
				   type: type,
				   origType: origType,
				   data: data,
				   handler: handler,
				   guid: handler.guid,
				   selector: selector,
				   needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				   namespace: namespaces.join( "." )
			   }, handleObjIn );
   
			   // Init the event handler queue if we're the first
			   if ( !( handlers = events[ type ] ) ) {
				   handlers = events[ type ] = [];
				   handlers.delegateCount = 0;
   
				   // Only use addEventListener if the special events handler returns false
				   if ( !special.setup ||
					   special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
   
					   if ( elem.addEventListener ) {
						   elem.addEventListener( type, eventHandle );
					   }
				   }
			   }
   
			   if ( special.add ) {
				   special.add.call( elem, handleObj );
   
				   if ( !handleObj.handler.guid ) {
					   handleObj.handler.guid = handler.guid;
				   }
			   }
   
			   // Add to the element's handler list, delegates in front
			   if ( selector ) {
				   handlers.splice( handlers.delegateCount++, 0, handleObj );
			   } else {
				   handlers.push( handleObj );
			   }
   
			   // Keep track of which events have ever been used, for event optimization
			   jQuery.event.global[ type ] = true;
		   }
   
	   },
   
	   // Detach an event or set of events from an element
	   remove: function( elem, types, handler, selector, mappedTypes ) {
   
		   var j, origCount, tmp,
			   events, t, handleObj,
			   special, handlers, type, namespaces, origType,
			   elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
   
		   if ( !elemData || !( events = elemData.events ) ) {
			   return;
		   }
   
		   // Once for each type.namespace in types; type may be omitted
		   types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		   t = types.length;
		   while ( t-- ) {
			   tmp = rtypenamespace.exec( types[ t ] ) || [];
			   type = origType = tmp[ 1 ];
			   namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
   
			   // Unbind all events (on this namespace, if provided) for the element
			   if ( !type ) {
				   for ( type in events ) {
					   jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				   }
				   continue;
			   }
   
			   special = jQuery.event.special[ type ] || {};
			   type = ( selector ? special.delegateType : special.bindType ) || type;
			   handlers = events[ type ] || [];
			   tmp = tmp[ 2 ] &&
				   new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
   
			   // Remove matching events
			   origCount = j = handlers.length;
			   while ( j-- ) {
				   handleObj = handlers[ j ];
   
				   if ( ( mappedTypes || origType === handleObj.origType ) &&
					   ( !handler || handler.guid === handleObj.guid ) &&
					   ( !tmp || tmp.test( handleObj.namespace ) ) &&
					   ( !selector || selector === handleObj.selector ||
						   selector === "**" && handleObj.selector ) ) {
					   handlers.splice( j, 1 );
   
					   if ( handleObj.selector ) {
						   handlers.delegateCount--;
					   }
					   if ( special.remove ) {
						   special.remove.call( elem, handleObj );
					   }
				   }
			   }
   
			   // Remove generic event handler if we removed something and no more handlers exist
			   // (avoids potential for endless recursion during removal of special event handlers)
			   if ( origCount && !handlers.length ) {
				   if ( !special.teardown ||
					   special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
   
					   jQuery.removeEvent( elem, type, elemData.handle );
				   }
   
				   delete events[ type ];
			   }
		   }
   
		   // Remove data and the expando if it's no longer used
		   if ( jQuery.isEmptyObject( events ) ) {
			   dataPriv.remove( elem, "handle events" );
		   }
	   },
   
	   dispatch: function( nativeEvent ) {
   
		   // Make a writable jQuery.Event from the native event object
		   var event = jQuery.event.fix( nativeEvent );
   
		   var i, j, ret, matched, handleObj, handlerQueue,
			   args = new Array( arguments.length ),
			   handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			   special = jQuery.event.special[ event.type ] || {};
   
		   // Use the fix-ed jQuery.Event rather than the (read-only) native event
		   args[ 0 ] = event;
   
		   for ( i = 1; i < arguments.length; i++ ) {
			   args[ i ] = arguments[ i ];
		   }
   
		   event.delegateTarget = this;
   
		   // Call the preDispatch hook for the mapped type, and let it bail if desired
		   if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			   return;
		   }
   
		   // Determine handlers
		   handlerQueue = jQuery.event.handlers.call( this, event, handlers );
   
		   // Run delegates first; they may want to stop propagation beneath us
		   i = 0;
		   while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			   event.currentTarget = matched.elem;
   
			   j = 0;
			   while ( ( handleObj = matched.handlers[ j++ ] ) &&
				   !event.isImmediatePropagationStopped() ) {
   
				   // If the event is namespaced, then each handler is only invoked if it is
				   // specially universal or its namespaces are a superset of the event's.
				   if ( !event.rnamespace || handleObj.namespace === false ||
					   event.rnamespace.test( handleObj.namespace ) ) {
   
					   event.handleObj = handleObj;
					   event.data = handleObj.data;
   
					   ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						   handleObj.handler ).apply( matched.elem, args );
   
					   if ( ret !== undefined ) {
						   if ( ( event.result = ret ) === false ) {
							   event.preventDefault();
							   event.stopPropagation();
						   }
					   }
				   }
			   }
		   }
   
		   // Call the postDispatch hook for the mapped type
		   if ( special.postDispatch ) {
			   special.postDispatch.call( this, event );
		   }
   
		   return event.result;
	   },
   
	   handlers: function( event, handlers ) {
		   var i, handleObj, sel, matchedHandlers, matchedSelectors,
			   handlerQueue = [],
			   delegateCount = handlers.delegateCount,
			   cur = event.target;
   
		   // Find delegate handlers
		   if ( delegateCount &&
   
			   // Support: IE <=9
			   // Black-hole SVG <use> instance trees (trac-13180)
			   cur.nodeType &&
   
			   // Support: Firefox <=42
			   // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			   // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			   // Support: IE 11 only
			   // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			   !( event.type === "click" && event.button >= 1 ) ) {
   
			   for ( ; cur !== this; cur = cur.parentNode || this ) {
   
				   // Don't check non-elements (#13208)
				   // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				   if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					   matchedHandlers = [];
					   matchedSelectors = {};
					   for ( i = 0; i < delegateCount; i++ ) {
						   handleObj = handlers[ i ];
   
						   // Don't conflict with Object.prototype properties (#13203)
						   sel = handleObj.selector + " ";
   
						   if ( matchedSelectors[ sel ] === undefined ) {
							   matchedSelectors[ sel ] = handleObj.needsContext ?
								   jQuery( sel, this ).index( cur ) > -1 :
								   jQuery.find( sel, this, null, [ cur ] ).length;
						   }
						   if ( matchedSelectors[ sel ] ) {
							   matchedHandlers.push( handleObj );
						   }
					   }
					   if ( matchedHandlers.length ) {
						   handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					   }
				   }
			   }
		   }
   
		   // Add the remaining (directly-bound) handlers
		   cur = this;
		   if ( delegateCount < handlers.length ) {
			   handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		   }
   
		   return handlerQueue;
	   },
   
	   addProp: function( name, hook ) {
		   Object.defineProperty( jQuery.Event.prototype, name, {
			   enumerable: true,
			   configurable: true,
   
			   get: isFunction( hook ) ?
				   function() {
					   if ( this.originalEvent ) {
							   return hook( this.originalEvent );
					   }
				   } :
				   function() {
					   if ( this.originalEvent ) {
							   return this.originalEvent[ name ];
					   }
				   },
   
			   set: function( value ) {
				   Object.defineProperty( this, name, {
					   enumerable: true,
					   configurable: true,
					   writable: true,
					   value: value
				   } );
			   }
		   } );
	   },
   
	   fix: function( originalEvent ) {
		   return originalEvent[ jQuery.expando ] ?
			   originalEvent :
			   new jQuery.Event( originalEvent );
	   },
   
	   special: {
		   load: {
   
			   // Prevent triggered image.load events from bubbling to window.load
			   noBubble: true
		   },
		   click: {
   
			   // Utilize native event to ensure correct state for checkable inputs
			   setup: function( data ) {
   
				   // For mutual compressibility with _default, replace `this` access with a local var.
				   // `|| data` is dead code meant only to preserve the variable through minification.
				   var el = this || data;
   
				   // Claim the first handler
				   if ( rcheckableType.test( el.type ) &&
					   el.click && nodeName( el, "input" ) ) {
   
					   // dataPriv.set( el, "click", ... )
					   leverageNative( el, "click", returnTrue );
				   }
   
				   // Return false to allow normal processing in the caller
				   return false;
			   },
			   trigger: function( data ) {
   
				   // For mutual compressibility with _default, replace `this` access with a local var.
				   // `|| data` is dead code meant only to preserve the variable through minification.
				   var el = this || data;
   
				   // Force setup before triggering a click
				   if ( rcheckableType.test( el.type ) &&
					   el.click && nodeName( el, "input" ) ) {
   
					   leverageNative( el, "click" );
				   }
   
				   // Return non-false to allow normal event-path propagation
				   return true;
			   },
   
			   // For cross-browser consistency, suppress native .click() on links
			   // Also prevent it if we're currently inside a leveraged native-event stack
			   _default: function( event ) {
				   var target = event.target;
				   return rcheckableType.test( target.type ) &&
					   target.click && nodeName( target, "input" ) &&
					   dataPriv.get( target, "click" ) ||
					   nodeName( target, "a" );
			   }
		   },
   
		   beforeunload: {
			   postDispatch: function( event ) {
   
				   // Support: Firefox 20+
				   // Firefox doesn't alert if the returnValue field is not set.
				   if ( event.result !== undefined && event.originalEvent ) {
					   event.originalEvent.returnValue = event.result;
				   }
			   }
		   }
	   }
   };
   
   // Ensure the presence of an event listener that handles manually-triggered
   // synthetic events by interrupting progress until reinvoked in response to
   // *native* events that it fires directly, ensuring that state changes have
   // already occurred before other listeners are invoked.
   function leverageNative( el, type, expectSync ) {
   
	   // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	   if ( !expectSync ) {
		   if ( dataPriv.get( el, type ) === undefined ) {
			   jQuery.event.add( el, type, returnTrue );
		   }
		   return;
	   }
   
	   // Register the controller as a special universal handler for all event namespaces
	   dataPriv.set( el, type, false );
	   jQuery.event.add( el, type, {
		   namespace: false,
		   handler: function( event ) {
			   var notAsync, result,
				   saved = dataPriv.get( this, type );
   
			   if ( ( event.isTrigger & 1 ) && this[ type ] ) {
   
				   // Interrupt processing of the outer synthetic .trigger()ed event
				   // Saved data should be false in such cases, but might be a leftover capture object
				   // from an async native handler (gh-4350)
				   if ( !saved.length ) {
   
					   // Store arguments for use when handling the inner native event
					   // There will always be at least one argument (an event object), so this array
					   // will not be confused with a leftover capture object.
					   saved = slice.call( arguments );
					   dataPriv.set( this, type, saved );
   
					   // Trigger the native event and capture its result
					   // Support: IE <=9 - 11+
					   // focus() and blur() are asynchronous
					   notAsync = expectSync( this, type );
					   this[ type ]();
					   result = dataPriv.get( this, type );
					   if ( saved !== result || notAsync ) {
						   dataPriv.set( this, type, false );
					   } else {
						   result = {};
					   }
					   if ( saved !== result ) {
   
						   // Cancel the outer synthetic event
						   event.stopImmediatePropagation();
						   event.preventDefault();
						   return result.value;
					   }
   
				   // If this is an inner synthetic event for an event with a bubbling surrogate
				   // (focus or blur), assume that the surrogate already propagated from triggering the
				   // native event and prevent that from happening again here.
				   // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				   // bubbling surrogate propagates *after* the non-bubbling base), but that seems
				   // less bad than duplication.
				   } else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					   event.stopPropagation();
				   }
   
			   // If this is a native event triggered above, everything is now in order
			   // Fire an inner synthetic event with the original arguments
			   } else if ( saved.length ) {
   
				   // ...and capture the result
				   dataPriv.set( this, type, {
					   value: jQuery.event.trigger(
   
						   // Support: IE <=9 - 11+
						   // Extend with the prototype to reset the above stopImmediatePropagation()
						   jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						   saved.slice( 1 ),
						   this
					   )
				   } );
   
				   // Abort handling of the native event
				   event.stopImmediatePropagation();
			   }
		   }
	   } );
   }
   
   jQuery.removeEvent = function( elem, type, handle ) {
   
	   // This "if" is needed for plain objects
	   if ( elem.removeEventListener ) {
		   elem.removeEventListener( type, handle );
	   }
   };
   
   jQuery.Event = function( src, props ) {
   
	   // Allow instantiation without the 'new' keyword
	   if ( !( this instanceof jQuery.Event ) ) {
		   return new jQuery.Event( src, props );
	   }
   
	   // Event object
	   if ( src && src.type ) {
		   this.originalEvent = src;
		   this.type = src.type;
   
		   // Events bubbling up the document may have been marked as prevented
		   // by a handler lower down the tree; reflect the correct value.
		   this.isDefaultPrevented = src.defaultPrevented ||
				   src.defaultPrevented === undefined &&
   
				   // Support: Android <=2.3 only
				   src.returnValue === false ?
			   returnTrue :
			   returnFalse;
   
		   // Create target properties
		   // Support: Safari <=6 - 7 only
		   // Target should not be a text node (#504, #13143)
		   this.target = ( src.target && src.target.nodeType === 3 ) ?
			   src.target.parentNode :
			   src.target;
   
		   this.currentTarget = src.currentTarget;
		   this.relatedTarget = src.relatedTarget;
   
	   // Event type
	   } else {
		   this.type = src;
	   }
   
	   // Put explicitly provided properties onto the event object
	   if ( props ) {
		   jQuery.extend( this, props );
	   }
   
	   // Create a timestamp if incoming event doesn't have one
	   this.timeStamp = src && src.timeStamp || Date.now();
   
	   // Mark it as fixed
	   this[ jQuery.expando ] = true;
   };
   
   // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
   // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
   jQuery.Event.prototype = {
	   constructor: jQuery.Event,
	   isDefaultPrevented: returnFalse,
	   isPropagationStopped: returnFalse,
	   isImmediatePropagationStopped: returnFalse,
	   isSimulated: false,
   
	   preventDefault: function() {
		   var e = this.originalEvent;
   
		   this.isDefaultPrevented = returnTrue;
   
		   if ( e && !this.isSimulated ) {
			   e.preventDefault();
		   }
	   },
	   stopPropagation: function() {
		   var e = this.originalEvent;
   
		   this.isPropagationStopped = returnTrue;
   
		   if ( e && !this.isSimulated ) {
			   e.stopPropagation();
		   }
	   },
	   stopImmediatePropagation: function() {
		   var e = this.originalEvent;
   
		   this.isImmediatePropagationStopped = returnTrue;
   
		   if ( e && !this.isSimulated ) {
			   e.stopImmediatePropagation();
		   }
   
		   this.stopPropagation();
	   }
   };
   
   // Includes all common event props including KeyEvent and MouseEvent specific props
   jQuery.each( {
	   altKey: true,
	   bubbles: true,
	   cancelable: true,
	   changedTouches: true,
	   ctrlKey: true,
	   detail: true,
	   eventPhase: true,
	   metaKey: true,
	   pageX: true,
	   pageY: true,
	   shiftKey: true,
	   view: true,
	   "char": true,
	   code: true,
	   charCode: true,
	   key: true,
	   keyCode: true,
	   button: true,
	   buttons: true,
	   clientX: true,
	   clientY: true,
	   offsetX: true,
	   offsetY: true,
	   pointerId: true,
	   pointerType: true,
	   screenX: true,
	   screenY: true,
	   targetTouches: true,
	   toElement: true,
	   touches: true,
   
	   which: function( event ) {
		   var button = event.button;
   
		   // Add which for key events
		   if ( event.which == null && rkeyEvent.test( event.type ) ) {
			   return event.charCode != null ? event.charCode : event.keyCode;
		   }
   
		   // Add which for click: 1 === left; 2 === middle; 3 === right
		   if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			   if ( button & 1 ) {
				   return 1;
			   }
   
			   if ( button & 2 ) {
				   return 3;
			   }
   
			   if ( button & 4 ) {
				   return 2;
			   }
   
			   return 0;
		   }
   
		   return event.which;
	   }
   }, jQuery.event.addProp );
   
   jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	   jQuery.event.special[ type ] = {
   
		   // Utilize native event if possible so blur/focus sequence is correct
		   setup: function() {
   
			   // Claim the first handler
			   // dataPriv.set( this, "focus", ... )
			   // dataPriv.set( this, "blur", ... )
			   leverageNative( this, type, expectSync );
   
			   // Return false to allow normal processing in the caller
			   return false;
		   },
		   trigger: function() {
   
			   // Force setup before trigger
			   leverageNative( this, type );
   
			   // Return non-false to allow normal event-path propagation
			   return true;
		   },
   
		   delegateType: delegateType
	   };
   } );
   
   // Create mouseenter/leave events using mouseover/out and event-time checks
   // so that event delegation works in jQuery.
   // Do the same for pointerenter/pointerleave and pointerover/pointerout
   //
   // Support: Safari 7 only
   // Safari sends mouseenter too often; see:
   // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
   // for the description of the bug (it existed in older Chrome versions as well).
   jQuery.each( {
	   mouseenter: "mouseover",
	   mouseleave: "mouseout",
	   pointerenter: "pointerover",
	   pointerleave: "pointerout"
   }, function( orig, fix ) {
	   jQuery.event.special[ orig ] = {
		   delegateType: fix,
		   bindType: fix,
   
		   handle: function( event ) {
			   var ret,
				   target = this,
				   related = event.relatedTarget,
				   handleObj = event.handleObj;
   
			   // For mouseenter/leave call the handler if related is outside the target.
			   // NB: No relatedTarget if the mouse left/entered the browser window
			   if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				   event.type = handleObj.origType;
				   ret = handleObj.handler.apply( this, arguments );
				   event.type = fix;
			   }
			   return ret;
		   }
	   };
   } );
   
   jQuery.fn.extend( {
   
	   on: function( types, selector, data, fn ) {
		   return on( this, types, selector, data, fn );
	   },
	   one: function( types, selector, data, fn ) {
		   return on( this, types, selector, data, fn, 1 );
	   },
	   off: function( types, selector, fn ) {
		   var handleObj, type;
		   if ( types && types.preventDefault && types.handleObj ) {
   
			   // ( event )  dispatched jQuery.Event
			   handleObj = types.handleObj;
			   jQuery( types.delegateTarget ).off(
				   handleObj.namespace ?
					   handleObj.origType + "." + handleObj.namespace :
					   handleObj.origType,
				   handleObj.selector,
				   handleObj.handler
			   );
			   return this;
		   }
		   if ( typeof types === "object" ) {
   
			   // ( types-object [, selector] )
			   for ( type in types ) {
				   this.off( type, selector, types[ type ] );
			   }
			   return this;
		   }
		   if ( selector === false || typeof selector === "function" ) {
   
			   // ( types [, fn] )
			   fn = selector;
			   selector = undefined;
		   }
		   if ( fn === false ) {
			   fn = returnFalse;
		   }
		   return this.each( function() {
			   jQuery.event.remove( this, types, fn, selector );
		   } );
	   }
   } );
   
   
   var
   
	   /* eslint-disable max-len */
   
	   // See https://github.com/eslint/eslint/issues/3229
	   rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
   
	   /* eslint-enable */
   
	   // Support: IE <=10 - 11, Edge 12 - 13 only
	   // In IE/Edge using regex groups here causes severe slowdowns.
	   // See https://connect.microsoft.com/IE/feedback/details/1736512/
	   rnoInnerhtml = /<script|<style|<link/i,
   
	   // checked="checked" or checked
	   rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	   rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
   
   // Prefer a tbody over its parent table for containing new rows
   function manipulationTarget( elem, content ) {
	   if ( nodeName( elem, "table" ) &&
		   nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
   
		   return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	   }
   
	   return elem;
   }
   
   // Replace/restore the type attribute of script elements for safe DOM manipulation
   function disableScript( elem ) {
	   elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	   return elem;
   }
   function restoreScript( elem ) {
	   if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		   elem.type = elem.type.slice( 5 );
	   } else {
		   elem.removeAttribute( "type" );
	   }
   
	   return elem;
   }
   
   function cloneCopyEvent( src, dest ) {
	   var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
   
	   if ( dest.nodeType !== 1 ) {
		   return;
	   }
   
	   // 1. Copy private data: events, handlers, etc.
	   if ( dataPriv.hasData( src ) ) {
		   pdataOld = dataPriv.access( src );
		   pdataCur = dataPriv.set( dest, pdataOld );
		   events = pdataOld.events;
   
		   if ( events ) {
			   delete pdataCur.handle;
			   pdataCur.events = {};
   
			   for ( type in events ) {
				   for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					   jQuery.event.add( dest, type, events[ type ][ i ] );
				   }
			   }
		   }
	   }
   
	   // 2. Copy user data
	   if ( dataUser.hasData( src ) ) {
		   udataOld = dataUser.access( src );
		   udataCur = jQuery.extend( {}, udataOld );
   
		   dataUser.set( dest, udataCur );
	   }
   }
   
   // Fix IE bugs, see support tests
   function fixInput( src, dest ) {
	   var nodeName = dest.nodeName.toLowerCase();
   
	   // Fails to persist the checked state of a cloned checkbox or radio button.
	   if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		   dest.checked = src.checked;
   
	   // Fails to return the selected option to the default selected state when cloning options
	   } else if ( nodeName === "input" || nodeName === "textarea" ) {
		   dest.defaultValue = src.defaultValue;
	   }
   }
   
   function domManip( collection, args, callback, ignored ) {
   
	   // Flatten any nested arrays
	   args = concat.apply( [], args );
   
	   var fragment, first, scripts, hasScripts, node, doc,
		   i = 0,
		   l = collection.length,
		   iNoClone = l - 1,
		   value = args[ 0 ],
		   valueIsFunction = isFunction( value );
   
	   // We can't cloneNode fragments that contain checked, in WebKit
	   if ( valueIsFunction ||
			   ( l > 1 && typeof value === "string" &&
				   !support.checkClone && rchecked.test( value ) ) ) {
		   return collection.each( function( index ) {
			   var self = collection.eq( index );
			   if ( valueIsFunction ) {
				   args[ 0 ] = value.call( this, index, self.html() );
			   }
			   domManip( self, args, callback, ignored );
		   } );
	   }
   
	   if ( l ) {
		   fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		   first = fragment.firstChild;
   
		   if ( fragment.childNodes.length === 1 ) {
			   fragment = first;
		   }
   
		   // Require either new content or an interest in ignored elements to invoke the callback
		   if ( first || ignored ) {
			   scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			   hasScripts = scripts.length;
   
			   // Use the original fragment for the last item
			   // instead of the first because it can end up
			   // being emptied incorrectly in certain situations (#8070).
			   for ( ; i < l; i++ ) {
				   node = fragment;
   
				   if ( i !== iNoClone ) {
					   node = jQuery.clone( node, true, true );
   
					   // Keep references to cloned scripts for later restoration
					   if ( hasScripts ) {
   
						   // Support: Android <=4.0 only, PhantomJS 1 only
						   // push.apply(_, arraylike) throws on ancient WebKit
						   jQuery.merge( scripts, getAll( node, "script" ) );
					   }
				   }
   
				   callback.call( collection[ i ], node, i );
			   }
   
			   if ( hasScripts ) {
				   doc = scripts[ scripts.length - 1 ].ownerDocument;
   
				   // Reenable scripts
				   jQuery.map( scripts, restoreScript );
   
				   // Evaluate executable scripts on first document insertion
				   for ( i = 0; i < hasScripts; i++ ) {
					   node = scripts[ i ];
					   if ( rscriptType.test( node.type || "" ) &&
						   !dataPriv.access( node, "globalEval" ) &&
						   jQuery.contains( doc, node ) ) {
   
						   if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
   
							   // Optional AJAX dependency, but won't run scripts if not present
							   if ( jQuery._evalUrl && !node.noModule ) {
								   jQuery._evalUrl( node.src, {
									   nonce: node.nonce || node.getAttribute( "nonce" )
								   } );
							   }
						   } else {
							   DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						   }
					   }
				   }
			   }
		   }
	   }
   
	   return collection;
   }
   
   function remove( elem, selector, keepData ) {
	   var node,
		   nodes = selector ? jQuery.filter( selector, elem ) : elem,
		   i = 0;
   
	   for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		   if ( !keepData && node.nodeType === 1 ) {
			   jQuery.cleanData( getAll( node ) );
		   }
   
		   if ( node.parentNode ) {
			   if ( keepData && isAttached( node ) ) {
				   setGlobalEval( getAll( node, "script" ) );
			   }
			   node.parentNode.removeChild( node );
		   }
	   }
   
	   return elem;
   }
   
   jQuery.extend( {
	   htmlPrefilter: function( html ) {
		   return html.replace( rxhtmlTag, "<$1></$2>" );
	   },
   
	   clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		   var i, l, srcElements, destElements,
			   clone = elem.cloneNode( true ),
			   inPage = isAttached( elem );
   
		   // Fix IE cloning issues
		   if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				   !jQuery.isXMLDoc( elem ) ) {
   
			   // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			   destElements = getAll( clone );
			   srcElements = getAll( elem );
   
			   for ( i = 0, l = srcElements.length; i < l; i++ ) {
				   fixInput( srcElements[ i ], destElements[ i ] );
			   }
		   }
   
		   // Copy the events from the original to the clone
		   if ( dataAndEvents ) {
			   if ( deepDataAndEvents ) {
				   srcElements = srcElements || getAll( elem );
				   destElements = destElements || getAll( clone );
   
				   for ( i = 0, l = srcElements.length; i < l; i++ ) {
					   cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				   }
			   } else {
				   cloneCopyEvent( elem, clone );
			   }
		   }
   
		   // Preserve script evaluation history
		   destElements = getAll( clone, "script" );
		   if ( destElements.length > 0 ) {
			   setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		   }
   
		   // Return the cloned set
		   return clone;
	   },
   
	   cleanData: function( elems ) {
		   var data, elem, type,
			   special = jQuery.event.special,
			   i = 0;
   
		   for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			   if ( acceptData( elem ) ) {
				   if ( ( data = elem[ dataPriv.expando ] ) ) {
					   if ( data.events ) {
						   for ( type in data.events ) {
							   if ( special[ type ] ) {
								   jQuery.event.remove( elem, type );
   
							   // This is a shortcut to avoid jQuery.event.remove's overhead
							   } else {
								   jQuery.removeEvent( elem, type, data.handle );
							   }
						   }
					   }
   
					   // Support: Chrome <=35 - 45+
					   // Assign undefined instead of using delete, see Data#remove
					   elem[ dataPriv.expando ] = undefined;
				   }
				   if ( elem[ dataUser.expando ] ) {
   
					   // Support: Chrome <=35 - 45+
					   // Assign undefined instead of using delete, see Data#remove
					   elem[ dataUser.expando ] = undefined;
				   }
			   }
		   }
	   }
   } );
   
   jQuery.fn.extend( {
	   detach: function( selector ) {
		   return remove( this, selector, true );
	   },
   
	   remove: function( selector ) {
		   return remove( this, selector );
	   },
   
	   text: function( value ) {
		   return access( this, function( value ) {
			   return value === undefined ?
				   jQuery.text( this ) :
				   this.empty().each( function() {
					   if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						   this.textContent = value;
					   }
				   } );
		   }, null, value, arguments.length );
	   },
   
	   append: function() {
		   return domManip( this, arguments, function( elem ) {
			   if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				   var target = manipulationTarget( this, elem );
				   target.appendChild( elem );
			   }
		   } );
	   },
   
	   prepend: function() {
		   return domManip( this, arguments, function( elem ) {
			   if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				   var target = manipulationTarget( this, elem );
				   target.insertBefore( elem, target.firstChild );
			   }
		   } );
	   },
   
	   before: function() {
		   return domManip( this, arguments, function( elem ) {
			   if ( this.parentNode ) {
				   this.parentNode.insertBefore( elem, this );
			   }
		   } );
	   },
   
	   after: function() {
		   return domManip( this, arguments, function( elem ) {
			   if ( this.parentNode ) {
				   this.parentNode.insertBefore( elem, this.nextSibling );
			   }
		   } );
	   },
   
	   empty: function() {
		   var elem,
			   i = 0;
   
		   for ( ; ( elem = this[ i ] ) != null; i++ ) {
			   if ( elem.nodeType === 1 ) {
   
				   // Prevent memory leaks
				   jQuery.cleanData( getAll( elem, false ) );
   
				   // Remove any remaining nodes
				   elem.textContent = "";
			   }
		   }
   
		   return this;
	   },
   
	   clone: function( dataAndEvents, deepDataAndEvents ) {
		   dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		   deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
   
		   return this.map( function() {
			   return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		   } );
	   },
   
	   html: function( value ) {
		   return access( this, function( value ) {
			   var elem = this[ 0 ] || {},
				   i = 0,
				   l = this.length;
   
			   if ( value === undefined && elem.nodeType === 1 ) {
				   return elem.innerHTML;
			   }
   
			   // See if we can take a shortcut and just use innerHTML
			   if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				   !wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
   
				   value = jQuery.htmlPrefilter( value );
   
				   try {
					   for ( ; i < l; i++ ) {
						   elem = this[ i ] || {};
   
						   // Remove element nodes and prevent memory leaks
						   if ( elem.nodeType === 1 ) {
							   jQuery.cleanData( getAll( elem, false ) );
							   elem.innerHTML = value;
						   }
					   }
   
					   elem = 0;
   
				   // If using innerHTML throws an exception, use the fallback method
				   } catch ( e ) {}
			   }
   
			   if ( elem ) {
				   this.empty().append( value );
			   }
		   }, null, value, arguments.length );
	   },
   
	   replaceWith: function() {
		   var ignored = [];
   
		   // Make the changes, replacing each non-ignored context element with the new content
		   return domManip( this, arguments, function( elem ) {
			   var parent = this.parentNode;
   
			   if ( jQuery.inArray( this, ignored ) < 0 ) {
				   jQuery.cleanData( getAll( this ) );
				   if ( parent ) {
					   parent.replaceChild( elem, this );
				   }
			   }
   
		   // Force callback invocation
		   }, ignored );
	   }
   } );
   
   jQuery.each( {
	   appendTo: "append",
	   prependTo: "prepend",
	   insertBefore: "before",
	   insertAfter: "after",
	   replaceAll: "replaceWith"
   }, function( name, original ) {
	   jQuery.fn[ name ] = function( selector ) {
		   var elems,
			   ret = [],
			   insert = jQuery( selector ),
			   last = insert.length - 1,
			   i = 0;
   
		   for ( ; i <= last; i++ ) {
			   elems = i === last ? this : this.clone( true );
			   jQuery( insert[ i ] )[ original ]( elems );
   
			   // Support: Android <=4.0 only, PhantomJS 1 only
			   // .get() because push.apply(_, arraylike) throws on ancient WebKit
			   push.apply( ret, elems.get() );
		   }
   
		   return this.pushStack( ret );
	   };
   } );
   var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
   
   var getStyles = function( elem ) {
   
		   // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		   // IE throws on elements created in popups
		   // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		   var view = elem.ownerDocument.defaultView;
   
		   if ( !view || !view.opener ) {
			   view = window;
		   }
   
		   return view.getComputedStyle( elem );
	   };
   
   var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
   
   
   
   ( function() {
   
	   // Executing both pixelPosition & boxSizingReliable tests require only one layout
	   // so they're executed at the same time to save the second computation.
	   function computeStyleTests() {
   
		   // This is a singleton, we need to execute it only once
		   if ( !div ) {
			   return;
		   }
   
		   container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			   "margin-top:1px;padding:0;border:0";
		   div.style.cssText =
			   "position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			   "margin:auto;border:1px;padding:1px;" +
			   "width:60%;top:1%";
		   documentElement.appendChild( container ).appendChild( div );
   
		   var divStyle = window.getComputedStyle( div );
		   pixelPositionVal = divStyle.top !== "1%";
   
		   // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		   reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
   
		   // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		   // Some styles come back with percentage values, even though they shouldn't
		   div.style.right = "60%";
		   pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
   
		   // Support: IE 9 - 11 only
		   // Detect misreporting of content dimensions for box-sizing:border-box elements
		   boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
   
		   // Support: IE 9 only
		   // Detect overflow:scroll screwiness (gh-3699)
		   // Support: Chrome <=64
		   // Don't get tricked when zoom affects offsetWidth (gh-4029)
		   div.style.position = "absolute";
		   scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
   
		   documentElement.removeChild( container );
   
		   // Nullify the div so it wouldn't be stored in the memory and
		   // it will also be a sign that checks already performed
		   div = null;
	   }
   
	   function roundPixelMeasures( measure ) {
		   return Math.round( parseFloat( measure ) );
	   }
   
	   var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		   reliableMarginLeftVal,
		   container = document.createElement( "div" ),
		   div = document.createElement( "div" );
   
	   // Finish early in limited (non-browser) environments
	   if ( !div.style ) {
		   return;
	   }
   
	   // Support: IE <=9 - 11 only
	   // Style of cloned element affects source element cloned (#8908)
	   div.style.backgroundClip = "content-box";
	   div.cloneNode( true ).style.backgroundClip = "";
	   support.clearCloneStyle = div.style.backgroundClip === "content-box";
   
	   jQuery.extend( support, {
		   boxSizingReliable: function() {
			   computeStyleTests();
			   return boxSizingReliableVal;
		   },
		   pixelBoxStyles: function() {
			   computeStyleTests();
			   return pixelBoxStylesVal;
		   },
		   pixelPosition: function() {
			   computeStyleTests();
			   return pixelPositionVal;
		   },
		   reliableMarginLeft: function() {
			   computeStyleTests();
			   return reliableMarginLeftVal;
		   },
		   scrollboxSize: function() {
			   computeStyleTests();
			   return scrollboxSizeVal;
		   }
	   } );
   } )();
   
   
   function curCSS( elem, name, computed ) {
	   var width, minWidth, maxWidth, ret,
   
		   // Support: Firefox 51+
		   // Retrieving style before computed somehow
		   // fixes an issue with getting wrong values
		   // on detached elements
		   style = elem.style;
   
	   computed = computed || getStyles( elem );
   
	   // getPropertyValue is needed for:
	   //   .css('filter') (IE 9 only, #12537)
	   //   .css('--customProperty) (#3144)
	   if ( computed ) {
		   ret = computed.getPropertyValue( name ) || computed[ name ];
   
		   if ( ret === "" && !isAttached( elem ) ) {
			   ret = jQuery.style( elem, name );
		   }
   
		   // A tribute to the "awesome hack by Dean Edwards"
		   // Android Browser returns percentage for some values,
		   // but width seems to be reliably pixels.
		   // This is against the CSSOM draft spec:
		   // https://drafts.csswg.org/cssom/#resolved-values
		   if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
   
			   // Remember the original values
			   width = style.width;
			   minWidth = style.minWidth;
			   maxWidth = style.maxWidth;
   
			   // Put in the new values to get a computed value out
			   style.minWidth = style.maxWidth = style.width = ret;
			   ret = computed.width;
   
			   // Revert the changed values
			   style.width = width;
			   style.minWidth = minWidth;
			   style.maxWidth = maxWidth;
		   }
	   }
   
	   return ret !== undefined ?
   
		   // Support: IE <=9 - 11 only
		   // IE returns zIndex value as an integer.
		   ret + "" :
		   ret;
   }
   
   
   function addGetHookIf( conditionFn, hookFn ) {
   
	   // Define the hook, we'll check on the first run if it's really needed.
	   return {
		   get: function() {
			   if ( conditionFn() ) {
   
				   // Hook not needed (or it's not possible to use it due
				   // to missing dependency), remove it.
				   delete this.get;
				   return;
			   }
   
			   // Hook needed; redefine it so that the support test is not executed again.
			   return ( this.get = hookFn ).apply( this, arguments );
		   }
	   };
   }
   
   
   var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	   emptyStyle = document.createElement( "div" ).style,
	   vendorProps = {};
   
   // Return a vendor-prefixed property or undefined
   function vendorPropName( name ) {
   
	   // Check for vendor prefixed names
	   var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		   i = cssPrefixes.length;
   
	   while ( i-- ) {
		   name = cssPrefixes[ i ] + capName;
		   if ( name in emptyStyle ) {
			   return name;
		   }
	   }
   }
   
   // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
   function finalPropName( name ) {
	   var final = jQuery.cssProps[ name ] || vendorProps[ name ];
   
	   if ( final ) {
		   return final;
	   }
	   if ( name in emptyStyle ) {
		   return name;
	   }
	   return vendorProps[ name ] = vendorPropName( name ) || name;
   }
   
   
   var
   
	   // Swappable if display is none or starts with table
	   // except "table", "table-cell", or "table-caption"
	   // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	   rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	   rcustomProp = /^--/,
	   cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	   cssNormalTransform = {
		   letterSpacing: "0",
		   fontWeight: "400"
	   };
   
   function setPositiveNumber( elem, value, subtract ) {
   
	   // Any relative (+/-) values have already been
	   // normalized at this point
	   var matches = rcssNum.exec( value );
	   return matches ?
   
		   // Guard against undefined "subtract", e.g., when used as in cssHooks
		   Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		   value;
   }
   
   function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	   var i = dimension === "width" ? 1 : 0,
		   extra = 0,
		   delta = 0;
   
	   // Adjustment may not be necessary
	   if ( box === ( isBorderBox ? "border" : "content" ) ) {
		   return 0;
	   }
   
	   for ( ; i < 4; i += 2 ) {
   
		   // Both box models exclude margin
		   if ( box === "margin" ) {
			   delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		   }
   
		   // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		   if ( !isBorderBox ) {
   
			   // Add padding
			   delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
   
			   // For "border" or "margin", add border
			   if ( box !== "padding" ) {
				   delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
   
			   // But still keep track of it otherwise
			   } else {
				   extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			   }
   
		   // If we get here with a border-box (content + padding + border), we're seeking "content" or
		   // "padding" or "margin"
		   } else {
   
			   // For "content", subtract padding
			   if ( box === "content" ) {
				   delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			   }
   
			   // For "content" or "padding", subtract border
			   if ( box !== "margin" ) {
				   delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			   }
		   }
	   }
   
	   // Account for positive content-box scroll gutter when requested by providing computedVal
	   if ( !isBorderBox && computedVal >= 0 ) {
   
		   // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		   // Assuming integer scroll gutter, subtract the rest and round down
		   delta += Math.max( 0, Math.ceil(
			   elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			   computedVal -
			   delta -
			   extra -
			   0.5
   
		   // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		   // Use an explicit zero to avoid NaN (gh-3964)
		   ) ) || 0;
	   }
   
	   return delta;
   }
   
   function getWidthOrHeight( elem, dimension, extra ) {
   
	   // Start with computed style
	   var styles = getStyles( elem ),
   
		   // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		   // Fake content-box until we know it's needed to know the true value.
		   boxSizingNeeded = !support.boxSizingReliable() || extra,
		   isBorderBox = boxSizingNeeded &&
			   jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		   valueIsBorderBox = isBorderBox,
   
		   val = curCSS( elem, dimension, styles ),
		   offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
   
	   // Support: Firefox <=54
	   // Return a confounding non-pixel value or feign ignorance, as appropriate.
	   if ( rnumnonpx.test( val ) ) {
		   if ( !extra ) {
			   return val;
		   }
		   val = "auto";
	   }
   
   
	   // Fall back to offsetWidth/offsetHeight when value is "auto"
	   // This happens for inline elements with no explicit setting (gh-3571)
	   // Support: Android <=4.1 - 4.3 only
	   // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	   // Support: IE 9-11 only
	   // Also use offsetWidth/offsetHeight for when box sizing is unreliable
	   // We use getClientRects() to check for hidden/disconnected.
	   // In those cases, the computed value can be trusted to be border-box
	   if ( ( !support.boxSizingReliable() && isBorderBox ||
		   val === "auto" ||
		   !parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
		   elem.getClientRects().length ) {
   
		   isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
   
		   // Where available, offsetWidth/offsetHeight approximate border box dimensions.
		   // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		   // retrieved value as a content box dimension.
		   valueIsBorderBox = offsetProp in elem;
		   if ( valueIsBorderBox ) {
			   val = elem[ offsetProp ];
		   }
	   }
   
	   // Normalize "" and auto
	   val = parseFloat( val ) || 0;
   
	   // Adjust for the element's box model
	   return ( val +
		   boxModelAdjustment(
			   elem,
			   dimension,
			   extra || ( isBorderBox ? "border" : "content" ),
			   valueIsBorderBox,
			   styles,
   
			   // Provide the current computed size to request scroll gutter calculation (gh-3589)
			   val
		   )
	   ) + "px";
   }
   
   jQuery.extend( {
   
	   // Add in style property hooks for overriding the default
	   // behavior of getting and setting a style property
	   cssHooks: {
		   opacity: {
			   get: function( elem, computed ) {
				   if ( computed ) {
   
					   // We should always get a number back from opacity
					   var ret = curCSS( elem, "opacity" );
					   return ret === "" ? "1" : ret;
				   }
			   }
		   }
	   },
   
	   // Don't automatically add "px" to these possibly-unitless properties
	   cssNumber: {
		   "animationIterationCount": true,
		   "columnCount": true,
		   "fillOpacity": true,
		   "flexGrow": true,
		   "flexShrink": true,
		   "fontWeight": true,
		   "gridArea": true,
		   "gridColumn": true,
		   "gridColumnEnd": true,
		   "gridColumnStart": true,
		   "gridRow": true,
		   "gridRowEnd": true,
		   "gridRowStart": true,
		   "lineHeight": true,
		   "opacity": true,
		   "order": true,
		   "orphans": true,
		   "widows": true,
		   "zIndex": true,
		   "zoom": true
	   },
   
	   // Add in properties whose names you wish to fix before
	   // setting or getting the value
	   cssProps: {},
   
	   // Get and set the style property on a DOM Node
	   style: function( elem, name, value, extra ) {
   
		   // Don't set styles on text and comment nodes
		   if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			   return;
		   }
   
		   // Make sure that we're working with the right name
		   var ret, type, hooks,
			   origName = camelCase( name ),
			   isCustomProp = rcustomProp.test( name ),
			   style = elem.style;
   
		   // Make sure that we're working with the right name. We don't
		   // want to query the value if it is a CSS custom property
		   // since they are user-defined.
		   if ( !isCustomProp ) {
			   name = finalPropName( origName );
		   }
   
		   // Gets hook for the prefixed version, then unprefixed version
		   hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
   
		   // Check if we're setting a value
		   if ( value !== undefined ) {
			   type = typeof value;
   
			   // Convert "+=" or "-=" to relative numbers (#7345)
			   if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				   value = adjustCSS( elem, name, ret );
   
				   // Fixes bug #9237
				   type = "number";
			   }
   
			   // Make sure that null and NaN values aren't set (#7116)
			   if ( value == null || value !== value ) {
				   return;
			   }
   
			   // If a number was passed in, add the unit (except for certain CSS properties)
			   // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			   // "px" to a few hardcoded values.
			   if ( type === "number" && !isCustomProp ) {
				   value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			   }
   
			   // background-* props affect original clone's values
			   if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				   style[ name ] = "inherit";
			   }
   
			   // If a hook was provided, use that value, otherwise just set the specified value
			   if ( !hooks || !( "set" in hooks ) ||
				   ( value = hooks.set( elem, value, extra ) ) !== undefined ) {
   
				   if ( isCustomProp ) {
					   style.setProperty( name, value );
				   } else {
					   style[ name ] = value;
				   }
			   }
   
		   } else {
   
			   // If a hook was provided get the non-computed value from there
			   if ( hooks && "get" in hooks &&
				   ( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
   
				   return ret;
			   }
   
			   // Otherwise just get the value from the style object
			   return style[ name ];
		   }
	   },
   
	   css: function( elem, name, extra, styles ) {
		   var val, num, hooks,
			   origName = camelCase( name ),
			   isCustomProp = rcustomProp.test( name );
   
		   // Make sure that we're working with the right name. We don't
		   // want to modify the value if it is a CSS custom property
		   // since they are user-defined.
		   if ( !isCustomProp ) {
			   name = finalPropName( origName );
		   }
   
		   // Try prefixed name followed by the unprefixed name
		   hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
   
		   // If a hook was provided get the computed value from there
		   if ( hooks && "get" in hooks ) {
			   val = hooks.get( elem, true, extra );
		   }
   
		   // Otherwise, if a way to get the computed value exists, use that
		   if ( val === undefined ) {
			   val = curCSS( elem, name, styles );
		   }
   
		   // Convert "normal" to computed value
		   if ( val === "normal" && name in cssNormalTransform ) {
			   val = cssNormalTransform[ name ];
		   }
   
		   // Make numeric if forced or a qualifier was provided and val looks numeric
		   if ( extra === "" || extra ) {
			   num = parseFloat( val );
			   return extra === true || isFinite( num ) ? num || 0 : val;
		   }
   
		   return val;
	   }
   } );
   
   jQuery.each( [ "height", "width" ], function( i, dimension ) {
	   jQuery.cssHooks[ dimension ] = {
		   get: function( elem, computed, extra ) {
			   if ( computed ) {
   
				   // Certain elements can have dimension info if we invisibly show them
				   // but it must have a current display style that would benefit
				   return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
   
					   // Support: Safari 8+
					   // Table columns in Safari have non-zero offsetWidth & zero
					   // getBoundingClientRect().width unless display is changed.
					   // Support: IE <=11 only
					   // Running getBoundingClientRect on a disconnected node
					   // in IE throws an error.
					   ( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						   swap( elem, cssShow, function() {
							   return getWidthOrHeight( elem, dimension, extra );
						   } ) :
						   getWidthOrHeight( elem, dimension, extra );
			   }
		   },
   
		   set: function( elem, value, extra ) {
			   var matches,
				   styles = getStyles( elem ),
   
				   // Only read styles.position if the test has a chance to fail
				   // to avoid forcing a reflow.
				   scrollboxSizeBuggy = !support.scrollboxSize() &&
					   styles.position === "absolute",
   
				   // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				   boxSizingNeeded = scrollboxSizeBuggy || extra,
				   isBorderBox = boxSizingNeeded &&
					   jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				   subtract = extra ?
					   boxModelAdjustment(
						   elem,
						   dimension,
						   extra,
						   isBorderBox,
						   styles
					   ) :
					   0;
   
			   // Account for unreliable border-box dimensions by comparing offset* to computed and
			   // faking a content-box to get border and padding (gh-3699)
			   if ( isBorderBox && scrollboxSizeBuggy ) {
				   subtract -= Math.ceil(
					   elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					   parseFloat( styles[ dimension ] ) -
					   boxModelAdjustment( elem, dimension, "border", false, styles ) -
					   0.5
				   );
			   }
   
			   // Convert to pixels if value adjustment is needed
			   if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				   ( matches[ 3 ] || "px" ) !== "px" ) {
   
				   elem.style[ dimension ] = value;
				   value = jQuery.css( elem, dimension );
			   }
   
			   return setPositiveNumber( elem, value, subtract );
		   }
	   };
   } );
   
   jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	   function( elem, computed ) {
		   if ( computed ) {
			   return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				   elem.getBoundingClientRect().left -
					   swap( elem, { marginLeft: 0 }, function() {
						   return elem.getBoundingClientRect().left;
					   } )
				   ) + "px";
		   }
	   }
   );
   
   // These hooks are used by animate to expand properties
   jQuery.each( {
	   margin: "",
	   padding: "",
	   border: "Width"
   }, function( prefix, suffix ) {
	   jQuery.cssHooks[ prefix + suffix ] = {
		   expand: function( value ) {
			   var i = 0,
				   expanded = {},
   
				   // Assumes a single number if not a string
				   parts = typeof value === "string" ? value.split( " " ) : [ value ];
   
			   for ( ; i < 4; i++ ) {
				   expanded[ prefix + cssExpand[ i ] + suffix ] =
					   parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			   }
   
			   return expanded;
		   }
	   };
   
	   if ( prefix !== "margin" ) {
		   jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	   }
   } );
   
   jQuery.fn.extend( {
	   css: function( name, value ) {
		   return access( this, function( elem, name, value ) {
			   var styles, len,
				   map = {},
				   i = 0;
   
			   if ( Array.isArray( name ) ) {
				   styles = getStyles( elem );
				   len = name.length;
   
				   for ( ; i < len; i++ ) {
					   map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				   }
   
				   return map;
			   }
   
			   return value !== undefined ?
				   jQuery.style( elem, name, value ) :
				   jQuery.css( elem, name );
		   }, name, value, arguments.length > 1 );
	   }
   } );
   
   
   function Tween( elem, options, prop, end, easing ) {
	   return new Tween.prototype.init( elem, options, prop, end, easing );
   }
   jQuery.Tween = Tween;
   
   Tween.prototype = {
	   constructor: Tween,
	   init: function( elem, options, prop, end, easing, unit ) {
		   this.elem = elem;
		   this.prop = prop;
		   this.easing = easing || jQuery.easing._default;
		   this.options = options;
		   this.start = this.now = this.cur();
		   this.end = end;
		   this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	   },
	   cur: function() {
		   var hooks = Tween.propHooks[ this.prop ];
   
		   return hooks && hooks.get ?
			   hooks.get( this ) :
			   Tween.propHooks._default.get( this );
	   },
	   run: function( percent ) {
		   var eased,
			   hooks = Tween.propHooks[ this.prop ];
   
		   if ( this.options.duration ) {
			   this.pos = eased = jQuery.easing[ this.easing ](
				   percent, this.options.duration * percent, 0, 1, this.options.duration
			   );
		   } else {
			   this.pos = eased = percent;
		   }
		   this.now = ( this.end - this.start ) * eased + this.start;
   
		   if ( this.options.step ) {
			   this.options.step.call( this.elem, this.now, this );
		   }
   
		   if ( hooks && hooks.set ) {
			   hooks.set( this );
		   } else {
			   Tween.propHooks._default.set( this );
		   }
		   return this;
	   }
   };
   
   Tween.prototype.init.prototype = Tween.prototype;
   
   Tween.propHooks = {
	   _default: {
		   get: function( tween ) {
			   var result;
   
			   // Use a property on the element directly when it is not a DOM element,
			   // or when there is no matching style property that exists.
			   if ( tween.elem.nodeType !== 1 ||
				   tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				   return tween.elem[ tween.prop ];
			   }
   
			   // Passing an empty string as a 3rd parameter to .css will automatically
			   // attempt a parseFloat and fallback to a string if the parse fails.
			   // Simple values such as "10px" are parsed to Float;
			   // complex values such as "rotate(1rad)" are returned as-is.
			   result = jQuery.css( tween.elem, tween.prop, "" );
   
			   // Empty strings, null, undefined and "auto" are converted to 0.
			   return !result || result === "auto" ? 0 : result;
		   },
		   set: function( tween ) {
   
			   // Use step hook for back compat.
			   // Use cssHook if its there.
			   // Use .style if available and use plain properties where available.
			   if ( jQuery.fx.step[ tween.prop ] ) {
				   jQuery.fx.step[ tween.prop ]( tween );
			   } else if ( tween.elem.nodeType === 1 && (
					   jQuery.cssHooks[ tween.prop ] ||
					   tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				   jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			   } else {
				   tween.elem[ tween.prop ] = tween.now;
			   }
		   }
	   }
   };
   
   // Support: IE <=9 only
   // Panic based approach to setting things on disconnected nodes
   Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	   set: function( tween ) {
		   if ( tween.elem.nodeType && tween.elem.parentNode ) {
			   tween.elem[ tween.prop ] = tween.now;
		   }
	   }
   };
   
   jQuery.easing = {
	   linear: function( p ) {
		   return p;
	   },
	   swing: function( p ) {
		   return 0.5 - Math.cos( p * Math.PI ) / 2;
	   },
	   _default: "swing"
   };
   
   jQuery.fx = Tween.prototype.init;
   
   // Back compat <1.8 extension point
   jQuery.fx.step = {};
   
   
   
   
   var
	   fxNow, inProgress,
	   rfxtypes = /^(?:toggle|show|hide)$/,
	   rrun = /queueHooks$/;
   
   function schedule() {
	   if ( inProgress ) {
		   if ( document.hidden === false && window.requestAnimationFrame ) {
			   window.requestAnimationFrame( schedule );
		   } else {
			   window.setTimeout( schedule, jQuery.fx.interval );
		   }
   
		   jQuery.fx.tick();
	   }
   }
   
   // Animations created synchronously will run synchronously
   function createFxNow() {
	   window.setTimeout( function() {
		   fxNow = undefined;
	   } );
	   return ( fxNow = Date.now() );
   }
   
   // Generate parameters to create a standard animation
   function genFx( type, includeWidth ) {
	   var which,
		   i = 0,
		   attrs = { height: type };
   
	   // If we include width, step value is 1 to do all cssExpand values,
	   // otherwise step value is 2 to skip over Left and Right
	   includeWidth = includeWidth ? 1 : 0;
	   for ( ; i < 4; i += 2 - includeWidth ) {
		   which = cssExpand[ i ];
		   attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	   }
   
	   if ( includeWidth ) {
		   attrs.opacity = attrs.width = type;
	   }
   
	   return attrs;
   }
   
   function createTween( value, prop, animation ) {
	   var tween,
		   collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		   index = 0,
		   length = collection.length;
	   for ( ; index < length; index++ ) {
		   if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
   
			   // We're done with this property
			   return tween;
		   }
	   }
   }
   
   function defaultPrefilter( elem, props, opts ) {
	   var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		   isBox = "width" in props || "height" in props,
		   anim = this,
		   orig = {},
		   style = elem.style,
		   hidden = elem.nodeType && isHiddenWithinTree( elem ),
		   dataShow = dataPriv.get( elem, "fxshow" );
   
	   // Queue-skipping animations hijack the fx hooks
	   if ( !opts.queue ) {
		   hooks = jQuery._queueHooks( elem, "fx" );
		   if ( hooks.unqueued == null ) {
			   hooks.unqueued = 0;
			   oldfire = hooks.empty.fire;
			   hooks.empty.fire = function() {
				   if ( !hooks.unqueued ) {
					   oldfire();
				   }
			   };
		   }
		   hooks.unqueued++;
   
		   anim.always( function() {
   
			   // Ensure the complete handler is called before this completes
			   anim.always( function() {
				   hooks.unqueued--;
				   if ( !jQuery.queue( elem, "fx" ).length ) {
					   hooks.empty.fire();
				   }
			   } );
		   } );
	   }
   
	   // Detect show/hide animations
	   for ( prop in props ) {
		   value = props[ prop ];
		   if ( rfxtypes.test( value ) ) {
			   delete props[ prop ];
			   toggle = toggle || value === "toggle";
			   if ( value === ( hidden ? "hide" : "show" ) ) {
   
				   // Pretend to be hidden if this is a "show" and
				   // there is still data from a stopped show/hide
				   if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					   hidden = true;
   
				   // Ignore all other no-op show/hide data
				   } else {
					   continue;
				   }
			   }
			   orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		   }
	   }
   
	   // Bail out if this is a no-op like .hide().hide()
	   propTween = !jQuery.isEmptyObject( props );
	   if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		   return;
	   }
   
	   // Restrict "overflow" and "display" styles during box animations
	   if ( isBox && elem.nodeType === 1 ) {
   
		   // Support: IE <=9 - 11, Edge 12 - 15
		   // Record all 3 overflow attributes because IE does not infer the shorthand
		   // from identically-valued overflowX and overflowY and Edge just mirrors
		   // the overflowX value there.
		   opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
   
		   // Identify a display type, preferring old show/hide data over the CSS cascade
		   restoreDisplay = dataShow && dataShow.display;
		   if ( restoreDisplay == null ) {
			   restoreDisplay = dataPriv.get( elem, "display" );
		   }
		   display = jQuery.css( elem, "display" );
		   if ( display === "none" ) {
			   if ( restoreDisplay ) {
				   display = restoreDisplay;
			   } else {
   
				   // Get nonempty value(s) by temporarily forcing visibility
				   showHide( [ elem ], true );
				   restoreDisplay = elem.style.display || restoreDisplay;
				   display = jQuery.css( elem, "display" );
				   showHide( [ elem ] );
			   }
		   }
   
		   // Animate inline elements as inline-block
		   if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			   if ( jQuery.css( elem, "float" ) === "none" ) {
   
				   // Restore the original display value at the end of pure show/hide animations
				   if ( !propTween ) {
					   anim.done( function() {
						   style.display = restoreDisplay;
					   } );
					   if ( restoreDisplay == null ) {
						   display = style.display;
						   restoreDisplay = display === "none" ? "" : display;
					   }
				   }
				   style.display = "inline-block";
			   }
		   }
	   }
   
	   if ( opts.overflow ) {
		   style.overflow = "hidden";
		   anim.always( function() {
			   style.overflow = opts.overflow[ 0 ];
			   style.overflowX = opts.overflow[ 1 ];
			   style.overflowY = opts.overflow[ 2 ];
		   } );
	   }
   
	   // Implement show/hide animations
	   propTween = false;
	   for ( prop in orig ) {
   
		   // General show/hide setup for this element animation
		   if ( !propTween ) {
			   if ( dataShow ) {
				   if ( "hidden" in dataShow ) {
					   hidden = dataShow.hidden;
				   }
			   } else {
				   dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			   }
   
			   // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			   if ( toggle ) {
				   dataShow.hidden = !hidden;
			   }
   
			   // Show elements before animating them
			   if ( hidden ) {
				   showHide( [ elem ], true );
			   }
   
			   /* eslint-disable no-loop-func */
   
			   anim.done( function() {
   
			   /* eslint-enable no-loop-func */
   
				   // The final step of a "hide" animation is actually hiding the element
				   if ( !hidden ) {
					   showHide( [ elem ] );
				   }
				   dataPriv.remove( elem, "fxshow" );
				   for ( prop in orig ) {
					   jQuery.style( elem, prop, orig[ prop ] );
				   }
			   } );
		   }
   
		   // Per-property setup
		   propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		   if ( !( prop in dataShow ) ) {
			   dataShow[ prop ] = propTween.start;
			   if ( hidden ) {
				   propTween.end = propTween.start;
				   propTween.start = 0;
			   }
		   }
	   }
   }
   
   function propFilter( props, specialEasing ) {
	   var index, name, easing, value, hooks;
   
	   // camelCase, specialEasing and expand cssHook pass
	   for ( index in props ) {
		   name = camelCase( index );
		   easing = specialEasing[ name ];
		   value = props[ index ];
		   if ( Array.isArray( value ) ) {
			   easing = value[ 1 ];
			   value = props[ index ] = value[ 0 ];
		   }
   
		   if ( index !== name ) {
			   props[ name ] = value;
			   delete props[ index ];
		   }
   
		   hooks = jQuery.cssHooks[ name ];
		   if ( hooks && "expand" in hooks ) {
			   value = hooks.expand( value );
			   delete props[ name ];
   
			   // Not quite $.extend, this won't overwrite existing keys.
			   // Reusing 'index' because we have the correct "name"
			   for ( index in value ) {
				   if ( !( index in props ) ) {
					   props[ index ] = value[ index ];
					   specialEasing[ index ] = easing;
				   }
			   }
		   } else {
			   specialEasing[ name ] = easing;
		   }
	   }
   }
   
   function Animation( elem, properties, options ) {
	   var result,
		   stopped,
		   index = 0,
		   length = Animation.prefilters.length,
		   deferred = jQuery.Deferred().always( function() {
   
			   // Don't match elem in the :animated selector
			   delete tick.elem;
		   } ),
		   tick = function() {
			   if ( stopped ) {
				   return false;
			   }
			   var currentTime = fxNow || createFxNow(),
				   remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
   
				   // Support: Android 2.3 only
				   // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				   temp = remaining / animation.duration || 0,
				   percent = 1 - temp,
				   index = 0,
				   length = animation.tweens.length;
   
			   for ( ; index < length; index++ ) {
				   animation.tweens[ index ].run( percent );
			   }
   
			   deferred.notifyWith( elem, [ animation, percent, remaining ] );
   
			   // If there's more to do, yield
			   if ( percent < 1 && length ) {
				   return remaining;
			   }
   
			   // If this was an empty animation, synthesize a final progress notification
			   if ( !length ) {
				   deferred.notifyWith( elem, [ animation, 1, 0 ] );
			   }
   
			   // Resolve the animation and report its conclusion
			   deferred.resolveWith( elem, [ animation ] );
			   return false;
		   },
		   animation = deferred.promise( {
			   elem: elem,
			   props: jQuery.extend( {}, properties ),
			   opts: jQuery.extend( true, {
				   specialEasing: {},
				   easing: jQuery.easing._default
			   }, options ),
			   originalProperties: properties,
			   originalOptions: options,
			   startTime: fxNow || createFxNow(),
			   duration: options.duration,
			   tweens: [],
			   createTween: function( prop, end ) {
				   var tween = jQuery.Tween( elem, animation.opts, prop, end,
						   animation.opts.specialEasing[ prop ] || animation.opts.easing );
				   animation.tweens.push( tween );
				   return tween;
			   },
			   stop: function( gotoEnd ) {
				   var index = 0,
   
					   // If we are going to the end, we want to run all the tweens
					   // otherwise we skip this part
					   length = gotoEnd ? animation.tweens.length : 0;
				   if ( stopped ) {
					   return this;
				   }
				   stopped = true;
				   for ( ; index < length; index++ ) {
					   animation.tweens[ index ].run( 1 );
				   }
   
				   // Resolve when we played the last frame; otherwise, reject
				   if ( gotoEnd ) {
					   deferred.notifyWith( elem, [ animation, 1, 0 ] );
					   deferred.resolveWith( elem, [ animation, gotoEnd ] );
				   } else {
					   deferred.rejectWith( elem, [ animation, gotoEnd ] );
				   }
				   return this;
			   }
		   } ),
		   props = animation.props;
   
	   propFilter( props, animation.opts.specialEasing );
   
	   for ( ; index < length; index++ ) {
		   result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		   if ( result ) {
			   if ( isFunction( result.stop ) ) {
				   jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					   result.stop.bind( result );
			   }
			   return result;
		   }
	   }
   
	   jQuery.map( props, createTween, animation );
   
	   if ( isFunction( animation.opts.start ) ) {
		   animation.opts.start.call( elem, animation );
	   }
   
	   // Attach callbacks from options
	   animation
		   .progress( animation.opts.progress )
		   .done( animation.opts.done, animation.opts.complete )
		   .fail( animation.opts.fail )
		   .always( animation.opts.always );
   
	   jQuery.fx.timer(
		   jQuery.extend( tick, {
			   elem: elem,
			   anim: animation,
			   queue: animation.opts.queue
		   } )
	   );
   
	   return animation;
   }
   
   jQuery.Animation = jQuery.extend( Animation, {
   
	   tweeners: {
		   "*": [ function( prop, value ) {
			   var tween = this.createTween( prop, value );
			   adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			   return tween;
		   } ]
	   },
   
	   tweener: function( props, callback ) {
		   if ( isFunction( props ) ) {
			   callback = props;
			   props = [ "*" ];
		   } else {
			   props = props.match( rnothtmlwhite );
		   }
   
		   var prop,
			   index = 0,
			   length = props.length;
   
		   for ( ; index < length; index++ ) {
			   prop = props[ index ];
			   Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			   Animation.tweeners[ prop ].unshift( callback );
		   }
	   },
   
	   prefilters: [ defaultPrefilter ],
   
	   prefilter: function( callback, prepend ) {
		   if ( prepend ) {
			   Animation.prefilters.unshift( callback );
		   } else {
			   Animation.prefilters.push( callback );
		   }
	   }
   } );
   
   jQuery.speed = function( speed, easing, fn ) {
	   var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		   complete: fn || !fn && easing ||
			   isFunction( speed ) && speed,
		   duration: speed,
		   easing: fn && easing || easing && !isFunction( easing ) && easing
	   };
   
	   // Go to the end state if fx are off
	   if ( jQuery.fx.off ) {
		   opt.duration = 0;
   
	   } else {
		   if ( typeof opt.duration !== "number" ) {
			   if ( opt.duration in jQuery.fx.speeds ) {
				   opt.duration = jQuery.fx.speeds[ opt.duration ];
   
			   } else {
				   opt.duration = jQuery.fx.speeds._default;
			   }
		   }
	   }
   
	   // Normalize opt.queue - true/undefined/null -> "fx"
	   if ( opt.queue == null || opt.queue === true ) {
		   opt.queue = "fx";
	   }
   
	   // Queueing
	   opt.old = opt.complete;
   
	   opt.complete = function() {
		   if ( isFunction( opt.old ) ) {
			   opt.old.call( this );
		   }
   
		   if ( opt.queue ) {
			   jQuery.dequeue( this, opt.queue );
		   }
	   };
   
	   return opt;
   };
   
   jQuery.fn.extend( {
	   fadeTo: function( speed, to, easing, callback ) {
   
		   // Show any hidden elements after setting opacity to 0
		   return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
   
			   // Animate to the value specified
			   .end().animate( { opacity: to }, speed, easing, callback );
	   },
	   animate: function( prop, speed, easing, callback ) {
		   var empty = jQuery.isEmptyObject( prop ),
			   optall = jQuery.speed( speed, easing, callback ),
			   doAnimation = function() {
   
				   // Operate on a copy of prop so per-property easing won't be lost
				   var anim = Animation( this, jQuery.extend( {}, prop ), optall );
   
				   // Empty animations, or finishing resolves immediately
				   if ( empty || dataPriv.get( this, "finish" ) ) {
					   anim.stop( true );
				   }
			   };
			   doAnimation.finish = doAnimation;
   
		   return empty || optall.queue === false ?
			   this.each( doAnimation ) :
			   this.queue( optall.queue, doAnimation );
	   },
	   stop: function( type, clearQueue, gotoEnd ) {
		   var stopQueue = function( hooks ) {
			   var stop = hooks.stop;
			   delete hooks.stop;
			   stop( gotoEnd );
		   };
   
		   if ( typeof type !== "string" ) {
			   gotoEnd = clearQueue;
			   clearQueue = type;
			   type = undefined;
		   }
		   if ( clearQueue && type !== false ) {
			   this.queue( type || "fx", [] );
		   }
   
		   return this.each( function() {
			   var dequeue = true,
				   index = type != null && type + "queueHooks",
				   timers = jQuery.timers,
				   data = dataPriv.get( this );
   
			   if ( index ) {
				   if ( data[ index ] && data[ index ].stop ) {
					   stopQueue( data[ index ] );
				   }
			   } else {
				   for ( index in data ) {
					   if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						   stopQueue( data[ index ] );
					   }
				   }
			   }
   
			   for ( index = timers.length; index--; ) {
				   if ( timers[ index ].elem === this &&
					   ( type == null || timers[ index ].queue === type ) ) {
   
					   timers[ index ].anim.stop( gotoEnd );
					   dequeue = false;
					   timers.splice( index, 1 );
				   }
			   }
   
			   // Start the next in the queue if the last step wasn't forced.
			   // Timers currently will call their complete callbacks, which
			   // will dequeue but only if they were gotoEnd.
			   if ( dequeue || !gotoEnd ) {
				   jQuery.dequeue( this, type );
			   }
		   } );
	   },
	   finish: function( type ) {
		   if ( type !== false ) {
			   type = type || "fx";
		   }
		   return this.each( function() {
			   var index,
				   data = dataPriv.get( this ),
				   queue = data[ type + "queue" ],
				   hooks = data[ type + "queueHooks" ],
				   timers = jQuery.timers,
				   length = queue ? queue.length : 0;
   
			   // Enable finishing flag on private data
			   data.finish = true;
   
			   // Empty the queue first
			   jQuery.queue( this, type, [] );
   
			   if ( hooks && hooks.stop ) {
				   hooks.stop.call( this, true );
			   }
   
			   // Look for any active animations, and finish them
			   for ( index = timers.length; index--; ) {
				   if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					   timers[ index ].anim.stop( true );
					   timers.splice( index, 1 );
				   }
			   }
   
			   // Look for any animations in the old queue and finish them
			   for ( index = 0; index < length; index++ ) {
				   if ( queue[ index ] && queue[ index ].finish ) {
					   queue[ index ].finish.call( this );
				   }
			   }
   
			   // Turn off finishing flag
			   delete data.finish;
		   } );
	   }
   } );
   
   jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	   var cssFn = jQuery.fn[ name ];
	   jQuery.fn[ name ] = function( speed, easing, callback ) {
		   return speed == null || typeof speed === "boolean" ?
			   cssFn.apply( this, arguments ) :
			   this.animate( genFx( name, true ), speed, easing, callback );
	   };
   } );
   
   // Generate shortcuts for custom animations
   jQuery.each( {
	   slideDown: genFx( "show" ),
	   slideUp: genFx( "hide" ),
	   slideToggle: genFx( "toggle" ),
	   fadeIn: { opacity: "show" },
	   fadeOut: { opacity: "hide" },
	   fadeToggle: { opacity: "toggle" }
   }, function( name, props ) {
	   jQuery.fn[ name ] = function( speed, easing, callback ) {
		   return this.animate( props, speed, easing, callback );
	   };
   } );
   
   jQuery.timers = [];
   jQuery.fx.tick = function() {
	   var timer,
		   i = 0,
		   timers = jQuery.timers;
   
	   fxNow = Date.now();
   
	   for ( ; i < timers.length; i++ ) {
		   timer = timers[ i ];
   
		   // Run the timer and safely remove it when done (allowing for external removal)
		   if ( !timer() && timers[ i ] === timer ) {
			   timers.splice( i--, 1 );
		   }
	   }
   
	   if ( !timers.length ) {
		   jQuery.fx.stop();
	   }
	   fxNow = undefined;
   };
   
   jQuery.fx.timer = function( timer ) {
	   jQuery.timers.push( timer );
	   jQuery.fx.start();
   };
   
   jQuery.fx.interval = 13;
   jQuery.fx.start = function() {
	   if ( inProgress ) {
		   return;
	   }
   
	   inProgress = true;
	   schedule();
   };
   
   jQuery.fx.stop = function() {
	   inProgress = null;
   };
   
   jQuery.fx.speeds = {
	   slow: 600,
	   fast: 200,
   
	   // Default speed
	   _default: 400
   };
   
   
   // Based off of the plugin by Clint Helfers, with permission.
   // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
   jQuery.fn.delay = function( time, type ) {
	   time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	   type = type || "fx";
   
	   return this.queue( type, function( next, hooks ) {
		   var timeout = window.setTimeout( next, time );
		   hooks.stop = function() {
			   window.clearTimeout( timeout );
		   };
	   } );
   };
   
   
   ( function() {
	   var input = document.createElement( "input" ),
		   select = document.createElement( "select" ),
		   opt = select.appendChild( document.createElement( "option" ) );
   
	   input.type = "checkbox";
   
	   // Support: Android <=4.3 only
	   // Default value for a checkbox should be "on"
	   support.checkOn = input.value !== "";
   
	   // Support: IE <=11 only
	   // Must access selectedIndex to make default options select
	   support.optSelected = opt.selected;
   
	   // Support: IE <=11 only
	   // An input loses its value after becoming a radio
	   input = document.createElement( "input" );
	   input.value = "t";
	   input.type = "radio";
	   support.radioValue = input.value === "t";
   } )();
   
   
   var boolHook,
	   attrHandle = jQuery.expr.attrHandle;
   
   jQuery.fn.extend( {
	   attr: function( name, value ) {
		   return access( this, jQuery.attr, name, value, arguments.length > 1 );
	   },
   
	   removeAttr: function( name ) {
		   return this.each( function() {
			   jQuery.removeAttr( this, name );
		   } );
	   }
   } );
   
   jQuery.extend( {
	   attr: function( elem, name, value ) {
		   var ret, hooks,
			   nType = elem.nodeType;
   
		   // Don't get/set attributes on text, comment and attribute nodes
		   if ( nType === 3 || nType === 8 || nType === 2 ) {
			   return;
		   }
   
		   // Fallback to prop when attributes are not supported
		   if ( typeof elem.getAttribute === "undefined" ) {
			   return jQuery.prop( elem, name, value );
		   }
   
		   // Attribute hooks are determined by the lowercase version
		   // Grab necessary hook if one is defined
		   if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			   hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				   ( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		   }
   
		   if ( value !== undefined ) {
			   if ( value === null ) {
				   jQuery.removeAttr( elem, name );
				   return;
			   }
   
			   if ( hooks && "set" in hooks &&
				   ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				   return ret;
			   }
   
			   elem.setAttribute( name, value + "" );
			   return value;
		   }
   
		   if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			   return ret;
		   }
   
		   ret = jQuery.find.attr( elem, name );
   
		   // Non-existent attributes return null, we normalize to undefined
		   return ret == null ? undefined : ret;
	   },
   
	   attrHooks: {
		   type: {
			   set: function( elem, value ) {
				   if ( !support.radioValue && value === "radio" &&
					   nodeName( elem, "input" ) ) {
					   var val = elem.value;
					   elem.setAttribute( "type", value );
					   if ( val ) {
						   elem.value = val;
					   }
					   return value;
				   }
			   }
		   }
	   },
   
	   removeAttr: function( elem, value ) {
		   var name,
			   i = 0,
   
			   // Attribute names can contain non-HTML whitespace characters
			   // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			   attrNames = value && value.match( rnothtmlwhite );
   
		   if ( attrNames && elem.nodeType === 1 ) {
			   while ( ( name = attrNames[ i++ ] ) ) {
				   elem.removeAttribute( name );
			   }
		   }
	   }
   } );
   
   // Hooks for boolean attributes
   boolHook = {
	   set: function( elem, value, name ) {
		   if ( value === false ) {
   
			   // Remove boolean attributes when set to false
			   jQuery.removeAttr( elem, name );
		   } else {
			   elem.setAttribute( name, name );
		   }
		   return name;
	   }
   };
   
   jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	   var getter = attrHandle[ name ] || jQuery.find.attr;
   
	   attrHandle[ name ] = function( elem, name, isXML ) {
		   var ret, handle,
			   lowercaseName = name.toLowerCase();
   
		   if ( !isXML ) {
   
			   // Avoid an infinite loop by temporarily removing this function from the getter
			   handle = attrHandle[ lowercaseName ];
			   attrHandle[ lowercaseName ] = ret;
			   ret = getter( elem, name, isXML ) != null ?
				   lowercaseName :
				   null;
			   attrHandle[ lowercaseName ] = handle;
		   }
		   return ret;
	   };
   } );
   
   
   
   
   var rfocusable = /^(?:input|select|textarea|button)$/i,
	   rclickable = /^(?:a|area)$/i;
   
   jQuery.fn.extend( {
	   prop: function( name, value ) {
		   return access( this, jQuery.prop, name, value, arguments.length > 1 );
	   },
   
	   removeProp: function( name ) {
		   return this.each( function() {
			   delete this[ jQuery.propFix[ name ] || name ];
		   } );
	   }
   } );
   
   jQuery.extend( {
	   prop: function( elem, name, value ) {
		   var ret, hooks,
			   nType = elem.nodeType;
   
		   // Don't get/set properties on text, comment and attribute nodes
		   if ( nType === 3 || nType === 8 || nType === 2 ) {
			   return;
		   }
   
		   if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
   
			   // Fix name and attach hooks
			   name = jQuery.propFix[ name ] || name;
			   hooks = jQuery.propHooks[ name ];
		   }
   
		   if ( value !== undefined ) {
			   if ( hooks && "set" in hooks &&
				   ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				   return ret;
			   }
   
			   return ( elem[ name ] = value );
		   }
   
		   if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			   return ret;
		   }
   
		   return elem[ name ];
	   },
   
	   propHooks: {
		   tabIndex: {
			   get: function( elem ) {
   
				   // Support: IE <=9 - 11 only
				   // elem.tabIndex doesn't always return the
				   // correct value when it hasn't been explicitly set
				   // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				   // Use proper attribute retrieval(#12072)
				   var tabindex = jQuery.find.attr( elem, "tabindex" );
   
				   if ( tabindex ) {
					   return parseInt( tabindex, 10 );
				   }
   
				   if (
					   rfocusable.test( elem.nodeName ) ||
					   rclickable.test( elem.nodeName ) &&
					   elem.href
				   ) {
					   return 0;
				   }
   
				   return -1;
			   }
		   }
	   },
   
	   propFix: {
		   "for": "htmlFor",
		   "class": "className"
	   }
   } );
   
   // Support: IE <=11 only
   // Accessing the selectedIndex property
   // forces the browser to respect setting selected
   // on the option
   // The getter ensures a default option is selected
   // when in an optgroup
   // eslint rule "no-unused-expressions" is disabled for this code
   // since it considers such accessions noop
   if ( !support.optSelected ) {
	   jQuery.propHooks.selected = {
		   get: function( elem ) {
   
			   /* eslint no-unused-expressions: "off" */
   
			   var parent = elem.parentNode;
			   if ( parent && parent.parentNode ) {
				   parent.parentNode.selectedIndex;
			   }
			   return null;
		   },
		   set: function( elem ) {
   
			   /* eslint no-unused-expressions: "off" */
   
			   var parent = elem.parentNode;
			   if ( parent ) {
				   parent.selectedIndex;
   
				   if ( parent.parentNode ) {
					   parent.parentNode.selectedIndex;
				   }
			   }
		   }
	   };
   }
   
   jQuery.each( [
	   "tabIndex",
	   "readOnly",
	   "maxLength",
	   "cellSpacing",
	   "cellPadding",
	   "rowSpan",
	   "colSpan",
	   "useMap",
	   "frameBorder",
	   "contentEditable"
   ], function() {
	   jQuery.propFix[ this.toLowerCase() ] = this;
   } );
   
   
   
   
	   // Strip and collapse whitespace according to HTML spec
	   // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	   function stripAndCollapse( value ) {
		   var tokens = value.match( rnothtmlwhite ) || [];
		   return tokens.join( " " );
	   }
   
   
   function getClass( elem ) {
	   return elem.getAttribute && elem.getAttribute( "class" ) || "";
   }
   
   function classesToArray( value ) {
	   if ( Array.isArray( value ) ) {
		   return value;
	   }
	   if ( typeof value === "string" ) {
		   return value.match( rnothtmlwhite ) || [];
	   }
	   return [];
   }
   
   jQuery.fn.extend( {
	   addClass: function( value ) {
		   var classes, elem, cur, curValue, clazz, j, finalValue,
			   i = 0;
   
		   if ( isFunction( value ) ) {
			   return this.each( function( j ) {
				   jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			   } );
		   }
   
		   classes = classesToArray( value );
   
		   if ( classes.length ) {
			   while ( ( elem = this[ i++ ] ) ) {
				   curValue = getClass( elem );
				   cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
   
				   if ( cur ) {
					   j = 0;
					   while ( ( clazz = classes[ j++ ] ) ) {
						   if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							   cur += clazz + " ";
						   }
					   }
   
					   // Only assign if different to avoid unneeded rendering.
					   finalValue = stripAndCollapse( cur );
					   if ( curValue !== finalValue ) {
						   elem.setAttribute( "class", finalValue );
					   }
				   }
			   }
		   }
   
		   return this;
	   },
   
	   removeClass: function( value ) {
		   var classes, elem, cur, curValue, clazz, j, finalValue,
			   i = 0;
   
		   if ( isFunction( value ) ) {
			   return this.each( function( j ) {
				   jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			   } );
		   }
   
		   if ( !arguments.length ) {
			   return this.attr( "class", "" );
		   }
   
		   classes = classesToArray( value );
   
		   if ( classes.length ) {
			   while ( ( elem = this[ i++ ] ) ) {
				   curValue = getClass( elem );
   
				   // This expression is here for better compressibility (see addClass)
				   cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
   
				   if ( cur ) {
					   j = 0;
					   while ( ( clazz = classes[ j++ ] ) ) {
   
						   // Remove *all* instances
						   while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							   cur = cur.replace( " " + clazz + " ", " " );
						   }
					   }
   
					   // Only assign if different to avoid unneeded rendering.
					   finalValue = stripAndCollapse( cur );
					   if ( curValue !== finalValue ) {
						   elem.setAttribute( "class", finalValue );
					   }
				   }
			   }
		   }
   
		   return this;
	   },
   
	   toggleClass: function( value, stateVal ) {
		   var type = typeof value,
			   isValidValue = type === "string" || Array.isArray( value );
   
		   if ( typeof stateVal === "boolean" && isValidValue ) {
			   return stateVal ? this.addClass( value ) : this.removeClass( value );
		   }
   
		   if ( isFunction( value ) ) {
			   return this.each( function( i ) {
				   jQuery( this ).toggleClass(
					   value.call( this, i, getClass( this ), stateVal ),
					   stateVal
				   );
			   } );
		   }
   
		   return this.each( function() {
			   var className, i, self, classNames;
   
			   if ( isValidValue ) {
   
				   // Toggle individual class names
				   i = 0;
				   self = jQuery( this );
				   classNames = classesToArray( value );
   
				   while ( ( className = classNames[ i++ ] ) ) {
   
					   // Check each className given, space separated list
					   if ( self.hasClass( className ) ) {
						   self.removeClass( className );
					   } else {
						   self.addClass( className );
					   }
				   }
   
			   // Toggle whole class name
			   } else if ( value === undefined || type === "boolean" ) {
				   className = getClass( this );
				   if ( className ) {
   
					   // Store className if set
					   dataPriv.set( this, "__className__", className );
				   }
   
				   // If the element has a class name or if we're passed `false`,
				   // then remove the whole classname (if there was one, the above saved it).
				   // Otherwise bring back whatever was previously saved (if anything),
				   // falling back to the empty string if nothing was stored.
				   if ( this.setAttribute ) {
					   this.setAttribute( "class",
						   className || value === false ?
						   "" :
						   dataPriv.get( this, "__className__" ) || ""
					   );
				   }
			   }
		   } );
	   },
   
	   hasClass: function( selector ) {
		   var className, elem,
			   i = 0;
   
		   className = " " + selector + " ";
		   while ( ( elem = this[ i++ ] ) ) {
			   if ( elem.nodeType === 1 &&
				   ( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					   return true;
			   }
		   }
   
		   return false;
	   }
   } );
   
   
   
   
   var rreturn = /\r/g;
   
   jQuery.fn.extend( {
	   val: function( value ) {
		   var hooks, ret, valueIsFunction,
			   elem = this[ 0 ];
   
		   if ( !arguments.length ) {
			   if ( elem ) {
				   hooks = jQuery.valHooks[ elem.type ] ||
					   jQuery.valHooks[ elem.nodeName.toLowerCase() ];
   
				   if ( hooks &&
					   "get" in hooks &&
					   ( ret = hooks.get( elem, "value" ) ) !== undefined
				   ) {
					   return ret;
				   }
   
				   ret = elem.value;
   
				   // Handle most common string cases
				   if ( typeof ret === "string" ) {
					   return ret.replace( rreturn, "" );
				   }
   
				   // Handle cases where value is null/undef or number
				   return ret == null ? "" : ret;
			   }
   
			   return;
		   }
   
		   valueIsFunction = isFunction( value );
   
		   return this.each( function( i ) {
			   var val;
   
			   if ( this.nodeType !== 1 ) {
				   return;
			   }
   
			   if ( valueIsFunction ) {
				   val = value.call( this, i, jQuery( this ).val() );
			   } else {
				   val = value;
			   }
   
			   // Treat null/undefined as ""; convert numbers to string
			   if ( val == null ) {
				   val = "";
   
			   } else if ( typeof val === "number" ) {
				   val += "";
   
			   } else if ( Array.isArray( val ) ) {
				   val = jQuery.map( val, function( value ) {
					   return value == null ? "" : value + "";
				   } );
			   }
   
			   hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
   
			   // If set returns undefined, fall back to normal setting
			   if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				   this.value = val;
			   }
		   } );
	   }
   } );
   
   jQuery.extend( {
	   valHooks: {
		   option: {
			   get: function( elem ) {
   
				   var val = jQuery.find.attr( elem, "value" );
				   return val != null ?
					   val :
   
					   // Support: IE <=10 - 11 only
					   // option.text throws exceptions (#14686, #14858)
					   // Strip and collapse whitespace
					   // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					   stripAndCollapse( jQuery.text( elem ) );
			   }
		   },
		   select: {
			   get: function( elem ) {
				   var value, option, i,
					   options = elem.options,
					   index = elem.selectedIndex,
					   one = elem.type === "select-one",
					   values = one ? null : [],
					   max = one ? index + 1 : options.length;
   
				   if ( index < 0 ) {
					   i = max;
   
				   } else {
					   i = one ? index : 0;
				   }
   
				   // Loop through all the selected options
				   for ( ; i < max; i++ ) {
					   option = options[ i ];
   
					   // Support: IE <=9 only
					   // IE8-9 doesn't update selected after form reset (#2551)
					   if ( ( option.selected || i === index ) &&
   
							   // Don't return options that are disabled or in a disabled optgroup
							   !option.disabled &&
							   ( !option.parentNode.disabled ||
								   !nodeName( option.parentNode, "optgroup" ) ) ) {
   
						   // Get the specific value for the option
						   value = jQuery( option ).val();
   
						   // We don't need an array for one selects
						   if ( one ) {
							   return value;
						   }
   
						   // Multi-Selects return an array
						   values.push( value );
					   }
				   }
   
				   return values;
			   },
   
			   set: function( elem, value ) {
				   var optionSet, option,
					   options = elem.options,
					   values = jQuery.makeArray( value ),
					   i = options.length;
   
				   while ( i-- ) {
					   option = options[ i ];
   
					   /* eslint-disable no-cond-assign */
   
					   if ( option.selected =
						   jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					   ) {
						   optionSet = true;
					   }
   
					   /* eslint-enable no-cond-assign */
				   }
   
				   // Force browsers to behave consistently when non-matching value is set
				   if ( !optionSet ) {
					   elem.selectedIndex = -1;
				   }
				   return values;
			   }
		   }
	   }
   } );
   
   // Radios and checkboxes getter/setter
   jQuery.each( [ "radio", "checkbox" ], function() {
	   jQuery.valHooks[ this ] = {
		   set: function( elem, value ) {
			   if ( Array.isArray( value ) ) {
				   return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			   }
		   }
	   };
	   if ( !support.checkOn ) {
		   jQuery.valHooks[ this ].get = function( elem ) {
			   return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		   };
	   }
   } );
   
   
   
   
   // Return jQuery for attributes-only inclusion
   
   
   support.focusin = "onfocusin" in window;
   
   
   var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	   stopPropagationCallback = function( e ) {
		   e.stopPropagation();
	   };
   
   jQuery.extend( jQuery.event, {
   
	   trigger: function( event, data, elem, onlyHandlers ) {
   
		   var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			   eventPath = [ elem || document ],
			   type = hasOwn.call( event, "type" ) ? event.type : event,
			   namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
   
		   cur = lastElement = tmp = elem = elem || document;
   
		   // Don't do events on text and comment nodes
		   if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			   return;
		   }
   
		   // focus/blur morphs to focusin/out; ensure we're not firing them right now
		   if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			   return;
		   }
   
		   if ( type.indexOf( "." ) > -1 ) {
   
			   // Namespaced trigger; create a regexp to match event type in handle()
			   namespaces = type.split( "." );
			   type = namespaces.shift();
			   namespaces.sort();
		   }
		   ontype = type.indexOf( ":" ) < 0 && "on" + type;
   
		   // Caller can pass in a jQuery.Event object, Object, or just an event type string
		   event = event[ jQuery.expando ] ?
			   event :
			   new jQuery.Event( type, typeof event === "object" && event );
   
		   // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		   event.isTrigger = onlyHandlers ? 2 : 3;
		   event.namespace = namespaces.join( "." );
		   event.rnamespace = event.namespace ?
			   new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			   null;
   
		   // Clean up the event in case it is being reused
		   event.result = undefined;
		   if ( !event.target ) {
			   event.target = elem;
		   }
   
		   // Clone any incoming data and prepend the event, creating the handler arg list
		   data = data == null ?
			   [ event ] :
			   jQuery.makeArray( data, [ event ] );
   
		   // Allow special events to draw outside the lines
		   special = jQuery.event.special[ type ] || {};
		   if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			   return;
		   }
   
		   // Determine event propagation path in advance, per W3C events spec (#9951)
		   // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		   if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
   
			   bubbleType = special.delegateType || type;
			   if ( !rfocusMorph.test( bubbleType + type ) ) {
				   cur = cur.parentNode;
			   }
			   for ( ; cur; cur = cur.parentNode ) {
				   eventPath.push( cur );
				   tmp = cur;
			   }
   
			   // Only add window if we got to document (e.g., not plain obj or detached DOM)
			   if ( tmp === ( elem.ownerDocument || document ) ) {
				   eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			   }
		   }
   
		   // Fire handlers on the event path
		   i = 0;
		   while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			   lastElement = cur;
			   event.type = i > 1 ?
				   bubbleType :
				   special.bindType || type;
   
			   // jQuery handler
			   handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				   dataPriv.get( cur, "handle" );
			   if ( handle ) {
				   handle.apply( cur, data );
			   }
   
			   // Native handler
			   handle = ontype && cur[ ontype ];
			   if ( handle && handle.apply && acceptData( cur ) ) {
				   event.result = handle.apply( cur, data );
				   if ( event.result === false ) {
					   event.preventDefault();
				   }
			   }
		   }
		   event.type = type;
   
		   // If nobody prevented the default action, do it now
		   if ( !onlyHandlers && !event.isDefaultPrevented() ) {
   
			   if ( ( !special._default ||
				   special._default.apply( eventPath.pop(), data ) === false ) &&
				   acceptData( elem ) ) {
   
				   // Call a native DOM method on the target with the same name as the event.
				   // Don't do default actions on window, that's where global variables be (#6170)
				   if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
   
					   // Don't re-trigger an onFOO event when we call its FOO() method
					   tmp = elem[ ontype ];
   
					   if ( tmp ) {
						   elem[ ontype ] = null;
					   }
   
					   // Prevent re-triggering of the same event, since we already bubbled it above
					   jQuery.event.triggered = type;
   
					   if ( event.isPropagationStopped() ) {
						   lastElement.addEventListener( type, stopPropagationCallback );
					   }
   
					   elem[ type ]();
   
					   if ( event.isPropagationStopped() ) {
						   lastElement.removeEventListener( type, stopPropagationCallback );
					   }
   
					   jQuery.event.triggered = undefined;
   
					   if ( tmp ) {
						   elem[ ontype ] = tmp;
					   }
				   }
			   }
		   }
   
		   return event.result;
	   },
   
	   // Piggyback on a donor event to simulate a different one
	   // Used only for `focus(in | out)` events
	   simulate: function( type, elem, event ) {
		   var e = jQuery.extend(
			   new jQuery.Event(),
			   event,
			   {
				   type: type,
				   isSimulated: true
			   }
		   );
   
		   jQuery.event.trigger( e, null, elem );
	   }
   
   } );
   
   jQuery.fn.extend( {
   
	   trigger: function( type, data ) {
		   return this.each( function() {
			   jQuery.event.trigger( type, data, this );
		   } );
	   },
	   triggerHandler: function( type, data ) {
		   var elem = this[ 0 ];
		   if ( elem ) {
			   return jQuery.event.trigger( type, data, elem, true );
		   }
	   }
   } );
   
   
   // Support: Firefox <=44
   // Firefox doesn't have focus(in | out) events
   // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
   //
   // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
   // focus(in | out) events fire after focus & blur events,
   // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
   // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
   if ( !support.focusin ) {
	   jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
   
		   // Attach a single capturing handler on the document while someone wants focusin/focusout
		   var handler = function( event ) {
			   jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		   };
   
		   jQuery.event.special[ fix ] = {
			   setup: function() {
				   var doc = this.ownerDocument || this,
					   attaches = dataPriv.access( doc, fix );
   
				   if ( !attaches ) {
					   doc.addEventListener( orig, handler, true );
				   }
				   dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			   },
			   teardown: function() {
				   var doc = this.ownerDocument || this,
					   attaches = dataPriv.access( doc, fix ) - 1;
   
				   if ( !attaches ) {
					   doc.removeEventListener( orig, handler, true );
					   dataPriv.remove( doc, fix );
   
				   } else {
					   dataPriv.access( doc, fix, attaches );
				   }
			   }
		   };
	   } );
   }
   var location = window.location;
   
   var nonce = Date.now();
   
   var rquery = ( /\?/ );
   
   
   
   // Cross-browser xml parsing
   jQuery.parseXML = function( data ) {
	   var xml;
	   if ( !data || typeof data !== "string" ) {
		   return null;
	   }
   
	   // Support: IE 9 - 11 only
	   // IE throws on parseFromString with invalid input.
	   try {
		   xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	   } catch ( e ) {
		   xml = undefined;
	   }
   
	   if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		   jQuery.error( "Invalid XML: " + data );
	   }
	   return xml;
   };
   
   
   var
	   rbracket = /\[\]$/,
	   rCRLF = /\r?\n/g,
	   rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	   rsubmittable = /^(?:input|select|textarea|keygen)/i;
   
   function buildParams( prefix, obj, traditional, add ) {
	   var name;
   
	   if ( Array.isArray( obj ) ) {
   
		   // Serialize array item.
		   jQuery.each( obj, function( i, v ) {
			   if ( traditional || rbracket.test( prefix ) ) {
   
				   // Treat each array item as a scalar.
				   add( prefix, v );
   
			   } else {
   
				   // Item is non-scalar (array or object), encode its numeric index.
				   buildParams(
					   prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					   v,
					   traditional,
					   add
				   );
			   }
		   } );
   
	   } else if ( !traditional && toType( obj ) === "object" ) {
   
		   // Serialize object item.
		   for ( name in obj ) {
			   buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		   }
   
	   } else {
   
		   // Serialize scalar item.
		   add( prefix, obj );
	   }
   }
   
   // Serialize an array of form elements or a set of
   // key/values into a query string
   jQuery.param = function( a, traditional ) {
	   var prefix,
		   s = [],
		   add = function( key, valueOrFunction ) {
   
			   // If value is a function, invoke it and use its return value
			   var value = isFunction( valueOrFunction ) ?
				   valueOrFunction() :
				   valueOrFunction;
   
			   s[ s.length ] = encodeURIComponent( key ) + "=" +
				   encodeURIComponent( value == null ? "" : value );
		   };
   
	   if ( a == null ) {
		   return "";
	   }
   
	   // If an array was passed in, assume that it is an array of form elements.
	   if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
   
		   // Serialize the form elements
		   jQuery.each( a, function() {
			   add( this.name, this.value );
		   } );
   
	   } else {
   
		   // If traditional, encode the "old" way (the way 1.3.2 or older
		   // did it), otherwise encode params recursively.
		   for ( prefix in a ) {
			   buildParams( prefix, a[ prefix ], traditional, add );
		   }
	   }
   
	   // Return the resulting serialization
	   return s.join( "&" );
   };
   
   jQuery.fn.extend( {
	   serialize: function() {
		   return jQuery.param( this.serializeArray() );
	   },
	   serializeArray: function() {
		   return this.map( function() {
   
			   // Can add propHook for "elements" to filter or add form elements
			   var elements = jQuery.prop( this, "elements" );
			   return elements ? jQuery.makeArray( elements ) : this;
		   } )
		   .filter( function() {
			   var type = this.type;
   
			   // Use .is( ":disabled" ) so that fieldset[disabled] works
			   return this.name && !jQuery( this ).is( ":disabled" ) &&
				   rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				   ( this.checked || !rcheckableType.test( type ) );
		   } )
		   .map( function( i, elem ) {
			   var val = jQuery( this ).val();
   
			   if ( val == null ) {
				   return null;
			   }
   
			   if ( Array.isArray( val ) ) {
				   return jQuery.map( val, function( val ) {
					   return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				   } );
			   }
   
			   return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		   } ).get();
	   }
   } );
   
   
   var
	   r20 = /%20/g,
	   rhash = /#.*$/,
	   rantiCache = /([?&])_=[^&]*/,
	   rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
   
	   // #7653, #8125, #8152: local protocol detection
	   rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	   rnoContent = /^(?:GET|HEAD)$/,
	   rprotocol = /^\/\//,
   
	   /* Prefilters
		* 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		* 2) These are called:
		*    - BEFORE asking for a transport
		*    - AFTER param serialization (s.data is a string if s.processData is true)
		* 3) key is the dataType
		* 4) the catchall symbol "*" can be used
		* 5) execution will start with transport dataType and THEN continue down to "*" if needed
		*/
	   prefilters = {},
   
	   /* Transports bindings
		* 1) key is the dataType
		* 2) the catchall symbol "*" can be used
		* 3) selection will start with transport dataType and THEN go to "*" if needed
		*/
	   transports = {},
   
	   // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	   allTypes = "*/".concat( "*" ),
   
	   // Anchor tag for parsing the document origin
	   originAnchor = document.createElement( "a" );
	   originAnchor.href = location.href;
   
   // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
   function addToPrefiltersOrTransports( structure ) {
   
	   // dataTypeExpression is optional and defaults to "*"
	   return function( dataTypeExpression, func ) {
   
		   if ( typeof dataTypeExpression !== "string" ) {
			   func = dataTypeExpression;
			   dataTypeExpression = "*";
		   }
   
		   var dataType,
			   i = 0,
			   dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
   
		   if ( isFunction( func ) ) {
   
			   // For each dataType in the dataTypeExpression
			   while ( ( dataType = dataTypes[ i++ ] ) ) {
   
				   // Prepend if requested
				   if ( dataType[ 0 ] === "+" ) {
					   dataType = dataType.slice( 1 ) || "*";
					   ( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
   
				   // Otherwise append
				   } else {
					   ( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				   }
			   }
		   }
	   };
   }
   
   // Base inspection function for prefilters and transports
   function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
   
	   var inspected = {},
		   seekingTransport = ( structure === transports );
   
	   function inspect( dataType ) {
		   var selected;
		   inspected[ dataType ] = true;
		   jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			   var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			   if ( typeof dataTypeOrTransport === "string" &&
				   !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
   
				   options.dataTypes.unshift( dataTypeOrTransport );
				   inspect( dataTypeOrTransport );
				   return false;
			   } else if ( seekingTransport ) {
				   return !( selected = dataTypeOrTransport );
			   }
		   } );
		   return selected;
	   }
   
	   return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
   }
   
   // A special extend for ajax options
   // that takes "flat" options (not to be deep extended)
   // Fixes #9887
   function ajaxExtend( target, src ) {
	   var key, deep,
		   flatOptions = jQuery.ajaxSettings.flatOptions || {};
   
	   for ( key in src ) {
		   if ( src[ key ] !== undefined ) {
			   ( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		   }
	   }
	   if ( deep ) {
		   jQuery.extend( true, target, deep );
	   }
   
	   return target;
   }
   
   /* Handles responses to an ajax request:
	* - finds the right dataType (mediates between content-type and expected dataType)
	* - returns the corresponding response
	*/
   function ajaxHandleResponses( s, jqXHR, responses ) {
   
	   var ct, type, finalDataType, firstDataType,
		   contents = s.contents,
		   dataTypes = s.dataTypes;
   
	   // Remove auto dataType and get content-type in the process
	   while ( dataTypes[ 0 ] === "*" ) {
		   dataTypes.shift();
		   if ( ct === undefined ) {
			   ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		   }
	   }
   
	   // Check if we're dealing with a known content-type
	   if ( ct ) {
		   for ( type in contents ) {
			   if ( contents[ type ] && contents[ type ].test( ct ) ) {
				   dataTypes.unshift( type );
				   break;
			   }
		   }
	   }
   
	   // Check to see if we have a response for the expected dataType
	   if ( dataTypes[ 0 ] in responses ) {
		   finalDataType = dataTypes[ 0 ];
	   } else {
   
		   // Try convertible dataTypes
		   for ( type in responses ) {
			   if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				   finalDataType = type;
				   break;
			   }
			   if ( !firstDataType ) {
				   firstDataType = type;
			   }
		   }
   
		   // Or just use first one
		   finalDataType = finalDataType || firstDataType;
	   }
   
	   // If we found a dataType
	   // We add the dataType to the list if needed
	   // and return the corresponding response
	   if ( finalDataType ) {
		   if ( finalDataType !== dataTypes[ 0 ] ) {
			   dataTypes.unshift( finalDataType );
		   }
		   return responses[ finalDataType ];
	   }
   }
   
   /* Chain conversions given the request and the original response
	* Also sets the responseXXX fields on the jqXHR instance
	*/
   function ajaxConvert( s, response, jqXHR, isSuccess ) {
	   var conv2, current, conv, tmp, prev,
		   converters = {},
   
		   // Work with a copy of dataTypes in case we need to modify it for conversion
		   dataTypes = s.dataTypes.slice();
   
	   // Create converters map with lowercased keys
	   if ( dataTypes[ 1 ] ) {
		   for ( conv in s.converters ) {
			   converters[ conv.toLowerCase() ] = s.converters[ conv ];
		   }
	   }
   
	   current = dataTypes.shift();
   
	   // Convert to each sequential dataType
	   while ( current ) {
   
		   if ( s.responseFields[ current ] ) {
			   jqXHR[ s.responseFields[ current ] ] = response;
		   }
   
		   // Apply the dataFilter if provided
		   if ( !prev && isSuccess && s.dataFilter ) {
			   response = s.dataFilter( response, s.dataType );
		   }
   
		   prev = current;
		   current = dataTypes.shift();
   
		   if ( current ) {
   
			   // There's only work to do if current dataType is non-auto
			   if ( current === "*" ) {
   
				   current = prev;
   
			   // Convert response if prev dataType is non-auto and differs from current
			   } else if ( prev !== "*" && prev !== current ) {
   
				   // Seek a direct converter
				   conv = converters[ prev + " " + current ] || converters[ "* " + current ];
   
				   // If none found, seek a pair
				   if ( !conv ) {
					   for ( conv2 in converters ) {
   
						   // If conv2 outputs current
						   tmp = conv2.split( " " );
						   if ( tmp[ 1 ] === current ) {
   
							   // If prev can be converted to accepted input
							   conv = converters[ prev + " " + tmp[ 0 ] ] ||
								   converters[ "* " + tmp[ 0 ] ];
							   if ( conv ) {
   
								   // Condense equivalence converters
								   if ( conv === true ) {
									   conv = converters[ conv2 ];
   
								   // Otherwise, insert the intermediate dataType
								   } else if ( converters[ conv2 ] !== true ) {
									   current = tmp[ 0 ];
									   dataTypes.unshift( tmp[ 1 ] );
								   }
								   break;
							   }
						   }
					   }
				   }
   
				   // Apply converter (if not an equivalence)
				   if ( conv !== true ) {
   
					   // Unless errors are allowed to bubble, catch and return them
					   if ( conv && s.throws ) {
						   response = conv( response );
					   } else {
						   try {
							   response = conv( response );
						   } catch ( e ) {
							   return {
								   state: "parsererror",
								   error: conv ? e : "No conversion from " + prev + " to " + current
							   };
						   }
					   }
				   }
			   }
		   }
	   }
   
	   return { state: "success", data: response };
   }
   
   jQuery.extend( {
   
	   // Counter for holding the number of active queries
	   active: 0,
   
	   // Last-Modified header cache for next request
	   lastModified: {},
	   etag: {},
   
	   ajaxSettings: {
		   url: location.href,
		   type: "GET",
		   isLocal: rlocalProtocol.test( location.protocol ),
		   global: true,
		   processData: true,
		   async: true,
		   contentType: "application/x-www-form-urlencoded; charset=UTF-8",
   
		   /*
		   timeout: 0,
		   data: null,
		   dataType: null,
		   username: null,
		   password: null,
		   cache: null,
		   throws: false,
		   traditional: false,
		   headers: {},
		   */
   
		   accepts: {
			   "*": allTypes,
			   text: "text/plain",
			   html: "text/html",
			   xml: "application/xml, text/xml",
			   json: "application/json, text/javascript"
		   },
   
		   contents: {
			   xml: /\bxml\b/,
			   html: /\bhtml/,
			   json: /\bjson\b/
		   },
   
		   responseFields: {
			   xml: "responseXML",
			   text: "responseText",
			   json: "responseJSON"
		   },
   
		   // Data converters
		   // Keys separate source (or catchall "*") and destination types with a single space
		   converters: {
   
			   // Convert anything to text
			   "* text": String,
   
			   // Text to html (true = no transformation)
			   "text html": true,
   
			   // Evaluate text as a json expression
			   "text json": JSON.parse,
   
			   // Parse text as xml
			   "text xml": jQuery.parseXML
		   },
   
		   // For options that shouldn't be deep extended:
		   // you can add your own custom options here if
		   // and when you create one that shouldn't be
		   // deep extended (see ajaxExtend)
		   flatOptions: {
			   url: true,
			   context: true
		   }
	   },
   
	   // Creates a full fledged settings object into target
	   // with both ajaxSettings and settings fields.
	   // If target is omitted, writes into ajaxSettings.
	   ajaxSetup: function( target, settings ) {
		   return settings ?
   
			   // Building a settings object
			   ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
   
			   // Extending ajaxSettings
			   ajaxExtend( jQuery.ajaxSettings, target );
	   },
   
	   ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	   ajaxTransport: addToPrefiltersOrTransports( transports ),
   
	   // Main method
	   ajax: function( url, options ) {
   
		   // If url is an object, simulate pre-1.5 signature
		   if ( typeof url === "object" ) {
			   options = url;
			   url = undefined;
		   }
   
		   // Force options to be an object
		   options = options || {};
   
		   var transport,
   
			   // URL without anti-cache param
			   cacheURL,
   
			   // Response headers
			   responseHeadersString,
			   responseHeaders,
   
			   // timeout handle
			   timeoutTimer,
   
			   // Url cleanup var
			   urlAnchor,
   
			   // Request state (becomes false upon send and true upon completion)
			   completed,
   
			   // To know if global events are to be dispatched
			   fireGlobals,
   
			   // Loop variable
			   i,
   
			   // uncached part of the url
			   uncached,
   
			   // Create the final options object
			   s = jQuery.ajaxSetup( {}, options ),
   
			   // Callbacks context
			   callbackContext = s.context || s,
   
			   // Context for global events is callbackContext if it is a DOM node or jQuery collection
			   globalEventContext = s.context &&
				   ( callbackContext.nodeType || callbackContext.jquery ) ?
					   jQuery( callbackContext ) :
					   jQuery.event,
   
			   // Deferreds
			   deferred = jQuery.Deferred(),
			   completeDeferred = jQuery.Callbacks( "once memory" ),
   
			   // Status-dependent callbacks
			   statusCode = s.statusCode || {},
   
			   // Headers (they are sent all at once)
			   requestHeaders = {},
			   requestHeadersNames = {},
   
			   // Default abort message
			   strAbort = "canceled",
   
			   // Fake xhr
			   jqXHR = {
				   readyState: 0,
   
				   // Builds headers hashtable if needed
				   getResponseHeader: function( key ) {
					   var match;
					   if ( completed ) {
						   if ( !responseHeaders ) {
							   responseHeaders = {};
							   while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								   responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									   ( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										   .concat( match[ 2 ] );
							   }
						   }
						   match = responseHeaders[ key.toLowerCase() + " " ];
					   }
					   return match == null ? null : match.join( ", " );
				   },
   
				   // Raw string
				   getAllResponseHeaders: function() {
					   return completed ? responseHeadersString : null;
				   },
   
				   // Caches the header
				   setRequestHeader: function( name, value ) {
					   if ( completed == null ) {
						   name = requestHeadersNames[ name.toLowerCase() ] =
							   requestHeadersNames[ name.toLowerCase() ] || name;
						   requestHeaders[ name ] = value;
					   }
					   return this;
				   },
   
				   // Overrides response content-type header
				   overrideMimeType: function( type ) {
					   if ( completed == null ) {
						   s.mimeType = type;
					   }
					   return this;
				   },
   
				   // Status-dependent callbacks
				   statusCode: function( map ) {
					   var code;
					   if ( map ) {
						   if ( completed ) {
   
							   // Execute the appropriate callbacks
							   jqXHR.always( map[ jqXHR.status ] );
						   } else {
   
							   // Lazy-add the new callbacks in a way that preserves old ones
							   for ( code in map ) {
								   statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							   }
						   }
					   }
					   return this;
				   },
   
				   // Cancel the request
				   abort: function( statusText ) {
					   var finalText = statusText || strAbort;
					   if ( transport ) {
						   transport.abort( finalText );
					   }
					   done( 0, finalText );
					   return this;
				   }
			   };
   
		   // Attach deferreds
		   deferred.promise( jqXHR );
   
		   // Add protocol if not provided (prefilters might expect it)
		   // Handle falsy url in the settings object (#10093: consistency with old signature)
		   // We also use the url parameter if available
		   s.url = ( ( url || s.url || location.href ) + "" )
			   .replace( rprotocol, location.protocol + "//" );
   
		   // Alias method option to type as per ticket #12004
		   s.type = options.method || options.type || s.method || s.type;
   
		   // Extract dataTypes list
		   s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
   
		   // A cross-domain request is in order when the origin doesn't match the current origin.
		   if ( s.crossDomain == null ) {
			   urlAnchor = document.createElement( "a" );
   
			   // Support: IE <=8 - 11, Edge 12 - 15
			   // IE throws exception on accessing the href property if url is malformed,
			   // e.g. http://example.com:80x/
			   try {
				   urlAnchor.href = s.url;
   
				   // Support: IE <=8 - 11 only
				   // Anchor's host property isn't correctly set when s.url is relative
				   urlAnchor.href = urlAnchor.href;
				   s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					   urlAnchor.protocol + "//" + urlAnchor.host;
			   } catch ( e ) {
   
				   // If there is an error parsing the URL, assume it is crossDomain,
				   // it can be rejected by the transport if it is invalid
				   s.crossDomain = true;
			   }
		   }
   
		   // Convert data if not already a string
		   if ( s.data && s.processData && typeof s.data !== "string" ) {
			   s.data = jQuery.param( s.data, s.traditional );
		   }
   
		   // Apply prefilters
		   inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
   
		   // If request was aborted inside a prefilter, stop there
		   if ( completed ) {
			   return jqXHR;
		   }
   
		   // We can fire global events as of now if asked to
		   // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		   fireGlobals = jQuery.event && s.global;
   
		   // Watch for a new set of requests
		   if ( fireGlobals && jQuery.active++ === 0 ) {
			   jQuery.event.trigger( "ajaxStart" );
		   }
   
		   // Uppercase the type
		   s.type = s.type.toUpperCase();
   
		   // Determine if request has content
		   s.hasContent = !rnoContent.test( s.type );
   
		   // Save the URL in case we're toying with the If-Modified-Since
		   // and/or If-None-Match header later on
		   // Remove hash to simplify url manipulation
		   cacheURL = s.url.replace( rhash, "" );
   
		   // More options handling for requests with no content
		   if ( !s.hasContent ) {
   
			   // Remember the hash so we can put it back
			   uncached = s.url.slice( cacheURL.length );
   
			   // If data is available and should be processed, append data to url
			   if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				   cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
   
				   // #9682: remove data so that it's not used in an eventual retry
				   delete s.data;
			   }
   
			   // Add or update anti-cache param if needed
			   if ( s.cache === false ) {
				   cacheURL = cacheURL.replace( rantiCache, "$1" );
				   uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			   }
   
			   // Put hash and anti-cache on the URL that will be requested (gh-1732)
			   s.url = cacheURL + uncached;
   
		   // Change '%20' to '+' if this is encoded form body content (gh-2658)
		   } else if ( s.data && s.processData &&
			   ( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			   s.data = s.data.replace( r20, "+" );
		   }
   
		   // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		   if ( s.ifModified ) {
			   if ( jQuery.lastModified[ cacheURL ] ) {
				   jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			   }
			   if ( jQuery.etag[ cacheURL ] ) {
				   jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			   }
		   }
   
		   // Set the correct header, if data is being sent
		   if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			   jqXHR.setRequestHeader( "Content-Type", s.contentType );
		   }
   
		   // Set the Accepts header for the server, depending on the dataType
		   jqXHR.setRequestHeader(
			   "Accept",
			   s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				   s.accepts[ s.dataTypes[ 0 ] ] +
					   ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				   s.accepts[ "*" ]
		   );
   
		   // Check for headers option
		   for ( i in s.headers ) {
			   jqXHR.setRequestHeader( i, s.headers[ i ] );
		   }
   
		   // Allow custom headers/mimetypes and early abort
		   if ( s.beforeSend &&
			   ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
   
			   // Abort if not done already and return
			   return jqXHR.abort();
		   }
   
		   // Aborting is no longer a cancellation
		   strAbort = "abort";
   
		   // Install callbacks on deferreds
		   completeDeferred.add( s.complete );
		   jqXHR.done( s.success );
		   jqXHR.fail( s.error );
   
		   // Get transport
		   transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
   
		   // If no transport, we auto-abort
		   if ( !transport ) {
			   done( -1, "No Transport" );
		   } else {
			   jqXHR.readyState = 1;
   
			   // Send global event
			   if ( fireGlobals ) {
				   globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			   }
   
			   // If request was aborted inside ajaxSend, stop there
			   if ( completed ) {
				   return jqXHR;
			   }
   
			   // Timeout
			   if ( s.async && s.timeout > 0 ) {
				   timeoutTimer = window.setTimeout( function() {
					   jqXHR.abort( "timeout" );
				   }, s.timeout );
			   }
   
			   try {
				   completed = false;
				   transport.send( requestHeaders, done );
			   } catch ( e ) {
   
				   // Rethrow post-completion exceptions
				   if ( completed ) {
					   throw e;
				   }
   
				   // Propagate others as results
				   done( -1, e );
			   }
		   }
   
		   // Callback for when everything is done
		   function done( status, nativeStatusText, responses, headers ) {
			   var isSuccess, success, error, response, modified,
				   statusText = nativeStatusText;
   
			   // Ignore repeat invocations
			   if ( completed ) {
				   return;
			   }
   
			   completed = true;
   
			   // Clear timeout if it exists
			   if ( timeoutTimer ) {
				   window.clearTimeout( timeoutTimer );
			   }
   
			   // Dereference transport for early garbage collection
			   // (no matter how long the jqXHR object will be used)
			   transport = undefined;
   
			   // Cache response headers
			   responseHeadersString = headers || "";
   
			   // Set readyState
			   jqXHR.readyState = status > 0 ? 4 : 0;
   
			   // Determine if successful
			   isSuccess = status >= 200 && status < 300 || status === 304;
   
			   // Get response data
			   if ( responses ) {
				   response = ajaxHandleResponses( s, jqXHR, responses );
			   }
   
			   // Convert no matter what (that way responseXXX fields are always set)
			   response = ajaxConvert( s, response, jqXHR, isSuccess );
   
			   // If successful, handle type chaining
			   if ( isSuccess ) {
   
				   // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				   if ( s.ifModified ) {
					   modified = jqXHR.getResponseHeader( "Last-Modified" );
					   if ( modified ) {
						   jQuery.lastModified[ cacheURL ] = modified;
					   }
					   modified = jqXHR.getResponseHeader( "etag" );
					   if ( modified ) {
						   jQuery.etag[ cacheURL ] = modified;
					   }
				   }
   
				   // if no content
				   if ( status === 204 || s.type === "HEAD" ) {
					   statusText = "nocontent";
   
				   // if not modified
				   } else if ( status === 304 ) {
					   statusText = "notmodified";
   
				   // If we have data, let's convert it
				   } else {
					   statusText = response.state;
					   success = response.data;
					   error = response.error;
					   isSuccess = !error;
				   }
			   } else {
   
				   // Extract error from statusText and normalize for non-aborts
				   error = statusText;
				   if ( status || !statusText ) {
					   statusText = "error";
					   if ( status < 0 ) {
						   status = 0;
					   }
				   }
			   }
   
			   // Set data for the fake xhr object
			   jqXHR.status = status;
			   jqXHR.statusText = ( nativeStatusText || statusText ) + "";
   
			   // Success/Error
			   if ( isSuccess ) {
				   deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			   } else {
				   deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			   }
   
			   // Status-dependent callbacks
			   jqXHR.statusCode( statusCode );
			   statusCode = undefined;
   
			   if ( fireGlobals ) {
				   globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					   [ jqXHR, s, isSuccess ? success : error ] );
			   }
   
			   // Complete
			   completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
   
			   if ( fireGlobals ) {
				   globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
   
				   // Handle the global AJAX counter
				   if ( !( --jQuery.active ) ) {
					   jQuery.event.trigger( "ajaxStop" );
				   }
			   }
		   }
   
		   return jqXHR;
	   },
   
	   getJSON: function( url, data, callback ) {
		   return jQuery.get( url, data, callback, "json" );
	   },
   
	   getScript: function( url, callback ) {
		   return jQuery.get( url, undefined, callback, "script" );
	   }
   } );
   
   jQuery.each( [ "get", "post" ], function( i, method ) {
	   jQuery[ method ] = function( url, data, callback, type ) {
   
		   // Shift arguments if data argument was omitted
		   if ( isFunction( data ) ) {
			   type = type || callback;
			   callback = data;
			   data = undefined;
		   }
   
		   // The url can be an options object (which then must have .url)
		   return jQuery.ajax( jQuery.extend( {
			   url: url,
			   type: method,
			   dataType: type,
			   data: data,
			   success: callback
		   }, jQuery.isPlainObject( url ) && url ) );
	   };
   } );
   
   
   jQuery._evalUrl = function( url, options ) {
	   return jQuery.ajax( {
		   url: url,
   
		   // Make this explicit, since user can override this through ajaxSetup (#11264)
		   type: "GET",
		   dataType: "script",
		   cache: true,
		   async: false,
		   global: false,
   
		   // Only evaluate the response if it is successful (gh-4126)
		   // dataFilter is not invoked for failure responses, so using it instead
		   // of the default converter is kludgy but it works.
		   converters: {
			   "text script": function() {}
		   },
		   dataFilter: function( response ) {
			   jQuery.globalEval( response, options );
		   }
	   } );
   };
   
   
   jQuery.fn.extend( {
	   wrapAll: function( html ) {
		   var wrap;
   
		   if ( this[ 0 ] ) {
			   if ( isFunction( html ) ) {
				   html = html.call( this[ 0 ] );
			   }
   
			   // The elements to wrap the target around
			   wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
   
			   if ( this[ 0 ].parentNode ) {
				   wrap.insertBefore( this[ 0 ] );
			   }
   
			   wrap.map( function() {
				   var elem = this;
   
				   while ( elem.firstElementChild ) {
					   elem = elem.firstElementChild;
				   }
   
				   return elem;
			   } ).append( this );
		   }
   
		   return this;
	   },
   
	   wrapInner: function( html ) {
		   if ( isFunction( html ) ) {
			   return this.each( function( i ) {
				   jQuery( this ).wrapInner( html.call( this, i ) );
			   } );
		   }
   
		   return this.each( function() {
			   var self = jQuery( this ),
				   contents = self.contents();
   
			   if ( contents.length ) {
				   contents.wrapAll( html );
   
			   } else {
				   self.append( html );
			   }
		   } );
	   },
   
	   wrap: function( html ) {
		   var htmlIsFunction = isFunction( html );
   
		   return this.each( function( i ) {
			   jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		   } );
	   },
   
	   unwrap: function( selector ) {
		   this.parent( selector ).not( "body" ).each( function() {
			   jQuery( this ).replaceWith( this.childNodes );
		   } );
		   return this;
	   }
   } );
   
   
   jQuery.expr.pseudos.hidden = function( elem ) {
	   return !jQuery.expr.pseudos.visible( elem );
   };
   jQuery.expr.pseudos.visible = function( elem ) {
	   return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
   };
   
   
   
   
   jQuery.ajaxSettings.xhr = function() {
	   try {
		   return new window.XMLHttpRequest();
	   } catch ( e ) {}
   };
   
   var xhrSuccessStatus = {
   
		   // File protocol always yields status code 0, assume 200
		   0: 200,
   
		   // Support: IE <=9 only
		   // #1450: sometimes IE returns 1223 when it should be 204
		   1223: 204
	   },
	   xhrSupported = jQuery.ajaxSettings.xhr();
   
   support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
   support.ajax = xhrSupported = !!xhrSupported;
   
   jQuery.ajaxTransport( function( options ) {
	   var callback, errorCallback;
   
	   // Cross domain only allowed if supported through XMLHttpRequest
	   if ( support.cors || xhrSupported && !options.crossDomain ) {
		   return {
			   send: function( headers, complete ) {
				   var i,
					   xhr = options.xhr();
   
				   xhr.open(
					   options.type,
					   options.url,
					   options.async,
					   options.username,
					   options.password
				   );
   
				   // Apply custom fields if provided
				   if ( options.xhrFields ) {
					   for ( i in options.xhrFields ) {
						   xhr[ i ] = options.xhrFields[ i ];
					   }
				   }
   
				   // Override mime type if needed
				   if ( options.mimeType && xhr.overrideMimeType ) {
					   xhr.overrideMimeType( options.mimeType );
				   }
   
				   // X-Requested-With header
				   // For cross-domain requests, seeing as conditions for a preflight are
				   // akin to a jigsaw puzzle, we simply never set it to be sure.
				   // (it can always be set on a per-request basis or even using ajaxSetup)
				   // For same-domain requests, won't change header if already provided.
				   if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					   headers[ "X-Requested-With" ] = "XMLHttpRequest";
				   }
   
				   // Set headers
				   for ( i in headers ) {
					   xhr.setRequestHeader( i, headers[ i ] );
				   }
   
				   // Callback
				   callback = function( type ) {
					   return function() {
						   if ( callback ) {
							   callback = errorCallback = xhr.onload =
								   xhr.onerror = xhr.onabort = xhr.ontimeout =
									   xhr.onreadystatechange = null;
   
							   if ( type === "abort" ) {
								   xhr.abort();
							   } else if ( type === "error" ) {
   
								   // Support: IE <=9 only
								   // On a manual native abort, IE9 throws
								   // errors on any property access that is not readyState
								   if ( typeof xhr.status !== "number" ) {
									   complete( 0, "error" );
								   } else {
									   complete(
   
										   // File: protocol always yields status 0; see #8605, #14207
										   xhr.status,
										   xhr.statusText
									   );
								   }
							   } else {
								   complete(
									   xhrSuccessStatus[ xhr.status ] || xhr.status,
									   xhr.statusText,
   
									   // Support: IE <=9 only
									   // IE9 has no XHR2 but throws on binary (trac-11426)
									   // For XHR2 non-text, let the caller handle it (gh-2498)
									   ( xhr.responseType || "text" ) !== "text"  ||
									   typeof xhr.responseText !== "string" ?
										   { binary: xhr.response } :
										   { text: xhr.responseText },
									   xhr.getAllResponseHeaders()
								   );
							   }
						   }
					   };
				   };
   
				   // Listen to events
				   xhr.onload = callback();
				   errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
   
				   // Support: IE 9 only
				   // Use onreadystatechange to replace onabort
				   // to handle uncaught aborts
				   if ( xhr.onabort !== undefined ) {
					   xhr.onabort = errorCallback;
				   } else {
					   xhr.onreadystatechange = function() {
   
						   // Check readyState before timeout as it changes
						   if ( xhr.readyState === 4 ) {
   
							   // Allow onerror to be called first,
							   // but that will not handle a native abort
							   // Also, save errorCallback to a variable
							   // as xhr.onerror cannot be accessed
							   window.setTimeout( function() {
								   if ( callback ) {
									   errorCallback();
								   }
							   } );
						   }
					   };
				   }
   
				   // Create the abort callback
				   callback = callback( "abort" );
   
				   try {
   
					   // Do send the request (this may raise an exception)
					   xhr.send( options.hasContent && options.data || null );
				   } catch ( e ) {
   
					   // #14683: Only rethrow if this hasn't been notified as an error yet
					   if ( callback ) {
						   throw e;
					   }
				   }
			   },
   
			   abort: function() {
				   if ( callback ) {
					   callback();
				   }
			   }
		   };
	   }
   } );
   
   
   
   
   // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
   jQuery.ajaxPrefilter( function( s ) {
	   if ( s.crossDomain ) {
		   s.contents.script = false;
	   }
   } );
   
   // Install script dataType
   jQuery.ajaxSetup( {
	   accepts: {
		   script: "text/javascript, application/javascript, " +
			   "application/ecmascript, application/x-ecmascript"
	   },
	   contents: {
		   script: /\b(?:java|ecma)script\b/
	   },
	   converters: {
		   "text script": function( text ) {
			   jQuery.globalEval( text );
			   return text;
		   }
	   }
   } );
   
   // Handle cache's special case and crossDomain
   jQuery.ajaxPrefilter( "script", function( s ) {
	   if ( s.cache === undefined ) {
		   s.cache = false;
	   }
	   if ( s.crossDomain ) {
		   s.type = "GET";
	   }
   } );
   
   // Bind script tag hack transport
   jQuery.ajaxTransport( "script", function( s ) {
   
	   // This transport only deals with cross domain or forced-by-attrs requests
	   if ( s.crossDomain || s.scriptAttrs ) {
		   var script, callback;
		   return {
			   send: function( _, complete ) {
				   script = jQuery( "<script>" )
					   .attr( s.scriptAttrs || {} )
					   .prop( { charset: s.scriptCharset, src: s.url } )
					   .on( "load error", callback = function( evt ) {
						   script.remove();
						   callback = null;
						   if ( evt ) {
							   complete( evt.type === "error" ? 404 : 200, evt.type );
						   }
					   } );
   
				   // Use native DOM manipulation to avoid our domManip AJAX trickery
				   document.head.appendChild( script[ 0 ] );
			   },
			   abort: function() {
				   if ( callback ) {
					   callback();
				   }
			   }
		   };
	   }
   } );
   
   
   
   
   var oldCallbacks = [],
	   rjsonp = /(=)\?(?=&|$)|\?\?/;
   
   // Default jsonp settings
   jQuery.ajaxSetup( {
	   jsonp: "callback",
	   jsonpCallback: function() {
		   var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		   this[ callback ] = true;
		   return callback;
	   }
   } );
   
   // Detect, normalize options and install callbacks for jsonp requests
   jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
   
	   var callbackName, overwritten, responseContainer,
		   jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			   "url" :
			   typeof s.data === "string" &&
				   ( s.contentType || "" )
					   .indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				   rjsonp.test( s.data ) && "data"
		   );
   
	   // Handle iff the expected data type is "jsonp" or we have a parameter to set
	   if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
   
		   // Get callback name, remembering preexisting value associated with it
		   callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			   s.jsonpCallback() :
			   s.jsonpCallback;
   
		   // Insert callback into url or form data
		   if ( jsonProp ) {
			   s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		   } else if ( s.jsonp !== false ) {
			   s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		   }
   
		   // Use data converter to retrieve json after script execution
		   s.converters[ "script json" ] = function() {
			   if ( !responseContainer ) {
				   jQuery.error( callbackName + " was not called" );
			   }
			   return responseContainer[ 0 ];
		   };
   
		   // Force json dataType
		   s.dataTypes[ 0 ] = "json";
   
		   // Install callback
		   overwritten = window[ callbackName ];
		   window[ callbackName ] = function() {
			   responseContainer = arguments;
		   };
   
		   // Clean-up function (fires after converters)
		   jqXHR.always( function() {
   
			   // If previous value didn't exist - remove it
			   if ( overwritten === undefined ) {
				   jQuery( window ).removeProp( callbackName );
   
			   // Otherwise restore preexisting value
			   } else {
				   window[ callbackName ] = overwritten;
			   }
   
			   // Save back as free
			   if ( s[ callbackName ] ) {
   
				   // Make sure that re-using the options doesn't screw things around
				   s.jsonpCallback = originalSettings.jsonpCallback;
   
				   // Save the callback name for future use
				   oldCallbacks.push( callbackName );
			   }
   
			   // Call if it was a function and we have a response
			   if ( responseContainer && isFunction( overwritten ) ) {
				   overwritten( responseContainer[ 0 ] );
			   }
   
			   responseContainer = overwritten = undefined;
		   } );
   
		   // Delegate to script
		   return "script";
	   }
   } );
   
   
   
   
   // Support: Safari 8 only
   // In Safari 8 documents created via document.implementation.createHTMLDocument
   // collapse sibling forms: the second one becomes a child of the first one.
   // Because of that, this security measure has to be disabled in Safari 8.
   // https://bugs.webkit.org/show_bug.cgi?id=137337
   support.createHTMLDocument = ( function() {
	   var body = document.implementation.createHTMLDocument( "" ).body;
	   body.innerHTML = "<form></form><form></form>";
	   return body.childNodes.length === 2;
   } )();
   
   
   // Argument "data" should be string of html
   // context (optional): If specified, the fragment will be created in this context,
   // defaults to document
   // keepScripts (optional): If true, will include scripts passed in the html string
   jQuery.parseHTML = function( data, context, keepScripts ) {
	   if ( typeof data !== "string" ) {
		   return [];
	   }
	   if ( typeof context === "boolean" ) {
		   keepScripts = context;
		   context = false;
	   }
   
	   var base, parsed, scripts;
   
	   if ( !context ) {
   
		   // Stop scripts or inline event handlers from being executed immediately
		   // by using document.implementation
		   if ( support.createHTMLDocument ) {
			   context = document.implementation.createHTMLDocument( "" );
   
			   // Set the base href for the created document
			   // so any parsed elements with URLs
			   // are based on the document's URL (gh-2965)
			   base = context.createElement( "base" );
			   base.href = document.location.href;
			   context.head.appendChild( base );
		   } else {
			   context = document;
		   }
	   }
   
	   parsed = rsingleTag.exec( data );
	   scripts = !keepScripts && [];
   
	   // Single tag
	   if ( parsed ) {
		   return [ context.createElement( parsed[ 1 ] ) ];
	   }
   
	   parsed = buildFragment( [ data ], context, scripts );
   
	   if ( scripts && scripts.length ) {
		   jQuery( scripts ).remove();
	   }
   
	   return jQuery.merge( [], parsed.childNodes );
   };
   
   
   /**
	* Load a url into a page
	*/
   jQuery.fn.load = function( url, params, callback ) {
	   var selector, type, response,
		   self = this,
		   off = url.indexOf( " " );
   
	   if ( off > -1 ) {
		   selector = stripAndCollapse( url.slice( off ) );
		   url = url.slice( 0, off );
	   }
   
	   // If it's a function
	   if ( isFunction( params ) ) {
   
		   // We assume that it's the callback
		   callback = params;
		   params = undefined;
   
	   // Otherwise, build a param string
	   } else if ( params && typeof params === "object" ) {
		   type = "POST";
	   }
   
	   // If we have elements to modify, make the request
	   if ( self.length > 0 ) {
		   jQuery.ajax( {
			   url: url,
   
			   // If "type" variable is undefined, then "GET" method will be used.
			   // Make value of this field explicit since
			   // user can override it through ajaxSetup method
			   type: type || "GET",
			   dataType: "html",
			   data: params
		   } ).done( function( responseText ) {
   
			   // Save response for use in complete callback
			   response = arguments;
   
			   self.html( selector ?
   
				   // If a selector was specified, locate the right elements in a dummy div
				   // Exclude scripts to avoid IE 'Permission Denied' errors
				   jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
   
				   // Otherwise use the full result
				   responseText );
   
		   // If the request succeeds, this function gets "data", "status", "jqXHR"
		   // but they are ignored because response was set above.
		   // If it fails, this function gets "jqXHR", "status", "error"
		   } ).always( callback && function( jqXHR, status ) {
			   self.each( function() {
				   callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			   } );
		   } );
	   }
   
	   return this;
   };
   
   
   
   
   // Attach a bunch of functions for handling common AJAX events
   jQuery.each( [
	   "ajaxStart",
	   "ajaxStop",
	   "ajaxComplete",
	   "ajaxError",
	   "ajaxSuccess",
	   "ajaxSend"
   ], function( i, type ) {
	   jQuery.fn[ type ] = function( fn ) {
		   return this.on( type, fn );
	   };
   } );
   
   
   
   
   jQuery.expr.pseudos.animated = function( elem ) {
	   return jQuery.grep( jQuery.timers, function( fn ) {
		   return elem === fn.elem;
	   } ).length;
   };
   
   
   
   
   jQuery.offset = {
	   setOffset: function( elem, options, i ) {
		   var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			   position = jQuery.css( elem, "position" ),
			   curElem = jQuery( elem ),
			   props = {};
   
		   // Set position first, in-case top/left are set even on static elem
		   if ( position === "static" ) {
			   elem.style.position = "relative";
		   }
   
		   curOffset = curElem.offset();
		   curCSSTop = jQuery.css( elem, "top" );
		   curCSSLeft = jQuery.css( elem, "left" );
		   calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			   ( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
   
		   // Need to be able to calculate position if either
		   // top or left is auto and position is either absolute or fixed
		   if ( calculatePosition ) {
			   curPosition = curElem.position();
			   curTop = curPosition.top;
			   curLeft = curPosition.left;
   
		   } else {
			   curTop = parseFloat( curCSSTop ) || 0;
			   curLeft = parseFloat( curCSSLeft ) || 0;
		   }
   
		   if ( isFunction( options ) ) {
   
			   // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			   options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		   }
   
		   if ( options.top != null ) {
			   props.top = ( options.top - curOffset.top ) + curTop;
		   }
		   if ( options.left != null ) {
			   props.left = ( options.left - curOffset.left ) + curLeft;
		   }
   
		   if ( "using" in options ) {
			   options.using.call( elem, props );
   
		   } else {
			   curElem.css( props );
		   }
	   }
   };
   
   jQuery.fn.extend( {
   
	   // offset() relates an element's border box to the document origin
	   offset: function( options ) {
   
		   // Preserve chaining for setter
		   if ( arguments.length ) {
			   return options === undefined ?
				   this :
				   this.each( function( i ) {
					   jQuery.offset.setOffset( this, options, i );
				   } );
		   }
   
		   var rect, win,
			   elem = this[ 0 ];
   
		   if ( !elem ) {
			   return;
		   }
   
		   // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		   // Support: IE <=11 only
		   // Running getBoundingClientRect on a
		   // disconnected node in IE throws an error
		   if ( !elem.getClientRects().length ) {
			   return { top: 0, left: 0 };
		   }
   
		   // Get document-relative position by adding viewport scroll to viewport-relative gBCR
		   rect = elem.getBoundingClientRect();
		   win = elem.ownerDocument.defaultView;
		   return {
			   top: rect.top + win.pageYOffset,
			   left: rect.left + win.pageXOffset
		   };
	   },
   
	   // position() relates an element's margin box to its offset parent's padding box
	   // This corresponds to the behavior of CSS absolute positioning
	   position: function() {
		   if ( !this[ 0 ] ) {
			   return;
		   }
   
		   var offsetParent, offset, doc,
			   elem = this[ 0 ],
			   parentOffset = { top: 0, left: 0 };
   
		   // position:fixed elements are offset from the viewport, which itself always has zero offset
		   if ( jQuery.css( elem, "position" ) === "fixed" ) {
   
			   // Assume position:fixed implies availability of getBoundingClientRect
			   offset = elem.getBoundingClientRect();
   
		   } else {
			   offset = this.offset();
   
			   // Account for the *real* offset parent, which can be the document or its root element
			   // when a statically positioned element is identified
			   doc = elem.ownerDocument;
			   offsetParent = elem.offsetParent || doc.documentElement;
			   while ( offsetParent &&
				   ( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				   jQuery.css( offsetParent, "position" ) === "static" ) {
   
				   offsetParent = offsetParent.parentNode;
			   }
			   if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
   
				   // Incorporate borders into its offset, since they are outside its content origin
				   parentOffset = jQuery( offsetParent ).offset();
				   parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				   parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			   }
		   }
   
		   // Subtract parent offsets and element margins
		   return {
			   top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			   left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		   };
	   },
   
	   // This method will return documentElement in the following cases:
	   // 1) For the element inside the iframe without offsetParent, this method will return
	   //    documentElement of the parent window
	   // 2) For the hidden or detached element
	   // 3) For body or html element, i.e. in case of the html node - it will return itself
	   //
	   // but those exceptions were never presented as a real life use-cases
	   // and might be considered as more preferable results.
	   //
	   // This logic, however, is not guaranteed and can change at any point in the future
	   offsetParent: function() {
		   return this.map( function() {
			   var offsetParent = this.offsetParent;
   
			   while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				   offsetParent = offsetParent.offsetParent;
			   }
   
			   return offsetParent || documentElement;
		   } );
	   }
   } );
   
   // Create scrollLeft and scrollTop methods
   jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	   var top = "pageYOffset" === prop;
   
	   jQuery.fn[ method ] = function( val ) {
		   return access( this, function( elem, method, val ) {
   
			   // Coalesce documents and windows
			   var win;
			   if ( isWindow( elem ) ) {
				   win = elem;
			   } else if ( elem.nodeType === 9 ) {
				   win = elem.defaultView;
			   }
   
			   if ( val === undefined ) {
				   return win ? win[ prop ] : elem[ method ];
			   }
   
			   if ( win ) {
				   win.scrollTo(
					   !top ? val : win.pageXOffset,
					   top ? val : win.pageYOffset
				   );
   
			   } else {
				   elem[ method ] = val;
			   }
		   }, method, val, arguments.length );
	   };
   } );
   
   // Support: Safari <=7 - 9.1, Chrome <=37 - 49
   // Add the top/left cssHooks using jQuery.fn.position
   // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
   // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
   // getComputedStyle returns percent when specified for top/left/bottom/right;
   // rather than make the css module depend on the offset module, just check for it here
   jQuery.each( [ "top", "left" ], function( i, prop ) {
	   jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		   function( elem, computed ) {
			   if ( computed ) {
				   computed = curCSS( elem, prop );
   
				   // If curCSS returns percentage, fallback to offset
				   return rnumnonpx.test( computed ) ?
					   jQuery( elem ).position()[ prop ] + "px" :
					   computed;
			   }
		   }
	   );
   } );
   
   
   // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
   jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	   jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		   function( defaultExtra, funcName ) {
   
		   // Margin is only for outerHeight, outerWidth
		   jQuery.fn[ funcName ] = function( margin, value ) {
			   var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				   extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
   
			   return access( this, function( elem, type, value ) {
				   var doc;
   
				   if ( isWindow( elem ) ) {
   
					   // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					   return funcName.indexOf( "outer" ) === 0 ?
						   elem[ "inner" + name ] :
						   elem.document.documentElement[ "client" + name ];
				   }
   
				   // Get document width or height
				   if ( elem.nodeType === 9 ) {
					   doc = elem.documentElement;
   
					   // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					   // whichever is greatest
					   return Math.max(
						   elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						   elem.body[ "offset" + name ], doc[ "offset" + name ],
						   doc[ "client" + name ]
					   );
				   }
   
				   return value === undefined ?
   
					   // Get width or height on the element, requesting but not forcing parseFloat
					   jQuery.css( elem, type, extra ) :
   
					   // Set width or height on the element
					   jQuery.style( elem, type, value, extra );
			   }, type, chainable ? margin : undefined, chainable );
		   };
	   } );
   } );
   
   
   jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	   "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	   "change select submit keydown keypress keyup contextmenu" ).split( " " ),
	   function( i, name ) {
   
	   // Handle event binding
	   jQuery.fn[ name ] = function( data, fn ) {
		   return arguments.length > 0 ?
			   this.on( name, null, data, fn ) :
			   this.trigger( name );
	   };
   } );
   
   jQuery.fn.extend( {
	   hover: function( fnOver, fnOut ) {
		   return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	   }
   } );
   
   
   
   
   jQuery.fn.extend( {
   
	   bind: function( types, data, fn ) {
		   return this.on( types, null, data, fn );
	   },
	   unbind: function( types, fn ) {
		   return this.off( types, null, fn );
	   },
   
	   delegate: function( selector, types, data, fn ) {
		   return this.on( types, selector, data, fn );
	   },
	   undelegate: function( selector, types, fn ) {
   
		   // ( namespace ) or ( selector, types [, fn] )
		   return arguments.length === 1 ?
			   this.off( selector, "**" ) :
			   this.off( types, selector || "**", fn );
	   }
   } );
   
   // Bind a function to a context, optionally partially applying any
   // arguments.
   // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
   // However, it is not slated for removal any time soon
   jQuery.proxy = function( fn, context ) {
	   var tmp, args, proxy;
   
	   if ( typeof context === "string" ) {
		   tmp = fn[ context ];
		   context = fn;
		   fn = tmp;
	   }
   
	   // Quick check to determine if target is callable, in the spec
	   // this throws a TypeError, but we will just return undefined.
	   if ( !isFunction( fn ) ) {
		   return undefined;
	   }
   
	   // Simulated bind
	   args = slice.call( arguments, 2 );
	   proxy = function() {
		   return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	   };
   
	   // Set the guid of unique handler to the same of original handler, so it can be removed
	   proxy.guid = fn.guid = fn.guid || jQuery.guid++;
   
	   return proxy;
   };
   
   jQuery.holdReady = function( hold ) {
	   if ( hold ) {
		   jQuery.readyWait++;
	   } else {
		   jQuery.ready( true );
	   }
   };
   jQuery.isArray = Array.isArray;
   jQuery.parseJSON = JSON.parse;
   jQuery.nodeName = nodeName;
   jQuery.isFunction = isFunction;
   jQuery.isWindow = isWindow;
   jQuery.camelCase = camelCase;
   jQuery.type = toType;
   
   jQuery.now = Date.now;
   
   jQuery.isNumeric = function( obj ) {
   
	   // As of jQuery 3.0, isNumeric is limited to
	   // strings and numbers (primitives or objects)
	   // that can be coerced to finite numbers (gh-2662)
	   var type = jQuery.type( obj );
	   return ( type === "number" || type === "string" ) &&
   
		   // parseFloat NaNs numeric-cast false positives ("")
		   // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		   // subtraction forces infinities to NaN
		   !isNaN( obj - parseFloat( obj ) );
   };
   
   
   
   
   // Register as a named AMD module, since jQuery can be concatenated with other
   // files that may use define, but not via a proper concatenation script that
   // understands anonymous AMD modules. A named AMD is safest and most robust
   // way to register. Lowercase jquery is used because AMD module names are
   // derived from file names, and jQuery is normally delivered in a lowercase
   // file name. Do this after creating the global so that if an AMD module wants
   // to call noConflict to hide this version of jQuery, it will work.
   
   // Note that for maximum portability, libraries that are not jQuery should
   // declare themselves as anonymous modules, and avoid setting a global if an
   // AMD loader is present. jQuery is a special case. For more information, see
   // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
   
   if ( true ) {
	   !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		   return jQuery;
	   }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
   }
   
   
   
   
   var
   
	   // Map over jQuery in case of overwrite
	   _jQuery = window.jQuery,
   
	   // Map over the $ in case of overwrite
	   _$ = window.$;
   
   jQuery.noConflict = function( deep ) {
	   if ( window.$ === jQuery ) {
		   window.$ = _$;
	   }
   
	   if ( deep && window.jQuery === jQuery ) {
		   window.jQuery = _jQuery;
	   }
   
	   return jQuery;
   };
   
   // Expose jQuery and $ identifiers, even in AMD
   // (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
   // and CommonJS for browser emulators (#13566)
   if ( !noGlobal ) {
	   window.jQuery = window.$ = jQuery;
   }
   
   
   
   
   return jQuery;
   } );
   
   
   /***/ }),
   /* 1 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * $script.js JS loader & dependency manager
	 * https://github.com/ded/script.js
	 * (c) Dustin Diaz 2014 | License MIT
	 */
   
   (function (name, definition) {
	 if ( true && module.exports) module.exports = definition()
	 else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				   __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				   (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				   __WEBPACK_AMD_DEFINE_FACTORY__),
				   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	 else {}
   })('$script', function () {
	 var doc = document
	   , head = doc.getElementsByTagName('head')[0]
	   , s = 'string'
	   , f = false
	   , push = 'push'
	   , readyState = 'readyState'
	   , onreadystatechange = 'onreadystatechange'
	   , list = {}
	   , ids = {}
	   , delay = {}
	   , scripts = {}
	   , scriptpath
	   , urlArgs
   
	 function every(ar, fn) {
	   for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
	   return 1
	 }
	 function each(ar, fn) {
	   every(ar, function (el) {
		 fn(el)
		 return 1
	   })
	 }
   
	 function $script(paths, idOrDone, optDone) {
	   paths = paths[push] ? paths : [paths]
	   var idOrDoneIsDone = idOrDone && idOrDone.call
		 , done = idOrDoneIsDone ? idOrDone : optDone
		 , id = idOrDoneIsDone ? paths.join('') : idOrDone
		 , queue = paths.length
	   function loopFn(item) {
		 return item.call ? item() : list[item]
	   }
	   function callback() {
		 if (!--queue) {
		   list[id] = 1
		   done && done()
		   for (var dset in delay) {
			 every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
		   }
		 }
	   }
	   setTimeout(function () {
		 each(paths, function loading(path, force) {
		   if (path === null) return callback()
		   
		   if (!force && !/^https?:\/\//.test(path) && scriptpath) {
			 path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
		   }
		   
		   if (scripts[path]) {
			 if (id) ids[id] = 1
			 return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
		   }
   
		   scripts[path] = 1
		   if (id) ids[id] = 1
		   create(path, callback)
		 })
	   }, 0)
	   return $script
	 }
   
	 function create(path, fn) {
	   var el = doc.createElement('script'), loaded
	   el.onload = el.onerror = el[onreadystatechange] = function () {
		 if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
		 el.onload = el[onreadystatechange] = null
		 loaded = 1
		 scripts[path] = 2
		 fn()
	   }
	   el.async = 1
	   el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
	   head.insertBefore(el, head.lastChild)
	 }
   
	 $script.get = create
   
	 $script.order = function (scripts, id, done) {
	   (function callback(s) {
		 s = scripts.shift()
		 !scripts.length ? $script(s, id, done) : $script(s, callback)
	   }())
	 }
   
	 $script.path = function (p) {
	   scriptpath = p
	 }
	 $script.urlArgs = function (str) {
	   urlArgs = str;
	 }
	 $script.ready = function (deps, ready, req) {
	   deps = deps[push] ? deps : [deps]
	   var missing = [];
	   !each(deps, function (dep) {
		 list[dep] || missing[push](dep);
	   }) && every(deps, function (dep) {return list[dep]}) ?
		 ready() : !function (key) {
		 delay[key] = delay[key] || []
		 delay[key][push](ready)
		 req && req(missing)
	   }(deps.join('|'))
	   return $script
	 }
   
	 $script.done = function (idOrDone) {
	   $script([null], idOrDone)
	 }
   
	 return $script
   });
   
   
   /***/ }),
   /* 2 */
   /***/ (function(module, exports, __webpack_require__) {
   
   "use strict";
   
   
   Object.defineProperty(exports, '__esModule', { value: true });
   
   var moneyFormats = {
	 USD: {
	   'money_format': '$',
	   'money_with_currency_format': '$ USD'
	 },
	 EUR: {
	   'money_format': '&euro;',
	   'money_with_currency_format': '&euro; EUR'
	 },
	 GBP: {
	   'money_format': '&pound;',
	   'money_with_currency_format': '&pound; GBP'
	 },
	 CAD: {
	   'money_format': '$',
	   'money_with_currency_format': '$ CAD'
	 },
	 ALL: {
	   'money_format': 'Lek ',
	   'money_with_currency_format': 'Lek  ALL'
	 },
	 DZD: {
	   'money_format': 'DA ',
	   'money_with_currency_format': 'DA  DZD'
	 },
	 AOA: {
	   'money_format': 'Kz',
	   'money_with_currency_format': 'Kz AOA'
	 },
	 ARS: {
	   'money_format': '$',
	   'money_with_currency_format': '$ ARS'
	 },
	 AMD: {
	   'money_format': ' AMD',
	   'money_with_currency_format': ' AMD'
	 },
	 AWG: {
	   'money_format': 'Afl',
	   'money_with_currency_format': 'Afl AWG'
	 },
	 AUD: {
	   'money_format': '$',
	   'money_with_currency_format': '$ AUD'
	 },
	 BBD: {
	   'money_format': '$',
	   'money_with_currency_format': '$ Bds'
	 },
	 AZN: {
	   'money_format': 'm.',
	   'money_with_currency_format': 'm. AZN'
	 },
	 BDT: {
	   'money_format': 'Tk ',
	   'money_with_currency_format': 'Tk  BDT'
	 },
	 BSD: {
	   'money_format': 'BS$',
	   'money_with_currency_format': 'BS$ BSD'
	 },
	 BHD: {
	   'money_format': '0 BD',
	   'money_with_currency_format': '0 BHD'
	 },
	 BYR: {
	   'money_format': 'Br ',
	   'money_with_currency_format': 'Br  BYR'
	 },
	 BZD: {
	   'money_format': 'BZ$',
	   'money_with_currency_format': 'BZ$ BZD'
	 },
	 BTN: {
	   'money_format': 'Nu ',
	   'money_with_currency_format': 'Nu  BTN'
	 },
	 BAM: {
	   'money_format': 'KM ',
	   'money_with_currency_format': 'KM  BAM'
	 },
	 BRL: {
	   'money_format': 'R$ ',
	   'money_with_currency_format': 'R$  BRL'
	 },
	 BOB: {
	   'money_format': 'Bs',
	   'money_with_currency_format': 'Bs BOB'
	 },
	 BWP: {
	   'money_format': 'P',
	   'money_with_currency_format': 'P BWP'
	 },
	 BND: {
	   'money_format': '$',
	   'money_with_currency_format': '$ BND'
	 },
	 BGN: {
	   'money_format': ' лв',
	   'money_with_currency_format': ' лв BGN'
	 },
	 MMK: {
	   'money_format': 'K',
	   'money_with_currency_format': 'K MMK'
	 },
	 KHR: {
	   'money_format': 'KHR',
	   'money_with_currency_format': 'KHR'
	 },
	 KYD: {
	   'money_format': '$',
	   'money_with_currency_format': '$ KYD'
	 },
	 XAF: {
	   'money_format': 'FCFA',
	   'money_with_currency_format': 'FCFA XAF'
	 },
	 CLP: {
	   'money_format': '$',
	   'money_with_currency_format': '$ CLP'
	 },
	 CNY: {
	   'money_format': '&#165;',
	   'money_with_currency_format': '&#165; CNY'
	 },
	 COP: {
	   'money_format': '$',
	   'money_with_currency_format': '$ COP'
	 },
	 CRC: {
	   'money_format': '&#8353; ',
	   'money_with_currency_format': '&#8353;  CRC'
	 },
	 HRK: {
	   'money_format': ' kn',
	   'money_with_currency_format': ' kn HRK'
	 },
	 CZK: {
	   'money_format': ' K&#269;',
	   'money_with_currency_format': ' K&#269;'
	 },
	 DKK: {
	   'money_format': '',
	   'money_with_currency_format': 'kr.'
	 },
	 DOP: {
	   'money_format': 'RD$ ',
	   'money_with_currency_format': 'RD$ '
	 },
	 XCD: {
	   'money_format': '$',
	   'money_with_currency_format': 'EC$'
	 },
	 EGP: {
	   'money_format': 'LE ',
	   'money_with_currency_format': 'LE  EGP'
	 },
	 ETB: {
	   'money_format': 'Br',
	   'money_with_currency_format': 'Br ETB'
	 },
	 XPF: {
	   'money_format': ' XPF',
	   'money_with_currency_format': ' XPF'
	 },
	 FJD: {
	   'money_format': '$',
	   'money_with_currency_format': 'FJ$'
	 },
	 GMD: {
	   'money_format': 'D ',
	   'money_with_currency_format': 'D  GMD'
	 },
	 GHS: {
	   'money_format': 'GH&#8373;',
	   'money_with_currency_format': 'GH&#8373;'
	 },
	 GTQ: {
	   'money_format': 'Q',
	   'money_with_currency_format': ' GTQ'
	 },
	 GYD: {
	   'money_format': 'G$',
	   'money_with_currency_format': '$ GYD'
	 },
	 GEL: {
	   'money_format': ' GEL',
	   'money_with_currency_format': ' GEL'
	 },
	 HNL: {
	   'money_format': 'L ',
	   'money_with_currency_format': 'L  HNL'
	 },
	 HKD: {
	   'money_format': '$',
	   'money_with_currency_format': 'HK$'
	 },
	 HUF: {
	   'money_format': '',
	   'money_with_currency_format': ' Ft'
	 },
	 ISK: {
	   'money_format': ' kr',
	   'money_with_currency_format': ' kr ISK'
	 },
	 INR: {
	   'money_format': 'Rs. ',
	   'money_with_currency_format': 'Rs. '
	 },
	 IDR: {
	   'money_format': '',
	   'money_with_currency_format': 'Rp '
	 },
	 ILS: {
	   'money_format': ' NIS',
	   'money_with_currency_format': ' NIS'
	 },
	 JMD: {
	   'money_format': '$',
	   'money_with_currency_format': '$ JMD'
	 },
	 JPY: {
	   'money_format': '&#165;',
	   'money_with_currency_format': '&#165; JPY'
	 },
	 JEP: {
	   'money_format': '&pound;',
	   'money_with_currency_format': '&pound; JEP'
	 },
	 JOD: {
	   'money_format': '0 JD',
	   'money_with_currency_format': '0 JOD'
	 },
	 KZT: {
	   'money_format': ' KZT',
	   'money_with_currency_format': ' KZT'
	 },
	 KES: {
	   'money_format': 'KSh',
	   'money_with_currency_format': 'KSh'
	 },
	 KWD: {
	   'money_format': '0 KD',
	   'money_with_currency_format': '0 KWD'
	 },
	 KGS: {
	   'money_format': 'лв',
	   'money_with_currency_format': 'лв'
	 },
	 LVL: {
	   'money_format': 'Ls ',
	   'money_with_currency_format': 'Ls  LVL'
	 },
	 LBP: {
	   'money_format': 'L&pound;',
	   'money_with_currency_format': 'L&pound; LBP'
	 },
	 LTL: {
	   'money_format': ' Lt',
	   'money_with_currency_format': ' Lt'
	 },
	 MGA: {
	   'money_format': 'Ar ',
	   'money_with_currency_format': 'Ar  MGA'
	 },
	 MKD: {
	   'money_format': 'ден ',
	   'money_with_currency_format': 'ден  MKD'
	 },
	 MOP: {
	   'money_format': 'MOP$',
	   'money_with_currency_format': 'MOP$'
	 },
	 MVR: {
	   'money_format': 'Rf',
	   'money_with_currency_format': 'Rf MRf'
	 },
	 MXN: {
	   'money_format': '$ ',
	   'money_with_currency_format': '$  MXN'
	 },
	 MYR: {
	   'money_format': 'RM MYR',
	   'money_with_currency_format': 'RM MYR'
	 },
	 MUR: {
	   'money_format': 'Rs ',
	   'money_with_currency_format': 'Rs  MUR'
	 },
	 MDL: {
	   'money_format': ' MDL',
	   'money_with_currency_format': ' MDL'
	 },
	 MAD: {
	   'money_format': ' dh',
	   'money_with_currency_format': 'Dh  MAD'
	 },
	 MNT: {
	   'money_format': ' &#8366',
	   'money_with_currency_format': ' MNT'
	 },
	 MZN: {
	   'money_format': ' Mt',
	   'money_with_currency_format': 'Mt  MZN'
	 },
	 NAD: {
	   'money_format': 'N$',
	   'money_with_currency_format': 'N$ NAD'
	 },
	 NPR: {
	   'money_format': 'Rs',
	   'money_with_currency_format': 'Rs NPR'
	 },
	 ANG: {
	   'money_format': '&fnof;',
	   'money_with_currency_format': ' NA&fnof;'
	 },
	 NZD: {
	   'money_format': '$',
	   'money_with_currency_format': '$ NZD'
	 },
	 NIO: {
	   'money_format': 'C$',
	   'money_with_currency_format': 'C$ NIO'
	 },
	 NGN: {
	   'money_format': '&#8358;',
	   'money_with_currency_format': '&#8358; NGN'
	 },
	 NOK: {
	   'money_format': 'kr ',
	   'money_with_currency_format': 'kr  NOK'
	 },
	 OMR: {
	   'money_format': ' OMR',
	   'money_with_currency_format': ' OMR'
	 },
	 PKR: {
	   'money_format': 'Rs.',
	   'money_with_currency_format': 'Rs. PKR'
	 },
	 PGK: {
	   'money_format': 'K ',
	   'money_with_currency_format': 'K  PGK'
	 },
	 PYG: {
	   'money_format': 'Gs. ',
	   'money_with_currency_format': 'Gs.  PYG'
	 },
	 PEN: {
	   'money_format': 'S/. ',
	   'money_with_currency_format': 'S/.  PEN'
	 },
	 PHP: {
	   'money_format': '&#8369;',
	   'money_with_currency_format': '&#8369; PHP'
	 },
	 PLN: {
	   'money_format': ' zl',
	   'money_with_currency_format': ' zl PLN'
	 },
	 QAR: {
	   'money_format': 'QAR ',
	   'money_with_currency_format': 'QAR '
	 },
	 RON: {
	   'money_format': ' lei',
	   'money_with_currency_format': ' lei RON'
	 },
	 RUB: {
	   'money_format': '&#1088;&#1091;&#1073;',
	   'money_with_currency_format': '&#1088;&#1091;&#1073; RUB'
	 },
	 RWF: {
	   'money_format': ' RF',
	   'money_with_currency_format': ' RWF'
	 },
	 WST: {
	   'money_format': 'WS$ ',
	   'money_with_currency_format': 'WS$  WST'
	 },
	 SAR: {
	   'money_format': ' SR',
	   'money_with_currency_format': ' SAR'
	 },
	 STD: {
	   'money_format': 'Db ',
	   'money_with_currency_format': 'Db  STD'
	 },
	 RSD: {
	   'money_format': ' RSD',
	   'money_with_currency_format': ' RSD'
	 },
	 SCR: {
	   'money_format': 'Rs ',
	   'money_with_currency_format': 'Rs  SCR'
	 },
	 SGD: {
	   'money_format': '$',
	   'money_with_currency_format': '$ SGD'
	 },
	 SYP: {
	   'money_format': 'S&pound;',
	   'money_with_currency_format': 'S&pound; SYP'
	 },
	 ZAR: {
	   'money_format': 'R ',
	   'money_with_currency_format': 'R  ZAR'
	 },
	 KRW: {
	   'money_format': '&#8361;',
	   'money_with_currency_format': '&#8361; KRW'
	 },
	 LKR: {
	   'money_format': 'Rs ',
	   'money_with_currency_format': 'Rs  LKR'
	 },
	 SEK: {
	   'money_format': ' kr',
	   'money_with_currency_format': ' kr SEK'
	 },
	 CHF: {
	   'money_format': 'SFr. ',
	   'money_with_currency_format': 'SFr.  CHF'
	 },
	 TWD: {
	   'money_format': '$',
	   'money_with_currency_format': '$ TWD'
	 },
	 THB: {
	   'money_format': ' &#xe3f;',
	   'money_with_currency_format': ' &#xe3f; THB'
	 },
	 TZS: {
	   'money_format': ' TZS',
	   'money_with_currency_format': ' TZS'
	 },
	 TTD: {
	   'money_format': '$',
	   'money_with_currency_format': '$ TTD'
	 },
	 TND: {
	   'money_format': '',
	   'money_with_currency_format': ' DT'
	 },
	 TRY: {
	   'money_format': 'TL',
	   'money_with_currency_format': 'TL'
	 },
	 UGX: {
	   'money_format': 'Ush ',
	   'money_with_currency_format': 'Ush  UGX'
	 },
	 UAH: {
	   'money_format': '₴',
	   'money_with_currency_format': '₴ UAH'
	 },
	 AED: {
	   'money_format': 'Dhs. ',
	   'money_with_currency_format': 'Dhs.  AED'
	 },
	 UYU: {
	   'money_format': '$',
	   'money_with_currency_format': '$ UYU'
	 },
	 VUV: {
	   'money_format': '$',
	   'money_with_currency_format': '$VT'
	 },
	 VEF: {
	   'money_format': 'Bs. ',
	   'money_with_currency_format': 'Bs.  VEF'
	 },
	 VND: {
	   'money_format': '&#8363;',
	   'money_with_currency_format': ' VND'
	 },
	 XBT: {
	   'money_format': ' BTC',
	   'money_with_currency_format': ' BTC'
	 },
	 XOF: {
	   'money_format': 'CFA',
	   'money_with_currency_format': 'CFA XOF'
	 },
	 ZMW: {
	   'money_format': 'K',
	   'money_with_currency_format': 'ZMW'
	 }
   };
   
   /**
	* Format a number to a specific format
	*
	* @param {Number} number - Value to format
	* @param {Number} precision - Amount of decimal points to show
	* @param {String} thousands - Thousands delimiter
	* @param {String} decimal - Decimal delimiter
	* @returns {String|Number}
	*/
   function formatWithDelimiters(number) {
	 var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	 var thousands = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
	 var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
   
	 if (isNaN(number) || !number) {
	   return 0;
	 }
   
	 var preciseNumber = (number / 100.0).toFixed(precision);
   
	 var parts = preciseNumber.split(thousands);
	 var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
	 var centsAmount = parts[1] ? decimal + parts[1] : '';
   
	 return dollarsAmount + centsAmount;
   }
   
   /**
	* Convert a money value in cents to a formatted currency string
	*
	* @param {Number|String} cents
	* @param {String} format
	* @returns {String}
	*/
   function formatMoney(cents, format) {
	 if (typeof cents === 'string') {
	   cents = cents.replace('.', '');
	 }
   
	 var value = '';
	 var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
   
	 switch (format.match(placeholderRegex)[1]) {
	   case 'amount':
		 value = formatWithDelimiters(cents, 2, ',', '.');
		 break;
	   case 'amount_with_space_separator':
		 value = formatWithDelimiters(cents, 2, ' ', '.');
		 break;
	   case 'amount_with_comma_separator':
		 value = formatWithDelimiters(cents, 2, '.', ',');
		 break;
	   case 'amount_with_apostrophe_separator':
		 value = formatWithDelimiters(cents, 2, '\'', '.');
		 break;
	   case 'amount_no_decimals':
		 value = formatWithDelimiters(cents, 0, ',', '.');
		 break;
	   case 'amount_no_decimals_with_space_separator':
		 value = formatWithDelimiters(cents, 0, ' ', '.');
		 break;
	   case 'amount_no_decimals_with_comma_separator':
		 value = formatWithDelimiters(cents, 0, ',', '.');
		 break;
	 }
   
	 return format.replace(placeholderRegex, value);
   }
   
   /**
	* Return the value of money in cents value
	*
	* @param {Number} moneyAmount - Money value of a price
	*                 eg: 1000
	* @param {String} format - Shop formatting of a price
	*                 eg: 
	* @param {String} currency - Currency of a price
	*                 eg: 'CAD'
	* @returns {Number}
	* @private
	*/
   function getCentsValue(moneyAmount, format, currency) {
	 var cents = 0;
	 // Convert prices from float values to integers if needed, then convert
	 if (format.indexOf('amount_no_decimals') !== -1) {
	   cents = moneyAmount * 100;
	 } else if (currency === 'JOD' || currency === 'KWD' || currency === 'BHD') {
	   cents = moneyAmount / 10;
	 } else {
	   cents = moneyAmount;
	 }
   
	 return cents;
   }
   
   /**
	* Converts formatted money to a number
	*
	* @param {Element} priceEl
	* @returns {Number|String}
	*/
   function getMoneyValue(priceEl) {
	 var price = priceEl.textContent;
	 var value = parseInt(price.replace(/[^0-9]/g, ''), 10);
   
	 return !isNaN(value) ? value : '';
   }
   
   var classCallCheck = function (instance, Constructor) {
	 if (!(instance instanceof Constructor)) {
	   throw new TypeError("Cannot call a class as a function");
	 }
   };
   
   var createClass = function () {
	 function defineProperties(target, props) {
	   for (var i = 0; i < props.length; i++) {
		 var descriptor = props[i];
		 descriptor.enumerable = descriptor.enumerable || false;
		 descriptor.configurable = true;
		 if ("value" in descriptor) descriptor.writable = true;
		 Object.defineProperty(target, descriptor.key, descriptor);
	   }
	 }
   
	 return function (Constructor, protoProps, staticProps) {
	   if (protoProps) defineProperties(Constructor.prototype, protoProps);
	   if (staticProps) defineProperties(Constructor, staticProps);
	   return Constructor;
	 };
   }();
   
   var CurrencyConverter = function () {
	 function CurrencyConverter() {
	   classCallCheck(this, CurrencyConverter);
   
	   this.defaults = {
		 switcherSelector: '[data-currency-converter]',
		 priceSelector: '.money',
		 shopCurrency: '',
		 defaultCurrency: '',
		 displayFormat: '',
		 moneyFormat: '$',
		 moneyFormatNoCurrency: '',
		 moneyFormatCurrency: ''
	   };
   
	   this.options = {};
	   this.moneyFormats = moneyFormats;
	   this.storage = 'currency';
	   this.currentCurrency = null;
	   this.isInitialised = false;
	 }
   
	 /**
	  * Initialize CurrencyConverter
	  *
	  * @param settings
	  * @property {Object} settings
	  *                    Configuration for CurrencyConverter
	  * @property {String} settings.switcherSelector
	  *                    CSS Selector for dropdown(s) which controls currency conversion
	  * @property {String} settings.priceSelector
	  *                    CSS Selector for elements containing prices
	  * @property {String} settings.shopCurrency
	  *                    Shop's currency (The currency used to process transactions)
	  * @property {String} settings.defaultCurrency
	  *                    Theme's currency setting, or initial currency to show on the page
	  * @property {String} settings.displayFormat
	  *                    `money_with_currency_format` or `money_format`
	  * @property {String} settings.moneyFormat
	  *                    Shop's currency formatted using the selected display format
	  * @property {String} settings.moneyFormatNoCurrency
	  *                    Shop's currency formatted without showing currency code
	  * @property {String} settings.moneyFormatCurrency
	  *                    Shop's currency formatted showing currency code
	  */
   
   
	 createClass(CurrencyConverter, [{
	   key: 'init',
	   value: function init(settings) {
		 var _this = this;
   
		 if (!window.Currency || this.isInitialised) return;
   
		 Object.keys(this.defaults).forEach(function (key) {
		   _this.options[key] = settings[key] || _this.defaults[key];
		 });
   
		 this.currentCurrency = this._getStoredCurrency() || this.options.defaultCurrency;
		 this.moneyFormats[this.options.shopCurrency].money_with_currency_format = this.options.moneyFormatCurrency;
		 this.moneyFormats[this.options.shopCurrency].money_format = this.options.moneyFormatNoCurrency;
   
		 this.isInitialised = true;
		 this._current();
	   }
   
	   /**
		* Change the currency to a new currency using an ISO currency code
		*
		* @param {String} newCurrency - New currency to convert prices to
		*/
   
	 }, {
	   key: 'setCurrency',
	   value: function setCurrency(newCurrency) {
		 if (!this.isInitialised) return;
   
		 this._convertAll(this.currentCurrency, newCurrency);
	   }
   
	   /**
		* Update a price on the page from shop currency to the active currency, and formatting
		*
		* @param priceEl {HTMLElement} - element containing price text, in the shop currency
		*/
   
	 }, {
	   key: 'update',
	   value: function update(priceEl) {
		 if (!this.isInitialised) return;
   
		 // unset any stored previous conversions and the data-currency attribute itself
		 var attributes = priceEl.attributes;
		 for (var attr = 0; attr < attributes.length; attr++) {
		   var attribute = attributes[attr];
   
		   if (attribute.name.indexOf('data-currency') === 0) {
			 priceEl.setAttribute(attribute.name, '');
		   }
		 }
   
		 this._convertEl(priceEl, this.options.shopCurrency, this.currentCurrency);
	   }
   
	   /**
		* Return the stored currency from the client's browser
		* @returns {String}
		* @private
		*/
   
	 }, {
	   key: '_getStoredCurrency',
	   value: function _getStoredCurrency() {
		 try {
		   return localStorage.getItem(this.storage);
		 } catch (error) {
		   console.warn(error);
		   return this.options.defaultCurrency;
		 }
	   }
   
	   /**
		* Save the client's currency in localstorage for persistence across pages
		* and sessions
		* @param {String} currency
		* @private
		*/
   
	 }, {
	   key: '_setStoredCurrency',
	   value: function _setStoredCurrency(currency) {
		 try {
		   localStorage.setItem(this.storage, currency);
		 } catch (error) {
		   console.warn(error);
		 }
	   }
   
	   /**
		* Update the currency switcher to the current currency
		* @private
		*/
   
	 }, {
	   key: '_current',
	   value: function _current() {
		 var switchers = document.querySelectorAll(this.options.switcherSelector);
		 for (var i = 0; i < switchers.length; i += 1) {
		   var switcher = switchers[i];
		   var childrenEls = switcher.querySelectorAll('option');
   
		   for (var j = 0; j < childrenEls.length; j += 1) {
			 var optionEl = childrenEls[j];
   
			 if (optionEl.selected && optionEl.value !== this.currentCurrency) {
			   optionEl.selected = false;
			 }
   
			 if (optionEl.value === this.currentCurrency) {
			   optionEl.selected = true;
			 }
		   }
		 }
   
		 this._convertAll(this.options.shopCurrency, this.currentCurrency);
	   }
   
	   /**
		* Converts an individual price to the new format
		*
		* @param {Element} priceEl - Node element containing price
		* @param {String} oldCurrency - Currency of element converting from
		* @param {String} newCurrency - Currency to convert to
		* @private
		*/
   
	 }, {
	   key: '_convertEl',
	   value: function _convertEl(priceEl, oldCurrency, newCurrency) {
		 // If the amount has already been converted, we leave it alone.
		 if (priceEl.getAttribute('data-currency') === newCurrency) {
		   return;
		 }
   
		 // If we are converting to a currency that we have saved, we will use the saved amount.
		 if (priceEl.getAttribute('data-currency-' + newCurrency)) {
		   priceEl.innerHTML = priceEl.getAttribute('data-currency-' + newCurrency);
		 } else {
		   var oldFormat = this.moneyFormats[oldCurrency][this.options.displayFormat];
		   var newFormat = this.moneyFormats[newCurrency][this.options.displayFormat];
   
		   var moneyValue = getMoneyValue(priceEl);
		   var centsValue = getCentsValue(moneyValue, oldFormat, oldCurrency);
   
		   // Cents value is empty, but not 0. 0$ is a valid price, while empty is not
		   if (centsValue === '') return;
   
		   var cents = window.Currency.convert(centsValue, oldCurrency, newCurrency);
		   var oldPriceFormatted = formatMoney(centsValue, oldFormat);
		   var priceFormatted = formatMoney(cents, newFormat);
   
		   priceEl.setAttribute('data-currency-' + oldCurrency, oldPriceFormatted);
		   priceEl.setAttribute('data-currency-' + newCurrency, priceFormatted);
		   priceEl.innerHTML = priceFormatted;
		 }
   
		 priceEl.setAttribute('data-currency', newCurrency);
	   }
   
	   /**
		* Convert all prices on the page to the new currency
		*
		* @param {String} oldCurrency - Currency of element converting from
		* @param {String} newCurrency - Currency to convert to
		* @private
		*/
   
	 }, {
	   key: '_convertAll',
	   value: function _convertAll(oldCurrency, newCurrency) {
		 var priceEls = document.querySelectorAll(this.options.priceSelector);
		 if (!priceEls) return;
   
		 this.currentCurrency = newCurrency;
		 this._setStoredCurrency(newCurrency);
   
		 for (var i = 0; i < priceEls.length; i += 1) {
		   this._convertEl(priceEls[i], oldCurrency, newCurrency);
		 }
	   }
	 }]);
	 return CurrencyConverter;
   }();
   
   var singletonInstance = new CurrencyConverter();
   
   exports['default'] = singletonInstance;
   exports.CurrencyConverter = CurrencyConverter;
   
   
   /***/ }),
   /* 3 */
   /***/ (function(module, exports) {
   
   /*!
	* Trend 0.2.0
	*
	* Fail-safe TransitionEnd event for jQuery.
	*
	* Adds a new "trend" event that can be used in browsers that don't
	* support "transitionend".
	*
	* NOTE: Only supports being bound with "jQuery.one".
	*
	* Copyright 2014, Pixel Union - http://pixelunion.net
	* Released under the MIT license
	*/
   ;(function($){
   
	 // Prefixed transitionend event names
	 var transitionEndEvents =
	   "webkitTransitionEnd " +
	   "otransitionend " +
	   "oTransitionEnd " +
	   "msTransitionEnd " +
	   "transitionend";
   
	 // Prefixed transition duration property names
	 var transitionDurationProperties = [
	   "transition-duration",
	   "-moz-transition-duration",
	   "-webkit-transition-duration",
	   "-ms-transition-duration",
	   "-o-transition-duration",
	   "-khtml-transition-duration"
	 ];
   
	 // Prefixed transition delay property names
	 var transitionDelayProperties = [
	   "transition-delay",
	   "-moz-transition-delay",
	   "-webkit-transition-delay",
	   "-ms-transition-delay",
	   "-o-transition-delay",
	   "-khtml-transition-delay"
	 ];
   
	 // Parses a CSS time value into milliseconds.
	 var parseTime = function(s) {
	   s = s.replace(/\s/, "");
	   var v = window.parseFloat(s);
   
	   return s.match(/[^m]s$/i)
		 ? v * 1000
		 : v;
	 };
   
	 // Parses the longest time unit found in a series of CSS properties.
	 // Returns a value in milliseconds.
	 var parseProperties = function(el, properties) {
	   var duration = 0;
   
	   for (var i = 0; i < properties.length; i++) {
		 // Get raw CSS value
		 var value = el.css(properties[i]);
		 if (!value) continue;
   
		 // Multiple transitions--pick the longest
		 if (value.indexOf(",") !== -1) {
		   var values = value.split(",");
		   var durations = (function(){
			 var results = [];
			 for (var i = 0; i < values.length; i++) {
			   var duration = parseTime(values[i]);
			   results.push(duration);
			 }
			 return results;
		   })();
   
		   duration = Math.max.apply(Math, durations);
		 }
   
		 // Single transition
		 else {
		   duration = parseTime(value);
		 }
   
		 // Accept first vaue
		 break;
	   }
   
	   return duration;
	 };
   
	 $.event.special.trend = {
	   // Triggers an event handler when an element is done transitioning.
	   //
	   // Handles browsers that don't support transitionend by adding a
	   // timeout with the transition duration.
	   add: function(handleObj) {
		 var el = $(this);
		 var fired = false;
   
		 // Mark element as being in transition
		 el.data("trend", true);
   
		 // Calculate a fallback duration. + 20 because some browsers fire
		 // timeouts faster than transitionend.
		 var time =
		   parseProperties(el, transitionDurationProperties) +
		   parseProperties(el, transitionDelayProperties) +
		   20;
   
		 var cb = function(e) {
		   // transitionend events can be sent for each property. Let's just
		   // skip all but the first. Also handles the timeout callback.
		   if (fired) return;
   
		   // Child elements that also have transitions can be fired before we
		   // complete. This will catch and ignore those. Unfortunately, we'll
		   // have to rely on the timeout in these cases.
		   if (e && e.srcElement !== el[0]) return;
   
		   // Mark element has not being in transition
		   el.data("trend", false);
   
		   // Callback
		   fired = true;
		   if (handleObj.handler) handleObj.handler();
		 };
   
		 el.one(transitionEndEvents, cb);
		 el.data("trend-timeout", window.setTimeout(cb, time));
	   },
   
	   remove: function(handleObj) {
		 var el = $(this);
		 el.off(transitionEndEvents);
		 window.clearTimeout(el.data("trend-timeout"));
	   }
	 };
   
   })(jQuery);
   
   
   /***/ }),
   /* 4 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! PhotoSwipe - v4.1.2 - 2017-04-05
   * http://photoswipe.com
   * Copyright (c) 2017 Dmitry Semenov; */
   (function (root, factory) { 
	   if (true) {
		   !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				   __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				   (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				   __WEBPACK_AMD_DEFINE_FACTORY__),
				   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	   } else {}
   })(this, function () {
   
	   'use strict';
	   var PhotoSwipe = function(template, UiClass, items, options){
   
   /*>>framework-bridge*/
   /**
	*
	* Set of generic functions used by gallery.
	* 
	* You're free to modify anything here as long as functionality is kept.
	* 
	*/
   var framework = {
	   features: null,
	   bind: function(target, type, listener, unbind) {
		   var methodName = (unbind ? 'remove' : 'add') + 'EventListener';
		   type = type.split(' ');
		   for(var i = 0; i < type.length; i++) {
			   if(type[i]) {
				   target[methodName]( type[i], listener, false);
			   }
		   }
	   },
	   isArray: function(obj) {
		   return (obj instanceof Array);
	   },
	   createEl: function(classes, tag) {
		   var el = document.createElement(tag || 'div');
		   if(classes) {
			   el.className = classes;
		   }
		   return el;
	   },
	   getScrollY: function() {
		   var yOffset = window.pageYOffset;
		   return yOffset !== undefined ? yOffset : document.documentElement.scrollTop;
	   },
	   unbind: function(target, type, listener) {
		   framework.bind(target,type,listener,true);
	   },
	   removeClass: function(el, className) {
		   var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
		   el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, ''); 
	   },
	   addClass: function(el, className) {
		   if( !framework.hasClass(el,className) ) {
			   el.className += (el.className ? ' ' : '') + className;
		   }
	   },
	   hasClass: function(el, className) {
		   return el.className && new RegExp('(^|\\s)' + className + '(\\s|$)').test(el.className);
	   },
	   getChildByClass: function(parentEl, childClassName) {
		   var node = parentEl.firstChild;
		   while(node) {
			   if( framework.hasClass(node, childClassName) ) {
				   return node;
			   }
			   node = node.nextSibling;
		   }
	   },
	   arraySearch: function(array, value, key) {
		   var i = array.length;
		   while(i--) {
			   if(array[i][key] === value) {
				   return i;
			   } 
		   }
		   return -1;
	   },
	   extend: function(o1, o2, preventOverwrite) {
		   for (var prop in o2) {
			   if (o2.hasOwnProperty(prop)) {
				   if(preventOverwrite && o1.hasOwnProperty(prop)) {
					   continue;
				   }
				   o1[prop] = o2[prop];
			   }
		   }
	   },
	   easing: {
		   sine: {
			   out: function(k) {
				   return Math.sin(k * (Math.PI / 2));
			   },
			   inOut: function(k) {
				   return - (Math.cos(Math.PI * k) - 1) / 2;
			   }
		   },
		   cubic: {
			   out: function(k) {
				   return --k * k * k + 1;
			   }
		   }
		   /*
			   elastic: {
				   out: function ( k ) {
   
					   var s, a = 0.1, p = 0.4;
					   if ( k === 0 ) return 0;
					   if ( k === 1 ) return 1;
					   if ( !a || a < 1 ) { a = 1; s = p / 4; }
					   else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
					   return ( a * Math.pow( 2, - 10 * k) * Math.sin( ( k - s ) * ( 2 * Math.PI ) / p ) + 1 );
   
				   },
			   },
			   back: {
				   out: function ( k ) {
					   var s = 1.70158;
					   return --k * k * ( ( s + 1 ) * k + s ) + 1;
				   }
			   }
		   */
	   },
   
	   /**
		* 
		* @return {object}
		* 
		* {
		*  raf : request animation frame function
		*  caf : cancel animation frame function
		*  transfrom : transform property key (with vendor), or null if not supported
		*  oldIE : IE8 or below
		* }
		* 
		*/
	   detectFeatures: function() {
		   if(framework.features) {
			   return framework.features;
		   }
		   var helperEl = framework.createEl(),
			   helperStyle = helperEl.style,
			   vendor = '',
			   features = {};
   
		   // IE8 and below
		   features.oldIE = document.all && !document.addEventListener;
   
		   features.touch = 'ontouchstart' in window;
   
		   if(window.requestAnimationFrame) {
			   features.raf = window.requestAnimationFrame;
			   features.caf = window.cancelAnimationFrame;
		   }
   
		   features.pointerEvent = navigator.pointerEnabled || navigator.msPointerEnabled;
   
		   // fix false-positive detection of old Android in new IE
		   // (IE11 ua string contains "Android 4.0")
		   
		   if(!features.pointerEvent) { 
   
			   var ua = navigator.userAgent;
   
			   // Detect if device is iPhone or iPod and if it's older than iOS 8
			   // http://stackoverflow.com/a/14223920
			   // 
			   // This detection is made because of buggy top/bottom toolbars
			   // that don't trigger window.resize event.
			   // For more info refer to _isFixedPosition variable in core.js
   
			   if (/iP(hone|od)/.test(navigator.platform)) {
				   var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
				   if(v && v.length > 0) {
					   v = parseInt(v[1], 10);
					   if(v >= 1 && v < 8 ) {
						   features.isOldIOSPhone = true;
					   }
				   }
			   }
   
			   // Detect old Android (before KitKat)
			   // due to bugs related to position:fixed
			   // http://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript
			   
			   var match = ua.match(/Android\s([0-9\.]*)/);
			   var androidversion =  match ? match[1] : 0;
			   androidversion = parseFloat(androidversion);
			   if(androidversion >= 1 ) {
				   if(androidversion < 4.4) {
					   features.isOldAndroid = true; // for fixed position bug & performance
				   }
				   features.androidVersion = androidversion; // for touchend bug
			   }	
			   features.isMobileOpera = /opera mini|opera mobi/i.test(ua);
   
			   // p.s. yes, yes, UA sniffing is bad, propose your solution for above bugs.
		   }
		   
		   var styleChecks = ['transform', 'perspective', 'animationName'],
			   vendors = ['', 'webkit','Moz','ms','O'],
			   styleCheckItem,
			   styleName;
   
		   for(var i = 0; i < 4; i++) {
			   vendor = vendors[i];
   
			   for(var a = 0; a < 3; a++) {
				   styleCheckItem = styleChecks[a];
   
				   // uppercase first letter of property name, if vendor is present
				   styleName = vendor + (vendor ? 
										   styleCheckItem.charAt(0).toUpperCase() + styleCheckItem.slice(1) : 
										   styleCheckItem);
			   
				   if(!features[styleCheckItem] && styleName in helperStyle ) {
					   features[styleCheckItem] = styleName;
				   }
			   }
   
			   if(vendor && !features.raf) {
				   vendor = vendor.toLowerCase();
				   features.raf = window[vendor+'RequestAnimationFrame'];
				   if(features.raf) {
					   features.caf = window[vendor+'CancelAnimationFrame'] || 
									   window[vendor+'CancelRequestAnimationFrame'];
				   }
			   }
		   }
			   
		   if(!features.raf) {
			   var lastTime = 0;
			   features.raf = function(fn) {
				   var currTime = new Date().getTime();
				   var timeToCall = Math.max(0, 16 - (currTime - lastTime));
				   var id = window.setTimeout(function() { fn(currTime + timeToCall); }, timeToCall);
				   lastTime = currTime + timeToCall;
				   return id;
			   };
			   features.caf = function(id) { clearTimeout(id); };
		   }
   
		   // Detect SVG support
		   features.svg = !!document.createElementNS && 
						   !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;
   
		   framework.features = features;
   
		   return features;
	   }
   };
   
   framework.detectFeatures();
   
   // Override addEventListener for old versions of IE
   if(framework.features.oldIE) {
   
	   framework.bind = function(target, type, listener, unbind) {
		   
		   type = type.split(' ');
   
		   var methodName = (unbind ? 'detach' : 'attach') + 'Event',
			   evName,
			   _handleEv = function() {
				   listener.handleEvent.call(listener);
			   };
   
		   for(var i = 0; i < type.length; i++) {
			   evName = type[i];
			   if(evName) {
   
				   if(typeof listener === 'object' && listener.handleEvent) {
					   if(!unbind) {
						   listener['oldIE' + evName] = _handleEv;
					   } else {
						   if(!listener['oldIE' + evName]) {
							   return false;
						   }
					   }
   
					   target[methodName]( 'on' + evName, listener['oldIE' + evName]);
				   } else {
					   target[methodName]( 'on' + evName, listener);
				   }
   
			   }
		   }
	   };
	   
   }
   
   /*>>framework-bridge*/
   
   /*>>core*/
   //function(template, UiClass, items, options)
   
   var self = this;
   
   /**
	* Static vars, don't change unless you know what you're doing.
	*/
   var DOUBLE_TAP_RADIUS = 25, 
	   NUM_HOLDERS = 3;
   
   /**
	* Options
	*/
   var _options = {
	   allowPanToNext:true,
	   spacing: 0.12,
	   bgOpacity: 1,
	   mouseUsed: false,
	   loop: true,
	   pinchToClose: true,
	   closeOnScroll: true,
	   closeOnVerticalDrag: true,
	   verticalDragRange: 0.75,
	   hideAnimationDuration: 333,
	   showAnimationDuration: 333,
	   showHideOpacity: false,
	   focus: true,
	   escKey: true,
	   arrowKeys: true,
	   mainScrollEndFriction: 0.35,
	   panEndFriction: 0.35,
	   isClickableElement: function(el) {
		   return el.tagName === 'A';
	   },
	   getDoubleTapZoom: function(isMouseClick, item) {
		   if(isMouseClick) {
			   return 1;
		   } else {
			   return item.initialZoomLevel < 0.7 ? 1 : 1.33;
		   }
	   },
	   maxSpreadZoom: 1.33,
	   modal: true,
   
	   // not fully implemented yet
	   scaleMode: 'fit' // TODO
   };
   framework.extend(_options, options);
   
   
   /**
	* Private helper variables & functions
	*/
   
   var _getEmptyPoint = function() { 
		   return {x:0,y:0}; 
	   };
   
   var _isOpen,
	   _isDestroying,
	   _closedByScroll,
	   _currentItemIndex,
	   _containerStyle,
	   _containerShiftIndex,
	   _currPanDist = _getEmptyPoint(),
	   _startPanOffset = _getEmptyPoint(),
	   _panOffset = _getEmptyPoint(),
	   _upMoveEvents, // drag move, drag end & drag cancel events array
	   _downEvents, // drag start events array
	   _globalEventHandlers,
	   _viewportSize = {},
	   _currZoomLevel,
	   _startZoomLevel,
	   _translatePrefix,
	   _translateSufix,
	   _updateSizeInterval,
	   _itemsNeedUpdate,
	   _currPositionIndex = 0,
	   _offset = {},
	   _slideSize = _getEmptyPoint(), // size of slide area, including spacing
	   _itemHolders,
	   _prevItemIndex,
	   _indexDiff = 0, // difference of indexes since last content update
	   _dragStartEvent,
	   _dragMoveEvent,
	   _dragEndEvent,
	   _dragCancelEvent,
	   _transformKey,
	   _pointerEventEnabled,
	   _isFixedPosition = true,
	   _likelyTouchDevice,
	   _modules = [],
	   _requestAF,
	   _cancelAF,
	   _initalClassName,
	   _initalWindowScrollY,
	   _oldIE,
	   _currentWindowScrollY,
	   _features,
	   _windowVisibleSize = {},
	   _renderMaxResolution = false,
	   _orientationChangeTimeout,
   
   
	   // Registers PhotoSWipe module (History, Controller ...)
	   _registerModule = function(name, module) {
		   framework.extend(self, module.publicMethods);
		   _modules.push(name);
	   },
   
	   _getLoopedId = function(index) {
		   var numSlides = _getNumItems();
		   if(index > numSlides - 1) {
			   return index - numSlides;
		   } else  if(index < 0) {
			   return numSlides + index;
		   }
		   return index;
	   },
	   
	   // Micro bind/trigger
	   _listeners = {},
	   _listen = function(name, fn) {
		   if(!_listeners[name]) {
			   _listeners[name] = [];
		   }
		   return _listeners[name].push(fn);
	   },
	   _shout = function(name) {
		   var listeners = _listeners[name];
   
		   if(listeners) {
			   var args = Array.prototype.slice.call(arguments);
			   args.shift();
   
			   for(var i = 0; i < listeners.length; i++) {
				   listeners[i].apply(self, args);
			   }
		   }
	   },
   
	   _getCurrentTime = function() {
		   return new Date().getTime();
	   },
	   _applyBgOpacity = function(opacity) {
		   _bgOpacity = opacity;
		   self.bg.style.opacity = opacity * _options.bgOpacity;
	   },
   
	   _applyZoomTransform = function(styleObj,x,y,zoom,item) {
		   if(!_renderMaxResolution || (item && item !== self.currItem) ) {
			   zoom = zoom / (item ? item.fitRatio : self.currItem.fitRatio);	
		   }
			   
		   styleObj[_transformKey] = _translatePrefix + x + 'px, ' + y + 'px' + _translateSufix + ' scale(' + zoom + ')';
	   },
	   _applyCurrentZoomPan = function( allowRenderResolution ) {
		   if(_currZoomElementStyle) {
   
			   if(allowRenderResolution) {
				   if(_currZoomLevel > self.currItem.fitRatio) {
					   if(!_renderMaxResolution) {
						   _setImageSize(self.currItem, false, true);
						   _renderMaxResolution = true;
					   }
				   } else {
					   if(_renderMaxResolution) {
						   _setImageSize(self.currItem);
						   _renderMaxResolution = false;
					   }
				   }
			   }
			   
   
			   _applyZoomTransform(_currZoomElementStyle, _panOffset.x, _panOffset.y, _currZoomLevel);
		   }
	   },
	   _applyZoomPanToItem = function(item) {
		   if(item.container) {
   
			   _applyZoomTransform(item.container.style, 
								   item.initialPosition.x, 
								   item.initialPosition.y, 
								   item.initialZoomLevel,
								   item);
		   }
	   },
	   _setTranslateX = function(x, elStyle) {
		   elStyle[_transformKey] = _translatePrefix + x + 'px, 0px' + _translateSufix;
	   },
	   _moveMainScroll = function(x, dragging) {
   
		   if(!_options.loop && dragging) {
			   var newSlideIndexOffset = _currentItemIndex + (_slideSize.x * _currPositionIndex - x) / _slideSize.x,
				   delta = Math.round(x - _mainScrollPos.x);
   
			   if( (newSlideIndexOffset < 0 && delta > 0) || 
				   (newSlideIndexOffset >= _getNumItems() - 1 && delta < 0) ) {
				   x = _mainScrollPos.x + delta * _options.mainScrollEndFriction;
			   } 
		   }
		   
		   _mainScrollPos.x = x;
		   _setTranslateX(x, _containerStyle);
	   },
	   _calculatePanOffset = function(axis, zoomLevel) {
		   var m = _midZoomPoint[axis] - _offset[axis];
		   return _startPanOffset[axis] + _currPanDist[axis] + m - m * ( zoomLevel / _startZoomLevel );
	   },
	   
	   _equalizePoints = function(p1, p2) {
		   p1.x = p2.x;
		   p1.y = p2.y;
		   if(p2.id) {
			   p1.id = p2.id;
		   }
	   },
	   _roundPoint = function(p) {
		   p.x = Math.round(p.x);
		   p.y = Math.round(p.y);
	   },
   
	   _mouseMoveTimeout = null,
	   _onFirstMouseMove = function() {
		   // Wait until mouse move event is fired at least twice during 100ms
		   // We do this, because some mobile browsers trigger it on touchstart
		   if(_mouseMoveTimeout ) { 
			   framework.unbind(document, 'mousemove', _onFirstMouseMove);
			   framework.addClass(template, 'pswp--has_mouse');
			   _options.mouseUsed = true;
			   _shout('mouseUsed');
		   }
		   _mouseMoveTimeout = setTimeout(function() {
			   _mouseMoveTimeout = null;
		   }, 100);
	   },
   
	   _bindEvents = function() {
		   framework.bind(document, 'keydown', self);
   
		   if(_features.transform) {
			   // don't bind click event in browsers that don't support transform (mostly IE8)
			   framework.bind(self.scrollWrap, 'click', self);
		   }
		   
   
		   if(!_options.mouseUsed) {
			   framework.bind(document, 'mousemove', _onFirstMouseMove);
		   }
   
		   framework.bind(window, 'resize scroll orientationchange', self);
   
		   _shout('bindEvents');
	   },
   
	   _unbindEvents = function() {
		   framework.unbind(window, 'resize scroll orientationchange', self);
		   framework.unbind(window, 'scroll', _globalEventHandlers.scroll);
		   framework.unbind(document, 'keydown', self);
		   framework.unbind(document, 'mousemove', _onFirstMouseMove);
   
		   if(_features.transform) {
			   framework.unbind(self.scrollWrap, 'click', self);
		   }
   
		   if(_isDragging) {
			   framework.unbind(window, _upMoveEvents, self);
		   }
   
		   clearTimeout(_orientationChangeTimeout);
   
		   _shout('unbindEvents');
	   },
	   
	   _calculatePanBounds = function(zoomLevel, update) {
		   var bounds = _calculateItemSize( self.currItem, _viewportSize, zoomLevel );
		   if(update) {
			   _currPanBounds = bounds;
		   }
		   return bounds;
	   },
	   
	   _getMinZoomLevel = function(item) {
		   if(!item) {
			   item = self.currItem;
		   }
		   return item.initialZoomLevel;
	   },
	   _getMaxZoomLevel = function(item) {
		   if(!item) {
			   item = self.currItem;
		   }
		   return item.w > 0 ? _options.maxSpreadZoom : 1;
	   },
   
	   // Return true if offset is out of the bounds
	   _modifyDestPanOffset = function(axis, destPanBounds, destPanOffset, destZoomLevel) {
		   if(destZoomLevel === self.currItem.initialZoomLevel) {
			   destPanOffset[axis] = self.currItem.initialPosition[axis];
			   return true;
		   } else {
			   destPanOffset[axis] = _calculatePanOffset(axis, destZoomLevel); 
   
			   if(destPanOffset[axis] > destPanBounds.min[axis]) {
				   destPanOffset[axis] = destPanBounds.min[axis];
				   return true;
			   } else if(destPanOffset[axis] < destPanBounds.max[axis] ) {
				   destPanOffset[axis] = destPanBounds.max[axis];
				   return true;
			   }
		   }
		   return false;
	   },
   
	   _setupTransforms = function() {
   
		   if(_transformKey) {
			   // setup 3d transforms
			   var allow3dTransform = _features.perspective && !_likelyTouchDevice;
			   _translatePrefix = 'translate' + (allow3dTransform ? '3d(' : '(');
			   _translateSufix = _features.perspective ? ', 0px)' : ')';	
			   return;
		   }
   
		   // Override zoom/pan/move functions in case old browser is used (most likely IE)
		   // (so they use left/top/width/height, instead of CSS transform)
	   
		   _transformKey = 'left';
		   framework.addClass(template, 'pswp--ie');
   
		   _setTranslateX = function(x, elStyle) {
			   elStyle.left = x + 'px';
		   };
		   _applyZoomPanToItem = function(item) {
   
			   var zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
				   s = item.container.style,
				   w = zoomRatio * item.w,
				   h = zoomRatio * item.h;
   
			   s.width = w + 'px';
			   s.height = h + 'px';
			   s.left = item.initialPosition.x + 'px';
			   s.top = item.initialPosition.y + 'px';
   
		   };
		   _applyCurrentZoomPan = function() {
			   if(_currZoomElementStyle) {
   
				   var s = _currZoomElementStyle,
					   item = self.currItem,
					   zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
					   w = zoomRatio * item.w,
					   h = zoomRatio * item.h;
   
				   s.width = w + 'px';
				   s.height = h + 'px';
   
   
				   s.left = _panOffset.x + 'px';
				   s.top = _panOffset.y + 'px';
			   }
			   
		   };
	   },
   
	   _onKeyDown = function(e) {
		   var keydownAction = '';
		   if(_options.escKey && e.keyCode === 27) { 
			   keydownAction = 'close';
		   } else if(_options.arrowKeys) {
			   if(e.keyCode === 37) {
				   keydownAction = 'prev';
			   } else if(e.keyCode === 39) { 
				   keydownAction = 'next';
			   }
		   }
   
		   if(keydownAction) {
			   // don't do anything if special key pressed to prevent from overriding default browser actions
			   // e.g. in Chrome on Mac cmd+arrow-left returns to previous page
			   if( !e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey ) {
				   if(e.preventDefault) {
					   e.preventDefault();
				   } else {
					   e.returnValue = false;
				   } 
				   self[keydownAction]();
			   }
		   }
	   },
   
	   _onGlobalClick = function(e) {
		   if(!e) {
			   return;
		   }
   
		   // don't allow click event to pass through when triggering after drag or some other gesture
		   if(_moved || _zoomStarted || _mainScrollAnimating || _verticalDragInitiated) {
			   e.preventDefault();
			   e.stopPropagation();
		   }
	   },
   
	   _updatePageScrollOffset = function() {
		   self.setScrollOffset(0, framework.getScrollY());		
	   };
	   
   
   
	   
   
   
   
   // Micro animation engine
   var _animations = {},
	   _numAnimations = 0,
	   _stopAnimation = function(name) {
		   if(_animations[name]) {
			   if(_animations[name].raf) {
				   _cancelAF( _animations[name].raf );
			   }
			   _numAnimations--;
			   delete _animations[name];
		   }
	   },
	   _registerStartAnimation = function(name) {
		   if(_animations[name]) {
			   _stopAnimation(name);
		   }
		   if(!_animations[name]) {
			   _numAnimations++;
			   _animations[name] = {};
		   }
	   },
	   _stopAllAnimations = function() {
		   for (var prop in _animations) {
   
			   if( _animations.hasOwnProperty( prop ) ) {
				   _stopAnimation(prop);
			   } 
			   
		   }
	   },
	   _animateProp = function(name, b, endProp, d, easingFn, onUpdate, onComplete) {
		   var startAnimTime = _getCurrentTime(), t;
		   _registerStartAnimation(name);
   
		   var animloop = function(){
			   if ( _animations[name] ) {
				   
				   t = _getCurrentTime() - startAnimTime; // time diff
				   //b - beginning (start prop)
				   //d - anim duration
   
				   if ( t >= d ) {
					   _stopAnimation(name);
					   onUpdate(endProp);
					   if(onComplete) {
						   onComplete();
					   }
					   return;
				   }
				   onUpdate( (endProp - b) * easingFn(t/d) + b );
   
				   _animations[name].raf = _requestAF(animloop);
			   }
		   };
		   animloop();
	   };
	   
   
   
   var publicMethods = {
   
	   // make a few local variables and functions public
	   shout: _shout,
	   listen: _listen,
	   viewportSize: _viewportSize,
	   options: _options,
   
	   isMainScrollAnimating: function() {
		   return _mainScrollAnimating;
	   },
	   getZoomLevel: function() {
		   return _currZoomLevel;
	   },
	   getCurrentIndex: function() {
		   return _currentItemIndex;
	   },
	   isDragging: function() {
		   return _isDragging;
	   },	
	   isZooming: function() {
		   return _isZooming;
	   },
	   setScrollOffset: function(x,y) {
		   _offset.x = x;
		   _currentWindowScrollY = _offset.y = y;
		   _shout('updateScrollOffset', _offset);
	   },
	   applyZoomPan: function(zoomLevel,panX,panY,allowRenderResolution) {
		   _panOffset.x = panX;
		   _panOffset.y = panY;
		   _currZoomLevel = zoomLevel;
		   _applyCurrentZoomPan( allowRenderResolution );
	   },
   
	   init: function() {
   
		   if(_isOpen || _isDestroying) {
			   return;
		   }
   
		   var i;
   
		   self.framework = framework; // basic functionality
		   self.template = template; // root DOM element of PhotoSwipe
		   self.bg = framework.getChildByClass(template, 'pswp__bg');
   
		   _initalClassName = template.className;
		   _isOpen = true;
				   
		   _features = framework.detectFeatures();
		   _requestAF = _features.raf;
		   _cancelAF = _features.caf;
		   _transformKey = _features.transform;
		   _oldIE = _features.oldIE;
		   
		   self.scrollWrap = framework.getChildByClass(template, 'pswp__scroll-wrap');
		   self.container = framework.getChildByClass(self.scrollWrap, 'pswp__container');
   
		   _containerStyle = self.container.style; // for fast access
   
		   // Objects that hold slides (there are only 3 in DOM)
		   self.itemHolders = _itemHolders = [
			   {el:self.container.children[0] , wrap:0, index: -1},
			   {el:self.container.children[1] , wrap:0, index: -1},
			   {el:self.container.children[2] , wrap:0, index: -1}
		   ];
   
		   // hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
		   _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'none';
   
		   _setupTransforms();
   
		   // Setup global events
		   _globalEventHandlers = {
			   resize: self.updateSize,
   
			   // Fixes: iOS 10.3 resize event
			   // does not update scrollWrap.clientWidth instantly after resize
			   // https://github.com/dimsemenov/PhotoSwipe/issues/1315
			   orientationchange: function() {
				   clearTimeout(_orientationChangeTimeout);
				   _orientationChangeTimeout = setTimeout(function() {
					   if(_viewportSize.x !== self.scrollWrap.clientWidth) {
						   self.updateSize();
					   }
				   }, 500);
			   },
			   scroll: _updatePageScrollOffset,
			   keydown: _onKeyDown,
			   click: _onGlobalClick
		   };
   
		   // disable show/hide effects on old browsers that don't support CSS animations or transforms, 
		   // old IOS, Android and Opera mobile. Blackberry seems to work fine, even older models.
		   var oldPhone = _features.isOldIOSPhone || _features.isOldAndroid || _features.isMobileOpera;
		   if(!_features.animationName || !_features.transform || oldPhone) {
			   _options.showAnimationDuration = _options.hideAnimationDuration = 0;
		   }
   
		   // init modules
		   for(i = 0; i < _modules.length; i++) {
			   self['init' + _modules[i]]();
		   }
		   
		   // init
		   if(UiClass) {
			   var ui = self.ui = new UiClass(self, framework);
			   ui.init();
		   }
   
		   _shout('firstUpdate');
		   _currentItemIndex = _currentItemIndex || _options.index || 0;
		   // validate index
		   if( isNaN(_currentItemIndex) || _currentItemIndex < 0 || _currentItemIndex >= _getNumItems() ) {
			   _currentItemIndex = 0;
		   }
		   self.currItem = _getItemAt( _currentItemIndex );
   
		   
		   if(_features.isOldIOSPhone || _features.isOldAndroid) {
			   _isFixedPosition = false;
		   }
		   
		   template.setAttribute('aria-hidden', 'false');
		   if(_options.modal) {
			   if(!_isFixedPosition) {
				   template.style.position = 'absolute';
				   template.style.top = framework.getScrollY() + 'px';
			   } else {
				   template.style.position = 'fixed';
			   }
		   }
   
		   if(_currentWindowScrollY === undefined) {
			   _shout('initialLayout');
			   _currentWindowScrollY = _initalWindowScrollY = framework.getScrollY();
		   }
		   
		   // add classes to root element of PhotoSwipe
		   var rootClasses = 'pswp--open ';
		   if(_options.mainClass) {
			   rootClasses += _options.mainClass + ' ';
		   }
		   if(_options.showHideOpacity) {
			   rootClasses += 'pswp--animate_opacity ';
		   }
		   rootClasses += _likelyTouchDevice ? 'pswp--touch' : 'pswp--notouch';
		   rootClasses += _features.animationName ? ' pswp--css_animation' : '';
		   rootClasses += _features.svg ? ' pswp--svg' : '';
		   framework.addClass(template, rootClasses);
   
		   self.updateSize();
   
		   // initial update
		   _containerShiftIndex = -1;
		   _indexDiff = null;
		   for(i = 0; i < NUM_HOLDERS; i++) {
			   _setTranslateX( (i+_containerShiftIndex) * _slideSize.x, _itemHolders[i].el.style);
		   }
   
		   if(!_oldIE) {
			   framework.bind(self.scrollWrap, _downEvents, self); // no dragging for old IE
		   }	
   
		   _listen('initialZoomInEnd', function() {
			   self.setContent(_itemHolders[0], _currentItemIndex-1);
			   self.setContent(_itemHolders[2], _currentItemIndex+1);
   
			   _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'block';
   
			   if(_options.focus) {
				   // focus causes layout, 
				   // which causes lag during the animation, 
				   // that's why we delay it untill the initial zoom transition ends
				   template.focus();
			   }
				
   
			   _bindEvents();
		   });
   
		   // set content for center slide (first time)
		   self.setContent(_itemHolders[1], _currentItemIndex);
		   
		   self.updateCurrItem();
   
		   _shout('afterInit');
   
		   if(!_isFixedPosition) {
   
			   // On all versions of iOS lower than 8.0, we check size of viewport every second.
			   // 
			   // This is done to detect when Safari top & bottom bars appear, 
			   // as this action doesn't trigger any events (like resize). 
			   // 
			   // On iOS8 they fixed this.
			   // 
			   // 10 Nov 2014: iOS 7 usage ~40%. iOS 8 usage 56%.
			   
			   _updateSizeInterval = setInterval(function() {
				   if(!_numAnimations && !_isDragging && !_isZooming && (_currZoomLevel === self.currItem.initialZoomLevel)  ) {
					   self.updateSize();
				   }
			   }, 1000);
		   }
   
		   framework.addClass(template, 'pswp--visible');
	   },
   
	   // Close the gallery, then destroy it
	   close: function() {
		   if(!_isOpen) {
			   return;
		   }
   
		   _isOpen = false;
		   _isDestroying = true;
		   _shout('close');
		   _unbindEvents();
   
		   _showOrHide(self.currItem, null, true, self.destroy);
	   },
   
	   // destroys the gallery (unbinds events, cleans up intervals and timeouts to avoid memory leaks)
	   destroy: function() {
		   _shout('destroy');
   
		   if(_showOrHideTimeout) {
			   clearTimeout(_showOrHideTimeout);
		   }
		   
		   template.setAttribute('aria-hidden', 'true');
		   template.className = _initalClassName;
   
		   if(_updateSizeInterval) {
			   clearInterval(_updateSizeInterval);
		   }
   
		   framework.unbind(self.scrollWrap, _downEvents, self);
   
		   // we unbind scroll event at the end, as closing animation may depend on it
		   framework.unbind(window, 'scroll', self);
   
		   _stopDragUpdateLoop();
   
		   _stopAllAnimations();
   
		   _listeners = null;
	   },
   
	   /**
		* Pan image to position
		* @param {Number} x     
		* @param {Number} y     
		* @param {Boolean} force Will ignore bounds if set to true.
		*/
	   panTo: function(x,y,force) {
		   if(!force) {
			   if(x > _currPanBounds.min.x) {
				   x = _currPanBounds.min.x;
			   } else if(x < _currPanBounds.max.x) {
				   x = _currPanBounds.max.x;
			   }
   
			   if(y > _currPanBounds.min.y) {
				   y = _currPanBounds.min.y;
			   } else if(y < _currPanBounds.max.y) {
				   y = _currPanBounds.max.y;
			   }
		   }
		   
		   _panOffset.x = x;
		   _panOffset.y = y;
		   _applyCurrentZoomPan();
	   },
	   
	   handleEvent: function (e) {
		   e = e || window.event;
		   if(_globalEventHandlers[e.type]) {
			   _globalEventHandlers[e.type](e);
		   }
	   },
   
   
	   goTo: function(index) {
   
		   index = _getLoopedId(index);
   
		   var diff = index - _currentItemIndex;
		   _indexDiff = diff;
   
		   _currentItemIndex = index;
		   self.currItem = _getItemAt( _currentItemIndex );
		   _currPositionIndex -= diff;
		   
		   _moveMainScroll(_slideSize.x * _currPositionIndex);
		   
   
		   _stopAllAnimations();
		   _mainScrollAnimating = false;
   
		   self.updateCurrItem();
	   },
	   next: function() {
		   self.goTo( _currentItemIndex + 1);
	   },
	   prev: function() {
		   self.goTo( _currentItemIndex - 1);
	   },
   
	   // update current zoom/pan objects
	   updateCurrZoomItem: function(emulateSetContent) {
		   if(emulateSetContent) {
			   _shout('beforeChange', 0);
		   }
   
		   // itemHolder[1] is middle (current) item
		   if(_itemHolders[1].el.children.length) {
			   var zoomElement = _itemHolders[1].el.children[0];
			   if( framework.hasClass(zoomElement, 'pswp__zoom-wrap') ) {
				   _currZoomElementStyle = zoomElement.style;
			   } else {
				   _currZoomElementStyle = null;
			   }
		   } else {
			   _currZoomElementStyle = null;
		   }
		   
		   _currPanBounds = self.currItem.bounds;	
		   _startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
   
		   _panOffset.x = _currPanBounds.center.x;
		   _panOffset.y = _currPanBounds.center.y;
   
		   if(emulateSetContent) {
			   _shout('afterChange');
		   }
	   },
   
   
	   invalidateCurrItems: function() {
		   _itemsNeedUpdate = true;
		   for(var i = 0; i < NUM_HOLDERS; i++) {
			   if( _itemHolders[i].item ) {
				   _itemHolders[i].item.needsUpdate = true;
			   }
		   }
	   },
   
	   updateCurrItem: function(beforeAnimation) {
   
		   if(_indexDiff === 0) {
			   return;
		   }
   
		   var diffAbs = Math.abs(_indexDiff),
			   tempHolder;
   
		   if(beforeAnimation && diffAbs < 2) {
			   return;
		   }
   
   
		   self.currItem = _getItemAt( _currentItemIndex );
		   _renderMaxResolution = false;
		   
		   _shout('beforeChange', _indexDiff);
   
		   if(diffAbs >= NUM_HOLDERS) {
			   _containerShiftIndex += _indexDiff + (_indexDiff > 0 ? -NUM_HOLDERS : NUM_HOLDERS);
			   diffAbs = NUM_HOLDERS;
		   }
		   for(var i = 0; i < diffAbs; i++) {
			   if(_indexDiff > 0) {
				   tempHolder = _itemHolders.shift();
				   _itemHolders[NUM_HOLDERS-1] = tempHolder; // move first to last
   
				   _containerShiftIndex++;
				   _setTranslateX( (_containerShiftIndex+2) * _slideSize.x, tempHolder.el.style);
				   self.setContent(tempHolder, _currentItemIndex - diffAbs + i + 1 + 1);
			   } else {
				   tempHolder = _itemHolders.pop();
				   _itemHolders.unshift( tempHolder ); // move last to first
   
				   _containerShiftIndex--;
				   _setTranslateX( _containerShiftIndex * _slideSize.x, tempHolder.el.style);
				   self.setContent(tempHolder, _currentItemIndex + diffAbs - i - 1 - 1);
			   }
			   
		   }
   
		   // reset zoom/pan on previous item
		   if(_currZoomElementStyle && Math.abs(_indexDiff) === 1) {
   
			   var prevItem = _getItemAt(_prevItemIndex);
			   if(prevItem.initialZoomLevel !== _currZoomLevel) {
				   _calculateItemSize(prevItem , _viewportSize );
				   _setImageSize(prevItem);
				   _applyZoomPanToItem( prevItem ); 				
			   }
   
		   }
   
		   // reset diff after update
		   _indexDiff = 0;
   
		   self.updateCurrZoomItem();
   
		   _prevItemIndex = _currentItemIndex;
   
		   _shout('afterChange');
		   
	   },
   
   
   
	   updateSize: function(force) {
		   
		   if(!_isFixedPosition && _options.modal) {
			   var windowScrollY = framework.getScrollY();
			   if(_currentWindowScrollY !== windowScrollY) {
				   template.style.top = windowScrollY + 'px';
				   _currentWindowScrollY = windowScrollY;
			   }
			   if(!force && _windowVisibleSize.x === window.innerWidth && _windowVisibleSize.y === window.innerHeight) {
				   return;
			   }
			   _windowVisibleSize.x = window.innerWidth;
			   _windowVisibleSize.y = window.innerHeight;
   
			   //template.style.width = _windowVisibleSize.x + 'px';
			   template.style.height = _windowVisibleSize.y + 'px';
		   }
   
   
   
		   _viewportSize.x = self.scrollWrap.clientWidth;
		   _viewportSize.y = self.scrollWrap.clientHeight;
   
		   _updatePageScrollOffset();
   
		   _slideSize.x = _viewportSize.x + Math.round(_viewportSize.x * _options.spacing);
		   _slideSize.y = _viewportSize.y;
   
		   _moveMainScroll(_slideSize.x * _currPositionIndex);
   
		   _shout('beforeResize'); // even may be used for example to switch image sources
   
   
		   // don't re-calculate size on inital size update
		   if(_containerShiftIndex !== undefined) {
   
			   var holder,
				   item,
				   hIndex;
   
			   for(var i = 0; i < NUM_HOLDERS; i++) {
				   holder = _itemHolders[i];
				   _setTranslateX( (i+_containerShiftIndex) * _slideSize.x, holder.el.style);
   
				   hIndex = _currentItemIndex+i-1;
   
				   if(_options.loop && _getNumItems() > 2) {
					   hIndex = _getLoopedId(hIndex);
				   }
   
				   // update zoom level on items and refresh source (if needsUpdate)
				   item = _getItemAt( hIndex );
   
				   // re-render gallery item if `needsUpdate`,
				   // or doesn't have `bounds` (entirely new slide object)
				   if( item && (_itemsNeedUpdate || item.needsUpdate || !item.bounds) ) {
   
					   self.cleanSlide( item );
					   
					   self.setContent( holder, hIndex );
   
					   // if "center" slide
					   if(i === 1) {
						   self.currItem = item;
						   self.updateCurrZoomItem(true);
					   }
   
					   item.needsUpdate = false;
   
				   } else if(holder.index === -1 && hIndex >= 0) {
					   // add content first time
					   self.setContent( holder, hIndex );
				   }
				   if(item && item.container) {
					   _calculateItemSize(item, _viewportSize);
					   _setImageSize(item);
					   _applyZoomPanToItem( item );
				   }
				   
			   }
			   _itemsNeedUpdate = false;
		   }	
   
		   _startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
		   _currPanBounds = self.currItem.bounds;
   
		   if(_currPanBounds) {
			   _panOffset.x = _currPanBounds.center.x;
			   _panOffset.y = _currPanBounds.center.y;
			   _applyCurrentZoomPan( true );
		   }
		   
		   _shout('resize');
	   },
	   
	   // Zoom current item to
	   zoomTo: function(destZoomLevel, centerPoint, speed, easingFn, updateFn) {
		   /*
			   if(destZoomLevel === 'fit') {
				   destZoomLevel = self.currItem.fitRatio;
			   } else if(destZoomLevel === 'fill') {
				   destZoomLevel = self.currItem.fillRatio;
			   }
		   */
   
		   if(centerPoint) {
			   _startZoomLevel = _currZoomLevel;
			   _midZoomPoint.x = Math.abs(centerPoint.x) - _panOffset.x ;
			   _midZoomPoint.y = Math.abs(centerPoint.y) - _panOffset.y ;
			   _equalizePoints(_startPanOffset, _panOffset);
		   }
   
		   var destPanBounds = _calculatePanBounds(destZoomLevel, false),
			   destPanOffset = {};
   
		   _modifyDestPanOffset('x', destPanBounds, destPanOffset, destZoomLevel);
		   _modifyDestPanOffset('y', destPanBounds, destPanOffset, destZoomLevel);
   
		   var initialZoomLevel = _currZoomLevel;
		   var initialPanOffset = {
			   x: _panOffset.x,
			   y: _panOffset.y
		   };
   
		   _roundPoint(destPanOffset);
   
		   var onUpdate = function(now) {
			   if(now === 1) {
				   _currZoomLevel = destZoomLevel;
				   _panOffset.x = destPanOffset.x;
				   _panOffset.y = destPanOffset.y;
			   } else {
				   _currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
				   _panOffset.x = (destPanOffset.x - initialPanOffset.x) * now + initialPanOffset.x;
				   _panOffset.y = (destPanOffset.y - initialPanOffset.y) * now + initialPanOffset.y;
			   }
   
			   if(updateFn) {
				   updateFn(now);
			   }
   
			   _applyCurrentZoomPan( now === 1 );
		   };
   
		   if(speed) {
			   _animateProp('customZoomTo', 0, 1, speed, easingFn || framework.easing.sine.inOut, onUpdate);
		   } else {
			   onUpdate(1);
		   }
	   }
   
   
   };
   
   
   /*>>core*/
   
   /*>>gestures*/
   /**
	* Mouse/touch/pointer event handlers.
	* 
	* separated from @core.js for readability
	*/
   
   var MIN_SWIPE_DISTANCE = 30,
	   DIRECTION_CHECK_OFFSET = 10; // amount of pixels to drag to determine direction of swipe
   
   var _gestureStartTime,
	   _gestureCheckSpeedTime,
   
	   // pool of objects that are used during dragging of zooming
	   p = {}, // first point
	   p2 = {}, // second point (for zoom gesture)
	   delta = {},
	   _currPoint = {},
	   _startPoint = {},
	   _currPointers = [],
	   _startMainScrollPos = {},
	   _releaseAnimData,
	   _posPoints = [], // array of points during dragging, used to determine type of gesture
	   _tempPoint = {},
   
	   _isZoomingIn,
	   _verticalDragInitiated,
	   _oldAndroidTouchEndTimeout,
	   _currZoomedItemIndex = 0,
	   _centerPoint = _getEmptyPoint(),
	   _lastReleaseTime = 0,
	   _isDragging, // at least one pointer is down
	   _isMultitouch, // at least two _pointers are down
	   _zoomStarted, // zoom level changed during zoom gesture
	   _moved,
	   _dragAnimFrame,
	   _mainScrollShifted,
	   _currentPoints, // array of current touch points
	   _isZooming,
	   _currPointsDistance,
	   _startPointsDistance,
	   _currPanBounds,
	   _mainScrollPos = _getEmptyPoint(),
	   _currZoomElementStyle,
	   _mainScrollAnimating, // true, if animation after swipe gesture is running
	   _midZoomPoint = _getEmptyPoint(),
	   _currCenterPoint = _getEmptyPoint(),
	   _direction,
	   _isFirstMove,
	   _opacityChanged,
	   _bgOpacity,
	   _wasOverInitialZoom,
   
	   _isEqualPoints = function(p1, p2) {
		   return p1.x === p2.x && p1.y === p2.y;
	   },
	   _isNearbyPoints = function(touch0, touch1) {
		   return Math.abs(touch0.x - touch1.x) < DOUBLE_TAP_RADIUS && Math.abs(touch0.y - touch1.y) < DOUBLE_TAP_RADIUS;
	   },
	   _calculatePointsDistance = function(p1, p2) {
		   _tempPoint.x = Math.abs( p1.x - p2.x );
		   _tempPoint.y = Math.abs( p1.y - p2.y );
		   return Math.sqrt(_tempPoint.x * _tempPoint.x + _tempPoint.y * _tempPoint.y);
	   },
	   _stopDragUpdateLoop = function() {
		   if(_dragAnimFrame) {
			   _cancelAF(_dragAnimFrame);
			   _dragAnimFrame = null;
		   }
	   },
	   _dragUpdateLoop = function() {
		   if(_isDragging) {
			   _dragAnimFrame = _requestAF(_dragUpdateLoop);
			   _renderMovement();
		   }
	   },
	   _canPan = function() {
		   return !(_options.scaleMode === 'fit' && _currZoomLevel ===  self.currItem.initialZoomLevel);
	   },
	   
	   // find the closest parent DOM element
	   _closestElement = function(el, fn) {
			 if(!el || el === document) {
				 return false;
			 }
   
			 // don't search elements above pswp__scroll-wrap
			 if(el.getAttribute('class') && el.getAttribute('class').indexOf('pswp__scroll-wrap') > -1 ) {
				 return false;
			 }
   
			 if( fn(el) ) {
				 return el;
			 }
   
			 return _closestElement(el.parentNode, fn);
	   },
   
	   _preventObj = {},
	   _preventDefaultEventBehaviour = function(e, isDown) {
		   _preventObj.prevent = !_closestElement(e.target, _options.isClickableElement);
   
		   _shout('preventDragEvent', e, isDown, _preventObj);
		   return _preventObj.prevent;
   
	   },
	   _convertTouchToPoint = function(touch, p) {
		   p.x = touch.pageX;
		   p.y = touch.pageY;
		   p.id = touch.identifier;
		   return p;
	   },
	   _findCenterOfPoints = function(p1, p2, pCenter) {
		   pCenter.x = (p1.x + p2.x) * 0.5;
		   pCenter.y = (p1.y + p2.y) * 0.5;
	   },
	   _pushPosPoint = function(time, x, y) {
		   if(time - _gestureCheckSpeedTime > 50) {
			   var o = _posPoints.length > 2 ? _posPoints.shift() : {};
			   o.x = x;
			   o.y = y; 
			   _posPoints.push(o);
			   _gestureCheckSpeedTime = time;
		   }
	   },
   
	   _calculateVerticalDragOpacityRatio = function() {
		   var yOffset = _panOffset.y - self.currItem.initialPosition.y; // difference between initial and current position
		   return 1 -  Math.abs( yOffset / (_viewportSize.y / 2)  );
	   },
   
	   
	   // points pool, reused during touch events
	   _ePoint1 = {},
	   _ePoint2 = {},
	   _tempPointsArr = [],
	   _tempCounter,
	   _getTouchPoints = function(e) {
		   // clean up previous points, without recreating array
		   while(_tempPointsArr.length > 0) {
			   _tempPointsArr.pop();
		   }
   
		   if(!_pointerEventEnabled) {
			   if(e.type.indexOf('touch') > -1) {
   
				   if(e.touches && e.touches.length > 0) {
					   _tempPointsArr[0] = _convertTouchToPoint(e.touches[0], _ePoint1);
					   if(e.touches.length > 1) {
						   _tempPointsArr[1] = _convertTouchToPoint(e.touches[1], _ePoint2);
					   }
				   }
				   
			   } else {
				   _ePoint1.x = e.pageX;
				   _ePoint1.y = e.pageY;
				   _ePoint1.id = '';
				   _tempPointsArr[0] = _ePoint1;//_ePoint1;
			   }
		   } else {
			   _tempCounter = 0;
			   // we can use forEach, as pointer events are supported only in modern browsers
			   _currPointers.forEach(function(p) {
				   if(_tempCounter === 0) {
					   _tempPointsArr[0] = p;
				   } else if(_tempCounter === 1) {
					   _tempPointsArr[1] = p;
				   }
				   _tempCounter++;
   
			   });
		   }
		   return _tempPointsArr;
	   },
   
	   _panOrMoveMainScroll = function(axis, delta) {
   
		   var panFriction,
			   overDiff = 0,
			   newOffset = _panOffset[axis] + delta[axis],
			   startOverDiff,
			   dir = delta[axis] > 0,
			   newMainScrollPosition = _mainScrollPos.x + delta.x,
			   mainScrollDiff = _mainScrollPos.x - _startMainScrollPos.x,
			   newPanPos,
			   newMainScrollPos;
   
		   // calculate fdistance over the bounds and friction
		   if(newOffset > _currPanBounds.min[axis] || newOffset < _currPanBounds.max[axis]) {
			   panFriction = _options.panEndFriction;
			   // Linear increasing of friction, so at 1/4 of viewport it's at max value. 
			   // Looks not as nice as was expected. Left for history.
			   // panFriction = (1 - (_panOffset[axis] + delta[axis] + panBounds.min[axis]) / (_viewportSize[axis] / 4) );
		   } else {
			   panFriction = 1;
		   }
		   
		   newOffset = _panOffset[axis] + delta[axis] * panFriction;
   
		   // move main scroll or start panning
		   if(_options.allowPanToNext || _currZoomLevel === self.currItem.initialZoomLevel) {
   
   
			   if(!_currZoomElementStyle) {
				   
				   newMainScrollPos = newMainScrollPosition;
   
			   } else if(_direction === 'h' && axis === 'x' && !_zoomStarted ) {
				   
				   if(dir) {
					   if(newOffset > _currPanBounds.min[axis]) {
						   panFriction = _options.panEndFriction;
						   overDiff = _currPanBounds.min[axis] - newOffset;
						   startOverDiff = _currPanBounds.min[axis] - _startPanOffset[axis];
					   }
					   
					   // drag right
					   if( (startOverDiff <= 0 || mainScrollDiff < 0) && _getNumItems() > 1 ) {
						   newMainScrollPos = newMainScrollPosition;
						   if(mainScrollDiff < 0 && newMainScrollPosition > _startMainScrollPos.x) {
							   newMainScrollPos = _startMainScrollPos.x;
						   }
					   } else {
						   if(_currPanBounds.min.x !== _currPanBounds.max.x) {
							   newPanPos = newOffset;
						   }
						   
					   }
   
				   } else {
   
					   if(newOffset < _currPanBounds.max[axis] ) {
						   panFriction =_options.panEndFriction;
						   overDiff = newOffset - _currPanBounds.max[axis];
						   startOverDiff = _startPanOffset[axis] - _currPanBounds.max[axis];
					   }
   
					   if( (startOverDiff <= 0 || mainScrollDiff > 0) && _getNumItems() > 1 ) {
						   newMainScrollPos = newMainScrollPosition;
   
						   if(mainScrollDiff > 0 && newMainScrollPosition < _startMainScrollPos.x) {
							   newMainScrollPos = _startMainScrollPos.x;
						   }
   
					   } else {
						   if(_currPanBounds.min.x !== _currPanBounds.max.x) {
							   newPanPos = newOffset;
						   }
					   }
   
				   }
   
   
				   //
			   }
   
			   if(axis === 'x') {
   
				   if(newMainScrollPos !== undefined) {
					   _moveMainScroll(newMainScrollPos, true);
					   if(newMainScrollPos === _startMainScrollPos.x) {
						   _mainScrollShifted = false;
					   } else {
						   _mainScrollShifted = true;
					   }
				   }
   
				   if(_currPanBounds.min.x !== _currPanBounds.max.x) {
					   if(newPanPos !== undefined) {
						   _panOffset.x = newPanPos;
					   } else if(!_mainScrollShifted) {
						   _panOffset.x += delta.x * panFriction;
					   }
				   }
   
				   return newMainScrollPos !== undefined;
			   }
   
		   }
   
		   if(!_mainScrollAnimating) {
			   
			   if(!_mainScrollShifted) {
				   if(_currZoomLevel > self.currItem.fitRatio) {
					   _panOffset[axis] += delta[axis] * panFriction;
				   
				   }
			   }
   
			   
		   }
		   
	   },
   
	   // Pointerdown/touchstart/mousedown handler
	   _onDragStart = function(e) {
   
		   // Allow dragging only via left mouse button.
		   // As this handler is not added in IE8 - we ignore e.which
		   // 
		   // http://www.quirksmode.org/js/events_properties.html
		   // https://developer.mozilla.org/en-US/docs/Web/API/event.button
		   if(e.type === 'mousedown' && e.button > 0  ) {
			   return;
		   }
   
		   if(_initialZoomRunning) {
			   e.preventDefault();
			   return;
		   }
   
		   if(_oldAndroidTouchEndTimeout && e.type === 'mousedown') {
			   return;
		   }
   
		   if(_preventDefaultEventBehaviour(e, true)) {
			   e.preventDefault();
		   }
   
   
   
		   _shout('pointerDown');
   
		   if(_pointerEventEnabled) {
			   var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
			   if(pointerIndex < 0) {
				   pointerIndex = _currPointers.length;
			   }
			   _currPointers[pointerIndex] = {x:e.pageX, y:e.pageY, id: e.pointerId};
		   }
		   
   
   
		   var startPointsList = _getTouchPoints(e),
			   numPoints = startPointsList.length;
   
		   _currentPoints = null;
   
		   _stopAllAnimations();
   
		   // init drag
		   if(!_isDragging || numPoints === 1) {
   
			   
   
			   _isDragging = _isFirstMove = true;
			   framework.bind(window, _upMoveEvents, self);
   
			   _isZoomingIn = 
				   _wasOverInitialZoom = 
				   _opacityChanged = 
				   _verticalDragInitiated = 
				   _mainScrollShifted = 
				   _moved = 
				   _isMultitouch = 
				   _zoomStarted = false;
   
			   _direction = null;
   
			   _shout('firstTouchStart', startPointsList);
   
			   _equalizePoints(_startPanOffset, _panOffset);
   
			   _currPanDist.x = _currPanDist.y = 0;
			   _equalizePoints(_currPoint, startPointsList[0]);
			   _equalizePoints(_startPoint, _currPoint);
   
			   //_equalizePoints(_startMainScrollPos, _mainScrollPos);
			   _startMainScrollPos.x = _slideSize.x * _currPositionIndex;
   
			   _posPoints = [{
				   x: _currPoint.x,
				   y: _currPoint.y
			   }];
   
			   _gestureCheckSpeedTime = _gestureStartTime = _getCurrentTime();
   
			   //_mainScrollAnimationEnd(true);
			   _calculatePanBounds( _currZoomLevel, true );
			   
			   // Start rendering
			   _stopDragUpdateLoop();
			   _dragUpdateLoop();
			   
		   }
   
		   // init zoom
		   if(!_isZooming && numPoints > 1 && !_mainScrollAnimating && !_mainScrollShifted) {
			   _startZoomLevel = _currZoomLevel;
			   _zoomStarted = false; // true if zoom changed at least once
   
			   _isZooming = _isMultitouch = true;
			   _currPanDist.y = _currPanDist.x = 0;
   
			   _equalizePoints(_startPanOffset, _panOffset);
   
			   _equalizePoints(p, startPointsList[0]);
			   _equalizePoints(p2, startPointsList[1]);
   
			   _findCenterOfPoints(p, p2, _currCenterPoint);
   
			   _midZoomPoint.x = Math.abs(_currCenterPoint.x) - _panOffset.x;
			   _midZoomPoint.y = Math.abs(_currCenterPoint.y) - _panOffset.y;
			   _currPointsDistance = _startPointsDistance = _calculatePointsDistance(p, p2);
		   }
   
   
	   },
   
	   // Pointermove/touchmove/mousemove handler
	   _onDragMove = function(e) {
   
		   e.preventDefault();
   
		   if(_pointerEventEnabled) {
			   var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
			   if(pointerIndex > -1) {
				   var p = _currPointers[pointerIndex];
				   p.x = e.pageX;
				   p.y = e.pageY; 
			   }
		   }
   
		   if(_isDragging) {
			   var touchesList = _getTouchPoints(e);
			   if(!_direction && !_moved && !_isZooming) {
   
				   if(_mainScrollPos.x !== _slideSize.x * _currPositionIndex) {
					   // if main scroll position is shifted – direction is always horizontal
					   _direction = 'h';
				   } else {
					   var diff = Math.abs(touchesList[0].x - _currPoint.x) - Math.abs(touchesList[0].y - _currPoint.y);
					   // check the direction of movement
					   if(Math.abs(diff) >= DIRECTION_CHECK_OFFSET) {
						   _direction = diff > 0 ? 'h' : 'v';
						   _currentPoints = touchesList;
					   }
				   }
				   
			   } else {
				   _currentPoints = touchesList;
			   }
		   }	
	   },
	   // 
	   _renderMovement =  function() {
   
		   if(!_currentPoints) {
			   return;
		   }
   
		   var numPoints = _currentPoints.length;
   
		   if(numPoints === 0) {
			   return;
		   }
   
		   _equalizePoints(p, _currentPoints[0]);
   
		   delta.x = p.x - _currPoint.x;
		   delta.y = p.y - _currPoint.y;
   
		   if(_isZooming && numPoints > 1) {
			   // Handle behaviour for more than 1 point
   
			   _currPoint.x = p.x;
			   _currPoint.y = p.y;
		   
			   // check if one of two points changed
			   if( !delta.x && !delta.y && _isEqualPoints(_currentPoints[1], p2) ) {
				   return;
			   }
   
			   _equalizePoints(p2, _currentPoints[1]);
   
   
			   if(!_zoomStarted) {
				   _zoomStarted = true;
				   _shout('zoomGestureStarted');
			   }
			   
			   // Distance between two points
			   var pointsDistance = _calculatePointsDistance(p,p2);
   
			   var zoomLevel = _calculateZoomLevel(pointsDistance);
   
			   // slightly over the of initial zoom level
			   if(zoomLevel > self.currItem.initialZoomLevel + self.currItem.initialZoomLevel / 15) {
				   _wasOverInitialZoom = true;
			   }
   
			   // Apply the friction if zoom level is out of the bounds
			   var zoomFriction = 1,
				   minZoomLevel = _getMinZoomLevel(),
				   maxZoomLevel = _getMaxZoomLevel();
   
			   if ( zoomLevel < minZoomLevel ) {
				   
				   if(_options.pinchToClose && !_wasOverInitialZoom && _startZoomLevel <= self.currItem.initialZoomLevel) {
					   // fade out background if zooming out
					   var minusDiff = minZoomLevel - zoomLevel;
					   var percent = 1 - minusDiff / (minZoomLevel / 1.2);
   
					   _applyBgOpacity(percent);
					   _shout('onPinchClose', percent);
					   _opacityChanged = true;
				   } else {
					   zoomFriction = (minZoomLevel - zoomLevel) / minZoomLevel;
					   if(zoomFriction > 1) {
						   zoomFriction = 1;
					   }
					   zoomLevel = minZoomLevel - zoomFriction * (minZoomLevel / 3);
				   }
				   
			   } else if ( zoomLevel > maxZoomLevel ) {
				   // 1.5 - extra zoom level above the max. E.g. if max is x6, real max 6 + 1.5 = 7.5
				   zoomFriction = (zoomLevel - maxZoomLevel) / ( minZoomLevel * 6 );
				   if(zoomFriction > 1) {
					   zoomFriction = 1;
				   }
				   zoomLevel = maxZoomLevel + zoomFriction * minZoomLevel;
			   }
   
			   if(zoomFriction < 0) {
				   zoomFriction = 0;
			   }
   
			   // distance between touch points after friction is applied
			   _currPointsDistance = pointsDistance;
   
			   // _centerPoint - The point in the middle of two pointers
			   _findCenterOfPoints(p, p2, _centerPoint);
		   
			   // paning with two pointers pressed
			   _currPanDist.x += _centerPoint.x - _currCenterPoint.x;
			   _currPanDist.y += _centerPoint.y - _currCenterPoint.y;
			   _equalizePoints(_currCenterPoint, _centerPoint);
   
			   _panOffset.x = _calculatePanOffset('x', zoomLevel);
			   _panOffset.y = _calculatePanOffset('y', zoomLevel);
   
			   _isZoomingIn = zoomLevel > _currZoomLevel;
			   _currZoomLevel = zoomLevel;
			   _applyCurrentZoomPan();
   
		   } else {
   
			   // handle behaviour for one point (dragging or panning)
   
			   if(!_direction) {
				   return;
			   }
   
			   if(_isFirstMove) {
				   _isFirstMove = false;
   
				   // subtract drag distance that was used during the detection direction  
   
				   if( Math.abs(delta.x) >= DIRECTION_CHECK_OFFSET) {
					   delta.x -= _currentPoints[0].x - _startPoint.x;
				   }
				   
				   if( Math.abs(delta.y) >= DIRECTION_CHECK_OFFSET) {
					   delta.y -= _currentPoints[0].y - _startPoint.y;
				   }
			   }
   
			   _currPoint.x = p.x;
			   _currPoint.y = p.y;
   
			   // do nothing if pointers position hasn't changed
			   if(delta.x === 0 && delta.y === 0) {
				   return;
			   }
   
			   if(_direction === 'v' && _options.closeOnVerticalDrag) {
				   if(!_canPan()) {
					   _currPanDist.y += delta.y;
					   _panOffset.y += delta.y;
   
					   var opacityRatio = _calculateVerticalDragOpacityRatio();
   
					   _verticalDragInitiated = true;
					   _shout('onVerticalDrag', opacityRatio);
   
					   _applyBgOpacity(opacityRatio);
					   _applyCurrentZoomPan();
					   return ;
				   }
			   }
   
			   _pushPosPoint(_getCurrentTime(), p.x, p.y);
   
			   _moved = true;
			   _currPanBounds = self.currItem.bounds;
			   
			   var mainScrollChanged = _panOrMoveMainScroll('x', delta);
			   if(!mainScrollChanged) {
				   _panOrMoveMainScroll('y', delta);
   
				   _roundPoint(_panOffset);
				   _applyCurrentZoomPan();
			   }
   
		   }
   
	   },
	   
	   // Pointerup/pointercancel/touchend/touchcancel/mouseup event handler
	   _onDragRelease = function(e) {
   
		   if(_features.isOldAndroid ) {
   
			   if(_oldAndroidTouchEndTimeout && e.type === 'mouseup') {
				   return;
			   }
   
			   // on Android (v4.1, 4.2, 4.3 & possibly older) 
			   // ghost mousedown/up event isn't preventable via e.preventDefault,
			   // which causes fake mousedown event
			   // so we block mousedown/up for 600ms
			   if( e.type.indexOf('touch') > -1 ) {
				   clearTimeout(_oldAndroidTouchEndTimeout);
				   _oldAndroidTouchEndTimeout = setTimeout(function() {
					   _oldAndroidTouchEndTimeout = 0;
				   }, 600);
			   }
			   
		   }
   
		   _shout('pointerUp');
   
		   if(_preventDefaultEventBehaviour(e, false)) {
			   e.preventDefault();
		   }
   
		   var releasePoint;
   
		   if(_pointerEventEnabled) {
			   var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
			   
			   if(pointerIndex > -1) {
				   releasePoint = _currPointers.splice(pointerIndex, 1)[0];
   
				   if(navigator.pointerEnabled) {
					   releasePoint.type = e.pointerType || 'mouse';
				   } else {
					   var MSPOINTER_TYPES = {
						   4: 'mouse', // event.MSPOINTER_TYPE_MOUSE
						   2: 'touch', // event.MSPOINTER_TYPE_TOUCH 
						   3: 'pen' // event.MSPOINTER_TYPE_PEN
					   };
					   releasePoint.type = MSPOINTER_TYPES[e.pointerType];
   
					   if(!releasePoint.type) {
						   releasePoint.type = e.pointerType || 'mouse';
					   }
				   }
   
			   }
		   }
   
		   var touchList = _getTouchPoints(e),
			   gestureType,
			   numPoints = touchList.length;
   
		   if(e.type === 'mouseup') {
			   numPoints = 0;
		   }
   
		   // Do nothing if there were 3 touch points or more
		   if(numPoints === 2) {
			   _currentPoints = null;
			   return true;
		   }
   
		   // if second pointer released
		   if(numPoints === 1) {
			   _equalizePoints(_startPoint, touchList[0]);
		   }				
   
   
		   // pointer hasn't moved, send "tap release" point
		   if(numPoints === 0 && !_direction && !_mainScrollAnimating) {
			   if(!releasePoint) {
				   if(e.type === 'mouseup') {
					   releasePoint = {x: e.pageX, y: e.pageY, type:'mouse'};
				   } else if(e.changedTouches && e.changedTouches[0]) {
					   releasePoint = {x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY, type:'touch'};
				   }		
			   }
   
			   _shout('touchRelease', e, releasePoint);
		   }
   
		   // Difference in time between releasing of two last touch points (zoom gesture)
		   var releaseTimeDiff = -1;
   
		   // Gesture completed, no pointers left
		   if(numPoints === 0) {
			   _isDragging = false;
			   framework.unbind(window, _upMoveEvents, self);
   
			   _stopDragUpdateLoop();
   
			   if(_isZooming) {
				   // Two points released at the same time
				   releaseTimeDiff = 0;
			   } else if(_lastReleaseTime !== -1) {
				   releaseTimeDiff = _getCurrentTime() - _lastReleaseTime;
			   }
		   }
		   _lastReleaseTime = numPoints === 1 ? _getCurrentTime() : -1;
		   
		   if(releaseTimeDiff !== -1 && releaseTimeDiff < 150) {
			   gestureType = 'zoom';
		   } else {
			   gestureType = 'swipe';
		   }
   
		   if(_isZooming && numPoints < 2) {
			   _isZooming = false;
   
			   // Only second point released
			   if(numPoints === 1) {
				   gestureType = 'zoomPointerUp';
			   }
			   _shout('zoomGestureEnded');
		   }
   
		   _currentPoints = null;
		   if(!_moved && !_zoomStarted && !_mainScrollAnimating && !_verticalDragInitiated) {
			   // nothing to animate
			   return;
		   }
	   
		   _stopAllAnimations();
   
		   
		   if(!_releaseAnimData) {
			   _releaseAnimData = _initDragReleaseAnimationData();
		   }
		   
		   _releaseAnimData.calculateSwipeSpeed('x');
   
   
		   if(_verticalDragInitiated) {
   
			   var opacityRatio = _calculateVerticalDragOpacityRatio();
   
			   if(opacityRatio < _options.verticalDragRange) {
				   self.close();
			   } else {
				   var initalPanY = _panOffset.y,
					   initialBgOpacity = _bgOpacity;
   
				   _animateProp('verticalDrag', 0, 1, 300, framework.easing.cubic.out, function(now) {
					   
					   _panOffset.y = (self.currItem.initialPosition.y - initalPanY) * now + initalPanY;
   
					   _applyBgOpacity(  (1 - initialBgOpacity) * now + initialBgOpacity );
					   _applyCurrentZoomPan();
				   });
   
				   _shout('onVerticalDrag', 1);
			   }
   
			   return;
		   }
   
   
		   // main scroll 
		   if(  (_mainScrollShifted || _mainScrollAnimating) && numPoints === 0) {
			   var itemChanged = _finishSwipeMainScrollGesture(gestureType, _releaseAnimData);
			   if(itemChanged) {
				   return;
			   }
			   gestureType = 'zoomPointerUp';
		   }
   
		   // prevent zoom/pan animation when main scroll animation runs
		   if(_mainScrollAnimating) {
			   return;
		   }
		   
		   // Complete simple zoom gesture (reset zoom level if it's out of the bounds)  
		   if(gestureType !== 'swipe') {
			   _completeZoomGesture();
			   return;
		   }
	   
		   // Complete pan gesture if main scroll is not shifted, and it's possible to pan current image
		   if(!_mainScrollShifted && _currZoomLevel > self.currItem.fitRatio) {
			   _completePanGesture(_releaseAnimData);
		   }
	   },
   
   
	   // Returns object with data about gesture
	   // It's created only once and then reused
	   _initDragReleaseAnimationData  = function() {
		   // temp local vars
		   var lastFlickDuration,
			   tempReleasePos;
   
		   // s = this
		   var s = {
			   lastFlickOffset: {},
			   lastFlickDist: {},
			   lastFlickSpeed: {},
			   slowDownRatio:  {},
			   slowDownRatioReverse:  {},
			   speedDecelerationRatio:  {},
			   speedDecelerationRatioAbs:  {},
			   distanceOffset:  {},
			   backAnimDestination: {},
			   backAnimStarted: {},
			   calculateSwipeSpeed: function(axis) {
				   
   
				   if( _posPoints.length > 1) {
					   lastFlickDuration = _getCurrentTime() - _gestureCheckSpeedTime + 50;
					   tempReleasePos = _posPoints[_posPoints.length-2][axis];
				   } else {
					   lastFlickDuration = _getCurrentTime() - _gestureStartTime; // total gesture duration
					   tempReleasePos = _startPoint[axis];
				   }
				   s.lastFlickOffset[axis] = _currPoint[axis] - tempReleasePos;
				   s.lastFlickDist[axis] = Math.abs(s.lastFlickOffset[axis]);
				   if(s.lastFlickDist[axis] > 20) {
					   s.lastFlickSpeed[axis] = s.lastFlickOffset[axis] / lastFlickDuration;
				   } else {
					   s.lastFlickSpeed[axis] = 0;
				   }
				   if( Math.abs(s.lastFlickSpeed[axis]) < 0.1 ) {
					   s.lastFlickSpeed[axis] = 0;
				   }
				   
				   s.slowDownRatio[axis] = 0.95;
				   s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
				   s.speedDecelerationRatio[axis] = 1;
			   },
   
			   calculateOverBoundsAnimOffset: function(axis, speed) {
				   if(!s.backAnimStarted[axis]) {
   
					   if(_panOffset[axis] > _currPanBounds.min[axis]) {
						   s.backAnimDestination[axis] = _currPanBounds.min[axis];
						   
					   } else if(_panOffset[axis] < _currPanBounds.max[axis]) {
						   s.backAnimDestination[axis] = _currPanBounds.max[axis];
					   }
   
					   if(s.backAnimDestination[axis] !== undefined) {
						   s.slowDownRatio[axis] = 0.7;
						   s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
						   if(s.speedDecelerationRatioAbs[axis] < 0.05) {
   
							   s.lastFlickSpeed[axis] = 0;
							   s.backAnimStarted[axis] = true;
   
							   _animateProp('bounceZoomPan'+axis,_panOffset[axis], 
								   s.backAnimDestination[axis], 
								   speed || 300, 
								   framework.easing.sine.out, 
								   function(pos) {
									   _panOffset[axis] = pos;
									   _applyCurrentZoomPan();
								   }
							   );
   
						   }
					   }
				   }
			   },
   
			   // Reduces the speed by slowDownRatio (per 10ms)
			   calculateAnimOffset: function(axis) {
				   if(!s.backAnimStarted[axis]) {
					   s.speedDecelerationRatio[axis] = s.speedDecelerationRatio[axis] * (s.slowDownRatio[axis] + 
												   s.slowDownRatioReverse[axis] - 
												   s.slowDownRatioReverse[axis] * s.timeDiff / 10);
   
					   s.speedDecelerationRatioAbs[axis] = Math.abs(s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis]);
					   s.distanceOffset[axis] = s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis] * s.timeDiff;
					   _panOffset[axis] += s.distanceOffset[axis];
   
				   }
			   },
   
			   panAnimLoop: function() {
				   if ( _animations.zoomPan ) {
					   _animations.zoomPan.raf = _requestAF(s.panAnimLoop);
   
					   s.now = _getCurrentTime();
					   s.timeDiff = s.now - s.lastNow;
					   s.lastNow = s.now;
					   
					   s.calculateAnimOffset('x');
					   s.calculateAnimOffset('y');
   
					   _applyCurrentZoomPan();
					   
					   s.calculateOverBoundsAnimOffset('x');
					   s.calculateOverBoundsAnimOffset('y');
   
   
					   if (s.speedDecelerationRatioAbs.x < 0.05 && s.speedDecelerationRatioAbs.y < 0.05) {
   
						   // round pan position
						   _panOffset.x = Math.round(_panOffset.x);
						   _panOffset.y = Math.round(_panOffset.y);
						   _applyCurrentZoomPan();
						   
						   _stopAnimation('zoomPan');
						   return;
					   }
				   }
   
			   }
		   };
		   return s;
	   },
   
	   _completePanGesture = function(animData) {
		   // calculate swipe speed for Y axis (paanning)
		   animData.calculateSwipeSpeed('y');
   
		   _currPanBounds = self.currItem.bounds;
		   
		   animData.backAnimDestination = {};
		   animData.backAnimStarted = {};
   
		   // Avoid acceleration animation if speed is too low
		   if(Math.abs(animData.lastFlickSpeed.x) <= 0.05 && Math.abs(animData.lastFlickSpeed.y) <= 0.05 ) {
			   animData.speedDecelerationRatioAbs.x = animData.speedDecelerationRatioAbs.y = 0;
   
			   // Run pan drag release animation. E.g. if you drag image and release finger without momentum.
			   animData.calculateOverBoundsAnimOffset('x');
			   animData.calculateOverBoundsAnimOffset('y');
			   return true;
		   }
   
		   // Animation loop that controls the acceleration after pan gesture ends
		   _registerStartAnimation('zoomPan');
		   animData.lastNow = _getCurrentTime();
		   animData.panAnimLoop();
	   },
   
   
	   _finishSwipeMainScrollGesture = function(gestureType, _releaseAnimData) {
		   var itemChanged;
		   if(!_mainScrollAnimating) {
			   _currZoomedItemIndex = _currentItemIndex;
		   }
   
   
		   
		   var itemsDiff;
   
		   if(gestureType === 'swipe') {
			   var totalShiftDist = _currPoint.x - _startPoint.x,
				   isFastLastFlick = _releaseAnimData.lastFlickDist.x < 10;
   
			   // if container is shifted for more than MIN_SWIPE_DISTANCE, 
			   // and last flick gesture was in right direction
			   if(totalShiftDist > MIN_SWIPE_DISTANCE && 
				   (isFastLastFlick || _releaseAnimData.lastFlickOffset.x > 20) ) {
				   // go to prev item
				   itemsDiff = -1;
			   } else if(totalShiftDist < -MIN_SWIPE_DISTANCE && 
				   (isFastLastFlick || _releaseAnimData.lastFlickOffset.x < -20) ) {
				   // go to next item
				   itemsDiff = 1;
			   }
		   }
   
		   var nextCircle;
   
		   if(itemsDiff) {
			   
			   _currentItemIndex += itemsDiff;
   
			   if(_currentItemIndex < 0) {
				   _currentItemIndex = _options.loop ? _getNumItems()-1 : 0;
				   nextCircle = true;
			   } else if(_currentItemIndex >= _getNumItems()) {
				   _currentItemIndex = _options.loop ? 0 : _getNumItems()-1;
				   nextCircle = true;
			   }
   
			   if(!nextCircle || _options.loop) {
				   _indexDiff += itemsDiff;
				   _currPositionIndex -= itemsDiff;
				   itemChanged = true;
			   }
			   
   
			   
		   }
   
		   var animateToX = _slideSize.x * _currPositionIndex;
		   var animateToDist = Math.abs( animateToX - _mainScrollPos.x );
		   var finishAnimDuration;
   
   
		   if(!itemChanged && animateToX > _mainScrollPos.x !== _releaseAnimData.lastFlickSpeed.x > 0) {
			   // "return to current" duration, e.g. when dragging from slide 0 to -1
			   finishAnimDuration = 333; 
		   } else {
			   finishAnimDuration = Math.abs(_releaseAnimData.lastFlickSpeed.x) > 0 ? 
									   animateToDist / Math.abs(_releaseAnimData.lastFlickSpeed.x) : 
									   333;
   
			   finishAnimDuration = Math.min(finishAnimDuration, 400);
			   finishAnimDuration = Math.max(finishAnimDuration, 250);
		   }
   
		   if(_currZoomedItemIndex === _currentItemIndex) {
			   itemChanged = false;
		   }
		   
		   _mainScrollAnimating = true;
		   
		   _shout('mainScrollAnimStart');
   
		   _animateProp('mainScroll', _mainScrollPos.x, animateToX, finishAnimDuration, framework.easing.cubic.out, 
			   _moveMainScroll,
			   function() {
				   _stopAllAnimations();
				   _mainScrollAnimating = false;
				   _currZoomedItemIndex = -1;
				   
				   if(itemChanged || _currZoomedItemIndex !== _currentItemIndex) {
					   self.updateCurrItem();
				   }
				   
				   _shout('mainScrollAnimComplete');
			   }
		   );
   
		   if(itemChanged) {
			   self.updateCurrItem(true);
		   }
   
		   return itemChanged;
	   },
   
	   _calculateZoomLevel = function(touchesDistance) {
		   return  1 / _startPointsDistance * touchesDistance * _startZoomLevel;
	   },
   
	   // Resets zoom if it's out of bounds
	   _completeZoomGesture = function() {
		   var destZoomLevel = _currZoomLevel,
			   minZoomLevel = _getMinZoomLevel(),
			   maxZoomLevel = _getMaxZoomLevel();
   
		   if ( _currZoomLevel < minZoomLevel ) {
			   destZoomLevel = minZoomLevel;
		   } else if ( _currZoomLevel > maxZoomLevel ) {
			   destZoomLevel = maxZoomLevel;
		   }
   
		   var destOpacity = 1,
			   onUpdate,
			   initialOpacity = _bgOpacity;
   
		   if(_opacityChanged && !_isZoomingIn && !_wasOverInitialZoom && _currZoomLevel < minZoomLevel) {
			   //_closedByScroll = true;
			   self.close();
			   return true;
		   }
   
		   if(_opacityChanged) {
			   onUpdate = function(now) {
				   _applyBgOpacity(  (destOpacity - initialOpacity) * now + initialOpacity );
			   };
		   }
   
		   self.zoomTo(destZoomLevel, 0, 200,  framework.easing.cubic.out, onUpdate);
		   return true;
	   };
   
   
   _registerModule('Gestures', {
	   publicMethods: {
   
		   initGestures: function() {
   
			   // helper function that builds touch/pointer/mouse events
			   var addEventNames = function(pref, down, move, up, cancel) {
				   _dragStartEvent = pref + down;
				   _dragMoveEvent = pref + move;
				   _dragEndEvent = pref + up;
				   if(cancel) {
					   _dragCancelEvent = pref + cancel;
				   } else {
					   _dragCancelEvent = '';
				   }
			   };
   
			   _pointerEventEnabled = _features.pointerEvent;
			   if(_pointerEventEnabled && _features.touch) {
				   // we don't need touch events, if browser supports pointer events
				   _features.touch = false;
			   }
   
			   if(_pointerEventEnabled) {
				   if(navigator.pointerEnabled) {
					   addEventNames('pointer', 'down', 'move', 'up', 'cancel');
				   } else {
					   // IE10 pointer events are case-sensitive
					   addEventNames('MSPointer', 'Down', 'Move', 'Up', 'Cancel');
				   }
			   } else if(_features.touch) {
				   addEventNames('touch', 'start', 'move', 'end', 'cancel');
				   _likelyTouchDevice = true;
			   } else {
				   addEventNames('mouse', 'down', 'move', 'up');	
			   }
   
			   _upMoveEvents = _dragMoveEvent + ' ' + _dragEndEvent  + ' ' +  _dragCancelEvent;
			   _downEvents = _dragStartEvent;
   
			   if(_pointerEventEnabled && !_likelyTouchDevice) {
				   _likelyTouchDevice = (navigator.maxTouchPoints > 1) || (navigator.msMaxTouchPoints > 1);
			   }
			   // make variable public
			   self.likelyTouchDevice = _likelyTouchDevice; 
			   
			   _globalEventHandlers[_dragStartEvent] = _onDragStart;
			   _globalEventHandlers[_dragMoveEvent] = _onDragMove;
			   _globalEventHandlers[_dragEndEvent] = _onDragRelease; // the Kraken
   
			   if(_dragCancelEvent) {
				   _globalEventHandlers[_dragCancelEvent] = _globalEventHandlers[_dragEndEvent];
			   }
   
			   // Bind mouse events on device with detected hardware touch support, in case it supports multiple types of input.
			   if(_features.touch) {
				   _downEvents += ' mousedown';
				   _upMoveEvents += ' mousemove mouseup';
				   _globalEventHandlers.mousedown = _globalEventHandlers[_dragStartEvent];
				   _globalEventHandlers.mousemove = _globalEventHandlers[_dragMoveEvent];
				   _globalEventHandlers.mouseup = _globalEventHandlers[_dragEndEvent];
			   }
   
			   if(!_likelyTouchDevice) {
				   // don't allow pan to next slide from zoomed state on Desktop
				   _options.allowPanToNext = false;
			   }
		   }
   
	   }
   });
   
   
   /*>>gestures*/
   
   /*>>show-hide-transition*/
   /**
	* show-hide-transition.js:
	*
	* Manages initial opening or closing transition.
	*
	* If you're not planning to use transition for gallery at all,
	* you may set options hideAnimationDuration and showAnimationDuration to 0,
	* and just delete startAnimation function.
	* 
	*/
   
   
   var _showOrHideTimeout,
	   _showOrHide = function(item, img, out, completeFn) {
   
		   if(_showOrHideTimeout) {
			   clearTimeout(_showOrHideTimeout);
		   }
   
		   _initialZoomRunning = true;
		   _initialContentSet = true;
		   
		   // dimensions of small thumbnail {x:,y:,w:}.
		   // Height is optional, as calculated based on large image.
		   var thumbBounds; 
		   if(item.initialLayout) {
			   thumbBounds = item.initialLayout;
			   item.initialLayout = null;
		   } else {
			   thumbBounds = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
		   }
   
		   var duration = out ? _options.hideAnimationDuration : _options.showAnimationDuration;
   
		   var onComplete = function() {
			   _stopAnimation('initialZoom');
			   if(!out) {
				   _applyBgOpacity(1);
				   if(img) {
					   img.style.display = 'block';
				   }
				   framework.addClass(template, 'pswp--animated-in');
				   _shout('initialZoom' + (out ? 'OutEnd' : 'InEnd'));
			   } else {
				   self.template.removeAttribute('style');
				   self.bg.removeAttribute('style');
			   }
   
			   if(completeFn) {
				   completeFn();
			   }
			   _initialZoomRunning = false;
		   };
   
		   // if bounds aren't provided, just open gallery without animation
		   if(!duration || !thumbBounds || thumbBounds.x === undefined) {
   
			   _shout('initialZoom' + (out ? 'Out' : 'In') );
   
			   _currZoomLevel = item.initialZoomLevel;
			   _equalizePoints(_panOffset,  item.initialPosition );
			   _applyCurrentZoomPan();
   
			   template.style.opacity = out ? 0 : 1;
			   _applyBgOpacity(1);
   
			   if(duration) {
				   setTimeout(function() {
					   onComplete();
				   }, duration);
			   } else {
				   onComplete();
			   }
   
			   return;
		   }
   
		   var startAnimation = function() {
			   var closeWithRaf = _closedByScroll,
				   fadeEverything = !self.currItem.src || self.currItem.loadError || _options.showHideOpacity;
			   
			   // apply hw-acceleration to image
			   if(item.miniImg) {
				   item.miniImg.style.webkitBackfaceVisibility = 'hidden';
			   }
   
			   if(!out) {
				   _currZoomLevel = thumbBounds.w / item.w;
				   _panOffset.x = thumbBounds.x;
				   _panOffset.y = thumbBounds.y - _initalWindowScrollY;
   
				   self[fadeEverything ? 'template' : 'bg'].style.opacity = 0.001;
				   _applyCurrentZoomPan();
			   }
   
			   _registerStartAnimation('initialZoom');
			   
			   if(out && !closeWithRaf) {
				   framework.removeClass(template, 'pswp--animated-in');
			   }
   
			   if(fadeEverything) {
				   if(out) {
					   framework[ (closeWithRaf ? 'remove' : 'add') + 'Class' ](template, 'pswp--animate_opacity');
				   } else {
					   setTimeout(function() {
						   framework.addClass(template, 'pswp--animate_opacity');
					   }, 30);
				   }
			   }
   
			   _showOrHideTimeout = setTimeout(function() {
   
				   _shout('initialZoom' + (out ? 'Out' : 'In') );
				   
   
				   if(!out) {
   
					   // "in" animation always uses CSS transitions (instead of rAF).
					   // CSS transition work faster here, 
					   // as developer may also want to animate other things, 
					   // like ui on top of sliding area, which can be animated just via CSS
					   
					   _currZoomLevel = item.initialZoomLevel;
					   _equalizePoints(_panOffset,  item.initialPosition );
					   _applyCurrentZoomPan();
					   _applyBgOpacity(1);
   
					   if(fadeEverything) {
						   template.style.opacity = 1;
					   } else {
						   _applyBgOpacity(1);
					   }
   
					   _showOrHideTimeout = setTimeout(onComplete, duration + 20);
				   } else {
   
					   // "out" animation uses rAF only when PhotoSwipe is closed by browser scroll, to recalculate position
					   var destZoomLevel = thumbBounds.w / item.w,
						   initialPanOffset = {
							   x: _panOffset.x,
							   y: _panOffset.y
						   },
						   initialZoomLevel = _currZoomLevel,
						   initalBgOpacity = _bgOpacity,
						   onUpdate = function(now) {
							   
							   if(now === 1) {
								   _currZoomLevel = destZoomLevel;
								   _panOffset.x = thumbBounds.x;
								   _panOffset.y = thumbBounds.y  - _currentWindowScrollY;
							   } else {
								   _currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
								   _panOffset.x = (thumbBounds.x - initialPanOffset.x) * now + initialPanOffset.x;
								   _panOffset.y = (thumbBounds.y - _currentWindowScrollY - initialPanOffset.y) * now + initialPanOffset.y;
							   }
							   
							   _applyCurrentZoomPan();
							   if(fadeEverything) {
								   template.style.opacity = 1 - now;
							   } else {
								   _applyBgOpacity( initalBgOpacity - now * initalBgOpacity );
							   }
						   };
   
					   if(closeWithRaf) {
						   _animateProp('initialZoom', 0, 1, duration, framework.easing.cubic.out, onUpdate, onComplete);
					   } else {
						   onUpdate(1);
						   _showOrHideTimeout = setTimeout(onComplete, duration + 20);
					   }
				   }
			   
			   }, out ? 25 : 90); // Main purpose of this delay is to give browser time to paint and
					   // create composite layers of PhotoSwipe UI parts (background, controls, caption, arrows).
					   // Which avoids lag at the beginning of scale transition.
		   };
		   startAnimation();
   
		   
	   };
   
   /*>>show-hide-transition*/
   
   /*>>items-controller*/
   /**
   *
   * Controller manages gallery items, their dimensions, and their content.
   * 
   */
   
   var _items,
	   _tempPanAreaSize = {},
	   _imagesToAppendPool = [],
	   _initialContentSet,
	   _initialZoomRunning,
	   _controllerDefaultOptions = {
		   index: 0,
		   errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
		   forceProgressiveLoading: false, // TODO
		   preload: [1,1],
		   getNumItemsFn: function() {
			   return _items.length;
		   }
	   };
   
   
   var _getItemAt,
	   _getNumItems,
	   _initialIsLoop,
	   _getZeroBounds = function() {
		   return {
			   center:{x:0,y:0}, 
			   max:{x:0,y:0}, 
			   min:{x:0,y:0}
		   };
	   },
	   _calculateSingleItemPanBounds = function(item, realPanElementW, realPanElementH ) {
		   var bounds = item.bounds;
   
		   // position of element when it's centered
		   bounds.center.x = Math.round((_tempPanAreaSize.x - realPanElementW) / 2);
		   bounds.center.y = Math.round((_tempPanAreaSize.y - realPanElementH) / 2) + item.vGap.top;
   
		   // maximum pan position
		   bounds.max.x = (realPanElementW > _tempPanAreaSize.x) ? 
							   Math.round(_tempPanAreaSize.x - realPanElementW) : 
							   bounds.center.x;
		   
		   bounds.max.y = (realPanElementH > _tempPanAreaSize.y) ? 
							   Math.round(_tempPanAreaSize.y - realPanElementH) + item.vGap.top : 
							   bounds.center.y;
		   
		   // minimum pan position
		   bounds.min.x = (realPanElementW > _tempPanAreaSize.x) ? 0 : bounds.center.x;
		   bounds.min.y = (realPanElementH > _tempPanAreaSize.y) ? item.vGap.top : bounds.center.y;
	   },
	   _calculateItemSize = function(item, viewportSize, zoomLevel) {
   
		   if (item.src && !item.loadError) {
			   var isInitial = !zoomLevel;
			   
			   if(isInitial) {
				   if(!item.vGap) {
					   item.vGap = {top:0,bottom:0};
				   }
				   // allows overriding vertical margin for individual items
				   _shout('parseVerticalMargin', item);
			   }
   
   
			   _tempPanAreaSize.x = viewportSize.x;
			   _tempPanAreaSize.y = viewportSize.y - item.vGap.top - item.vGap.bottom;
   
			   if (isInitial) {
				   var hRatio = _tempPanAreaSize.x / item.w;
				   var vRatio = _tempPanAreaSize.y / item.h;
   
				   item.fitRatio = hRatio < vRatio ? hRatio : vRatio;
				   //item.fillRatio = hRatio > vRatio ? hRatio : vRatio;
   
				   var scaleMode = _options.scaleMode;
   
				   if (scaleMode === 'orig') {
					   zoomLevel = 1;
				   } else if (scaleMode === 'fit') {
					   zoomLevel = item.fitRatio;
				   }
   
				   if (zoomLevel > 1) {
					   zoomLevel = 1;
				   }
   
				   item.initialZoomLevel = zoomLevel;
				   
				   if(!item.bounds) {
					   // reuse bounds object
					   item.bounds = _getZeroBounds(); 
				   }
			   }
   
			   if(!zoomLevel) {
				   return;
			   }
   
			   _calculateSingleItemPanBounds(item, item.w * zoomLevel, item.h * zoomLevel);
   
			   if (isInitial && zoomLevel === item.initialZoomLevel) {
				   item.initialPosition = item.bounds.center;
			   }
   
			   return item.bounds;
		   } else {
			   item.w = item.h = 0;
			   item.initialZoomLevel = item.fitRatio = 1;
			   item.bounds = _getZeroBounds();
			   item.initialPosition = item.bounds.center;
   
			   // if it's not image, we return zero bounds (content is not zoomable)
			   return item.bounds;
		   }
		   
	   },
   
	   
   
   
	   _appendImage = function(index, item, baseDiv, img, preventAnimation, keepPlaceholder) {
		   
   
		   if(item.loadError) {
			   return;
		   }
   
		   if(img) {
   
			   item.imageAppended = true;
			   _setImageSize(item, img, (item === self.currItem && _renderMaxResolution) );
			   
			   baseDiv.appendChild(img);
   
			   if(keepPlaceholder) {
				   setTimeout(function() {
					   if(item && item.loaded && item.placeholder) {
						   item.placeholder.style.display = 'none';
						   item.placeholder = null;
					   }
				   }, 500);
			   }
		   }
	   },
	   
   
   
	   _preloadImage = function(item) {
		   item.loading = true;
		   item.loaded = false;
		   var img = item.img = framework.createEl('pswp__img', 'img');
		   var onComplete = function() {
			   item.loading = false;
			   item.loaded = true;
   
			   if(item.loadComplete) {
				   item.loadComplete(item);
			   } else {
				   item.img = null; // no need to store image object
			   }
			   img.onload = img.onerror = null;
			   img = null;
		   };
		   img.onload = onComplete;
		   img.onerror = function() {
			   item.loadError = true;
			   onComplete();
		   };		
   
		   img.src = item.src;// + '?a=' + Math.random();
   
		   return img;
	   },
	   _checkForError = function(item, cleanUp) {
		   if(item.src && item.loadError && item.container) {
   
			   if(cleanUp) {
				   item.container.innerHTML = '';
			   }
   
			   item.container.innerHTML = _options.errorMsg.replace('%url%',  item.src );
			   return true;
			   
		   }
	   },
	   _setImageSize = function(item, img, maxRes) {
		   if(!item.src) {
			   return;
		   }
   
		   if(!img) {
			   img = item.container.lastChild;
		   }
   
		   var w = maxRes ? item.w : Math.round(item.w * item.fitRatio),
			   h = maxRes ? item.h : Math.round(item.h * item.fitRatio);
		   
		   if(item.placeholder && !item.loaded) {
			   item.placeholder.style.width = w + 'px';
			   item.placeholder.style.height = h + 'px';
		   }
   
		   img.style.width = w + 'px';
		   img.style.height = h + 'px';
	   },
	   _appendImagesPool = function() {
   
		   if(_imagesToAppendPool.length) {
			   var poolItem;
   
			   for(var i = 0; i < _imagesToAppendPool.length; i++) {
				   poolItem = _imagesToAppendPool[i];
				   if( poolItem.holder.index === poolItem.index ) {
					   _appendImage(poolItem.index, poolItem.item, poolItem.baseDiv, poolItem.img, false, poolItem.clearPlaceholder);
				   }
			   }
			   _imagesToAppendPool = [];
		   }
	   };
	   
   
   
   _registerModule('Controller', {
   
	   publicMethods: {
   
		   lazyLoadItem: function(index) {
			   index = _getLoopedId(index);
			   var item = _getItemAt(index);
   
			   if(!item || ((item.loaded || item.loading) && !_itemsNeedUpdate)) {
				   return;
			   }
   
			   _shout('gettingData', index, item);
   
			   if (!item.src) {
				   return;
			   }
   
			   _preloadImage(item);
		   },
		   initController: function() {
			   framework.extend(_options, _controllerDefaultOptions, true);
			   self.items = _items = items;
			   _getItemAt = self.getItemAt;
			   _getNumItems = _options.getNumItemsFn; //self.getNumItems;
   
   
   
			   _initialIsLoop = _options.loop;
			   if(_getNumItems() < 3) {
				   _options.loop = false; // disable loop if less then 3 items
			   }
   
			   _listen('beforeChange', function(diff) {
   
				   var p = _options.preload,
					   isNext = diff === null ? true : (diff >= 0),
					   preloadBefore = Math.min(p[0], _getNumItems() ),
					   preloadAfter = Math.min(p[1], _getNumItems() ),
					   i;
   
   
				   for(i = 1; i <= (isNext ? preloadAfter : preloadBefore); i++) {
					   self.lazyLoadItem(_currentItemIndex+i);
				   }
				   for(i = 1; i <= (isNext ? preloadBefore : preloadAfter); i++) {
					   self.lazyLoadItem(_currentItemIndex-i);
				   }
			   });
   
			   _listen('initialLayout', function() {
				   self.currItem.initialLayout = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
			   });
   
			   _listen('mainScrollAnimComplete', _appendImagesPool);
			   _listen('initialZoomInEnd', _appendImagesPool);
   
   
   
			   _listen('destroy', function() {
				   var item;
				   for(var i = 0; i < _items.length; i++) {
					   item = _items[i];
					   // remove reference to DOM elements, for GC
					   if(item.container) {
						   item.container = null; 
					   }
					   if(item.placeholder) {
						   item.placeholder = null;
					   }
					   if(item.img) {
						   item.img = null;
					   }
					   if(item.preloader) {
						   item.preloader = null;
					   }
					   if(item.loadError) {
						   item.loaded = item.loadError = false;
					   }
				   }
				   _imagesToAppendPool = null;
			   });
		   },
   
   
		   getItemAt: function(index) {
			   if (index >= 0) {
				   return _items[index] !== undefined ? _items[index] : false;
			   }
			   return false;
		   },
   
		   allowProgressiveImg: function() {
			   // 1. Progressive image loading isn't working on webkit/blink 
			   //    when hw-acceleration (e.g. translateZ) is applied to IMG element.
			   //    That's why in PhotoSwipe parent element gets zoom transform, not image itself.
			   //    
			   // 2. Progressive image loading sometimes blinks in webkit/blink when applying animation to parent element.
			   //    That's why it's disabled on touch devices (mainly because of swipe transition)
			   //    
			   // 3. Progressive image loading sometimes doesn't work in IE (up to 11).
   
			   // Don't allow progressive loading on non-large touch devices
			   return _options.forceProgressiveLoading || !_likelyTouchDevice || _options.mouseUsed || screen.width > 1200; 
			   // 1200 - to eliminate touch devices with large screen (like Chromebook Pixel)
		   },
   
		   setContent: function(holder, index) {
   
			   if(_options.loop) {
				   index = _getLoopedId(index);
			   }
   
			   var prevItem = self.getItemAt(holder.index);
			   if(prevItem) {
				   prevItem.container = null;
			   }
	   
			   var item = self.getItemAt(index),
				   img;
			   
			   if(!item) {
				   holder.el.innerHTML = '';
				   return;
			   }
   
			   // allow to override data
			   _shout('gettingData', index, item);
   
			   holder.index = index;
			   holder.item = item;
   
			   // base container DIV is created only once for each of 3 holders
			   var baseDiv = item.container = framework.createEl('pswp__zoom-wrap'); 
   
			   
   
			   if(!item.src && item.html) {
				   if(item.html.tagName) {
					   baseDiv.appendChild(item.html);
				   } else {
					   baseDiv.innerHTML = item.html;
				   }
			   }
   
			   _checkForError(item);
   
			   _calculateItemSize(item, _viewportSize);
			   
			   if(item.src && !item.loadError && !item.loaded) {
   
				   item.loadComplete = function(item) {
   
					   // gallery closed before image finished loading
					   if(!_isOpen) {
						   return;
					   }
   
					   // check if holder hasn't changed while image was loading
					   if(holder && holder.index === index ) {
						   if( _checkForError(item, true) ) {
							   item.loadComplete = item.img = null;
							   _calculateItemSize(item, _viewportSize);
							   _applyZoomPanToItem(item);
   
							   if(holder.index === _currentItemIndex) {
								   // recalculate dimensions
								   self.updateCurrZoomItem();
							   }
							   return;
						   }
						   if( !item.imageAppended ) {
							   if(_features.transform && (_mainScrollAnimating || _initialZoomRunning) ) {
								   _imagesToAppendPool.push({
									   item:item,
									   baseDiv:baseDiv,
									   img:item.img,
									   index:index,
									   holder:holder,
									   clearPlaceholder:true
								   });
							   } else {
								   _appendImage(index, item, baseDiv, item.img, _mainScrollAnimating || _initialZoomRunning, true);
							   }
						   } else {
							   // remove preloader & mini-img
							   if(!_initialZoomRunning && item.placeholder) {
								   item.placeholder.style.display = 'none';
								   item.placeholder = null;
							   }
						   }
					   }
   
					   item.loadComplete = null;
					   item.img = null; // no need to store image element after it's added
   
					   _shout('imageLoadComplete', index, item);
				   };
   
				   if(framework.features.transform) {
					   
					   var placeholderClassName = 'pswp__img pswp__img--placeholder'; 
					   placeholderClassName += (item.msrc ? '' : ' pswp__img--placeholder--blank');
   
					   var placeholder = framework.createEl(placeholderClassName, item.msrc ? 'img' : '');
					   if(item.msrc) {
						   placeholder.src = item.msrc;
					   }
					   
					   _setImageSize(item, placeholder);
   
					   baseDiv.appendChild(placeholder);
					   item.placeholder = placeholder;
   
				   }
				   
   
				   
   
				   if(!item.loading) {
					   _preloadImage(item);
				   }
   
   
				   if( self.allowProgressiveImg() ) {
					   // just append image
					   if(!_initialContentSet && _features.transform) {
						   _imagesToAppendPool.push({
							   item:item, 
							   baseDiv:baseDiv, 
							   img:item.img, 
							   index:index, 
							   holder:holder
						   });
					   } else {
						   _appendImage(index, item, baseDiv, item.img, true, true);
					   }
				   }
				   
			   } else if(item.src && !item.loadError) {
				   // image object is created every time, due to bugs of image loading & delay when switching images
				   img = framework.createEl('pswp__img', 'img');
				   img.style.opacity = 1;
				   img.src = item.src;
				   _setImageSize(item, img);
				   _appendImage(index, item, baseDiv, img, true);
			   }
			   
   
			   if(!_initialContentSet && index === _currentItemIndex) {
				   _currZoomElementStyle = baseDiv.style;
				   _showOrHide(item, (img ||item.img) );
			   } else {
				   _applyZoomPanToItem(item);
			   }
   
			   holder.el.innerHTML = '';
			   holder.el.appendChild(baseDiv);
		   },
   
		   cleanSlide: function( item ) {
			   if(item.img ) {
				   item.img.onload = item.img.onerror = null;
			   }
			   item.loaded = item.loading = item.img = item.imageAppended = false;
		   }
   
	   }
   });
   
   /*>>items-controller*/
   
   /*>>tap*/
   /**
	* tap.js:
	*
	* Displatches tap and double-tap events.
	* 
	*/
   
   var tapTimer,
	   tapReleasePoint = {},
	   _dispatchTapEvent = function(origEvent, releasePoint, pointerType) {		
		   var e = document.createEvent( 'CustomEvent' ),
			   eDetail = {
				   origEvent:origEvent, 
				   target:origEvent.target, 
				   releasePoint: releasePoint, 
				   pointerType:pointerType || 'touch'
			   };
   
		   e.initCustomEvent( 'pswpTap', true, true, eDetail );
		   origEvent.target.dispatchEvent(e);
	   };
   
   _registerModule('Tap', {
	   publicMethods: {
		   initTap: function() {
			   _listen('firstTouchStart', self.onTapStart);
			   _listen('touchRelease', self.onTapRelease);
			   _listen('destroy', function() {
				   tapReleasePoint = {};
				   tapTimer = null;
			   });
		   },
		   onTapStart: function(touchList) {
			   if(touchList.length > 1) {
				   clearTimeout(tapTimer);
				   tapTimer = null;
			   }
		   },
		   onTapRelease: function(e, releasePoint) {
			   if(!releasePoint) {
				   return;
			   }
   
			   if(!_moved && !_isMultitouch && !_numAnimations) {
				   var p0 = releasePoint;
				   if(tapTimer) {
					   clearTimeout(tapTimer);
					   tapTimer = null;
   
					   // Check if taped on the same place
					   if ( _isNearbyPoints(p0, tapReleasePoint) ) {
						   _shout('doubleTap', p0);
						   return;
					   }
				   }
   
				   if(releasePoint.type === 'mouse') {
					   _dispatchTapEvent(e, releasePoint, 'mouse');
					   return;
				   }
   
				   var clickedTagName = e.target.tagName.toUpperCase();
				   // avoid double tap delay on buttons and elements that have class pswp__single-tap
				   if(clickedTagName === 'BUTTON' || framework.hasClass(e.target, 'pswp__single-tap') ) {
					   _dispatchTapEvent(e, releasePoint);
					   return;
				   }
   
				   _equalizePoints(tapReleasePoint, p0);
   
				   tapTimer = setTimeout(function() {
					   _dispatchTapEvent(e, releasePoint);
					   tapTimer = null;
				   }, 300);
			   }
		   }
	   }
   });
   
   /*>>tap*/
   
   /*>>desktop-zoom*/
   /**
	*
	* desktop-zoom.js:
	*
	* - Binds mousewheel event for paning zoomed image.
	* - Manages "dragging", "zoomed-in", "zoom-out" classes.
	*   (which are used for cursors and zoom icon)
	* - Adds toggleDesktopZoom function.
	* 
	*/
   
   var _wheelDelta;
	   
   _registerModule('DesktopZoom', {
   
	   publicMethods: {
   
		   initDesktopZoom: function() {
   
			   if(_oldIE) {
				   // no zoom for old IE (<=8)
				   return;
			   }
   
			   if(_likelyTouchDevice) {
				   // if detected hardware touch support, we wait until mouse is used,
				   // and only then apply desktop-zoom features
				   _listen('mouseUsed', function() {
					   self.setupDesktopZoom();
				   });
			   } else {
				   self.setupDesktopZoom(true);
			   }
   
		   },
   
		   setupDesktopZoom: function(onInit) {
   
			   _wheelDelta = {};
   
			   var events = 'wheel mousewheel DOMMouseScroll';
			   
			   _listen('bindEvents', function() {
				   framework.bind(template, events,  self.handleMouseWheel);
			   });
   
			   _listen('unbindEvents', function() {
				   if(_wheelDelta) {
					   framework.unbind(template, events, self.handleMouseWheel);
				   }
			   });
   
			   self.mouseZoomedIn = false;
   
			   var hasDraggingClass,
				   updateZoomable = function() {
					   if(self.mouseZoomedIn) {
						   framework.removeClass(template, 'pswp--zoomed-in');
						   self.mouseZoomedIn = false;
					   }
					   if(_currZoomLevel < 1) {
						   framework.addClass(template, 'pswp--zoom-allowed');
					   } else {
						   framework.removeClass(template, 'pswp--zoom-allowed');
					   }
					   removeDraggingClass();
				   },
				   removeDraggingClass = function() {
					   if(hasDraggingClass) {
						   framework.removeClass(template, 'pswp--dragging');
						   hasDraggingClass = false;
					   }
				   };
   
			   _listen('resize' , updateZoomable);
			   _listen('afterChange' , updateZoomable);
			   _listen('pointerDown', function() {
				   if(self.mouseZoomedIn) {
					   hasDraggingClass = true;
					   framework.addClass(template, 'pswp--dragging');
				   }
			   });
			   _listen('pointerUp', removeDraggingClass);
   
			   if(!onInit) {
				   updateZoomable();
			   }
			   
		   },
   
		   handleMouseWheel: function(e) {
   
			   if(_currZoomLevel <= self.currItem.fitRatio) {
				   if( _options.modal ) {
   
					   if (!_options.closeOnScroll || _numAnimations || _isDragging) {
						   e.preventDefault();
					   } else if(_transformKey && Math.abs(e.deltaY) > 2) {
						   // close PhotoSwipe
						   // if browser supports transforms & scroll changed enough
						   _closedByScroll = true;
						   self.close();
					   }
   
				   }
				   return true;
			   }
   
			   // allow just one event to fire
			   e.stopPropagation();
   
			   // https://developer.mozilla.org/en-US/docs/Web/Events/wheel
			   _wheelDelta.x = 0;
   
			   if('deltaX' in e) {
				   if(e.deltaMode === 1 /* DOM_DELTA_LINE */) {
					   // 18 - average line height
					   _wheelDelta.x = e.deltaX * 18;
					   _wheelDelta.y = e.deltaY * 18;
				   } else {
					   _wheelDelta.x = e.deltaX;
					   _wheelDelta.y = e.deltaY;
				   }
			   } else if('wheelDelta' in e) {
				   if(e.wheelDeltaX) {
					   _wheelDelta.x = -0.16 * e.wheelDeltaX;
				   }
				   if(e.wheelDeltaY) {
					   _wheelDelta.y = -0.16 * e.wheelDeltaY;
				   } else {
					   _wheelDelta.y = -0.16 * e.wheelDelta;
				   }
			   } else if('detail' in e) {
				   _wheelDelta.y = e.detail;
			   } else {
				   return;
			   }
   
			   _calculatePanBounds(_currZoomLevel, true);
   
			   var newPanX = _panOffset.x - _wheelDelta.x,
				   newPanY = _panOffset.y - _wheelDelta.y;
   
			   // only prevent scrolling in nonmodal mode when not at edges
			   if (_options.modal ||
				   (
				   newPanX <= _currPanBounds.min.x && newPanX >= _currPanBounds.max.x &&
				   newPanY <= _currPanBounds.min.y && newPanY >= _currPanBounds.max.y
				   ) ) {
				   e.preventDefault();
			   }
   
			   // TODO: use rAF instead of mousewheel?
			   self.panTo(newPanX, newPanY);
		   },
   
		   toggleDesktopZoom: function(centerPoint) {
			   centerPoint = centerPoint || {x:_viewportSize.x/2 + _offset.x, y:_viewportSize.y/2 + _offset.y };
   
			   var doubleTapZoomLevel = _options.getDoubleTapZoom(true, self.currItem);
			   var zoomOut = _currZoomLevel === doubleTapZoomLevel;
			   
			   self.mouseZoomedIn = !zoomOut;
   
			   self.zoomTo(zoomOut ? self.currItem.initialZoomLevel : doubleTapZoomLevel, centerPoint, 333);
			   framework[ (!zoomOut ? 'add' : 'remove') + 'Class'](template, 'pswp--zoomed-in');
		   }
   
	   }
   });
   
   
   /*>>desktop-zoom*/
   
   /*>>history*/
   /**
	*
	* history.js:
	*
	* - Back button to close gallery.
	* 
	* - Unique URL for each slide: example.com/&pid=1&gid=3
	*   (where PID is picture index, and GID and gallery index)
	*   
	* - Switch URL when slides change.
	* 
	*/
   
   
   var _historyDefaultOptions = {
	   history: true,
	   galleryUID: 1
   };
   
   var _historyUpdateTimeout,
	   _hashChangeTimeout,
	   _hashAnimCheckTimeout,
	   _hashChangedByScript,
	   _hashChangedByHistory,
	   _hashReseted,
	   _initialHash,
	   _historyChanged,
	   _closedFromURL,
	   _urlChangedOnce,
	   _windowLoc,
   
	   _supportsPushState,
   
	   _getHash = function() {
		   return _windowLoc.hash.substring(1);
	   },
	   _cleanHistoryTimeouts = function() {
   
		   if(_historyUpdateTimeout) {
			   clearTimeout(_historyUpdateTimeout);
		   }
   
		   if(_hashAnimCheckTimeout) {
			   clearTimeout(_hashAnimCheckTimeout);
		   }
	   },
   
	   // pid - Picture index
	   // gid - Gallery index
	   _parseItemIndexFromURL = function() {
		   var hash = _getHash(),
			   params = {};
   
		   if(hash.length < 5) { // pid=1
			   return params;
		   }
   
		   var i, vars = hash.split('&');
		   for (i = 0; i < vars.length; i++) {
			   if(!vars[i]) {
				   continue;
			   }
			   var pair = vars[i].split('=');	
			   if(pair.length < 2) {
				   continue;
			   }
			   params[pair[0]] = pair[1];
		   }
		   if(_options.galleryPIDs) {
			   // detect custom pid in hash and search for it among the items collection
			   var searchfor = params.pid;
			   params.pid = 0; // if custom pid cannot be found, fallback to the first item
			   for(i = 0; i < _items.length; i++) {
				   if(_items[i].pid === searchfor) {
					   params.pid = i;
					   break;
				   }
			   }
		   } else {
			   params.pid = parseInt(params.pid,10)-1;
		   }
		   if( params.pid < 0 ) {
			   params.pid = 0;
		   }
		   return params;
	   },
	   _updateHash = function() {
   
		   if(_hashAnimCheckTimeout) {
			   clearTimeout(_hashAnimCheckTimeout);
		   }
   
   
		   if(_numAnimations || _isDragging) {
			   // changing browser URL forces layout/paint in some browsers, which causes noticable lag during animation
			   // that's why we update hash only when no animations running
			   _hashAnimCheckTimeout = setTimeout(_updateHash, 500);
			   return;
		   }
		   
		   if(_hashChangedByScript) {
			   clearTimeout(_hashChangeTimeout);
		   } else {
			   _hashChangedByScript = true;
		   }
   
   
		   var pid = (_currentItemIndex + 1);
		   var item = _getItemAt( _currentItemIndex );
		   if(item.hasOwnProperty('pid')) {
			   // carry forward any custom pid assigned to the item
			   pid = item.pid;
		   }
		   var newHash = _initialHash + '&'  +  'gid=' + _options.galleryUID + '&' + 'pid=' + pid;
   
		   if(!_historyChanged) {
			   if(_windowLoc.hash.indexOf(newHash) === -1) {
				   _urlChangedOnce = true;
			   }
			   // first time - add new hisory record, then just replace
		   }
   
		   var newURL = _windowLoc.href.split('#')[0] + '#' +  newHash;
   
		   if( _supportsPushState ) {
   
			   if('#' + newHash !== window.location.hash) {
				   history[_historyChanged ? 'replaceState' : 'pushState']('', document.title, newURL);
			   }
   
		   } else {
			   if(_historyChanged) {
				   _windowLoc.replace( newURL );
			   } else {
				   _windowLoc.hash = newHash;
			   }
		   }
		   
		   
   
		   _historyChanged = true;
		   _hashChangeTimeout = setTimeout(function() {
			   _hashChangedByScript = false;
		   }, 60);
	   };
   
   
   
	   
   
   _registerModule('History', {
   
	   
   
	   publicMethods: {
		   initHistory: function() {
   
			   framework.extend(_options, _historyDefaultOptions, true);
   
			   if( !_options.history ) {
				   return;
			   }
   
   
			   _windowLoc = window.location;
			   _urlChangedOnce = false;
			   _closedFromURL = false;
			   _historyChanged = false;
			   _initialHash = _getHash();
			   _supportsPushState = ('pushState' in history);
   
   
			   if(_initialHash.indexOf('gid=') > -1) {
				   _initialHash = _initialHash.split('&gid=')[0];
				   _initialHash = _initialHash.split('?gid=')[0];
			   }
			   
   
			   _listen('afterChange', self.updateURL);
			   _listen('unbindEvents', function() {
				   framework.unbind(window, 'hashchange', self.onHashChange);
			   });
   
   
			   var returnToOriginal = function() {
				   _hashReseted = true;
				   if(!_closedFromURL) {
   
					   if(_urlChangedOnce) {
						   history.back();
					   } else {
   
						   if(_initialHash) {
							   _windowLoc.hash = _initialHash;
						   } else {
							   if (_supportsPushState) {
   
								   // remove hash from url without refreshing it or scrolling to top
								   history.pushState('', document.title,  _windowLoc.pathname + _windowLoc.search );
							   } else {
								   _windowLoc.hash = '';
							   }
						   }
					   }
					   
				   }
   
				   _cleanHistoryTimeouts();
			   };
   
   
			   _listen('unbindEvents', function() {
				   if(_closedByScroll) {
					   // if PhotoSwipe is closed by scroll, we go "back" before the closing animation starts
					   // this is done to keep the scroll position
					   returnToOriginal();
				   }
			   });
			   _listen('destroy', function() {
				   if(!_hashReseted) {
					   returnToOriginal();
				   }
			   });
			   _listen('firstUpdate', function() {
				   _currentItemIndex = _parseItemIndexFromURL().pid;
			   });
   
			   
   
			   
			   var index = _initialHash.indexOf('pid=');
			   if(index > -1) {
				   _initialHash = _initialHash.substring(0, index);
				   if(_initialHash.slice(-1) === '&') {
					   _initialHash = _initialHash.slice(0, -1);
				   }
			   }
			   
   
			   setTimeout(function() {
				   if(_isOpen) { // hasn't destroyed yet
					   framework.bind(window, 'hashchange', self.onHashChange);
				   }
			   }, 40);
			   
		   },
		   onHashChange: function() {
   
			   if(_getHash() === _initialHash) {
   
				   _closedFromURL = true;
				   self.close();
				   return;
			   }
			   if(!_hashChangedByScript) {
   
				   _hashChangedByHistory = true;
				   self.goTo( _parseItemIndexFromURL().pid );
				   _hashChangedByHistory = false;
			   }
			   
		   },
		   updateURL: function() {
   
			   // Delay the update of URL, to avoid lag during transition, 
			   // and to not to trigger actions like "refresh page sound" or "blinking favicon" to often
			   
			   _cleanHistoryTimeouts();
			   
   
			   if(_hashChangedByHistory) {
				   return;
			   }
   
			   if(!_historyChanged) {
				   _updateHash(); // first time
			   } else {
				   _historyUpdateTimeout = setTimeout(_updateHash, 800);
			   }
		   }
	   
	   }
   });
   
   
   /*>>history*/
	   framework.extend(self, publicMethods); };
	   return PhotoSwipe;
   });
   
   /***/ }),
   /* 5 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! PhotoSwipe Default UI - 4.1.2 - 2017-04-05
   * http://photoswipe.com
   * Copyright (c) 2017 Dmitry Semenov; */
   /**
   *
   * UI on top of main sliding area (caption, arrows, close button, etc.).
   * Built just using public methods/properties of PhotoSwipe.
   * 
   */
   (function (root, factory) { 
	   if (true) {
		   !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				   __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				   (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				   __WEBPACK_AMD_DEFINE_FACTORY__),
				   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	   } else {}
   })(this, function () {
   
	   'use strict';
   
   
   
   var PhotoSwipeUI_Default =
	function(pswp, framework) {
   
	   var ui = this;
	   var _overlayUIUpdated = false,
		   _controlsVisible = true,
		   _fullscrenAPI,
		   _controls,
		   _captionContainer,
		   _fakeCaptionContainer,
		   _indexIndicator,
		   _shareButton,
		   _shareModal,
		   _shareModalHidden = true,
		   _initalCloseOnScrollValue,
		   _isIdle,
		   _listen,
   
		   _loadingIndicator,
		   _loadingIndicatorHidden,
		   _loadingIndicatorTimeout,
   
		   _galleryHasOneSlide,
   
		   _options,
		   _defaultUIOptions = {
			   barsSize: {top:44, bottom:'auto'},
			   closeElClasses: ['item', 'caption', 'zoom-wrap', 'ui', 'top-bar'], 
			   timeToIdle: 4000, 
			   timeToIdleOutside: 1000,
			   loadingIndicatorDelay: 1000, // 2s
			   
			   addCaptionHTMLFn: function(item, captionEl /*, isFake */) {
				   if(!item.title) {
					   captionEl.children[0].innerHTML = '';
					   return false;
				   }
				   captionEl.children[0].innerHTML = item.title;
				   return true;
			   },
   
			   closeEl:true,
			   captionEl: true,
			   fullscreenEl: true,
			   zoomEl: true,
			   shareEl: true,
			   counterEl: true,
			   arrowEl: true,
			   preloaderEl: true,
   
			   tapToClose: false,
			   tapToToggleControls: true,
   
			   clickToCloseNonZoomable: true,
   
			   shareButtons: [
				   {id:'facebook', label:'Share on Facebook', url:'https://www.facebook.com/sharer/sharer.php?u='},
				   {id:'twitter', label:'Tweet', url:'https://twitter.com/intent/tweet?text=&url='},
				   {id:'pinterest', label:'Pin it', url:'http://www.pinterest.com/pin/create/button/'+
													   '?url=&media=&description='},
				   {id:'download', label:'Download image', url:'', download:true}
			   ],
			   getImageURLForShare: function( /* shareButtonData */ ) {
				   return pswp.currItem.src || '';
			   },
			   getPageURLForShare: function( /* shareButtonData */ ) {
				   return window.location.href;
			   },
			   getTextForShare: function( /* shareButtonData */ ) {
				   return pswp.currItem.title || '';
			   },
				   
			   indexIndicatorSep: ' / ',
			   fitControlsWidth: 1200
   
		   },
		   _blockControlsTap,
		   _blockControlsTapTimeout;
   
   
   
	   var _onControlsTap = function(e) {
			   if(_blockControlsTap) {
				   return true;
			   }
   
   
			   e = e || window.event;
   
			   if(_options.timeToIdle && _options.mouseUsed && !_isIdle) {
				   // reset idle timer
				   _onIdleMouseMove();
			   }
   
   
			   var target = e.target || e.srcElement,
				   uiElement,
				   clickedClass = target.getAttribute('class') || '',
				   found;
   
			   for(var i = 0; i < _uiElements.length; i++) {
				   uiElement = _uiElements[i];
				   if(uiElement.onTap && clickedClass.indexOf('pswp__' + uiElement.name ) > -1 ) {
					   uiElement.onTap();
					   found = true;
   
				   }
			   }
   
			   if(found) {
				   if(e.stopPropagation) {
					   e.stopPropagation();
				   }
				   _blockControlsTap = true;
   
				   // Some versions of Android don't prevent ghost click event 
				   // when preventDefault() was called on touchstart and/or touchend.
				   // 
				   // This happens on v4.3, 4.2, 4.1, 
				   // older versions strangely work correctly, 
				   // but just in case we add delay on all of them)	
				   var tapDelay = framework.features.isOldAndroid ? 600 : 30;
				   _blockControlsTapTimeout = setTimeout(function() {
					   _blockControlsTap = false;
				   }, tapDelay);
			   }
   
		   },
		   _fitControlsInViewport = function() {
			   return !pswp.likelyTouchDevice || _options.mouseUsed || screen.width > _options.fitControlsWidth;
		   },
		   _togglePswpClass = function(el, cName, add) {
			   framework[ (add ? 'add' : 'remove') + 'Class' ](el, 'pswp__' + cName);
		   },
   
		   // add class when there is just one item in the gallery
		   // (by default it hides left/right arrows and 1ofX counter)
		   _countNumItems = function() {
			   var hasOneSlide = (_options.getNumItemsFn() === 1);
   
			   if(hasOneSlide !== _galleryHasOneSlide) {
				   _togglePswpClass(_controls, 'ui--one-slide', hasOneSlide);
				   _galleryHasOneSlide = hasOneSlide;
			   }
		   },
		   _toggleShareModalClass = function() {
			   _togglePswpClass(_shareModal, 'share-modal--hidden', _shareModalHidden);
		   },
		   _toggleShareModal = function() {
   
			   _shareModalHidden = !_shareModalHidden;
			   
			   
			   if(!_shareModalHidden) {
				   _toggleShareModalClass();
				   setTimeout(function() {
					   if(!_shareModalHidden) {
						   framework.addClass(_shareModal, 'pswp__share-modal--fade-in');
					   }
				   }, 30);
			   } else {
				   framework.removeClass(_shareModal, 'pswp__share-modal--fade-in');
				   setTimeout(function() {
					   if(_shareModalHidden) {
						   _toggleShareModalClass();
					   }
				   }, 300);
			   }
			   
			   if(!_shareModalHidden) {
				   _updateShareURLs();
			   }
			   return false;
		   },
   
		   _openWindowPopup = function(e) {
			   e = e || window.event;
			   var target = e.target || e.srcElement;
   
			   pswp.shout('shareLinkClick', e, target);
   
			   if(!target.href) {
				   return false;
			   }
   
			   if( target.hasAttribute('download') ) {
				   return true;
			   }
   
			   window.open(target.href, 'pswp_share', 'scrollbars=yes,resizable=yes,toolbar=no,'+
										   'location=yes,width=550,height=420,top=100,left=' + 
										   (window.screen ? Math.round(screen.width / 2 - 275) : 100)  );
   
			   if(!_shareModalHidden) {
				   _toggleShareModal();
			   }
			   
			   return false;
		   },
		   _updateShareURLs = function() {
			   var shareButtonOut = '',
				   shareButtonData,
				   shareURL,
				   image_url,
				   page_url,
				   share_text;
   
			   for(var i = 0; i < _options.shareButtons.length; i++) {
				   shareButtonData = _options.shareButtons[i];
   
				   image_url = _options.getImageURLForShare(shareButtonData);
				   page_url = _options.getPageURLForShare(shareButtonData);
				   share_text = _options.getTextForShare(shareButtonData);
   
				   shareURL = shareButtonData.url.replace('', encodeURIComponent(page_url) )
									   .replace('', encodeURIComponent(image_url) )
									   .replace('', image_url )
									   .replace('', encodeURIComponent(share_text) );
   
				   shareButtonOut += '<a href="' + shareURL + '" target="_blank" '+
									   'class="pswp__share--' + shareButtonData.id + '"' +
									   (shareButtonData.download ? 'download' : '') + '>' + 
									   shareButtonData.label + '</a>';
   
				   if(_options.parseShareButtonOut) {
					   shareButtonOut = _options.parseShareButtonOut(shareButtonData, shareButtonOut);
				   }
			   }
			   _shareModal.children[0].innerHTML = shareButtonOut;
			   _shareModal.children[0].onclick = _openWindowPopup;
   
		   },
		   _hasCloseClass = function(target) {
			   for(var  i = 0; i < _options.closeElClasses.length; i++) {
				   if( framework.hasClass(target, 'pswp__' + _options.closeElClasses[i]) ) {
					   return true;
				   }
			   }
		   },
		   _idleInterval,
		   _idleTimer,
		   _idleIncrement = 0,
		   _onIdleMouseMove = function() {
			   clearTimeout(_idleTimer);
			   _idleIncrement = 0;
			   if(_isIdle) {
				   ui.setIdle(false);
			   }
		   },
		   _onMouseLeaveWindow = function(e) {
			   e = e ? e : window.event;
			   var from = e.relatedTarget || e.toElement;
			   if (!from || from.nodeName === 'HTML') {
				   clearTimeout(_idleTimer);
				   _idleTimer = setTimeout(function() {
					   ui.setIdle(true);
				   }, _options.timeToIdleOutside);
			   }
		   },
		   _setupFullscreenAPI = function() {
			   if(_options.fullscreenEl && !framework.features.isOldAndroid) {
				   if(!_fullscrenAPI) {
					   _fullscrenAPI = ui.getFullscreenAPI();
				   }
				   if(_fullscrenAPI) {
					   framework.bind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
					   ui.updateFullscreen();
					   framework.addClass(pswp.template, 'pswp--supports-fs');
				   } else {
					   framework.removeClass(pswp.template, 'pswp--supports-fs');
				   }
			   }
		   },
		   _setupLoadingIndicator = function() {
			   // Setup loading indicator
			   if(_options.preloaderEl) {
			   
				   _toggleLoadingIndicator(true);
   
				   _listen('beforeChange', function() {
   
					   clearTimeout(_loadingIndicatorTimeout);
   
					   // display loading indicator with delay
					   _loadingIndicatorTimeout = setTimeout(function() {
   
						   if(pswp.currItem && pswp.currItem.loading) {
   
							   if( !pswp.allowProgressiveImg() || (pswp.currItem.img && !pswp.currItem.img.naturalWidth)  ) {
								   // show preloader if progressive loading is not enabled, 
								   // or image width is not defined yet (because of slow connection)
								   _toggleLoadingIndicator(false); 
								   // items-controller.js function allowProgressiveImg
							   }
							   
						   } else {
							   _toggleLoadingIndicator(true); // hide preloader
						   }
   
					   }, _options.loadingIndicatorDelay);
					   
				   });
				   _listen('imageLoadComplete', function(index, item) {
					   if(pswp.currItem === item) {
						   _toggleLoadingIndicator(true);
					   }
				   });
   
			   }
		   },
		   _toggleLoadingIndicator = function(hide) {
			   if( _loadingIndicatorHidden !== hide ) {
				   _togglePswpClass(_loadingIndicator, 'preloader--active', !hide);
				   _loadingIndicatorHidden = hide;
			   }
		   },
		   _applyNavBarGaps = function(item) {
			   var gap = item.vGap;
   
			   if( _fitControlsInViewport() ) {
				   
				   var bars = _options.barsSize; 
				   if(_options.captionEl && bars.bottom === 'auto') {
					   if(!_fakeCaptionContainer) {
						   _fakeCaptionContainer = framework.createEl('pswp__caption pswp__caption--fake');
						   _fakeCaptionContainer.appendChild( framework.createEl('pswp__caption__center') );
						   _controls.insertBefore(_fakeCaptionContainer, _captionContainer);
						   framework.addClass(_controls, 'pswp__ui--fit');
					   }
					   if( _options.addCaptionHTMLFn(item, _fakeCaptionContainer, true) ) {
   
						   var captionSize = _fakeCaptionContainer.clientHeight;
						   gap.bottom = parseInt(captionSize,10) || 44;
					   } else {
						   gap.bottom = bars.top; // if no caption, set size of bottom gap to size of top
					   }
				   } else {
					   gap.bottom = bars.bottom === 'auto' ? 0 : bars.bottom;
				   }
				   
				   // height of top bar is static, no need to calculate it
				   gap.top = bars.top;
			   } else {
				   gap.top = gap.bottom = 0;
			   }
		   },
		   _setupIdle = function() {
			   // Hide controls when mouse is used
			   if(_options.timeToIdle) {
				   _listen('mouseUsed', function() {
					   
					   framework.bind(document, 'mousemove', _onIdleMouseMove);
					   framework.bind(document, 'mouseout', _onMouseLeaveWindow);
   
					   _idleInterval = setInterval(function() {
						   _idleIncrement++;
						   if(_idleIncrement === 2) {
							   ui.setIdle(true);
						   }
					   }, _options.timeToIdle / 2);
				   });
			   }
		   },
		   _setupHidingControlsDuringGestures = function() {
   
			   // Hide controls on vertical drag
			   _listen('onVerticalDrag', function(now) {
				   if(_controlsVisible && now < 0.95) {
					   ui.hideControls();
				   } else if(!_controlsVisible && now >= 0.95) {
					   ui.showControls();
				   }
			   });
   
			   // Hide controls when pinching to close
			   var pinchControlsHidden;
			   _listen('onPinchClose' , function(now) {
				   if(_controlsVisible && now < 0.9) {
					   ui.hideControls();
					   pinchControlsHidden = true;
				   } else if(pinchControlsHidden && !_controlsVisible && now > 0.9) {
					   ui.showControls();
				   }
			   });
   
			   _listen('zoomGestureEnded', function() {
				   pinchControlsHidden = false;
				   if(pinchControlsHidden && !_controlsVisible) {
					   ui.showControls();
				   }
			   });
   
		   };
   
   
   
	   var _uiElements = [
		   { 
			   name: 'caption', 
			   option: 'captionEl',
			   onInit: function(el) {  
				   _captionContainer = el; 
			   } 
		   },
		   { 
			   name: 'share-modal', 
			   option: 'shareEl',
			   onInit: function(el) {  
				   _shareModal = el;
			   },
			   onTap: function() {
				   _toggleShareModal();
			   } 
		   },
		   { 
			   name: 'button--share', 
			   option: 'shareEl',
			   onInit: function(el) { 
				   _shareButton = el;
			   },
			   onTap: function() {
				   _toggleShareModal();
			   } 
		   },
		   { 
			   name: 'button--zoom', 
			   option: 'zoomEl',
			   onTap: pswp.toggleDesktopZoom
		   },
		   { 
			   name: 'counter', 
			   option: 'counterEl',
			   onInit: function(el) {  
				   _indexIndicator = el;
			   } 
		   },
		   { 
			   name: 'button--close', 
			   option: 'closeEl',
			   onTap: pswp.close
		   },
		   { 
			   name: 'button--arrow--left', 
			   option: 'arrowEl',
			   onTap: pswp.prev
		   },
		   { 
			   name: 'button--arrow--right', 
			   option: 'arrowEl',
			   onTap: pswp.next
		   },
		   { 
			   name: 'button--fs', 
			   option: 'fullscreenEl',
			   onTap: function() {  
				   if(_fullscrenAPI.isFullscreen()) {
					   _fullscrenAPI.exit();
				   } else {
					   _fullscrenAPI.enter();
				   }
			   } 
		   },
		   { 
			   name: 'preloader', 
			   option: 'preloaderEl',
			   onInit: function(el) {  
				   _loadingIndicator = el;
			   } 
		   }
   
	   ];
   
	   var _setupUIElements = function() {
		   var item,
			   classAttr,
			   uiElement;
   
		   var loopThroughChildElements = function(sChildren) {
			   if(!sChildren) {
				   return;
			   }
   
			   var l = sChildren.length;
			   for(var i = 0; i < l; i++) {
				   item = sChildren[i];
				   classAttr = item.className;
   
				   for(var a = 0; a < _uiElements.length; a++) {
					   uiElement = _uiElements[a];
   
					   if(classAttr.indexOf('pswp__' + uiElement.name) > -1  ) {
   
						   if( _options[uiElement.option] ) { // if element is not disabled from options
							   
							   framework.removeClass(item, 'pswp__element--disabled');
							   if(uiElement.onInit) {
								   uiElement.onInit(item);
							   }
							   
							   //item.style.display = 'block';
						   } else {
							   framework.addClass(item, 'pswp__element--disabled');
							   //item.style.display = 'none';
						   }
					   }
				   }
			   }
		   };
		   loopThroughChildElements(_controls.children);
   
		   var topBar =  framework.getChildByClass(_controls, 'pswp__top-bar');
		   if(topBar) {
			   loopThroughChildElements( topBar.children );
		   }
	   };
   
   
	   
   
	   ui.init = function() {
   
		   // extend options
		   framework.extend(pswp.options, _defaultUIOptions, true);
   
		   // create local link for fast access
		   _options = pswp.options;
   
		   // find pswp__ui element
		   _controls = framework.getChildByClass(pswp.scrollWrap, 'pswp__ui');
   
		   // create local link
		   _listen = pswp.listen;
   
   
		   _setupHidingControlsDuringGestures();
   
		   // update controls when slides change
		   _listen('beforeChange', ui.update);
   
		   // toggle zoom on double-tap
		   _listen('doubleTap', function(point) {
			   var initialZoomLevel = pswp.currItem.initialZoomLevel;
			   if(pswp.getZoomLevel() !== initialZoomLevel) {
				   pswp.zoomTo(initialZoomLevel, point, 333);
			   } else {
				   pswp.zoomTo(_options.getDoubleTapZoom(false, pswp.currItem), point, 333);
			   }
		   });
   
		   // Allow text selection in caption
		   _listen('preventDragEvent', function(e, isDown, preventObj) {
			   var t = e.target || e.srcElement;
			   if(
				   t && 
				   t.getAttribute('class') && e.type.indexOf('mouse') > -1 && 
				   ( t.getAttribute('class').indexOf('__caption') > 0 || (/(SMALL|STRONG|EM)/i).test(t.tagName) ) 
			   ) {
				   preventObj.prevent = false;
			   }
		   });
   
		   // bind events for UI
		   _listen('bindEvents', function() {
			   framework.bind(_controls, 'pswpTap click', _onControlsTap);
			   framework.bind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
   
			   if(!pswp.likelyTouchDevice) {
				   framework.bind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
			   }
		   });
   
		   // unbind events for UI
		   _listen('unbindEvents', function() {
			   if(!_shareModalHidden) {
				   _toggleShareModal();
			   }
   
			   if(_idleInterval) {
				   clearInterval(_idleInterval);
			   }
			   framework.unbind(document, 'mouseout', _onMouseLeaveWindow);
			   framework.unbind(document, 'mousemove', _onIdleMouseMove);
			   framework.unbind(_controls, 'pswpTap click', _onControlsTap);
			   framework.unbind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
			   framework.unbind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
   
			   if(_fullscrenAPI) {
				   framework.unbind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
				   if(_fullscrenAPI.isFullscreen()) {
					   _options.hideAnimationDuration = 0;
					   _fullscrenAPI.exit();
				   }
				   _fullscrenAPI = null;
			   }
		   });
   
   
		   // clean up things when gallery is destroyed
		   _listen('destroy', function() {
			   if(_options.captionEl) {
				   if(_fakeCaptionContainer) {
					   _controls.removeChild(_fakeCaptionContainer);
				   }
				   framework.removeClass(_captionContainer, 'pswp__caption--empty');
			   }
   
			   if(_shareModal) {
				   _shareModal.children[0].onclick = null;
			   }
			   framework.removeClass(_controls, 'pswp__ui--over-close');
			   framework.addClass( _controls, 'pswp__ui--hidden');
			   ui.setIdle(false);
		   });
		   
   
		   if(!_options.showAnimationDuration) {
			   framework.removeClass( _controls, 'pswp__ui--hidden');
		   }
		   _listen('initialZoomIn', function() {
			   if(_options.showAnimationDuration) {
				   framework.removeClass( _controls, 'pswp__ui--hidden');
			   }
		   });
		   _listen('initialZoomOut', function() {
			   framework.addClass( _controls, 'pswp__ui--hidden');
		   });
   
		   _listen('parseVerticalMargin', _applyNavBarGaps);
		   
		   _setupUIElements();
   
		   if(_options.shareEl && _shareButton && _shareModal) {
			   _shareModalHidden = true;
		   }
   
		   _countNumItems();
   
		   _setupIdle();
   
		   _setupFullscreenAPI();
   
		   _setupLoadingIndicator();
	   };
   
	   ui.setIdle = function(isIdle) {
		   _isIdle = isIdle;
		   _togglePswpClass(_controls, 'ui--idle', isIdle);
	   };
   
	   ui.update = function() {
		   // Don't update UI if it's hidden
		   if(_controlsVisible && pswp.currItem) {
			   
			   ui.updateIndexIndicator();
   
			   if(_options.captionEl) {
				   _options.addCaptionHTMLFn(pswp.currItem, _captionContainer);
   
				   _togglePswpClass(_captionContainer, 'caption--empty', !pswp.currItem.title);
			   }
   
			   _overlayUIUpdated = true;
   
		   } else {
			   _overlayUIUpdated = false;
		   }
   
		   if(!_shareModalHidden) {
			   _toggleShareModal();
		   }
   
		   _countNumItems();
	   };
   
	   ui.updateFullscreen = function(e) {
   
		   if(e) {
			   // some browsers change window scroll position during the fullscreen
			   // so PhotoSwipe updates it just in case
			   setTimeout(function() {
				   pswp.setScrollOffset( 0, framework.getScrollY() );
			   }, 50);
		   }
		   
		   // toogle pswp--fs class on root element
		   framework[ (_fullscrenAPI.isFullscreen() ? 'add' : 'remove') + 'Class' ](pswp.template, 'pswp--fs');
	   };
   
	   ui.updateIndexIndicator = function() {
		   if(_options.counterEl) {
			   _indexIndicator.innerHTML = (pswp.getCurrentIndex()+1) + 
										   _options.indexIndicatorSep + 
										   _options.getNumItemsFn();
		   }
	   };
	   
	   ui.onGlobalTap = function(e) {
		   e = e || window.event;
		   var target = e.target || e.srcElement;
   
		   if(_blockControlsTap) {
			   return;
		   }
   
		   if(e.detail && e.detail.pointerType === 'mouse') {
   
			   // close gallery if clicked outside of the image
			   if(_hasCloseClass(target)) {
				   pswp.close();
				   return;
			   }
   
			   if(framework.hasClass(target, 'pswp__img')) {
				   if(pswp.getZoomLevel() === 1 && pswp.getZoomLevel() <= pswp.currItem.fitRatio) {
					   if(_options.clickToCloseNonZoomable) {
						   pswp.close();
					   }
				   } else {
					   pswp.toggleDesktopZoom(e.detail.releasePoint);
				   }
			   }
			   
		   } else {
   
			   // tap anywhere (except buttons) to toggle visibility of controls
			   if(_options.tapToToggleControls) {
				   if(_controlsVisible) {
					   ui.hideControls();
				   } else {
					   ui.showControls();
				   }
			   }
   
			   // tap to close gallery
			   if(_options.tapToClose && (framework.hasClass(target, 'pswp__img') || _hasCloseClass(target)) ) {
				   pswp.close();
				   return;
			   }
			   
		   }
	   };
	   ui.onMouseOver = function(e) {
		   e = e || window.event;
		   var target = e.target || e.srcElement;
   
		   // add class when mouse is over an element that should close the gallery
		   _togglePswpClass(_controls, 'ui--over-close', _hasCloseClass(target));
	   };
   
	   ui.hideControls = function() {
		   framework.addClass(_controls,'pswp__ui--hidden');
		   _controlsVisible = false;
	   };
   
	   ui.showControls = function() {
		   _controlsVisible = true;
		   if(!_overlayUIUpdated) {
			   ui.update();
		   }
		   framework.removeClass(_controls,'pswp__ui--hidden');
	   };
   
	   ui.supportsFullscreen = function() {
		   var d = document;
		   return !!(d.exitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen || d.msExitFullscreen);
	   };
   
	   ui.getFullscreenAPI = function() {
		   var dE = document.documentElement,
			   api,
			   tF = 'fullscreenchange';
   
		   if (dE.requestFullscreen) {
			   api = {
				   enterK: 'requestFullscreen',
				   exitK: 'exitFullscreen',
				   elementK: 'fullscreenElement',
				   eventK: tF
			   };
   
		   } else if(dE.mozRequestFullScreen ) {
			   api = {
				   enterK: 'mozRequestFullScreen',
				   exitK: 'mozCancelFullScreen',
				   elementK: 'mozFullScreenElement',
				   eventK: 'moz' + tF
			   };
   
			   
   
		   } else if(dE.webkitRequestFullscreen) {
			   api = {
				   enterK: 'webkitRequestFullscreen',
				   exitK: 'webkitExitFullscreen',
				   elementK: 'webkitFullscreenElement',
				   eventK: 'webkit' + tF
			   };
   
		   } else if(dE.msRequestFullscreen) {
			   api = {
				   enterK: 'msRequestFullscreen',
				   exitK: 'msExitFullscreen',
				   elementK: 'msFullscreenElement',
				   eventK: 'MSFullscreenChange'
			   };
		   }
   
		   if(api) {
			   api.enter = function() { 
				   // disable close-on-scroll in fullscreen
				   _initalCloseOnScrollValue = _options.closeOnScroll; 
				   _options.closeOnScroll = false; 
   
				   if(this.enterK === 'webkitRequestFullscreen') {
					   pswp.template[this.enterK]( Element.ALLOW_KEYBOARD_INPUT );
				   } else {
					   return pswp.template[this.enterK](); 
				   }
			   };
			   api.exit = function() { 
				   _options.closeOnScroll = _initalCloseOnScrollValue;
   
				   return document[this.exitK](); 
   
			   };
			   api.isFullscreen = function() { return document[this.elementK]; };
		   }
   
		   return api;
	   };
   
   
   
   };
   return PhotoSwipeUI_Default;
   
   
   });
   
   
   /***/ }),
   /* 6 */
   /***/ (function(module, exports, __webpack_require__) {
   
   var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*********************************************************************
   *  #### Twitter Post Fetcher v17.0.3 ####
   *  Coded by Jason Mayes 2015. A present to all the developers out there.
   *  www.jasonmayes.com
   *  Please keep this disclaimer with my code if you use it. Thanks. :-)
   *  Got feedback or questions, ask here:
   *  http://www.jasonmayes.com/projects/twitterApi/
   *  Github: https://github.com/jasonmayes/Twitter-Post-Fetcher
   *  Updates will be posted to this site.
   *********************************************************************/
   !function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				   __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				   (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				   __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):undefined}(0,function(){var e="",t=20,a=!0,i=[],n=!1,s=!0,l=!0,r=null,o=!0,c=!0,d=null,m=!0,u=!1,p=!1,g=!0,h="en",w=!0,f=!1,v=null;function b(e){return e.replace(/<b[^>]*>(.*?)<\/b>/gi,function(e,t){return t}).replace(/class="(?!(tco-hidden|tco-display|tco-ellipsis))+.*?"|data-query-source=".*?"|dir=".*?"|rel=".*?"/gi,"")}function _(e){for(var t=e.getElementsByTagName("a"),a=t.length-1;a>=0;a--)t[a].setAttribute("target","_blank")}function y(e,t){for(var a=[],i=new RegExp("(^| )"+t+"( |$)"),n=e.getElementsByTagName("*"),s=0,l=n.length;s<l;s++)i.test(n[s].className)&&a.push(n[s]);return a}function T(e){if(void 0!==e&&e.innerHTML.indexOf("data-image")>=0){var t=e.innerHTML.split('data-image="')[1].split('"')[0];return decodeURIComponent(t)+".jpg"}}var k={fetch:function(o){if(void 0===o.maxTweets&&(o.maxTweets=20),void 0===o.enableLinks&&(o.enableLinks=!0),void 0===o.showUser&&(o.showUser=!0),void 0===o.showTime&&(o.showTime=!0),void 0===o.dateFunction&&(o.dateFunction="default"),void 0===o.showRetweet&&(o.showRetweet=!0),void 0===o.customCallback&&(o.customCallback=null),void 0===o.showInteraction&&(o.showInteraction=!0),void 0===o.showImages&&(o.showImages=!1),void 0===o.useEmoji&&(o.useEmoji=!1),void 0===o.linksInNewWindow&&(o.linksInNewWindow=!0),void 0===o.showPermalinks&&(o.showPermalinks=!0),void 0===o.dataOnly&&(o.dataOnly=!1),n)i.push(o);else{n=!0,e=o.domId,t=o.maxTweets,a=o.enableLinks,l=o.showUser,s=o.showTime,c=o.showRetweet,r=o.dateFunction,d=o.customCallback,m=o.showInteraction,u=o.showImages,p=o.useEmoji,g=o.linksInNewWindow,w=o.showPermalinks,f=o.dataOnly;var b=document.getElementsByTagName("head")[0];null!==v&&b.removeChild(v),(v=document.createElement("script")).type="text/javascript",void 0!==o.list?v.src="https://syndication.twitter.com/timeline/list?callback=__twttrf.callback&dnt=false&list_slug="+o.list.listSlug+"&screen_name="+o.list.screenName+"&suppress_response_codes=true&lang="+(o.lang||h)+"&rnd="+Math.random():void 0!==o.profile?v.src="https://syndication.twitter.com/timeline/profile?callback=__twttrf.callback&dnt=false&screen_name="+o.profile.screenName+"&suppress_response_codes=true&lang="+(o.lang||h)+"&rnd="+Math.random():void 0!==o.likes?v.src="https://syndication.twitter.com/timeline/likes?callback=__twttrf.callback&dnt=false&screen_name="+o.likes.screenName+"&suppress_response_codes=true&lang="+(o.lang||h)+"&rnd="+Math.random():v.src="https://cdn.syndication.twimg.com/widgets/timelines/"+o.id+"?&lang="+(o.lang||h)+"&callback=__twttrf.callback&suppress_response_codes=true&rnd="+Math.random(),b.appendChild(v)}},callback:function(h){if(void 0===h||void 0===h.body)return n=!1,void(i.length>0&&(k.fetch(i[0]),i.splice(0,1)));p||(h.body=h.body.replace(/(<img[^c]*class="Emoji[^>]*>)|(<img[^c]*class="u-block[^>]*>)/g,"")),u||(h.body=h.body.replace(/(<img[^c]*class="NaturalImage-image[^>]*>|(<img[^c]*class="CroppedImage-image[^>]*>))/g,"")),l||(h.body=h.body.replace(/(<img[^c]*class="Avatar"[^>]*>)/g,""));var v=document.createElement("div");function C(e){var t=e.getElementsByTagName("img")[0];return t&&t.length&&(t.src=t.getAttribute("data-src-2x")),e}v.innerHTML=h.body,void 0===v.getElementsByClassName&&(o=!1);var x=[],E=[],N=[],A=[],I=[],B=[],L=[],M=0;if(o)for(var H=v.getElementsByClassName("timeline-Tweet");M<H.length;)H[M].getElementsByClassName("timeline-Tweet-retweetCredit").length>0?I.push(!0):I.push(!1),(!I[M]||I[M]&&c)&&(x.push(H[M].getElementsByClassName("timeline-Tweet-text")[0]),B.push(H[M].getAttribute("data-tweet-id")),l&&E.push(C(H[M].getElementsByClassName("timeline-Tweet-author")[0])),N.push(H[M].getElementsByClassName("dt-updated")[0]),L.push(H[M].getElementsByClassName("timeline-Tweet-timestamp")[0]),void 0!==H[M].getElementsByClassName("timeline-Tweet-media")[0]?A.push(H[M].getElementsByClassName("timeline-Tweet-media")[0]):A.push(void 0)),M++;else for(H=y(v,"timeline-Tweet");M<H.length;)y(H[M],"timeline-Tweet-retweetCredit").length>0?I.push(!0):I.push(!1),(!I[M]||I[M]&&c)&&(x.push(y(H[M],"timeline-Tweet-text")[0]),B.push(H[M].getAttribute("data-tweet-id")),l&&E.push(C(y(H[M],"timeline-Tweet-author")[0])),N.push(y(H[M],"dt-updated")[0]),L.push(y(H[M],"timeline-Tweet-timestamp")[0]),void 0!==y(H[M],"timeline-Tweet-media")[0]?A.push(y(H[M],"timeline-Tweet-media")[0]):A.push(void 0)),M++;x.length>t&&(x.splice(t,x.length-t),E.splice(t,E.length-t),N.splice(t,N.length-t),I.splice(t,I.length-t),A.splice(t,A.length-t),L.splice(t,L.length-t));var R=[],j=(M=x.length,0);if(f)for(;j<M;)R.push({tweet:x[j].innerHTML,author:E[j]?E[j].innerHTML:"Unknown Author",author_data:{profile_url:E[j]?E[j].querySelector('[data-scribe="element:user_link"]').href:null,profile_image:E[j]?E[j].querySelector('[data-scribe="element:avatar"]').getAttribute("data-src-1x"):null,profile_image_2x:E[j]?E[j].querySelector('[data-scribe="element:avatar"]').getAttribute("data-src-2x"):null,screen_name:E[j]?E[j].querySelector('[data-scribe="element:screen_name"]').title:null,name:E[j]?E[j].querySelector('[data-scribe="element:name"]').title:null},time:N[j].textContent,timestamp:N[j].getAttribute("datetime").replace("+0000","Z").replace(/([\+\-])(\d\d)(\d\d)/,"$1$2:$3"),image:T(A[j]),rt:I[j],tid:B[j],permalinkURL:void 0===L[j]?"":L[j].href}),j++;else for(;j<M;){if("string"!=typeof r){var q=N[j].getAttribute("datetime"),P=new Date(N[j].getAttribute("datetime").replace(/-/g,"/").replace("T"," ").split("+")[0]),S=r(P,q);if(N[j].setAttribute("aria-label",S),x[j].textContent)if(o)N[j].textContent=S;else{var U=document.createElement("p"),F=document.createTextNode(S);U.appendChild(F),U.setAttribute("aria-label",S),N[j]=U}else N[j].textContent=S}var O="";a?(g&&(_(x[j]),l&&_(E[j])),l&&(O+='<div class="user">'+b(E[j].innerHTML)+"</div>"),O+='<p class="tweet">'+b(x[j].innerHTML)+"</p>",s&&(O+=w?'<p class="timePosted"><a href="'+L[j]+'">'+N[j].getAttribute("aria-label")+"</a></p>":'<p class="timePosted">'+N[j].getAttribute("aria-label")+"</p>")):(x[j].textContent,l&&(O+='<p class="user">'+E[j].textContent+"</p>"),O+='<p class="tweet">'+x[j].textContent+"</p>",s&&(O+='<p class="timePosted">'+N[j].textContent+"</p>")),m&&(O+='<p class="interact"><a href="https://twitter.com/intent/tweet?in_reply_to='+B[j]+'" class="twitter_reply_icon"'+(g?' target="_blank">':">")+'Reply</a><a href="https://twitter.com/intent/retweet?tweet_id='+B[j]+'" class="twitter_retweet_icon"'+(g?' target="_blank">':">")+'Retweet</a><a href="https://twitter.com/intent/favorite?tweet_id='+B[j]+'" class="twitter_fav_icon"'+(g?' target="_blank">':">")+"Favorite</a></p>"),u&&void 0!==A[j]&&void 0!==T(A[j])&&(O+='<div class="media"><img src="'+T(A[j])+'" alt="Image from tweet" /></div>'),u?R.push(O):!u&&x[j].textContent.length&&R.push(O),j++}!function(t){if(null===d){for(var a=t.length,i=0,n=document.getElementById(e),s="<ul>";i<a;)s+="<li>"+t[i]+"</li>",i++;s+="</ul>",n.innerHTML=s}else d(t)}(R),n=!1,i.length>0&&(k.fetch(i[0]),i.splice(0,1))}};return window.__twttrf=k,window.twitterFetcher=k,k});
   
   
   /***/ }),
   /* 7 */
   /***/ (function(module, exports) {
   
   module.exports = debounce
   
   function debounce (fn, delay, at_start, guarantee) {
	 var timeout
	 var args
	 var self
   
	 return function debounced () {
	   self = this
	   args = Array.prototype.slice.call(arguments)
   
	   if (timeout && (at_start || guarantee)) {
		 return
	   } else if (!at_start) {
		 clear()
   
		 timeout = setTimeout(run, delay)
		 return timeout
	   }
   
	   timeout = setTimeout(clear, delay)
	   fn.apply(self, args)
   
	   function run () {
		 clear()
		 fn.apply(self, args)
	   }
   
	   function clear () {
		 clearTimeout(timeout)
		 timeout = null
	   }
	 }
   }
   
   
   /***/ }),
   /* 8 */
   /***/ (function(module, exports) {
   
   /**
	* Copyright 2016 Google Inc. All Rights Reserved.
	*
	* Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
	*
	*  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
	*
	*/
   
   (function(window, document) {
   'use strict';
   
   
   // Exits early if all IntersectionObserver and IntersectionObserverEntry
   // features are natively supported.
   if ('IntersectionObserver' in window &&
	   'IntersectionObserverEntry' in window &&
	   'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
   
	 // Minimal polyfill for Edge 15's lack of `isIntersecting`
	 // See: https://github.com/w3c/IntersectionObserver/issues/211
	 if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
	   Object.defineProperty(window.IntersectionObserverEntry.prototype,
		 'isIntersecting', {
		 get: function () {
		   return this.intersectionRatio > 0;
		 }
	   });
	 }
	 return;
   }
   
   
   /**
	* An IntersectionObserver registry. This registry exists to hold a strong
	* reference to IntersectionObserver instances currently observering a target
	* element. Without this registry, instances without another reference may be
	* garbage collected.
	*/
   var registry = [];
   
   
   /**
	* Creates the global IntersectionObserverEntry constructor.
	* https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
	* @param {Object} entry A dictionary of instance properties.
	* @constructor
	*/
   function IntersectionObserverEntry(entry) {
	 this.time = entry.time;
	 this.target = entry.target;
	 this.rootBounds = entry.rootBounds;
	 this.boundingClientRect = entry.boundingClientRect;
	 this.intersectionRect = entry.intersectionRect || getEmptyRect();
	 this.isIntersecting = !!entry.intersectionRect;
   
	 // Calculates the intersection ratio.
	 var targetRect = this.boundingClientRect;
	 var targetArea = targetRect.width * targetRect.height;
	 var intersectionRect = this.intersectionRect;
	 var intersectionArea = intersectionRect.width * intersectionRect.height;
   
	 // Sets intersection ratio.
	 if (targetArea) {
	   this.intersectionRatio = intersectionArea / targetArea;
	 } else {
	   // If area is zero and is intersecting, sets to 1, otherwise to 0
	   this.intersectionRatio = this.isIntersecting ? 1 : 0;
	 }
   }
   
   
   /**
	* Creates the global IntersectionObserver constructor.
	* https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
	* @param {Function} callback The function to be invoked after intersection
	*     changes have queued. The function is not invoked if the queue has
	*     been emptied by calling the `takeRecords` method.
	* @param {Object=} opt_options Optional configuration options.
	* @constructor
	*/
   function IntersectionObserver(callback, opt_options) {
   
	 var options = opt_options || {};
   
	 if (typeof callback != 'function') {
	   throw new Error('callback must be a function');
	 }
   
	 if (options.root && options.root.nodeType != 1) {
	   throw new Error('root must be an Element');
	 }
   
	 // Binds and throttles `this._checkForIntersections`.
	 this._checkForIntersections = throttle(
		 this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);
   
	 // Private properties.
	 this._callback = callback;
	 this._observationTargets = [];
	 this._queuedEntries = [];
	 this._rootMarginValues = this._parseRootMargin(options.rootMargin);
   
	 // Public properties.
	 this.thresholds = this._initThresholds(options.threshold);
	 this.root = options.root || null;
	 this.rootMargin = this._rootMarginValues.map(function(margin) {
	   return margin.value + margin.unit;
	 }).join(' ');
   }
   
   
   /**
	* The minimum interval within which the document will be checked for
	* intersection changes.
	*/
   IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;
   
   
   /**
	* The frequency in which the polyfill polls for intersection changes.
	* this can be updated on a per instance basis and must be set prior to
	* calling `observe` on the first target.
	*/
   IntersectionObserver.prototype.POLL_INTERVAL = null;
   
   /**
	* Use a mutation observer on the root element
	* to detect intersection changes.
	*/
   IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;
   
   
   /**
	* Starts observing a target element for intersection changes based on
	* the thresholds values.
	* @param {Element} target The DOM element to observe.
	*/
   IntersectionObserver.prototype.observe = function(target) {
	 var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
	   return item.element == target;
	 });
   
	 if (isTargetAlreadyObserved) {
	   return;
	 }
   
	 if (!(target && target.nodeType == 1)) {
	   throw new Error('target must be an Element');
	 }
   
	 this._registerInstance();
	 this._observationTargets.push({element: target, entry: null});
	 this._monitorIntersections();
	 this._checkForIntersections();
   };
   
   
   /**
	* Stops observing a target element for intersection changes.
	* @param {Element} target The DOM element to observe.
	*/
   IntersectionObserver.prototype.unobserve = function(target) {
	 this._observationTargets =
		 this._observationTargets.filter(function(item) {
   
	   return item.element != target;
	 });
	 if (!this._observationTargets.length) {
	   this._unmonitorIntersections();
	   this._unregisterInstance();
	 }
   };
   
   
   /**
	* Stops observing all target elements for intersection changes.
	*/
   IntersectionObserver.prototype.disconnect = function() {
	 this._observationTargets = [];
	 this._unmonitorIntersections();
	 this._unregisterInstance();
   };
   
   
   /**
	* Returns any queue entries that have not yet been reported to the
	* callback and clears the queue. This can be used in conjunction with the
	* callback to obtain the absolute most up-to-date intersection information.
	* @return {Array} The currently queued entries.
	*/
   IntersectionObserver.prototype.takeRecords = function() {
	 var records = this._queuedEntries.slice();
	 this._queuedEntries = [];
	 return records;
   };
   
   
   /**
	* Accepts the threshold value from the user configuration object and
	* returns a sorted array of unique threshold values. If a value is not
	* between 0 and 1 and error is thrown.
	* @private
	* @param {Array|number=} opt_threshold An optional threshold value or
	*     a list of threshold values, defaulting to [0].
	* @return {Array} A sorted list of unique and valid threshold values.
	*/
   IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
	 var threshold = opt_threshold || [0];
	 if (!Array.isArray(threshold)) threshold = [threshold];
   
	 return threshold.sort().filter(function(t, i, a) {
	   if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
		 throw new Error('threshold must be a number between 0 and 1 inclusively');
	   }
	   return t !== a[i - 1];
	 });
   };
   
   
   /**
	* Accepts the rootMargin value from the user configuration object
	* and returns an array of the four margin values as an object containing
	* the value and unit properties. If any of the values are not properly
	* formatted or use a unit other than px or %, and error is thrown.
	* @private
	* @param {string=} opt_rootMargin An optional rootMargin value,
	*     defaulting to '0px'.
	* @return {Array<Object>} An array of margin objects with the keys
	*     value and unit.
	*/
   IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
	 var marginString = opt_rootMargin || '0px';
	 var margins = marginString.split(/\s+/).map(function(margin) {
	   var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
	   if (!parts) {
		 throw new Error('rootMargin must be specified in pixels or percent');
	   }
	   return {value: parseFloat(parts[1]), unit: parts[2]};
	 });
   
	 // Handles shorthand.
	 margins[1] = margins[1] || margins[0];
	 margins[2] = margins[2] || margins[0];
	 margins[3] = margins[3] || margins[1];
   
	 return margins;
   };
   
   
   /**
	* Starts polling for intersection changes if the polling is not already
	* happening, and if the page's visibilty state is visible.
	* @private
	*/
   IntersectionObserver.prototype._monitorIntersections = function() {
	 if (!this._monitoringIntersections) {
	   this._monitoringIntersections = true;
   
	   // If a poll interval is set, use polling instead of listening to
	   // resize and scroll events or DOM mutations.
	   if (this.POLL_INTERVAL) {
		 this._monitoringInterval = setInterval(
			 this._checkForIntersections, this.POLL_INTERVAL);
	   }
	   else {
		 addEvent(window, 'resize', this._checkForIntersections, true);
		 addEvent(document, 'scroll', this._checkForIntersections, true);
   
		 if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
		   this._domObserver = new MutationObserver(this._checkForIntersections);
		   this._domObserver.observe(document, {
			 attributes: true,
			 childList: true,
			 characterData: true,
			 subtree: true
		   });
		 }
	   }
	 }
   };
   
   
   /**
	* Stops polling for intersection changes.
	* @private
	*/
   IntersectionObserver.prototype._unmonitorIntersections = function() {
	 if (this._monitoringIntersections) {
	   this._monitoringIntersections = false;
   
	   clearInterval(this._monitoringInterval);
	   this._monitoringInterval = null;
   
	   removeEvent(window, 'resize', this._checkForIntersections, true);
	   removeEvent(document, 'scroll', this._checkForIntersections, true);
   
	   if (this._domObserver) {
		 this._domObserver.disconnect();
		 this._domObserver = null;
	   }
	 }
   };
   
   
   /**
	* Scans each observation target for intersection changes and adds them
	* to the internal entries queue. If new entries are found, it
	* schedules the callback to be invoked.
	* @private
	*/
   IntersectionObserver.prototype._checkForIntersections = function() {
	 var rootIsInDom = this._rootIsInDom();
	 var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();
   
	 this._observationTargets.forEach(function(item) {
	   var target = item.element;
	   var targetRect = getBoundingClientRect(target);
	   var rootContainsTarget = this._rootContainsTarget(target);
	   var oldEntry = item.entry;
	   var intersectionRect = rootIsInDom && rootContainsTarget &&
		   this._computeTargetAndRootIntersection(target, rootRect);
   
	   var newEntry = item.entry = new IntersectionObserverEntry({
		 time: now(),
		 target: target,
		 boundingClientRect: targetRect,
		 rootBounds: rootRect,
		 intersectionRect: intersectionRect
	   });
   
	   if (!oldEntry) {
		 this._queuedEntries.push(newEntry);
	   } else if (rootIsInDom && rootContainsTarget) {
		 // If the new entry intersection ratio has crossed any of the
		 // thresholds, add a new entry.
		 if (this._hasCrossedThreshold(oldEntry, newEntry)) {
		   this._queuedEntries.push(newEntry);
		 }
	   } else {
		 // If the root is not in the DOM or target is not contained within
		 // root but the previous entry for this target had an intersection,
		 // add a new record indicating removal.
		 if (oldEntry && oldEntry.isIntersecting) {
		   this._queuedEntries.push(newEntry);
		 }
	   }
	 }, this);
   
	 if (this._queuedEntries.length) {
	   this._callback(this.takeRecords(), this);
	 }
   };
   
   
   /**
	* Accepts a target and root rect computes the intersection between then
	* following the algorithm in the spec.
	* TODO(philipwalton): at this time clip-path is not considered.
	* https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
	* @param {Element} target The target DOM element
	* @param {Object} rootRect The bounding rect of the root after being
	*     expanded by the rootMargin value.
	* @return {?Object} The final intersection rect object or undefined if no
	*     intersection is found.
	* @private
	*/
   IntersectionObserver.prototype._computeTargetAndRootIntersection =
	   function(target, rootRect) {
   
	 // If the element isn't displayed, an intersection can't happen.
	 if (window.getComputedStyle(target).display == 'none') return;
   
	 var targetRect = getBoundingClientRect(target);
	 var intersectionRect = targetRect;
	 var parent = getParentNode(target);
	 var atRoot = false;
   
	 while (!atRoot) {
	   var parentRect = null;
	   var parentComputedStyle = parent.nodeType == 1 ?
		   window.getComputedStyle(parent) : {};
   
	   // If the parent isn't displayed, an intersection can't happen.
	   if (parentComputedStyle.display == 'none') return;
   
	   if (parent == this.root || parent == document) {
		 atRoot = true;
		 parentRect = rootRect;
	   } else {
		 // If the element has a non-visible overflow, and it's not the <body>
		 // or <html> element, update the intersection rect.
		 // Note: <body> and <html> cannot be clipped to a rect that's not also
		 // the document rect, so no need to compute a new intersection.
		 if (parent != document.body &&
			 parent != document.documentElement &&
			 parentComputedStyle.overflow != 'visible') {
		   parentRect = getBoundingClientRect(parent);
		 }
	   }
   
	   // If either of the above conditionals set a new parentRect,
	   // calculate new intersection data.
	   if (parentRect) {
		 intersectionRect = computeRectIntersection(parentRect, intersectionRect);
   
		 if (!intersectionRect) break;
	   }
	   parent = getParentNode(parent);
	 }
	 return intersectionRect;
   };
   
   
   /**
	* Returns the root rect after being expanded by the rootMargin value.
	* @return {Object} The expanded root rect.
	* @private
	*/
   IntersectionObserver.prototype._getRootRect = function() {
	 var rootRect;
	 if (this.root) {
	   rootRect = getBoundingClientRect(this.root);
	 } else {
	   // Use <html>/<body> instead of window since scroll bars affect size.
	   var html = document.documentElement;
	   var body = document.body;
	   rootRect = {
		 top: 0,
		 left: 0,
		 right: html.clientWidth || body.clientWidth,
		 width: html.clientWidth || body.clientWidth,
		 bottom: html.clientHeight || body.clientHeight,
		 height: html.clientHeight || body.clientHeight
	   };
	 }
	 return this._expandRectByRootMargin(rootRect);
   };
   
   
   /**
	* Accepts a rect and expands it by the rootMargin value.
	* @param {Object} rect The rect object to expand.
	* @return {Object} The expanded rect.
	* @private
	*/
   IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
	 var margins = this._rootMarginValues.map(function(margin, i) {
	   return margin.unit == 'px' ? margin.value :
		   margin.value * (i % 2 ? rect.width : rect.height) / 100;
	 });
	 var newRect = {
	   top: rect.top - margins[0],
	   right: rect.right + margins[1],
	   bottom: rect.bottom + margins[2],
	   left: rect.left - margins[3]
	 };
	 newRect.width = newRect.right - newRect.left;
	 newRect.height = newRect.bottom - newRect.top;
   
	 return newRect;
   };
   
   
   /**
	* Accepts an old and new entry and returns true if at least one of the
	* threshold values has been crossed.
	* @param {?IntersectionObserverEntry} oldEntry The previous entry for a
	*    particular target element or null if no previous entry exists.
	* @param {IntersectionObserverEntry} newEntry The current entry for a
	*    particular target element.
	* @return {boolean} Returns true if a any threshold has been crossed.
	* @private
	*/
   IntersectionObserver.prototype._hasCrossedThreshold =
	   function(oldEntry, newEntry) {
   
	 // To make comparing easier, an entry that has a ratio of 0
	 // but does not actually intersect is given a value of -1
	 var oldRatio = oldEntry && oldEntry.isIntersecting ?
		 oldEntry.intersectionRatio || 0 : -1;
	 var newRatio = newEntry.isIntersecting ?
		 newEntry.intersectionRatio || 0 : -1;
   
	 // Ignore unchanged ratios
	 if (oldRatio === newRatio) return;
   
	 for (var i = 0; i < this.thresholds.length; i++) {
	   var threshold = this.thresholds[i];
   
	   // Return true if an entry matches a threshold or if the new ratio
	   // and the old ratio are on the opposite sides of a threshold.
	   if (threshold == oldRatio || threshold == newRatio ||
		   threshold < oldRatio !== threshold < newRatio) {
		 return true;
	   }
	 }
   };
   
   
   /**
	* Returns whether or not the root element is an element and is in the DOM.
	* @return {boolean} True if the root element is an element and is in the DOM.
	* @private
	*/
   IntersectionObserver.prototype._rootIsInDom = function() {
	 return !this.root || containsDeep(document, this.root);
   };
   
   
   /**
	* Returns whether or not the target element is a child of root.
	* @param {Element} target The target element to check.
	* @return {boolean} True if the target element is a child of root.
	* @private
	*/
   IntersectionObserver.prototype._rootContainsTarget = function(target) {
	 return containsDeep(this.root || document, target);
   };
   
   
   /**
	* Adds the instance to the global IntersectionObserver registry if it isn't
	* already present.
	* @private
	*/
   IntersectionObserver.prototype._registerInstance = function() {
	 if (registry.indexOf(this) < 0) {
	   registry.push(this);
	 }
   };
   
   
   /**
	* Removes the instance from the global IntersectionObserver registry.
	* @private
	*/
   IntersectionObserver.prototype._unregisterInstance = function() {
	 var index = registry.indexOf(this);
	 if (index != -1) registry.splice(index, 1);
   };
   
   
   /**
	* Returns the result of the performance.now() method or null in browsers
	* that don't support the API.
	* @return {number} The elapsed time since the page was requested.
	*/
   function now() {
	 return window.performance && performance.now && performance.now();
   }
   
   
   /**
	* Throttles a function and delays its executiong, so it's only called at most
	* once within a given time period.
	* @param {Function} fn The function to throttle.
	* @param {number} timeout The amount of time that must pass before the
	*     function can be called again.
	* @return {Function} The throttled function.
	*/
   function throttle(fn, timeout) {
	 var timer = null;
	 return function () {
	   if (!timer) {
		 timer = setTimeout(function() {
		   fn();
		   timer = null;
		 }, timeout);
	   }
	 };
   }
   
   
   /**
	* Adds an event handler to a DOM node ensuring cross-browser compatibility.
	* @param {Node} node The DOM node to add the event handler to.
	* @param {string} event The event name.
	* @param {Function} fn The event handler to add.
	* @param {boolean} opt_useCapture Optionally adds the even to the capture
	*     phase. Note: this only works in modern browsers.
	*/
   function addEvent(node, event, fn, opt_useCapture) {
	 if (typeof node.addEventListener == 'function') {
	   node.addEventListener(event, fn, opt_useCapture || false);
	 }
	 else if (typeof node.attachEvent == 'function') {
	   node.attachEvent('on' + event, fn);
	 }
   }
   
   
   /**
	* Removes a previously added event handler from a DOM node.
	* @param {Node} node The DOM node to remove the event handler from.
	* @param {string} event The event name.
	* @param {Function} fn The event handler to remove.
	* @param {boolean} opt_useCapture If the event handler was added with this
	*     flag set to true, it should be set to true here in order to remove it.
	*/
   function removeEvent(node, event, fn, opt_useCapture) {
	 if (typeof node.removeEventListener == 'function') {
	   node.removeEventListener(event, fn, opt_useCapture || false);
	 }
	 else if (typeof node.detatchEvent == 'function') {
	   node.detatchEvent('on' + event, fn);
	 }
   }
   
   
   /**
	* Returns the intersection between two rect objects.
	* @param {Object} rect1 The first rect.
	* @param {Object} rect2 The second rect.
	* @return {?Object} The intersection rect or undefined if no intersection
	*     is found.
	*/
   function computeRectIntersection(rect1, rect2) {
	 var top = Math.max(rect1.top, rect2.top);
	 var bottom = Math.min(rect1.bottom, rect2.bottom);
	 var left = Math.max(rect1.left, rect2.left);
	 var right = Math.min(rect1.right, rect2.right);
	 var width = right - left;
	 var height = bottom - top;
   
	 return (width >= 0 && height >= 0) && {
	   top: top,
	   bottom: bottom,
	   left: left,
	   right: right,
	   width: width,
	   height: height
	 };
   }
   
   
   /**
	* Shims the native getBoundingClientRect for compatibility with older IE.
	* @param {Element} el The element whose bounding rect to get.
	* @return {Object} The (possibly shimmed) rect of the element.
	*/
   function getBoundingClientRect(el) {
	 var rect;
   
	 try {
	   rect = el.getBoundingClientRect();
	 } catch (err) {
	   // Ignore Windows 7 IE11 "Unspecified error"
	   // https://github.com/w3c/IntersectionObserver/pull/205
	 }
   
	 if (!rect) return getEmptyRect();
   
	 // Older IE
	 if (!(rect.width && rect.height)) {
	   rect = {
		 top: rect.top,
		 right: rect.right,
		 bottom: rect.bottom,
		 left: rect.left,
		 width: rect.right - rect.left,
		 height: rect.bottom - rect.top
	   };
	 }
	 return rect;
   }
   
   
   /**
	* Returns an empty rect object. An empty rect is returned when an element
	* is not in the DOM.
	* @return {Object} The empty rect.
	*/
   function getEmptyRect() {
	 return {
	   top: 0,
	   bottom: 0,
	   left: 0,
	   right: 0,
	   width: 0,
	   height: 0
	 };
   }
   
   /**
	* Checks to see if a parent element contains a child elemnt (including inside
	* shadow DOM).
	* @param {Node} parent The parent element.
	* @param {Node} child The child element.
	* @return {boolean} True if the parent node contains the child node.
	*/
   function containsDeep(parent, child) {
	 var node = child;
	 while (node) {
	   if (node == parent) return true;
   
	   node = getParentNode(node);
	 }
	 return false;
   }
   
   
   /**
	* Gets the parent node of an element or its host element if the parent node
	* is a shadow root.
	* @param {Node} node The node whose parent to get.
	* @return {Node|null} The parent node or null if no parent exists.
	*/
   function getParentNode(node) {
	 var parent = node.parentNode;
   
	 if (parent && parent.nodeType == 11 && parent.host) {
	   // If the parent is a shadow root, return the host element.
	   return parent.host;
	 }
	 return parent;
   }
   
   
   // Exposes the constructors globally.
   window.IntersectionObserver = IntersectionObserver;
   window.IntersectionObserverEntry = IntersectionObserverEntry;
   
   }(window, document));
   
   
   /***/ }),
   /* 9 */
   /***/ (function(module, exports) {
   
   // https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
   // Allows use of .forEach on NodeLists in browsers without native support
   if (window.NodeList && !NodeList.prototype.forEach) {
	 NodeList.prototype.forEach = Array.prototype.forEach;
   }
   
   /***/ }),
   /* 10 */
   /***/ (function(module, exports) {
   
   /*!
	* Revealer 2.0.0
	*
	* Copyright 2015, Pixel Union - http://pixelunion.net
	* Released under the MIT license
	*/
   (function($){
	 // check for trend event (make sure jquery.trend is included)
	 if (typeof $.event.special.trend !== "object") {
	   console.warn("Please make sure jquery.trend is included! Otherwise revealer won't work.");
	 }
   
	 // Simple requestAnimationFrame polyfill
	 var raf = window.requestAnimationFrame ||
	   window.mozRequestAnimationFrame ||
	   window.webkitRequestAnimationFrame ||
	   function(fn) { window.setTimeout(fn, 1000/60); }
   
   
	 // Public API
	 var methods = {
	   isVisible: function(el) {
		 return !!el.data("revealer-visible");
	   },
   
	   show: function(el, force) {
		 // Check state
		 if (methods.isVisible(el)) {
		   el.removeClass("animating animating-in");
		   el.off("revealer-animating revealer-show");
		   return;
		 }
   
		 // Remove previous event listeners
		 el.data("revealer-visible", true);
		 el.off("trend");
   
		 if (force) {
		   el.addClass("visible");
		   raf(function(){
			 el.trigger("revealer-animating");
			 el.trigger("revealer-show");
		   });
		   return;
		 }
   
		 raf(function(){
		   // Start animation state transition
		   el.addClass("animating animating-in");
		   el.trigger("revealer-animating");
   
		   raf(function(){
			 el.addClass("visible");
   
			 el.one("trend", function(){
			   el.removeClass("animating animating-in");
			   el.trigger("revealer-show");
			 });
		   });
		 });
	   },
   
	   hide: function(el, force) {
		 // Check state
		 if (!methods.isVisible(el)) {
		   el.removeClass("animating animating-out visible");
		   el.off("revealer-animating revealer-hide");
		   return;
		 }
   
		 // Remove previous event listeners
		 el.data("revealer-visible", false);
		 el.off("trend");
   
		 if (force) {
		   el.removeClass("visible");
		   raf(function(){
			 el.trigger("revealer-animating");
			 el.trigger("revealer-hide");
		   });
		   return;
		 }
   
		 raf(function(){
		   el.addClass("animating animating-out");
		   el.trigger("revealer-animating");
   
		   raf(function(){
			 el.removeClass("visible");
   
			 el.one("trend", function(){
			   el.removeClass("animating animating-in animating-out");
			   el.trigger("revealer-hide");
			 });
		   });
		 });
	   },
   
	   toggle: function(el, force) {
		 if (methods.isVisible(el)) {
		   methods.hide(el, force);
		 } else {
		   methods.show(el, force);
		 }
	   }
	 };
   
	 // jQuery plugin
	 $.fn.revealer = function(method, force) {
	   // Get action
	   var action = methods[method || "toggle"];
	   if (!action) return this;
   
	   // Run action
	   if (method === "isVisible") {
		 return action(this);
	   }
   
	   return this.each(function(){
		 action($(this), force);
	   });
	 };
   })(jQuery);
   
   
   /***/ }),
   /* 11 */
   /***/ (function(module, __webpack_exports__, __webpack_require__) {
   
   "use strict";
   __webpack_require__.r(__webpack_exports__);
   
   // EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
   var jquery = __webpack_require__(0);
   var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
   
   // EXTERNAL MODULE: ./node_modules/scriptjs/dist/script.js
   var script = __webpack_require__(1);
   var script_default = /*#__PURE__*/__webpack_require__.n(script);
   
   // CONCATENATED MODULE: ./node_modules/shopify-sections-manager/dist/shopify-sections-manager.es.js
   
   /*!
	* shopify-sections-manager v0.0.0
	* (c) 2018 Pixel Union
	*/
   
   var classCallCheck = function (instance, Constructor) {
	 if (!(instance instanceof Constructor)) {
	   throw new TypeError("Cannot call a class as a function");
	 }
   };
   
   var createClass = function () {
	 function defineProperties(target, props) {
	   for (var i = 0; i < props.length; i++) {
		 var descriptor = props[i];
		 descriptor.enumerable = descriptor.enumerable || false;
		 descriptor.configurable = true;
		 if ("value" in descriptor) descriptor.writable = true;
		 Object.defineProperty(target, descriptor.key, descriptor);
	   }
	 }
   
	 return function (Constructor, protoProps, staticProps) {
	   if (protoProps) defineProperties(Constructor.prototype, protoProps);
	   if (staticProps) defineProperties(Constructor, staticProps);
	   return Constructor;
	 };
   }();
   
   function triggerInstanceEvent(instance, eventName) {
	 if (instance && instance[eventName]) {
	   for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
		 args[_key - 2] = arguments[_key];
	   }
   
	   instance[eventName].apply(instance, args);
	 }
   }
   
   function loadData(el) {
	 var dataEl = el.querySelector('[data-section-data]');
	 if (!dataEl) return {};
   
	 // Load data from attribute, or innerHTML
	 var data = dataEl.getAttribute('data-section-data') || dataEl.innerHTML;
   
	 try {
	   return JSON.parse(data);
	 } catch (error) {
	   console.warn('Sections: invalid section data found. ' + error.message);
	   return {};
	 }
   }
   
   var ShopifySectionsManager = function () {
	 function ShopifySectionsManager() {
	   classCallCheck(this, ShopifySectionsManager);
   
	   this.handlers = {};
	   this.instances = {};
	   this._onSectionEvent = this._onSectionEvent.bind(this);
   
	   document.addEventListener('shopify:section:load', this._onSectionEvent);
	   document.addEventListener('shopify:section:unload', this._onSectionEvent);
	   document.addEventListener('shopify:section:select', this._onSectionEvent);
	   document.addEventListener('shopify:section:deselect', this._onSectionEvent);
	   document.addEventListener('shopify:section:reorder', this._onSectionEvent);
	   document.addEventListener('shopify:block:select', this._onSectionEvent);
	   document.addEventListener('shopify:block:deselect', this._onSectionEvent);
	 }
   
	 /**
	  * Stop listening for section events, and unbind all handlers.
	  */
   
   
	 createClass(ShopifySectionsManager, [{
	   key: 'unbind',
	   value: function unbind() {
		 document.removeEventListener('shopify:section:load', this._onSectionEvent);
		 document.removeEventListener('shopify:section:unload', this._onSectionEvent);
		 document.removeEventListener('shopify:section:select', this._onSectionEvent);
		 document.removeEventListener('shopify:section:deselect', this._onSectionEvent);
		 document.removeEventListener('shopify:section:reorder', this._onSectionEvent);
		 document.removeEventListener('shopify:block:select', this._onSectionEvent);
		 document.removeEventListener('shopify:block:deselect', this._onSectionEvent);
   
		 // Unload all instances
		 for (var i = 0; i < this.instances.length; i++) {
		   triggerInstanceEvent(this.instances[i], 'onSectionUnload');
		 }
   
		 this.handlers = {};
		 this.instances = {};
	   }
   
	   /**
		* Register a section handler.
		*
		* @param {string} type
		*        The section type to handle. The handler will be called for all
		*        sections with this type.
		*
		* @param {function} handler
		*        The handler function is passed information about a specific section
		*        instance. The handler is expected to return an object that will be
		*        associated with the section instance.
		*
		*        Section handlers are passed an object with the following parameters:
		*          {string} id
		*          An ID that maps to a specific section instance. Typically the
		*          section's filename for static sections, or a generated ID for
		*          dynamic sections.
		*
		*          {string} type
		*          The section type, as supplied when registered.
		*
		*          {Element} el
		*          The root DOM element for the section instance.
		*
		*          {Object} data
		*          Data loaded from the section script element. Defaults to an
		*          empty object.
		*
		*          {Function} postMessage
		*          A function that can be called to pass messages between sections.
		*          The function should be called with a message "name", and
		*          optionally some data.
		*/
   
	 }, {
	   key: 'register',
	   value: function register(type, handler) {
		 if (this.handlers[type]) {
		   console.warn('Sections: section handler already exists of type \'' + type + '\'.');
		 }
   
		 // Store the section handler
		 this.handlers[type] = handler;
   
		 // Init sections for this type
		 this._initSections(type);
	   }
   
	   /**
		* Initialize sections already on the page.
		*/
   
	 }, {
	   key: '_initSections',
	   value: function _initSections(type) {
		 // Fetch all existing sections of our type on the page
		 var dataEls = document.querySelectorAll('[data-section-type="' + type + '"]');
		 if (!dataEls) return;
   
		 // Create an instance for each section
		 for (var i = 0; i < dataEls.length; i++) {
		   var dataEl = dataEls[i];
		   var el = dataEl.parentNode;
   
		   // Get instance ID
		   var idEl = el.querySelector('[data-section-id]');
   
		   if (!idEl) {
			 console.warn('Sections: unable to find section id for \'' + type + '\'.', el);
			 return;
		   }
   
		   var sectionId = idEl.getAttribute('data-section-id');
		   if (!sectionId) {
			 console.warn('Sections: unable to find section id for \'' + type + '\'.', el);
			 return;
		   }
   
		   this._createInstance(sectionId, el);
		 }
	   }
	 }, {
	   key: '_onSectionEvent',
	   value: function _onSectionEvent(event) {
		 var el = event.target;
		 var sectionId = event.detail.sectionId;
		 var blockId = event.detail.blockId;
		 var instance = this.instances[sectionId];
   
		 switch (event.type) {
		   case 'shopify:section:load':
			 this._createInstance(sectionId, el);
			 break;
   
		   case 'shopify:section:unload':
			 triggerInstanceEvent(instance, 'onSectionUnload', { el: el, id: sectionId });
			 delete this.instances[sectionId];
			 break;
   
		   case 'shopify:section:select':
			 triggerInstanceEvent(instance, 'onSectionSelect', { el: el, id: sectionId });
			 break;
   
		   case 'shopify:section:deselect':
			 triggerInstanceEvent(instance, 'onSectionDeselect', { el: el, id: sectionId });
			 break;
   
		   case 'shopify:section:reorder':
			 triggerInstanceEvent(instance, 'onSectionReorder', { el: el, id: sectionId });
			 break;
   
		   case 'shopify:block:select':
			 triggerInstanceEvent(instance, 'onSectionBlockSelect', { el: el, id: blockId });
			 break;
   
		   case 'shopify:block:deselect':
			 triggerInstanceEvent(instance, 'onSectionBlockDeselect', { el: el, id: blockId });
			 break;
   
		   default:
			 break;
		 }
	   }
	 }, {
	   key: '_postMessage',
	   value: function _postMessage(name, data) {
		 var _this = this;
   
		 Object.keys(this.instances).forEach(function (id) {
		   triggerInstanceEvent(_this.instances[id], 'onSectionMessage', name, data);
		 });
	   }
	 }, {
	   key: '_createInstance',
	   value: function _createInstance(id, el) {
		 var typeEl = el.querySelector('[data-section-type]');
		 if (!typeEl) return;
   
		 var type = typeEl.getAttribute('data-section-type');
		 if (!type) return;
   
		 var handler = this.handlers[type];
		 if (!handler) {
		   console.warn('Sections: unable to find section handler for type \'' + type + '\'.');
		   return;
		 }
   
		 var data = loadData(el);
		 var postMessage = this._postMessage.bind(this);
   
		 this.instances[id] = handler({ id: id, type: type, el: el, data: data, postMessage: postMessage });
	   }
	 }]);
	 return ShopifySectionsManager;
   }();
   
   /* harmony default export */ var shopify_sections_manager_es = (ShopifySectionsManager);
   
   // CONCATENATED MODULE: ./node_modules/pxs-map/dist/index.es.js
   
   /*!
	* pxs-map v2.0.3
	* (c) 2018 undefined
	*/
   
   
   
   
   var index_es_classCallCheck = function (instance, Constructor) {
	 if (!(instance instanceof Constructor)) {
	   throw new TypeError("Cannot call a class as a function");
	 }
   };
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   var toConsumableArray = function (arr) {
	 if (Array.isArray(arr)) {
	   for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
   
	   return arr2;
	 } else {
	   return Array.from(arr);
	 }
   };
   
   /*
	* Function to convert any given latitude and longitude format to decimal degrees
	*/
   function getDecimalDegrees() {
	 var firstComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	 var secondComponent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	 var thirdComponent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	 var fourthComponent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
   
	 var directions = {
	   N: 1,
	   E: 1,
	   S: -1,
	   W: -1
	 };
	 var decimalDegrees = 0.0;
	 var components = [firstComponent, secondComponent, thirdComponent, fourthComponent];
   
	 for (var i = 0; i < components.length; i++) {
	   var component = components[i];
   
	   if (component) {
		 if (Number.isNaN(parseFloat(component))) {
		   decimalDegrees *= directions[component];
		 } else {
		   decimalDegrees += parseFloat(component) / Math.pow(60, i);
		 }
	   }
	 }
   
	 return decimalDegrees;
   }
   
   /*
	* By providing the ability to use a place name, or latitude and longitude coordinates
	* we give merchants, and our demo stores the option to bypass the Geocoding API.
	* The Geocoding API (https://developers.google.com/maps/documentation/geocoding/usage-and-billing) allows us
	* to take a place name and convert it to latitude and longitude expressed in decimal degrees.
	*/
   function getLatitudeLongitude(address) {
	 var deferred = jquery_default.a.Deferred();
	 // Degrees, Minutes and Seconds: DDD° MM' SS.S"
	 var latLongDegreesMinutesSeconds = /^([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2})(?:'[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:"[ ]?| )?(N|E|S|W) ?([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2})(?:'[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:"[ ]?| )?(N|E|S|W)$/g;
	 // Degrees and Decimal Minutes: DDD° MM.MMM'
	 var latLongDegreesMinutes = /^([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:'[ ]?| )?(N|E|S|W) ?([0-9]{1,3})(?:°[ ]?| )([0-9]{1,2}(?:\.[0-9]+)?)(?:'[ ]?| )?(N|E|S|W)$/g;
	 // Decimal Degrees: DDD.DDDDD°
	 var latLongDegrees = /^([-|+]?[0-9]{1,3}(?:\.[0-9]+)?)(?:°[ ]?| )?(N|E|S|W)?,? ?([-|+]?[0-9]{1,3}(?:\.[0-9]+)?)(?:°[ ]?| )?(N|E|S|W)?$/g;
	 var latLongFormats = [latLongDegreesMinutesSeconds, latLongDegreesMinutes, latLongDegrees];
	 var latLongMatches = latLongFormats.map(function (latLongFormat) {
	   return address.match(latLongFormat);
	 });
   
	 /*
	  * Select the first latitude and longitude format that is matched.
	  * Ordering:
	  *   1. Degrees, minutes, and seconds,
	  *   2. Degrees, and decimal minutes,
	  *   3. Decimal degrees.
	  */
	 var latLongMatch = latLongMatches.reduce(function (accumulator, value, index) {
	   if (!accumulator && value) {
		 var latLongResult = latLongFormats[index].exec(address);
		 var lat = latLongResult.slice(1, latLongResult.length / 2 + 1);
		 var lng = latLongResult.slice(latLongResult.length / 2 + 1, latLongResult.length);
   
		 return {
		   lat: lat,
		   lng: lng
		 };
	   }
   
	   return accumulator;
	 }, null);
   
	 // If we've got a match on latitude and longitude, use that and avoid geocoding
	 if (latLongMatch) {
	   var latDecimalDegrees = getDecimalDegrees.apply(undefined, toConsumableArray(latLongMatch.lat));
	   var longDecimalDegrees = getDecimalDegrees.apply(undefined, toConsumableArray(latLongMatch.lng));
   
	   deferred.resolve({
		 lat: latDecimalDegrees,
		 lng: longDecimalDegrees
	   });
	 } else {
	   // Otherwise, geocode the assumed address
	   var geocoder = new google.maps.Geocoder();
   
	   geocoder.geocode({ address: address }, function (results, status) {
		 if (status !== google.maps.GeocoderStatus.OK) {
		   deferred.reject(status);
		 }
   
		 deferred.resolve(results[0].geometry.location);
	   });
	 }
   
	 return deferred;
   }
   
   function getMapStyles(colors) {
	 if (!colors) {
	   return [];
	 }
   
	 return [{ elementType: 'geometry', stylers: [{ color: colors.e }] }, { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] }, { elementType: 'labels.text.fill', stylers: [{ color: colors.a }] }, { elementType: 'labels.text.stroke', stylers: [{ color: colors.e }] }, { featureType: 'administrative', elementType: 'geometry', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.country', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.land_parcel', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.neighborhood', stylers: [{ visibility: 'off' }] }, { featureType: 'administrative.locality', stylers: [{ visibility: 'off' }] }, { featureType: 'poi', stylers: [{ visibility: 'off' }] }, { featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: colors.d }] }, { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] }, { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: colors.c }] }, { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: colors.b }] }, { featureType: 'road.highway.controlled_access', stylers: [{ visibility: 'off' }] }, { featureType: 'road.local', elementType: 'labels.text.fill', stylers: [{ color: colors.b }] }, { featureType: 'road.local', elementType: 'labels.text.stroke', stylers: [{ color: colors.e }] }, { featureType: 'transit', stylers: [{ visibility: 'off' }] }, { featureType: 'water', elementType: 'geometry', stylers: [{ color: colors.f }] }];
   }
   
   function createMap(options) {
	 var deferred = jquery_default.a.Deferred();
	 var container = options.container,
		 address = options.address,
		 zoom = options.zoom,
		 colors = options.colors;
   
   
	 getLatitudeLongitude(address).done(function (latLong) {
	   var map = new google.maps.Map(container, {
		 center: latLong,
		 clickableIcons: false,
		 disableDefaultUI: true,
		 disableDoubleClickZoom: true,
		 gestureHandling: 'none',
		 keyboardShortcuts: false,
		 maxZoom: zoom,
		 minZoom: zoom,
		 scrollWheel: false,
		 styles: getMapStyles(colors),
		 zoom: zoom,
		 zoomControl: false
	   });
   
	   new google.maps.Marker({
		 clickable: false,
		 map: map,
		 position: map.getCenter()
	   });
   
	   map.panBy(0, 0);
	   deferred.resolve(map);
	 }).fail(function (status) {
	   var usageLimits = 'https://developers.google.com/maps/faq#usagelimits';
	   var errorMessage = void 0;
   
	   switch (status) {
		 case 'ZERO_RESULTS':
		   errorMessage = '<p>Unable to find the address:</p> ' + address;
		   break;
		 case 'OVER_QUERY_LIMIT':
		   errorMessage = '\n            <p>Unable to load Google Maps, you have reached your usage limit.</p>\n            <p>\n              Please visit\n              <a href="' + usageLimits + '" target="_blank">' + usageLimits + '</a>\n              for more details.\n            </p>\n          ';
		   break;
		 default:
		   errorMessage = 'Unable to load Google Maps.';
		   break;
	   }
   
	   deferred.reject(errorMessage);
	 });
   
	 return deferred;
   }
   
   function displayErrorInThemeEditor(container, errorMessage) {
	 var isThemeEditor = window.Shopify && window.Shopify.designMode;
   
	 if (!isThemeEditor) {
	   return;
	 }
   
	 container.innerHTML = '<div class="map-error-message">' + errorMessage + '</div>';
   }
   
   var index_es_PxsMap = function PxsMap(section) {
	 var _this = this;
   
	 index_es_classCallCheck(this, PxsMap);
   
	 this.map = null;
   
	 var el = section.el.querySelector('[data-map]');
	 var container = el.querySelector('[data-map-container]');
	 var settings = section.data;
	 var address = settings.address,
		 colors = settings.colors;
   
	 var apiKey = settings.api_key;
	 // Scale so range is 12 ~ 17, rather than 1 to 6
	 var zoom = Number.isNaN(settings.zoom) ? 13 : 11 + parseInt(settings.zoom, 10);
   
	 if (apiKey) {
	   if (window.googleMaps === undefined) {
		 script_default()('https://maps.googleapis.com/maps/api/js?key=' + apiKey, function () {
		   window.googleMaps = true;
		   createMap({
			 container: container,
			 address: address,
			 zoom: zoom,
			 colors: colors
		   }).done(function (map) {
			 _this.map = map;
		   }).fail(function (error) {
			 return displayErrorInThemeEditor(container, error);
		   });
		 });
	   } else {
		 createMap({
		   container: container,
		   address: address,
		   zoom: zoom,
		   colors: colors
		 }).done(function (map) {
		   _this.map = map;
		 }).fail(function (error) {
		   return displayErrorInThemeEditor(container, error);
		 });
	   }
	 }
   };
   
   /* harmony default export */ var index_es = (index_es_PxsMap);
   
   // EXTERNAL MODULE: ./node_modules/intersection-observer/intersection-observer.js
   var intersection_observer = __webpack_require__(8);
   
   // CONCATENATED MODULE: ./node_modules/rimg/dist/index.es.js
   /*!
	* rimg v2.1.9
	* (c) 2019 Pixel Union
	*/
   /**
	* The default template render function. Turns a template string into an image
	* URL.
	*
	* @param {String} template
	* @param {Size} size
	* @returns {String}
	*/
   function defaultTemplateRender(template, size) {
	 return template.replace('{size}', size.width + 'x' + size.height);
   }
   
   /**
	* @type Settings
	*/
   var defaults = {
	 scale: 1,
	 template: false,
	 templateRender: defaultTemplateRender,
	 max: { width: Infinity, height: Infinity },
	 round: 32,
	 placeholder: false,
	 crop: null
   };
   
   /**
	* Get a data attribute value from an element, with a default fallback and
	* sanitization step.
	*
	* @param {Element} el
	*
	* @param {String} name
	*        The data attribute name.
	*
	* @param {Object} options
	*        An object holding fallback values if the data attribute does not
	*        exist. If this object doesn't have the property, we further fallback
	*        to our defaults.
	*
	* @param {Function} [sanitize]
	*        A function to sanitize the data attribute value with.
	*
	* @returns {String|*}
	*/
   function getData(el, name, options, sanitize) {
	 var attr = 'data-rimg-' + name;
	 if (!el.hasAttribute(attr)) return options[name] || defaults[name];
   
	 var value = el.getAttribute(attr);
   
	 return sanitize ? sanitize(value) : value;
   }
   
   /**
	* Sanitize data attributes that represent a size (in the form of `10x10`).
	*
	* @param {String} value
	* @returns {Object} An object with `width` and `height` properties.
	*/
   function parseSize(value) {
	 value = value.split('x');
	 return { width: parseInt(value[0], 10), height: parseInt(value[1], 10) };
   }
   
   /**
	* Sanitize crop values to ensure they are valid, or null
	*
	* @param {String} value
	* @returns {Object} Shopify crop parameter ('top', 'center', 'bottom', 'left', 'right') or null, if an unsupported value is found
	*/
   function processCropValue(value) {
	 switch (value) {
	   case 'top':
	   case 'center':
	   case 'bottom':
	   case 'left':
	   case 'right':
		 return value;
	   default:
		 return null;
	 }
   }
   
   /**
	* Loads information about an element.
	*
	* Options can be set on the element itself using data attributes, or through
	* the `options` parameter. Data attributes take priority.
	*
	* @param {HTMLElement} el
	* @param {Settings} options
	* @returns {Item}
	*/
   function parseItem(el) {
	 var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
   
	 var isImage = el.hasAttribute('data-rimg-template');
   
	 /**
	  * @typedef {Settings} Item
	  */
	 return {
	   el: el,
   
	   // Type of element
	   isImage: isImage,
	   isBackgroundImage: isImage && el.tagName !== 'IMG',
   
	   // Image scale
	   scale: getData(el, 'scale', options),
   
	   // Device density
	   density: window.devicePixelRatio || 1,
   
	   // Image template URL
	   template: getData(el, 'template', options),
	   templateRender: options.templateRender || defaults.templateRender,
   
	   // Maximum image dimensions
	   max: getData(el, 'max', options, parseSize),
   
	   // Round image dimensions to the nearest multiple
	   round: getData(el, 'round', options),
   
	   // Placeholder image dimensions
	   placeholder: getData(el, 'placeholder', options, parseSize),
   
	   // Crop value; null if image is uncropped, otherwise equal to the Shopify crop parameter ('center', 'top', etc.)
	   crop: getData(el, 'crop', options, processCropValue)
	 };
   }
   
   /**
	* Round to the nearest multiple.
	*
	* This is so we don't tax the image server too much.
	*
	* @param {Number} size The size, in pixels.
	* @param {Number} [multiple] The multiple to round to the nearest.
	* @param {Number} [maxLimit] Maximum allowed value - value to return if rounded multiple is above this limit
	* @returns {Number}
	*/
   function roundSize(size) {
	 var multiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
	 var maxLimit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
   
	 return size === 0 ? multiple : Math.min(Math.ceil(size / multiple) * multiple, maxLimit);
   }
   
   /**
	* Get the size of an element.
	*
	* If it is too small, it's parent element is checked, and so on. This helps
	* avoid the situation where an element doesn't have a size yet or is positioned
	* out of the layout.
	*
	* @param {HTMLElement} el
	* @return {Object} size
	* @return {Number} size.width The width, in pixels.
	* @return {Number} size.height The height, in pixels.
	*/
   function getElementSize(el) {
	 var size = { width: 0, height: 0 };
   
	 while (el) {
	   size.width = el.offsetWidth;
	   size.height = el.offsetHeight;
	   if (size.width > 20 && size.height > 20) break;
	   el = el.parentNode;
	 }
   
	 return size;
   }
   
   /**
	* Trigger a custom event.
	*
	* Note: this approach is deprecated, but still required to support older
	* browsers such as IE 10.
	*
	* @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
	*
	* @param {HTMLElement} el
	*        The element to trigger the event on.
	*
	* @param {String} name
	*        The event name.
	*
	* @returns {Boolean}
	*          True if the event was canceled.
	*/
   function trigger(el, name) {
	 var event = document.createEvent('Event');
	 event.initEvent(name, true, true);
	 return !el.dispatchEvent(event);
   }
   
   /**
	* Return the maximum supported density of the image, given the container.
	*
	* @param {Item} item
	* @param {Size} size
	*/
   function supportedDensity(item, size) {
	 return Math.min(Math.min(Math.max(item.max.width / size.width, 1), item.density), Math.min(Math.max(item.max.height / size.height, 1), item.density)).toFixed(2);
   }
   
   /**
	* Set the image URL on the element. Supports background images and `srcset`.
	*
	* @param {Item} item
	* @param {Size} size
	* @param {Boolean} isPlaceholder
	*/
   function setImage(item, size, isPlaceholder, onLoad) {
	 var render = item.templateRender;
	 var density = isPlaceholder ? 1 : supportedDensity(item, size);
	 var round = isPlaceholder ? 1 : item.round;
   
	 // Calculate the final display size, taking into account the image's
	 // maximum dimensions.
	 var targetWidth = size.width * density;
	 var targetHeight = size.height * density;
   
	 var displaySize = void 0;
   
	 if (item.crop) {
	   displaySize = {
		 width: roundSize(targetWidth, round, item.max.width),
		 height: roundSize(targetHeight, round, item.max.height)
	   };
	 } else {
	   // Shopify serves images clamped by the requested dimensions (fitted to the smallest dimension).
	   // To get the desired and expected pixel density we need to request cover dimensions (fitted to largest dimension).
	   // This isn't a problem with cropped images which are served at the exact dimension requested.
	   var containerAspectRatio = size.width / size.height;
	   var imageAspectRatio = item.max.width / item.max.height;
   
	   if (containerAspectRatio > imageAspectRatio) {
		 // fit width
		 displaySize = {
		   width: roundSize(targetWidth, round, item.max.width),
		   height: roundSize(targetWidth / imageAspectRatio, round, item.max.height)
		 };
	   } else {
		 // fit height
		 displaySize = {
		   width: roundSize(targetHeight * imageAspectRatio, round, item.max.width),
		   height: roundSize(targetHeight, round, item.max.height)
		 };
	   }
	 }
   
	 var url = render(item.template, displaySize);
   
	 // On load callback
	 var image = new Image();
	 image.onload = onLoad;
	 image.src = url;
   
	 // Set image
	 if (item.isBackgroundImage) {
	   item.el.style.backgroundImage = 'url(\'' + url + '\')';
	 } else {
	   item.el.setAttribute('srcset', url + ' ' + density + 'x');
	 }
   }
   
   /**
	* Load the image, set loaded status, and trigger the load event.
	*
	* @fires rimg:load
	* @fires rimg:error
	* @param {Item} item
	* @param {Size} size
	*/
   function loadFullImage(item, size) {
	 var el = item.el;
   
	 setImage(item, size, false, function (event) {
	   if (event.type === 'load') {
		 el.setAttribute('data-rimg', 'loaded');
	   } else {
		 el.setAttribute('data-rimg', 'error');
		 trigger(el, 'rimg:error');
	   }
   
	   trigger(el, 'rimg:load');
	 });
   }
   
   /**
	* Load in a responsive image.
	*
	* Sets the image's `srcset` attribute to the final image URLs, calculated based
	* on the actual size the image is being shown at.
	*
	* @fires rimg:loading
	*        The image URLs have been set and we are waiting for them to load.
	*
	* @fires rimg:loaded
	*        The final image has loaded.
	*
	* @fires rimg:error
	*        The final image failed loading.
	*
	* @param {Item} item
	*/
   function loadImage(item) {
	 var el = item.el;
   
	 // Already loaded?
	 var status = el.getAttribute('data-rimg');
	 if (status === 'loading' || status === 'loaded') return;
   
	 // Is the SVG loaded?
	 // In Firefox, el.complete always returns true so we also check el.naturalWidth,
	 // which equals 0 until the image loads
	 if (el.naturalWidth == 0 && el.complete && !item.isBackgroundImage) {
	   // Wait for the load event, then call load image
	   el.addEventListener('load', function cb() {
		 el.removeEventListener('load', cb);
		 loadImage(item);
	   });
   
	   return;
	 }
   
	 // Trigger loading event, and stop if cancelled
	 if (trigger(el, 'rimg:loading')) return;
   
	 // Mark as loading
	 el.setAttribute('data-rimg', 'loading');
   
	 // Get element size. This is used as the ideal display size.
	 var size = getElementSize(item.el);
   
	 size.width *= item.scale;
	 size.height *= item.scale;
   
	 if (item.placeholder) {
	   // Load a placeholder image first, followed by the full image. Force the
	   // element to keep its dimensions while it loads. If the image is smaller
	   // than the element size, use the image's size. Density is taken into account
	   // for HiDPI devices to avoid blurry images.
	   if (!item.isBackgroundImage) {
		 el.setAttribute('width', Math.min(Math.floor(item.max.width / item.density), size.width));
		 el.setAttribute('height', Math.min(Math.floor(item.max.height / item.density), size.height));
	   }
   
	   setImage(item, item.placeholder, true, function () {
		 return loadFullImage(item, size);
	   });
	 } else {
	   loadFullImage(item, size);
	 }
   }
   
   /**
	* Prepare an element to be displayed on the screen.
	*
	* Images have special logic applied to them to swap out the different sources.
	*
	* @fires rimg:enter
	*        The element is entering the viewport.
	*
	* @param {HTMLElement} el
	* @param {Settings} options
	*/
   function load(el, options) {
	 if (!el) return;
	 trigger(el, 'rimg:enter');
   
	 var item = parseItem(el, options);
   
	 if (item.isImage) {
	   if (!item.isBackgroundImage) {
		 el.setAttribute('data-rimg-template-svg', el.getAttribute('srcset'));
	   }
   
	   loadImage(item);
	 }
   }
   
   /**
	* Reset an element's state so that its image can be recalculated.
	*
	* @fires rimg:update
	*        The element is being updated.
	*
	* @param {HTMLElement} el
	* @param {Settings} options
	*/
   function update(el, options) {
	 if (!el) return;
	 trigger(el, 'rimg:update');
   
	 var item = parseItem(el, options);
   
	 if (item.isImage) {
	   if (!item.isBackgroundImage) {
		 el.setAttribute('data-rimg', 'lazy');
		 el.setAttribute('srcset', el.getAttribute('data-rimg-template-svg'));
	   }
   
	   loadImage(item);
	 }
   }
   
   /**
	* Returns true if the element is within the viewport.
	* @param {HTMLElement} el
	* @returns {Boolean}
	*/
   function inViewport(el) {
	 if (!el.offsetWidth || !el.offsetHeight || !el.getClientRects().length) {
	   return false;
	 }
   
	 var root = document.documentElement;
	 var width = Math.min(root.clientWidth, window.innerWidth);
	 var height = Math.min(root.clientHeight, window.innerHeight);
	 var rect = el.getBoundingClientRect();
   
	 return rect.bottom >= 0 && rect.right >= 0 && rect.top <= height && rect.left <= width;
   }
   
   /**
	* @typedef {Object} Size
	* @property {Number} width
	* @property {Number} height
	*/
   
   /**
	* A function to turn a template string into a URL.
	*
	* @callback TemplateRenderer
	* @param {String} template
	* @param {Size} size
	* @returns {String}
	*/
   
   /**
	* @typedef {Object} Settings
	*
	* @property {String} [template]
	*           A template string used to generate URLs for an image. This allows us to
	*           dynamically load images with sizes to match the container's size.
	*
	* @property {TemplateRenderer} [templateRender]
	*           A function to turn a template string into a URL.
	*
	* @property {Size} [max]
	*           The maximum available size for the image. This ensures we don't
	*           try to load an image larger than is possible.
	* 
	* @property {Number} [scale]
	*           A number to scale the final image dimensions by. 
	*           Only applies to lazy-loaded images. Defaults to 1.
	*
	* @property {Number} [round]
	*           Round image dimensions to the nearest multiple. This is intended to
	*           tax the image server less by lowering the number of possible image
	*           sizes requested.
	*
	* @property {Size} [placeholder]
	*           The size of the lo-fi image to load before the full image.
	* 
	* @property {String} [crop]
	*           Crop value; null if image is uncropped, otherwise equal 
	*           to the Shopify crop parameter ('center', 'top', etc.).
	*/
   
   /**
	* Initialize the responsive image handler.
	*
	* @param {String|HTMLElement|NodeList} selector
	*        The CSS selector, element, or elements to track for lazy-loading.
	*
	* @param {Settings} options
	*
	* @returns {PublicApi}
	*/
   function rimg() {
	 var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
	 var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
   
	 // Intersections
	 var io = new IntersectionObserver(function (entries) {
	   entries.forEach(function (entry) {
		 if (entry.isIntersecting || entry.intersectionRatio > 0) {
		   io.unobserve(entry.target);
		   load(entry.target, options);
		 }
	   });
	 }, {
	   // Watch the viewport, with 20% vertical margins
	   rootMargin: '20% 0px'
	 });
   
	 /**
	  * @typedef {Object} PublicApi
	  */
	 var api = {
	   /**
		* Track a new selector, element, or nodelist for lazy-loading.
		* @type Function
		* @param {String|HTMLElement|NodeList} selector
		*/
	   track: function track() {
		 var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
   
		 var els = querySelector(selector);
   
		 for (var i = 0; i < els.length; i++) {
		   // If an element is already in the viewport, load it right away. This
		   // fixes a race-condition with dynamically added elements.
		   if (inViewport(els[i])) {
			 load(els[i], options);
		   } else {
			 io.observe(els[i]);
		   }
		 }
	   },
   
   
	   /**
		* Update element(s) that have already been loaded to force their images
		* to be recalculated.
		* @type Function
		* @param {String|HTMLElement|NodeList} selector
		*/
	   update: function update$$1() {
		 var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="loaded"]';
   
		 var els = querySelector(selector);
		 for (var i = 0; i < els.length; i++) {
		   update(els[i], options);
		 }
	   },
   
   
	   /**
		* Stop tracking element(s) for lazy-loading.
		* @type Function
		* @param {String|HTMLElement|NodeList} selector
		*/
	   untrack: function untrack() {
		 var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg]';
   
		 var els = querySelector(selector);
		 for (var i = 0; i < els.length; i++) {
		   io.unobserve(els[i]);
		 }
	   },
   
   
	   /**
		* Unload all event handlers and observers.
		* @type Function
		*/
	   unload: function unload() {
		 io.disconnect();
	   }
	 };
   
	 // Add initial elements
	 api.track(selector);
   
	 return api;
   }
   
   /**
	* Finds a group of elements on the page.
	*
	* @param {String|HTMLElement|NodeList} selector
	* @returns {Object} An array-like object.
	*/
   function querySelector(selector) {
	 if (typeof selector === 'string') {
	   return document.querySelectorAll(selector);
	 }
   
	 if (selector instanceof HTMLElement) {
	   return [selector];
	 }
   
	 if (selector instanceof NodeList) {
	   return selector;
	 }
   
	 return [];
   }
   
   /* harmony default export */ var dist_index_es = (rimg);
   
   // CONCATENATED MODULE: ./node_modules/rimg-shopify/dist/index.es.js
   /*!
	* rimg-shopify v2.3.0
	* (c) 2018 Pixel Union
	*/
   
   
   /**
	* Polyfill for Element.matches().
	*
	* @see https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
	*/
   if (!Element.prototype.matches) {
	 Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
	   var matches = (this.document || this.ownerDocument).querySelectorAll(s),
		   i = matches.length;
	   while (--i >= 0 && matches.item(i) !== this) {}
	   return i > -1;
	 };
   }
   
   var state = {
	 init: init,
	 watch: watch,
	 unwatch: unwatch
   };
   
   function init() {
	 var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-rimg="lazy"]';
	 var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
   
	 state.selector = selector;
	 state.instance = dist_index_es(selector, options);
	 state.loadedWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
   
	 // Listen for Shopify theme editor events
	 document.addEventListener('shopify:section:load', function (event) {
	   return watch(event.target);
	 });
   
	 window.addEventListener('resize', function () {
	   return _update();
	 });
   
	 document.addEventListener('shopify:section:unload', function (event) {
	   return unwatch(event.target);
	 });
   
	 // Listen for custom events to allow themes to hook into rimg
	 document.addEventListener('theme:rimg:watch', function (event) {
	   return watch(event.target);
	 });
   
	 document.addEventListener('theme:rimg:unwatch', function (event) {
	   return unwatch(event.target);
	 });
   
	 // Support custom events triggered through jQuery
	 // See: https://github.com/jquery/jquery/issues/3347
	 if (window.jQuery) {
	   jQuery(document).on({
		 'theme:rimg:watch': function themeRimgWatch(event) {
		   return watch(event.target);
		 },
		 'theme:rimg:unwatch': function themeRimgUnwatch(event) {
		   return unwatch(event.target);
		 }
	   });
	 }
   }
   
   /**
	* Track an element, and its children.
	*
	* @param {HTMLElement} el
	*/
   function watch(el) {
	 // Track element
	 if (typeof el.matches === 'function' && el.matches(state.selector)) {
	   state.instance.track(el);
	 }
   
	 // Track element's children
	 state.instance.track(el.querySelectorAll(state.selector));
   }
   
   /**
	* Untrack an element, and its children
	*
	* @param {HTMLElement} el
	* @private
	*/
   function unwatch(el) {
	 // Untrack element's children
	 state.instance.untrack(el.querySelectorAll(state.selector));
   
	 // Untrack element
	 if (typeof el.matches === 'function' && el.matches(state.selector)) {
	   state.instance.untrack(el);
	 }
   }
   
   /**
	* Update an element, and its children.
	*
	* @param {HTMLElement} el
	*/
   function _update() {
	 var currentWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
   
	 // Return if we're not 2x smaller, or larger than the existing loading size
	 if (currentWidth / state.loadedWidth > 0.5 && currentWidth / state.loadedWidth < 2) {
	   return;
	 }
   
	 state.loadedWidth = currentWidth;
	 state.instance.update();
   }
   
   /* harmony default export */ var rimg_shopify_dist_index_es = (state);
   
   // CONCATENATED MODULE: ./source/scripts/utils/jquery.js
   
   window.$ = jquery_default.a;
   window.jQuery = jquery_default.a;
   // EXTERNAL MODULE: ./source/scripts/polyfills/nodeListForEach.js
   var nodeListForEach = __webpack_require__(9);
   
   // CONCATENATED MODULE: ./source/scripts/templates/TemplateAccountAddresses.js
   function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var TemplateAccountAddresses_TemplateAccountAddresses =
   /*#__PURE__*/
   function () {
	 function TemplateAccountAddresses(template) {
	   var _this = this;
   
	   _classCallCheck(this, TemplateAccountAddresses);
   
	   this.el = template.el;
	   this.$el = jquery_default()(this.el);
	   this.countryProvinceSelectors = [];
	   this.toggleForm = jquery_default()('[data-toggle-address-form]', this.$el);
	   this.toggleEdit = jquery_default()('[data-edit-address]', this.$el);
	   this.deleteAddress = jquery_default()('[data-delete-address]', this.$el);
	   this.countryProvinceSelector = new Shopify.CountryProvinceSelector('address-country', 'address-province', {
		 hideElement: 'address-province-container'
	   });
   
	   this._bindEvents();
   
	   var $addresses = jquery_default()('[id^=address-country-]', this.el);
	   $addresses.each(function (index, address) {
		 var $address = jquery_default()(address);
		 var addressId = $address.attr('id').split('-')[2];
   
		 _this.countryProvinceSelectors.push(new Shopify.CountryProvinceSelector("address-country-".concat(addressId), "address-province-".concat(addressId), {
		   hideElement: "address-province-container-".concat(addressId)
		 }));
	   });
	 }
   
	 _createClass(TemplateAccountAddresses, [{
	   key: "_bindEvents",
	   value: function _bindEvents() {
		 this.toggleEdit.each(function (i, el) {
		   jquery_default()(el).on('click', function (e) {
			 e.preventDefault();
			 var addressID = jquery_default()(el).data('edit-address');
			 Shopify.CustomerAddress.toggleForm(addressID);
		   });
		 });
		 this.deleteAddress.each(function (i, el) {
		   jquery_default()(el).on('click', function (e) {
			 e.preventDefault();
			 var addressID = jquery_default()(el).data('delete-address');
			 Shopify.CustomerAddress.destroy(addressID, 'Are you sure you wish to delete this address?');
		   });
		 });
		 this.toggleForm.on('click', function (e) {
		   e.preventDefault();
		   Shopify.CustomerAddress.toggleNewForm();
		 });
	   }
	 }, {
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 this._unbindEvents();
	   }
	 }, {
	   key: "_unbindEvents",
	   value: function _unbindEvents() {
		 this.toggleEdit.each(function (i, el) {
		   jquery_default()(el).off('click');
		 });
		 this.deleteAddress.each(function (i, el) {
		   jquery_default()(el).off('click');
		 });
		 this.toggleForm.off('click');
	   }
	 }]);
   
	 return TemplateAccountAddresses;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/templates/TemplateAccountLogin.js
   function TemplateAccountLogin_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function TemplateAccountLogin_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function TemplateAccountLogin_createClass(Constructor, protoProps, staticProps) { if (protoProps) TemplateAccountLogin_defineProperties(Constructor.prototype, protoProps); if (staticProps) TemplateAccountLogin_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var TemplateAccountLogin_TemplateAccountLogin =
   /*#__PURE__*/
   function () {
	 function TemplateAccountLogin(template) {
	   TemplateAccountLogin_classCallCheck(this, TemplateAccountLogin);
   
	   this.el = template.el;
	   this.$el = jquery_default()(this.el);
	   jquery_default()('.guest-login a', this.el).on('click.account', this.submitGuestCheckout.bind(this));
	 }
   
	 TemplateAccountLogin_createClass(TemplateAccountLogin, [{
	   key: "submitGuestCheckout",
	   value: function submitGuestCheckout() {
		 jquery_default()('#customer_login_guest', this.el).submit();
	   }
	 }, {
	   key: "unload",
	   value: function unload() {
		 jquery_default()('.guest-login a', this.el).off('click.account');
	   }
	 }]);
   
	 return TemplateAccountLogin;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/templates/TemplateGiftCard.js
   function TemplateGiftCard_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function TemplateGiftCard_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function TemplateGiftCard_createClass(Constructor, protoProps, staticProps) { if (protoProps) TemplateGiftCard_defineProperties(Constructor.prototype, protoProps); if (staticProps) TemplateGiftCard_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var TemplateGiftCard_TemplateGiftCard =
   /*#__PURE__*/
   function () {
	 function TemplateGiftCard(template) {
	   TemplateGiftCard_classCallCheck(this, TemplateGiftCard);
   
	   this.el = template.el;
	   this.$el = jquery_default()(this.el);
	   return this.addQrCode();
	 }
   
	 TemplateGiftCard_createClass(TemplateGiftCard, [{
	   key: "addQrCode",
	   value: function addQrCode() {
		 var qrWrapper = jquery_default()('[data-qr-code]', this.el);
		 return new QRCode(qrWrapper[0], {
		   text: qrWrapper.data('qr-code'),
		   width: 120,
		   height: 120
		 });
	   }
	 }]);
   
	 return TemplateGiftCard;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/templates/TemplatePassword.js
   function TemplatePassword_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function TemplatePassword_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function TemplatePassword_createClass(Constructor, protoProps, staticProps) { if (protoProps) TemplatePassword_defineProperties(Constructor.prototype, protoProps); if (staticProps) TemplatePassword_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var TemplatePassword_TemplatePassword =
   /*#__PURE__*/
   function () {
	 function TemplatePassword(template) {
	   var _this = this;
   
	   TemplatePassword_classCallCheck(this, TemplatePassword);
   
	   this.el = template.el;
	   this.$el = jquery_default()(this.el);
	   this.adminLogin = jquery_default()('.password-page-modal-wrapper', this.el);
	   this.adminModal = this.adminLogin.find('.password-page-modal');
	   this.openByDefault = this.adminLogin.find('[data-open-modal]').length;
   
	   if (this.openByDefault) {
		 this.open();
	   }
   
	   jquery_default()('.close', this.el).on('click.password', this.close.bind(this));
	   jquery_default()('.close-modal', this.el).on('click.password', this.close.bind(this));
	   jquery_default()('.admin-login-modal', this.el).on('click.password', this.open.bind(this));
	   jquery_default()(window).on('resize.password', function () {
		 return _this.formatTheModal();
	   });
	 }
   
	 TemplatePassword_createClass(TemplatePassword, [{
	   key: "formatTheModal",
	   value: function formatTheModal() {
		 if (jquery_default()(window).height() <= this.adminModal.outerHeight()) {
		   this.adminModal.css({
			 'margin-top': 0
		   });
		 } else {
		   var offset = (jquery_default()(window).height() - this.adminModal.outerHeight()) / 2;
		   this.adminModal.css({
			 'margin-top': offset
		   });
		 }
	   }
	 }, {
	   key: "open",
	   value: function open() {
		 var _this2 = this;
   
		 jquery_default()('body').css({
		   overflow: 'hidden'
		 }); // Locks the background
   
		 this.adminLogin.show(); // Display modal background
   
		 this.formatTheModal(); // Vertically / horizontally center and resize the modal
   
		 this.adminLogin.fadeTo(200, 1); // Bind the close function to the 'esc' key
   
		 jquery_default()(document).on('keyup.password', function (e) {
		   if (e.keyCode === 27) {
			 _this2.close();
		   }
		 });
	   }
	 }, {
	   key: "close",
	   value: function close(e) {
		 var _this3 = this;
   
		 if (e == null || e.target === e.currentTarget) {
		   this.adminLogin.fadeTo(200, 0, function () {
			 _this3.adminLogin.hide();
		   });
		   jquery_default()(document).off('keyup.password');
		 }
	   }
	 }, {
	   key: "unload",
	   value: function unload() {
		 jquery_default()('.close', this.el).off('click.password');
		 jquery_default()('.close-modal', this.el).off('click.password');
		 jquery_default()('.admin-login-modal', this.el).off('click.password');
		 jquery_default()(window).off('resize.password');
		 jquery_default()(document).off('keyup.password');
	   }
	 }]);
   
	 return TemplatePassword;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/RTE.js
   function RTE_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function RTE_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function RTE_createClass(Constructor, protoProps, staticProps) { if (protoProps) RTE_defineProperties(Constructor.prototype, protoProps); if (staticProps) RTE_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var RTE_RTE =
   /*#__PURE__*/
   function () {
	 function RTE(el) {
	   var _this = this;
   
	   RTE_classCallCheck(this, RTE);
   
	   this.el = el;
	   this.$el = jquery_default()(this.el);
	   this.setupTabs();
	   this.setupVideos();
	   jquery_default()(window).on('resize.rte', function () {
		 return _this.setupVideos();
	   });
	   jquery_default()('.tabs li').on('click.rte', this.switchTabs.bind(this));
	 }
   
	 RTE_createClass(RTE, [{
	   key: "setupVideos",
	   value: function setupVideos() {
		 var videos = this.$el.not('.special').find('iframe, embed, object');
		 var contentWidth = this.$el.width();
   
		 for (var i = 0; i < videos.length; i++) {
		   var $video = jquery_default()(videos[i]);
		   var aspectRatio = $video.height() / $video.width();
		   $video.css({
			 width: contentWidth,
			 height: contentWidth * aspectRatio
		   });
		 }
	   }
	 }, {
	   key: "switchTabs",
	   value: function switchTabs(e) {
		 var tab = jquery_default()(e.currentTarget, this.el);
		 var tabContainer = tab.parent();
		 var tabContentContainer = tabContainer.next();
		 var position = tab.index();
		 var content = tabContentContainer.find('> li').eq(position);
		 tabContainer.find('> li').removeClass('active');
		 tabContentContainer.find('> li').removeClass('active');
		 tab.addClass('active');
		 content.addClass('active'); // We have to re-format videos exclusive to the tabs being opened
		 // in the event that resizing occured while it was hidden.
   
		 var videos = content.find('iframe, embed, object');
		 var contentWidth = content.width();
   
		 for (var i = 0; i < videos.length; i++) {
		   var $video = jquery_default()(videos[i]);
		   var aspectRatio = $video.height() / $video.width();
		   $video.css({
			 width: contentWidth,
			 height: contentWidth * aspectRatio
		   });
		 }
	   }
	 }, {
	   key: "setupTabs",
	   value: function setupTabs() {
		 var tabs = this.$el.find('.tabs');
		 var tabsContent = this.$el.find('.tabs-content');
   
		 if (this.$el.find(':first-child').hasClass('tabs')) {
		   this.$el.parent().addClass('no-border');
		 }
   
		 tabs.find('li:first').addClass('active');
		 return tabsContent.find('li:first').addClass('active');
	   }
	 }, {
	   key: "unload",
	   value: function unload() {
		 jquery_default()(window).off('resize.rte');
		 jquery_default()('.tabs li', this.el).off('click.rte');
	   }
	 }]);
   
	 return RTE;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/DynamicBlog.js
   function DynamicBlog_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function DynamicBlog_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function DynamicBlog_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicBlog_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicBlog_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var DynamicBlog_DynamicBlog =
   /*#__PURE__*/
   function () {
	 function DynamicBlog(section) {
	   DynamicBlog_classCallCheck(this, DynamicBlog);
   
	   this.el = section.el;
	   this.rteEls = this.el.querySelectorAll('.rte');
	   this.rtes = [];
   
	   for (var i = 0; i < this.rteEls.length; i++) {
		 this.rtes.push(new RTE_RTE(this.rteEls[i]));
	   }
	 }
   
	 DynamicBlog_createClass(DynamicBlog, [{
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 this.rtes.forEach(function (rte) {
		   return rte.unload();
		 });
	   }
	 }]);
   
	 return DynamicBlog;
   }();
   
   
   // EXTERNAL MODULE: ./node_modules/shopify-currency-converter/dist/index.js
   var dist = __webpack_require__(2);
   var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
   
   // CONCATENATED MODULE: ./source/scripts/components/AddToCartButton.js
   function AddToCartButton_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function AddToCartButton_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function AddToCartButton_createClass(Constructor, protoProps, staticProps) { if (protoProps) AddToCartButton_defineProperties(Constructor.prototype, protoProps); if (staticProps) AddToCartButton_defineProperties(Constructor, staticProps); return Constructor; }
   
   var AddToCartButton =
   /*#__PURE__*/
   function () {
	 function AddToCartButton(el) {
	   AddToCartButton_classCallCheck(this, AddToCartButton);
   
	   this.states = {
		 default: 'addtocart-button-active',
		 loading: 'addtocart-button-loading',
		 disabled: 'addtocart-button-disabled',
		 error: 'addtocart-button-error'
	   };
	   this.el = el;
	   this.el.classList.add(this.states.default);
	 }
   
	 AddToCartButton_createClass(AddToCartButton, [{
	   key: "setState",
	   value: function setState(state) {
		 var _this = this;
   
		 var keys = Object.keys(this.states);
   
		 if (keys.indexOf(state) > -1) {
		   keys.forEach(function (key) {
			 return _this.el.classList.remove(_this.states[key]);
		   });
		   this.el.classList.add(this.states[state]);
		 }
	   }
	 }, {
	   key: "resetState",
	   value: function resetState() {
		 var _this2 = this;
   
		 var keys = Object.keys(this.states);
		 keys.forEach(function (key) {
		   return _this2.el.classList.remove(_this2.states[key]);
		 });
		 this.el.classList.add(this.states.default);
	   }
	 }]);
   
	 return AddToCartButton;
   }();
   
   
   // CONCATENATED MODULE: ./node_modules/shopify-asyncview/dist/index.es.js
   
	 /*!
	  * shopify-asyncview v1.0.2
	  * (c) 2019 Pixel Union
	 */
   
   var dist_index_es_classCallCheck = function (instance, Constructor) {
	 if (!(instance instanceof Constructor)) {
	   throw new TypeError("Cannot call a class as a function");
	 }
   };
   
   var index_es_createClass = function () {
	 function defineProperties(target, props) {
	   for (var i = 0; i < props.length; i++) {
		 var descriptor = props[i];
		 descriptor.enumerable = descriptor.enumerable || false;
		 descriptor.configurable = true;
		 if ("value" in descriptor) descriptor.writable = true;
		 Object.defineProperty(target, descriptor.key, descriptor);
	   }
	 }
   
	 return function (Constructor, protoProps, staticProps) {
	   if (protoProps) defineProperties(Constructor.prototype, protoProps);
	   if (staticProps) defineProperties(Constructor, staticProps);
	   return Constructor;
	 };
   }();
   
   var index_es_deferred = {};
   
   var AsyncView = function () {
	 function AsyncView() {
	   dist_index_es_classCallCheck(this, AsyncView);
	 }
   
	 index_es_createClass(AsyncView, null, [{
	   key: 'load',
   
	   /**
		* Load the template given by the provided URL into the provided
		* view
		*
		* @param {string} url - The url to load.
		* @param {string} view - The view to load into.
		* @param {object} options - Config options.
		* @param {string} options.hash - A hash of the current page content.
		*/
	   value: function load(url, view) {
		 var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
   
		 var data = void 0;
		 if (url in index_es_deferred) {
		   return index_es_deferred[url];
		 }
   
		 var $deferred = $.Deferred();
   
		 index_es_deferred[url] = $deferred;
   
		 if (options.hash) {
		   data = sessionStorage.getItem(url);
   
		   if (data) {
			 var deserialized = JSON.parse(data);
   
			 if (options.hash === deserialized.options.hash) {
			   delete index_es_deferred[url];
			   return $deferred.resolve(deserialized).promise();
			 }
		   }
		 }
   
		 // NOTE The $.ajax request has the cache option set to false.
		 // This is to prevent certain browsers from returning cached
		 // versions of the url we are requesting.
		 // See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4
		 $.ajax({
		   url: url,
		   cache: false,
		   data: 'view=' + view,
		   dataType: 'html',
		   headers: {
			 'cache-control': 'no-cache'
		   },
		   success: function success(response) {
			 var el = document.createElement('div');
			 el.innerHTML = response;
   
			 var responseOptions = {};
			 var optionsEl = el.querySelector('[data-options]');
   
			 if (optionsEl && optionsEl.innerHTML) {
			   responseOptions = JSON.parse(el.querySelector('[data-options]').innerHTML);
			 }
   
			 var htmls = el.querySelectorAll('[data-html]');
   
			 var html = {};
   
			 if (htmls.length === 1 && htmls[0].getAttribute('data-html') === '') {
			   html = htmls[0].innerHTML;
			 } else {
			   for (var i = 0; i < htmls.length; i++) {
				 html[htmls[i].getAttribute('data-html')] = htmls[i].innerHTML;
			   }
			 }
   
			 if (options.hash) {
			   try {
				 sessionStorage.setItem(url, JSON.stringify({ options: responseOptions, html: html }));
			   } catch (error) {
				 console.error(error);
			   }
			 }
   
			 delete index_es_deferred[url];
			 return $deferred.resolve({ options: responseOptions, html: html });
		   },
		   error: function error() {
			 delete index_es_deferred[url];
			 return $deferred.reject();
		   }
   
		 });
   
		 return $deferred.promise();
	   }
	 }]);
	 return AsyncView;
   }();
   
   /* harmony default export */ var shopify_asyncview_dist_index_es = (AsyncView);
   
   // CONCATENATED MODULE: ./source/scripts/utils/ScrollLock.js
   function ScrollLock_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function ScrollLock_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function ScrollLock_createClass(Constructor, protoProps, staticProps) { if (protoProps) ScrollLock_defineProperties(Constructor.prototype, protoProps); if (staticProps) ScrollLock_defineProperties(Constructor, staticProps); return Constructor; }
   
   var _document = document,
	   documentElement = _document.documentElement,
	   body = _document.body;
   
   function _blockScroll(event) {
	 event.preventDefault();
   }
   
   var LOCKED = false;
   
   var ScrollLock =
   /*#__PURE__*/
   function () {
	 function ScrollLock() {
	   ScrollLock_classCallCheck(this, ScrollLock);
	 }
   
	 ScrollLock_createClass(ScrollLock, null, [{
	   key: "lock",
	   value: function lock() {
		 if (LOCKED) {
		   return;
		 }
   
		 LOCKED = true;
		 documentElement.classList.add('scroll-locked');
		 body.addEventListener('touchmove', _blockScroll, false);
		 body.addEventListener('scroll', _blockScroll, false);
	   }
	 }, {
	   key: "unlock",
	   value: function unlock() {
		 if (!LOCKED) {
		   return;
		 }
   
		 LOCKED = false;
		 documentElement.classList.remove('scroll-locked');
		 body.removeEventListener('touchmove', _blockScroll, false);
		 body.removeEventListener('scroll', _blockScroll, false);
	   }
	 }]);
   
	 return ScrollLock;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/CartMini.js
   function CartMini_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function CartMini_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function CartMini_createClass(Constructor, protoProps, staticProps) { if (protoProps) CartMini_defineProperties(Constructor.prototype, protoProps); if (staticProps) CartMini_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   var instance = null;
   
   var CartMini_CartMini =
   /*#__PURE__*/
   function () {
	 function CartMini() {
	   var _this = this;
   
	   CartMini_classCallCheck(this, CartMini);
   
	   if (instance) {
		 return instance;
	   }
   
	   instance = this;
	   this.el = document.querySelector('[data-cart-mini]');
	   this.sidebar = this.el.querySelector('[data-cart-mini-sidebar]');
	   this.sidebarClose = this.el.querySelector('[data-cart-mini-close]');
	   this.content = this.el.querySelector('[data-cart-mini-content]');
	   this.footer = this.el.querySelector('[data-cart-mini-footer]');
	   this.refresh().done(function () {
		 _this.el.addEventListener('click', _this.close.bind(_this));
   
		 _this.sidebar.addEventListener('click', function (e) {
		   return e.stopPropagation();
		 });
   
		 _this.sidebarClose.addEventListener('click', _this.close.bind(_this));
	   });
	 }
   
	 CartMini_createClass(CartMini, [{
	   key: "open",
	   value: function open() {
		 this.el.classList.add('cart-mini-open');
		 ScrollLock.lock();
	   }
	 }, {
	   key: "close",
	   value: function close() {
		 this.el.classList.remove('cart-mini-open');
		 ScrollLock.unlock();
	   }
	 }, {
	   key: "removeItem",
	   value: function removeItem(lineItem) {
		 var _this2 = this;
   
		 var $item = jquery_default()("[data-cart-mini-item=\"".concat(lineItem, "\"]"), this.el);
		 $item.addClass('cart-mini-item-loading');
		 jquery_default.a.post('/cart/change.js', {
		   id: lineItem,
		   quantity: 0
		 }, function () {
		   if (document.querySelector('[data-section-id="static-cart"]')) {
			 // If we remove an item from minicart while on the cart page,
			 // refresh the page to sync cart items on page
			 window.location = '/cart';
		   } else {
			 _this2.refresh();
		   }
		 }, 'json');
	   }
	 }, {
	   key: "refresh",
	   value: function refresh() {
		 var _this3 = this;
   
		 var $deferred = jquery_default.a.Deferred();
		 this.el.classList.remove('cart-mini-loaded');
		 jquery_default()('[data-cart-mini-item-remove]', this.el).off('click.cart-mini');
		 var $deferred1 = jquery_default.a.get('/cart.js', function (data) {
		   return jquery_default()('[data-cart-mini-count]').text(data.item_count === 0 ? '0' : data.item_count);
		 }, 'json');
		 var $deferred2 = shopify_asyncview_dist_index_es.load('/cart', 'mini').done(function (data) {
		   _this3.content.innerHTML = data.html.content;
		   _this3.footer.innerHTML = data.html.footer;
		   jquery_default()('[data-cart-mini-item-remove]', _this3.el).on('click.cart-mini', function (event) {
			 _this3.removeItem(event.currentTarget.getAttribute('data-cart-mini-item-remove'));
		   });
   
		   _this3.el.querySelectorAll('.money').forEach(function (money) {
			 return dist_default.a.update(money);
		   });
   
		   _this3.el.classList.add('cart-mini-loaded');
   
		   return $deferred.resolve();
		 }).fail($deferred.reject());
		 return jquery_default.a.when($deferred1, $deferred2);
	   }
	 }]);
   
	 return CartMini;
   }();
   
   
   // EXTERNAL MODULE: ./node_modules/jquery-trend/jquery.trend.js
   var jquery_trend = __webpack_require__(3);
   
   // EXTERNAL MODULE: ./node_modules/jquery-revealer/jquery.revealer.js
   var jquery_revealer = __webpack_require__(10);
   
   // CONCATENATED MODULE: ./node_modules/shopify-variants/dist/shopify-variants.es.js
   
   /*!
	* shopify-variants v1.0.0
	* (c) 2018 Pixel Union
	*/
   
   
   
   var shopify_variants_es_classCallCheck = function (instance, Constructor) {
	 if (!(instance instanceof Constructor)) {
	   throw new TypeError("Cannot call a class as a function");
	 }
   };
   
   var shopify_variants_es_createClass = function () {
	 function defineProperties(target, props) {
	   for (var i = 0; i < props.length; i++) {
		 var descriptor = props[i];
		 descriptor.enumerable = descriptor.enumerable || false;
		 descriptor.configurable = true;
		 if ("value" in descriptor) descriptor.writable = true;
		 Object.defineProperty(target, descriptor.key, descriptor);
	   }
	 }
   
	 return function (Constructor, protoProps, staticProps) {
	   if (protoProps) defineProperties(Constructor.prototype, protoProps);
	   if (staticProps) defineProperties(Constructor, staticProps);
	   return Constructor;
	 };
   }();
   
   var shopify_variants_es_toConsumableArray = function (arr) {
	 if (Array.isArray(arr)) {
	   for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
   
	   return arr2;
	 } else {
	   return Array.from(arr);
	 }
   };
   
   var Node = function () {
	 function Node(variant) {
	   shopify_variants_es_classCallCheck(this, Node);
   
	   this.variant = variant;
	   this.optionsCount = this.variant.options.length;
	   this.neighbors = [];
   
	   for (var i = 0; i < this.optionsCount; i++) {
		 this.neighbors.push([]);
	   }
	 }
   
	 shopify_variants_es_createClass(Node, [{
	   key: "addNeighbor",
	   value: function addNeighbor(variant) {
		 for (var i = 0; i < this.optionsCount; i++) {
		   if (this.variant.options[i] !== variant.options[i]) {
			 this.neighbors[i].push(variant);
			 break;
		   }
		 }
	   }
	 }, {
	   key: "getValidOptions",
	   value: function getValidOptions() {
		 var _this = this;
   
		 var options = [];
   
		 var _loop = function _loop(i) {
		   var variants = [_this.variant].concat(shopify_variants_es_toConsumableArray(_this.neighbors[i]));
		   options[i] = {};
   
		   variants.forEach(function (item) {
			 var variant = item;
			 var option = variant.options[i];
   
			 options[i][option] = {
			   available: options[i][option] && options[i][option].available || variant.available
			 };
		   });
		 };
   
		 for (var i = 0; i < this.optionsCount; i++) {
		   _loop(i);
		 }
   
		 return options;
	   }
	 }]);
	 return Node;
   }();
   
   var Options = function () {
	 function Options(product) {
	   shopify_variants_es_classCallCheck(this, Options);
   
	   this.productHandle = product.handle;
	   this.optionsCount = product.options.length;
	   this.variants = product.variants;
	   this.nodeMap = {};
   
	   this._generateNodeMap(product);
	 }
   
	 shopify_variants_es_createClass(Options, [{
	   key: "_generateNodeMap",
	   value: function _generateNodeMap() {
		 var _this2 = this;
   
		 this.variants.forEach(function (variant) {
		   _this2.nodeMap[variant.id] = new Node(variant);
   
		   _this2.variants.forEach(function (variant2) {
			 _this2.nodeMap[variant.id].addNeighbor(variant2);
		   });
		 });
	   }
	 }, {
	   key: "getVariantFromOptions",
	   value: function getVariantFromOptions(options) {
		 var variant = null;
		 this.variants.forEach(function (potentialVariant) {   
		   for (var i = 0; i < potentialVariant.options.length; i++) {
			 if (options[i] == potentialVariant.options[i]) {
				variant =  potentialVariant;
			}
		   }
		 });
		 return variant || false;
	   }
	 }, {
	   key: "getClosestVariantFromOptions",
	   value: function getClosestVariantFromOptions(options) {
		 var closestVariant = null;
		 var matchingValues = 0;
   
		 this.variants.forEach(function (variant) {
		   var tempMatchingValues = 0;
   
		   for (var i = 0; i < variant.options.length; i++) {
			 if (options[i] === variant.options[i]) {
			   tempMatchingValues++;
			 } else {
			   break;
			 }
		   }
   
		   if (tempMatchingValues >= matchingValues) {
			 closestVariant = variant;
			 matchingValues = tempMatchingValues;
		   }
		 });
   
		 return closestVariant ? closestVariant : false;
	   }
	 }, {
	   key: "getVariantOrClosestFromOptions",
	   value: function getVariantOrClosestFromOptions(options) {
		 return this.getVariantFromOptions(options) || this.getClosestVariantFromOptions(options);
	   }
	 }, {
	   key: "getAvailableOptionsFromVariant",
	   value: function getAvailableOptionsFromVariant(variant) {
		 return this.nodeMap[variant.id].getValidOptions();
	   }
	 }]);
	 return Options;
   }();
   
   var shopify_variants_es_Variants = function () {
	 function Variants(product, $variants, $options) {
	   shopify_variants_es_classCallCheck(this, Variants);
   
	   this.product = product;
	   this.optionsCount = this.product.options.length;
	   this.$variants = $variants;
	   this.$options = $options;
	   this.options = new Options(this.product);
	   this.optionsTypes = {
		 select: 'select',
		 radio: 'input[type="radio"]'
	   };
   
	   this._bindEvents();
   
	   if (this.$options.is(this.optionsTypes.select)) {
		 this.optionsType = this.optionsTypes.select;
	   } else if (this.$options.is(this.optionsTypes.radio)) {
		 this.optionsType = this.optionsTypes.radio;
	   } else {
		 console.warn('Shopify Variants: Option set is not a valid type');
		 this._unbindEvents();
	   }
   
	   this._switchVariant(true);
	 }
   
	 shopify_variants_es_createClass(Variants, [{
	   key: '_bindEvents',
	   value: function _bindEvents() {
		 var _this = this;
   
		 this.$options.on('change.variants', function () {
		   return _this._switchVariant();
		 });
	   }
	 }, {
	   key: '_unbindEvents',
	   value: function _unbindEvents() {
		 this.$options.off('change.variants');
	   }
	 }, {
	   key: '_switchVariant',
	   value: function _switchVariant() {
		 var firstLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
   
		 var options = [];
		 var product = this.product;
   
		 var variant = null;
		 var availableOptions = null;
		 let mql = window.matchMedia('(max-width: 576px)');

		 if (this.optionsType === this.optionsTypes.select) {
		   this.$options.each(function (i, option) {
			 options.push(option.value);
		   });
		 } else if (this.optionsType === this.optionsTypes.radio) {
			 this.$options.filter(':checked').each(function (i, option) {
				if (mql.matches) {
				   if(option.closest('.product-detailed-mobile-view')){
					   options.push(option.value);
				   }
			   }
			   else{
				if(!option.closest('.product-detailed-mobile-view')){
					options.push(option.value);
				}
			   }
			});
		 } else {
		   return;
		 }
		 variant = this.options.getVariantOrClosestFromOptions(options);
   
		 if (variant) {
		   availableOptions = this.options.getAvailableOptionsFromVariant(variant);
		 } else {
		   return;
		 }
   
		 if (this.optionsType === this.optionsTypes.select) {
		   this._switchVariantSelect(variant, availableOptions);
		 } else if (this.optionsType === this.optionsTypes.radio) {
		   this._switchVariantRadio(variant, availableOptions);
		 } else {
		   return;
		 }
		 this.$variants.val(variant.id);
		 jquery_default()(window).trigger('shopify-variants:switch-variant', { product: product, variant: variant, firstLoad: firstLoad });
	   }
	 }, {
	   key: '_switchVariantSelect',
	   value: function _switchVariantSelect(variant, availableOptions) {
		 var _this2 = this;
		 var _loop = function _loop(i) {
		   // Corresponding select dropdown
		   var $select = jquery_default()(_this2.$options[i]);
		   var $optionEls = $select.find('option');
		   // Iterate over each option on dropdown
		   $optionEls.each(function (index, option) {
			 var $option = jquery_default()(option);
			 var value = option.value;
   
			 // Not an available option
   
			 $option.prop('disabled', !availableOptions[i][value] || !availableOptions[i][value].available).prop('selected', false);
   
			 // Dropdown option matches variant option
			 if (variant.options[i] === value) {
			   $option.prop('disabled', false).prop('selected', true);
			 }
		   });
		 };
   
		 // Iterate over each option type
		 for (var i = 0; i < this.product.options.length; i++) {
		   _loop(i);
		 }
	   }
	 }, {
	   key: '_switchVariantRadio',
	   value: function _switchVariantRadio(variant, availableOptions) {
		 var _this3 = this;
   
		 this.$options.attr('disabled', true).prop('checked', false).attr('data-soldout', false);
   
		 var _loop2 = function _loop2(i) {
		   var selector = encodeURIComponent(_this3.product.options[i]).replace(/%20/g, '+').replace(/[!'()*]/g, function (char) {
			 return '%' + char.charCodeAt(0).toString(16).toUpperCase();
		   });
		   var $options = _this3.$options.filter('[name="' + selector + '"]');
		   $options.each(function (index, option) {
			 var $option = jquery_default()(option);
			 if (variant.options[i] === $option.val()) {
			   $option.prop('checked', true);
			 }
			 if (availableOptions[i][$option.val()]) {
				 $option.attr('disabled', false);
   
			   if (!availableOptions[i][$option.val()].available) {
				 $option.attr('disabled', true);
				 $option.attr('data-soldout', true);
			   }
			 }
		   });
		 };
   
		 for (var i = 0; i < this.product.options.length; i++) {
		   _loop2(i);
		 }
	   }
	 }, {
	   key: 'isDefault',
	   value: function isDefault() {
		 if (this.product.variants[0].title === 'Default Title' && this.product.variants[0].option1 === 'Default Title') {
		   return true;
		 }
   
		 return false;
	   }
	 }, {
	   key: 'hasSingleOption',
	   value: function hasSingleOption() {
		 return this.optionsCount === 1;
	   }
	 }, {
	   key: 'getSelectedVariant',
	   value: function getSelectedVariant() {
		 if (this.isDefault()) {
		   return this.product.variants[0];
		 }
   
		 var options = [];
   
		 if (this.optionsType === this.optionsTypes.select) {
		   this.$options.each(function (i, option) {
			 options.push(option.value);
		   });
		 } else if (this.optionsType === this.optionsTypes.radio) {
		   this.$options.filter(':checked').each(function (i, option) {
			 options.push(option.value);
		   });
		 } else {
		   return null;
		 }
   
		 return this.options.getVariantFromOptions(options);
	   }
	 }, {
	   key: 'unload',
	   value: function unload() {
		 this._unbindEvents();
	   }
	 }]);
	 return Variants;
   }();
   
   /* harmony default export */ var shopify_variants_es = (shopify_variants_es_Variants);
   
   // EXTERNAL MODULE: ./node_modules/photoswipe/dist/photoswipe.js
   var photoswipe = __webpack_require__(4);
   var photoswipe_default = /*#__PURE__*/__webpack_require__.n(photoswipe);
   
   // EXTERNAL MODULE: ./node_modules/photoswipe/dist/photoswipe-ui-default.js
   var photoswipe_ui_default = __webpack_require__(5);
   var photoswipe_ui_default_default = /*#__PURE__*/__webpack_require__.n(photoswipe_ui_default);
   
   // CONCATENATED MODULE: ./source/scripts/components/ImageZoom.js
   function ImageZoom_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function ImageZoom_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function ImageZoom_createClass(Constructor, protoProps, staticProps) { if (protoProps) ImageZoom_defineProperties(Constructor.prototype, protoProps); if (staticProps) ImageZoom_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var photoswipeEl = document.querySelector('[data-photoswipe]');
   
   var ImageZoom_ImageZoom =
   /*#__PURE__*/
   function () {
	 function ImageZoom(images) {
	   ImageZoom_classCallCheck(this, ImageZoom);
   
	   this.images = images;
	 }
   
	 ImageZoom_createClass(ImageZoom, [{
	   key: "open",
	   value: function open() {
		 var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		 var imageId = parseInt(image.getAttribute('data-image-zoom'), 10);
		 var index = 0;
   
		 if (imageId != null) {
		   for (var i = 0; i < this.images.length; i++) {
			 if (this.images[i].id === imageId) {
			   index = i;
			   break;
			 }
		   }
		 }
   
		 var options = {
		   arrowEl: false,
		   barsSize: {
			 top: 0,
			 bottom: 'auto'
		   },
		   captionEl: false,
		   clickToCloseNonZoomable: false,
		   closeOnScroll: false,
		   counterEl: false,
		   fullscreenEl: false,
		   getThumbBoundsFn: function getThumbBoundsFn() {
			 // get window scroll Y
			 var pageYScroll = window.pageYOffset || document.documentElement.scrollTop; // get position of element relative to viewport
   
			 var rect = image.getBoundingClientRect();
			 return {
			   x: rect.left,
			   y: rect.top + pageYScroll,
			   w: rect.width
			 };
		   },
		   index: index,
		   shareEl: false,
		   showHideOpacity: true,
		   timeToIdle: false,
		   timeToIdleOutside: false,
		   zoomEl: false
		 }; // Initializes and opens PhotoSwipe
   
		 this.photoswipe = new photoswipe_default.a(photoswipeEl, photoswipe_ui_default_default.a, this.images, options);
		 this.photoswipe.init();
	   }
	 }, {
	   key: "close",
	   value: function close() {
		 if (this.photoswipe) {
		   this.photoswipe.close();
		 }
	   }
	 }, {
	   key: "unload",
	   value: function unload() {
		 this.close();
	   }
	 }]);
   
	 return ImageZoom;
   }();
   
   // CONCATENATED MODULE: ./source/scripts/components/Product.js
   function Product_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function Product_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function Product_createClass(Constructor, protoProps, staticProps) { if (protoProps) Product_defineProperties(Constructor.prototype, protoProps); if (staticProps) Product_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   
   
   
   
   
   
   var Product_Product =
   /*#__PURE__*/
   function () {
	 function Product(component) {
	   var _this = this;
   
	   Product_classCallCheck(this, Product);
   
	   this.el = component.el;
	   this.$el = jquery_default()(this.el);
	   this.data = component.data;
	//    this.onScroll = this.onScroll.bind(this);
	//    this.imagesJson = JSON.parse(this.el.querySelector('[data-images]').innerHTML);
	   this.window = jquery_default()(window);
	   this.productArea = jquery_default()('.product_form__container', this.el);
	//    this.thumbsCount = this.productArea.find('.thumb').length;
	//    this.productImages = this.productArea.find('.product-images');
	//    this.productMainImage = jquery_default()('.product-main-image', this.el);
	//    this.productDetailsWrapper = this.productArea.find('.product-details-wrapper');
	//    this.productDetails = this.productArea.find('.product-details');
	//    this.$productToggleFullview = jquery_default()('.product-toggle-fullview', this.el);
   
   
	   this.addToCartTrigger = this.el.querySelector('[data-product-submit]');
	   this.addToCartButton = new AddToCartButton(this.addToCartTrigger);
	   this.cartMini = new CartMini_CartMini();
	   this.processing = false;
   
   
	   this.eventId = "product-".concat(this.el.id);
   
	   this.window.on("shopify-variants:switch-variant.".concat(this.eventId), function (event, data) {
		 return _this._onVariantSwitch(data.product, data.variant);
	   });
	   this.setupVariants();
   
	   if (window.Shopify && Shopify.PaymentButton) {
		 Shopify.PaymentButton.init();
	   }
   
	   jquery_default()('.product_form__container .submit', this.el).on('click.product', function (e) {
		 e.preventDefault();
   
		 _this.addToCart();
	   });
	   jquery_default()('.product_form__container .single-option-selector', this.el).on('change.product', this.resetErrors.bind(this));

	 }
   
	 Product_createClass(Product, [{
	   key: "setupVariants",
	   value: function setupVariants() {
		 var $variants = jquery_default()('[data-variants]', this.el);
		 var $options = jquery_default()('[data-product-option]', this.el);
   
		 if ($variants.length && $options.length) {
		   this.variantHelpers = new shopify_variants_es(this.data.product, $variants, $options);
		 } else {
		   // Products with variants are converted by the initial variant switch,
		   // but product without need to be converted, if they haven't already
		   this.el.querySelectorAll('.money:not([data-currency])').forEach(function (money) {
			 return dist_default.a.update(money);
		   });
		 }
	   }
	 }, {
	   key: "handleErrors",
	   value: function handleErrors(response) {
		 var _this2 = this;
   
		 var error = JSON.parse(response.responseText);
		 jquery_default()('[data-product-form]', this.el).append("<div class=\"error-message\">".concat(error.description, "</div>"));
		 this.timeout = setTimeout(function () {
		   _this2.processing = false;
   
		   _this2.addToCartButton.setState('error');
   
		   setTimeout(function () {
			 return _this2.addToCartButton.resetState();
		   }, 1000);
		 }, 1000);
	   }
	 }, {
	   key: "resetErrors",
	   value: function resetErrors() {
		 jquery_default()('.error-message', this.el).remove();
		 this.processing = false;
	   }
	 }, {
	   key: "addToCart",
	   value: function addToCart() {
			var _this3 = this;
		
			if (this.processing) {
				return;
			} // Connect error handler
			// We need to do this each time because the quickshop might override it

			var addToCartCallback = () => {
				Shopify.onError = function (XMLHttpRequest) {
					return _this3.handleErrors(XMLHttpRequest);
				};
			
				this.resetErrors();
				this.processing = true;
				this.addToCartButton.setState('loading');
				jquery_default.a.ajax({
					type: 'POST',
					url: '/cart/add.js',
					data: jquery_default()('[data-product-form]', this.el).serialize(),
					success: () => {
						Shopify.getCart(newCart => {
							checkGWP(newCart, () => {
								if (_this3.data.productSettings.cartRedirect) {
									window.location = '/cart';
									return;
								}

								_this3.cartMini.refresh();
								_this3.addToCartButton.setState('success');
								_this3.cartMini.open();
								_this3.addToCartButton.resetState();
								_this3.processing = false;
							})
						})
					},
					error: this.handleErrors.bind(this),
					dataType: 'json'
				});
			}

			if (window.settings.maximumItemQuantityPerOrder.enabled) {
				Shopify.getCart(cart => {
					var itemId = this.el.querySelector('[name="id"]').value;
					var currentItemQuantity = cart.items.find(item => item.id == itemId)?.quantity || 0;
					var itemQuantity = parseInt(this.el.querySelector('[name="quantity"]').value);
					
					if ((currentItemQuantity + itemQuantity) > window.settings.maximumItemQuantityPerOrder.maximumItemQuantity) {
						document.getElementById('cart_maximum_item_popup').classList.add('visible');
					} else {
						addToCartCallback();
					}
				})
			} else {
				addToCartCallback();
			}
		}
	 }, {
	   key: "unload",
	   value: function unload() {
		 clearTimeout(this.timeout);
		 clearTimeout(this.timeout2);
		 clearTimeout(this.timeout3);
		 this.window.off(".".concat(this.eventId));
		 jquery_default()(document).off('click.product');
		 jquery_default()('.product_form__container .thumb', this.el).off('click.product');
		 jquery_default()('.product_form__container .submit', this.el).off('click.product');
		 jquery_default()('.modal-wrap .close', this.el).off('click.product');
		 jquery_default()('.product_form__container .single-option-selector', this.el).off('change.product');
   
		 if (this.variantHelpers) {
		   this.variantHelpers.unload();
		 }
   
		 if (this.imageZoom) {
		   this.imageZoom.unload();
		 }
   
		 if (this.shareThis) {
		   this.sharethis.unload();
		 }
	   }
	 }, {
	   key: "_onVariantSwitch",
	   value: function _onVariantSwitch(product, variant) {
		 if (product !== this.data.product) {
		   return;
		 }
   
		 var options = variant.options;
		 var $options = jquery_default()('[data-product-option]', this.el);
		 options.forEach(function (option, index) {
		   $options.eq(index).siblings('[data-selected-option]').text(option);
		 });
		 jquery_default()('[data-product-variant-sku]', this.el).text(variant.sku || '');
   
		 this._updatePrice(variant);
   
		 this._updateImages(variant);
   
		 this._updateHistory(variant);
	   }
	 }, {
	   key: "_updateImages",
	   value: function _updateImages(variant) {
		 var imageId = (variant.featured_image || this.data.product.featured_image).id;
   
		 if (imageId == null) {
		   return;
		 }
	   }
	 }, {
	   key: "_updatePrice",
	   value: function _updatePrice(variant) {
		 var $addToCartButton = jquery_default()('[data-product-submit]', this.productArea);
		 var $priceFields = jquery_default()('.product-details .price', this.productArea);
   
		 if (variant) {
		   if (variant.available) {
			 $addToCartButton.val(this.data.productSettings.addToCartText).removeClass('disabled').removeAttr('disabled');
		   } else {
			 $addToCartButton.val(this.data.productSettings.soldOutText).addClass('disabled').attr('disabled', 'disabled');
		   }
   
		   console.log(this.data.moneyFormat);
		   if (variant.compare_at_price > variant.price) {
			 $priceFields.find('.money:not(.original)').html(window.Shopify.formatMoney(variant.price, this.data.moneyFormat));
			 $priceFields.find('.money.original').html(window.Shopify.formatMoney(variant.compare_at_price, this.data.moneyFormat)).removeClass('hidden');
		   } else {
			 $priceFields.find('.money:not(.original)').html(window.Shopify.formatMoney(variant.price, this.data.moneyFormat));
			 $priceFields.find('.money.original').addClass('hidden');
		   }
		 } else {
		   // Variant doesn't exist
		   $addToCartButton.val(this.data.productSettings.unavailableText).addClass('disabled').attr('disabled', 'disabled');
		 }
   
		 $priceFields.find('.money').each(function (index, element) {
		   return dist_default.a.update(element);
		 });
	   }
	 }, {
	   key: "_updateHistory",
	   value: function _updateHistory(variant) {
		 if (!this.data.productSettings.enableHistory || variant == null) {
		   return;
		 }
   
		 var newUrl = [window.location.protocol, '//', window.location.host, window.location.pathname, '?variant=', variant.id];
		 var variantUrl = newUrl.join('');
		 window.history.replaceState({
		   path: variantUrl
		 }, '', variantUrl);
	   }
	 }]);
   
	 return Product;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/Quickshop.js
   function Quickshop_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function Quickshop_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function Quickshop_createClass(Constructor, protoProps, staticProps) { if (protoProps) Quickshop_defineProperties(Constructor.prototype, protoProps); if (staticProps) Quickshop_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   var DEBUG = false;
   var Quickshop_instance = null;
   
   function _onContentClick(event) {
	 event.stopPropagation();
   }
   
   var Quickshop_Quickshop =
   /*#__PURE__*/
   function () {
	 function Quickshop() {
	   Quickshop_classCallCheck(this, Quickshop);
   
	   if (Quickshop_instance) {
		 return Quickshop_instance;
	   }
   
	   this.instance = this;
	   this.el = document.querySelector('[data-quickshop]');
	   this.contentEl = document.querySelector('[data-quickshop-content]');
	   this.closeEl = document.querySelector('[data-quickshop-close]');
	   this.injectEl = document.querySelector('[data-quickshop-product-inject]');
	   this.settingsSha256 = this.el.getAttribute('data-quickshop-settings-sha256');
	   this.useCaching = !DEBUG && !(window.Shopify && window.Shopify.designMode);
	   this.deferred = {};
	   this.onCloseClick = this.close.bind(this);
	 }
   
	 Quickshop_createClass(Quickshop, [{
	   key: "open",
	   value: function open(url, productSha256) {
		 var _this = this;
   
		 var $deferred = jquery_default.a.Deferred();
		 var $scripts = jquery_default()('[data-scripts]');
		 this.el.addEventListener('click', this.onCloseClick);
		 this.contentEl.addEventListener('click', _onContentClick);
		 this.closeEl.addEventListener('click', this.onCloseClick);
		 this.el.classList.add('quickshop-visible');
		 script_default()($scripts.data('shopify-api-url'), function () {
		   shopify_asyncview_dist_index_es.load(url, 'ajax', {
			 hash: "".concat(productSha256).concat(_this.settingsSha256)
		   }).done(function (data) {
			 _this.injectEl.innerHTML = data.html;
   
			 var images = _this.el.querySelector('.showcase');
   
			 rimg_shopify_dist_index_es.watch(images);
			 _this.product = new Product_Product({
			   el: _this.injectEl,
			   data: data.options
			 });
			 ScrollLock.lock();
   
			 _this.el.classList.add('quickshop-loaded');
   
			 return $deferred.resolve();
		   }).fail($deferred.reject());
		 });
		 return $deferred.promise();
	   }
	 }, {
	   key: "close",
	   value: function close() {
		 if (this.product != null) {
		   this.product.unload();
		 }
   
		 if (this.rte != null) {
		   this.rte.unload();
		 }
   
		 ScrollLock.unlock();
		 this.el.removeEventListener('click', this.onCloseClick);
		 this.contentEl.removeEventListener('click', _onContentClick);
		 this.closeEl.removeEventListener('click', this.onCloseClick);
		 this.el.classList.remove('quickshop-loaded');
		 this.el.classList.remove('quickshop-visible');
	   }
	 }, {
	   key: "unload",
	   value: function unload() {
		 this.close();
		 this.instance = null;
	   }
	 }]);
   
	 return Quickshop;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/ProductItem.js
   function ProductItem_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function ProductItem_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function ProductItem_createClass(Constructor, protoProps, staticProps) { if (protoProps) ProductItem_defineProperties(Constructor.prototype, protoProps); if (staticProps) ProductItem_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   var ProductItem_ProductItem =
   /*#__PURE__*/
   function () {
	 function ProductItem(el) {
	   var _this = this;
   
	   ProductItem_classCallCheck(this, ProductItem);
   
	   this.el = el;
	   this.cartMini = new CartMini_CartMini();
	   this.quickshopTrigger = this.el.querySelector('[data-product-card-interaction-quickshop]');
	   this.addToCartTrigger = this.el.querySelector('[data-product-card-interaction-addtocart]');
	   this.el.querySelectorAll('.money:not([data-currency])').forEach(function (money) {
		 return dist_default.a.update(money);
	   });
   
	   if (this.quickshopTrigger) {
		 this.quickshopProductUrl = this.quickshopTrigger.getAttribute('data-product-url');
		 this.quickshopProductSha256 = this.quickshopTrigger.getAttribute('data-product-sha256');
		 this.quickshop = new Quickshop_Quickshop();
		 jquery_default()(this.quickshopTrigger).on('click', function (event) {
		   event.preventDefault();
   
		   _this.quickshop.open(_this.quickshopProductUrl, _this.quickshopProductSha256);
		 });
	   }
   
	   if (this.addToCartTrigger) {
		 this.addToCartButton = new AddToCartButton(this.addToCartTrigger);
		 this.addToCartVariantId = this.addToCartTrigger.getAttribute('data-product-variant-id');
		 jquery_default()(this.addToCartTrigger).on('click', function (event) {
		   event.preventDefault();
   
		   _this.addToCartButton.setState('loading');
   
		   if (window.settings.maximumItemQuantityPerOrder.enabled) {
			   Shopify.getCart(cart => {
				var itemId = this.getAttribute('data-product-variant-id')
				var currentItemQuantity = cart.items.find(item => item.id == itemId)?.quantity || 0;
				var maxQuantity = window.settings.maximumItemQuantityPerOrder.maximumItemQuantity 
				console.log(this.getAttribute('max-quantity-items'))
				if (this.getAttribute('max-quantity-items') !== null){
					maxQuantity = this.getAttribute('max-quantity-items')
				}

				if ((currentItemQuantity + 1) > maxQuantity) {
					document.getElementById('cart_maximum_item_popup').classList.add('visible');
					document.getElementById('cart_maximum_item_popup').querySelector('.copy span').innerHTML = maxQuantity
					_this.addToCartButton.resetState();
				} else {
					addToCartCallback();
				}
			})
		} else {
			addToCartCallback();
		}

		function addToCartCallback(){
			jquery_default.a.ajax({
				type: 'POST',
				url: '/cart/add.js',
				data: {
				  id: _this.addToCartVariantId,
				  quantity: 1
				},
				success: () => {
				   Shopify.getCart(cart => {
					   checkGWP(cart, () => {
						   _this.cartMini.refresh();
   
						   setTimeout(() => {
							   _this.addToCartButton.setState('success');
							   _this.cartMini.open();
							   setTimeout(() => {
								   return _this.addToCartButton.resetState();
							   }, 1000);
						   }, 1000);
					   });
				   });
				},
				error: function error() {
				  return setTimeout(function () {
					_this.addToCartButton.setState('error');
	  
					setTimeout(function () {
					  return _this.addToCartButton.resetState();
					}, 1000);
				  }, 1000);
				},
				dataType: 'json'
			  });
			}
		 });
	   }
	 }
   
	 ProductItem_createClass(ProductItem, [{
	   key: "unload",
	   value: function unload() {
		 jquery_default()('[data-product-card-interaction-quickshop]', this.el).off('click');
		 jquery_default()('[data-product-card-interaction-addtocart]', this.el).off('click');
   
		 if (this.addToCartButton) {
		   this.addToCartButton.resetState();
		 }
   
		 this.addToCartButton = null;
	   }
	 }]);
   
	 return ProductItem;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/DynamicCollection.js
   function DynamicCollection_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function DynamicCollection_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function DynamicCollection_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicCollection_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicCollection_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var DynamicCollection_DynamicCollection =
   /*#__PURE__*/
   function () {
	 function DynamicCollection(section) {
	   DynamicCollection_classCallCheck(this, DynamicCollection);
   
	   this.el = section.el;
	   this.productEls = this.el.querySelectorAll('[data-product-item]');
	   this.products = [];
	   this.rteEls = this.el.querySelectorAll('.rte');
	   this.rtes = [];
   
	   for (var i = 0; i < this.productEls.length; i++) {
		 this.products.push(new ProductItem_ProductItem(this.productEls[i]));
	   }
   
	   for (var _i = 0; _i < this.rteEls.length; _i++) {
		 this.rtes.push(new RTE_RTE(this.rteEls[_i]));
	   }
	 }
   
	 DynamicCollection_createClass(DynamicCollection, [{
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 this.products.forEach(function (product) {
		   return product.unload();
		 });
		 this.rtes.forEach(function (rte) {
		   return rte.unload();
		 });
	   }
	 }]);
   
	 return DynamicCollection;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/utils/layout.js
   var eventHandlers = [];
   
   function getBreakpoint() {
	 return window.getComputedStyle(document.documentElement, ':after').getPropertyValue('content').replace(/"/g, '');
   }
   
   var previousBreakpoint = getBreakpoint();
   window.addEventListener('resize', function (event) {
	 var currentBreakpoint = getBreakpoint();
   
	 if (previousBreakpoint !== currentBreakpoint) {
	   eventHandlers.forEach(function (eventHandler) {
		 eventHandler(event, {
		   previous: previousBreakpoint,
		   current: currentBreakpoint
		 });
	   });
	 }
   
	 previousBreakpoint = currentBreakpoint;
   });
   
   function isBreakpoint() {
	 for (var i = 0; i < arguments.length; i++) {
	   if (getBreakpoint() === (i < 0 || arguments.length <= i ? undefined : arguments[i])) {
		 return true;
	   }
	 }
   
	 return false;
   }
   
   function onBreakpointChange(eventHandler) {
	 if (eventHandlers.indexOf(eventHandler) === -1) {
	   eventHandlers.push(eventHandler);
	 }
   }
   
   function offBreakpointChange(eventHandler) {
	 var index = eventHandlers.indexOf(eventHandler);
   
	 if (index !== -1) {
	   eventHandlers.splice(index, 1);
	 }
   }
   
   /* harmony default export */ var layout = ({
	 getBreakpoint: getBreakpoint,
	 isBreakpoint: isBreakpoint,
	 onBreakpointChange: onBreakpointChange,
	 offBreakpointChange: offBreakpointChange
   });
   
   // CONCATENATED MODULE: ./source/scripts/sections/DynamicImageBlock.js
   function DynamicImageBlock_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function DynamicImageBlock_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function DynamicImageBlock_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicImageBlock_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicImageBlock_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var DynamicImageBlock_DynamicImageBlock =
   /*#__PURE__*/
   function () {
	 function DynamicImageBlock(section) {
	   var _this = this;
   
	   DynamicImageBlock_classCallCheck(this, DynamicImageBlock);
   
	   this.el = section.el;
	   this.settings = section.data;
	   this.parallax = this.settings.parallax;
	   this.fixedHeightMobile = this.settings.fixedHeightMobile;
	   this.fixedHeightDesktop = this.settings.fixedHeightDesktop;
	   this.parallaxObject = null;
   
	   if (this.parallax) {
		 this.parallaxObject = new Parallax({
		   img: this.el.querySelector('img, svg'),
		   container: this.el.querySelector('.picture-block-image'),
		   isVisible: function isVisible() {
			 return true;
		   }
		 });
		 var isNotFixed = layout.isBreakpoint('S', 'M') && !this.fixedHeightMobile || !layout.isBreakpoint('S', 'M') && !this.fixedHeightDesktop;
   
		 if (isNotFixed) {
		   this.el.querySelector('.picture-block-image').style.height = this.el.querySelector('img, svg').clientHeight + 'px';
		 }
   
		 window.addEventListener('resize', function () {
		   if (isNotFixed) {
			 _this.el.querySelector('.picture-block-image').style.height = _this.el.querySelector('img, svg').clientHeight + 'px';
		   } else {
			 _this.el.querySelector('.picture-block-image').style.height = '';
		   }
		 });
	   }
	 }
   
	 DynamicImageBlock_createClass(DynamicImageBlock, [{
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 if (this.parallax) {
		   this.parallaxObject.unload();
		   this.parallaxObject = null;
		 }
	   }
	 }]);
   
	 return DynamicImageBlock;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/DynamicMenuList.js
   function DynamicMenuList_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function DynamicMenuList_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function DynamicMenuList_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicMenuList_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicMenuList_defineProperties(Constructor, staticProps); return Constructor; }
   
   var DynamicMenuList =
   /*#__PURE__*/
   function () {
	 function DynamicMenuList(section) {
	   DynamicMenuList_classCallCheck(this, DynamicMenuList);
   
	   this.el = section.el;
	   this.toggles = this.el.querySelectorAll('[data-menu-list-toggle]');
   
	   for (var i = 0; i < this.toggles.length; i++) {
		 this.toggles[i].addEventListener('click', function (event) {
		   var links = event.currentTarget.parentNode.querySelectorAll('[data-menu-list-hidden]');
		   var text = event.currentTarget.querySelectorAll('.menu-list-link-text');
   
		   for (var _i = 0; _i < text.length; _i++) {
			 text[_i].classList.toggle('menu-list-link-hidden');
		   }
   
		   for (var _i2 = 0; _i2 < links.length; _i2++) {
			 links[_i2].classList.toggle('menu-list-link-hidden');
		   }
		 });
	   }
	 }
   
	 DynamicMenuList_createClass(DynamicMenuList, [{
	   key: "onSectionUnload",
	   value: function onSectionUnload() {}
	 }]);
   
	 return DynamicMenuList;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/DynamicProduct.js
   function DynamicProduct_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function DynamicProduct_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function DynamicProduct_createClass(Constructor, protoProps, staticProps) { if (protoProps) DynamicProduct_defineProperties(Constructor.prototype, protoProps); if (staticProps) DynamicProduct_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   var DynamicProduct_DynamicProduct =
   /*#__PURE__*/
   function () {
	 function DynamicProduct(section) {
	   var _this = this;
   
	   DynamicProduct_classCallCheck(this, DynamicProduct);
   
	   this.el = section.el;
	   this.productEls = this.el.querySelectorAll('[data-product-item]');
	   this.products = [];
	   var $scripts = $('[data-scripts]');
	   script_default()($scripts.data('shopify-api-url'), function () {
		 _this.product = new Product_Product({
		   el: _this.el,
		   data: section.data
		 });
   
		 for (var i = 0; i < _this.productEls.length; i++) {
		   _this.products.push(new ProductItem_ProductItem(_this.productEls[i]));
		 }
	   });
	 }
   
	 DynamicProduct_createClass(DynamicProduct, [{
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 this.product.unload();
		 this.products.forEach(function (product) {
		   return product.unload();
		 });
	   }
	 }]);
   
	 return DynamicProduct;
   }();
   
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/Static404.js
   function Static404_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function Static404_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function Static404_createClass(Constructor, protoProps, staticProps) { if (protoProps) Static404_defineProperties(Constructor.prototype, protoProps); if (staticProps) Static404_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var Static404_Static404 =
   /*#__PURE__*/
   function () {
	 function Static404(section) {
	   Static404_classCallCheck(this, Static404);
   
	   this.el = section.el;
	   this.productEls = this.el.querySelectorAll('[data-product-item]');
	   this.products = [];
   
	   for (var i = 0; i < this.productEls.length; i++) {
		 this.products.push(new ProductItem_ProductItem(this.productEls[i]));
	   }
	 }
   
	 Static404_createClass(Static404, [{
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 this.products.forEach(function (product) {
		   return product.unload();
		 });
	   }
	 }]);
   
	 return Static404;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticArticle.js
   function StaticArticle_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticArticle_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticArticle_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticArticle_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticArticle_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var StaticArticle_StaticArticle =
   /*#__PURE__*/
   function () {
	 function StaticArticle(section) {
	   StaticArticle_classCallCheck(this, StaticArticle);
   
	   this.el = section.el;
	   this.rteEls = this.el.querySelectorAll('.rte');
	   this.rtes = [];
   
	   for (var i = 0; i < this.rteEls.length; i++) {
		 this.rtes.push(new RTE_RTE(this.rteEls[i]));
	   }
   
	   this.shareThisEl = this.el.querySelector('[data-sharethis]');
   
	   if (this.shareThisEl) {
		 this.sharethis = new ShareThis_ShareThis(this.shareThisEl);
	   }
	 }
   
	 StaticArticle_createClass(StaticArticle, [{
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 this.rtes.forEach(function (rte) {
		   return rte.unload();
		 });
   
		 if (this.shareThis) {
		   this.sharethis.unload();
		 }
	   }
	 }]);
   
	 return StaticArticle;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticBlog.js
   function StaticBlog_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticBlog_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticBlog_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticBlog_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticBlog_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var StaticBlog_StaticBlog =
   /*#__PURE__*/
   function () {
	 function StaticBlog(section) {
	   StaticBlog_classCallCheck(this, StaticBlog);
   
	   this.el = section.el;
	   this.rteEls = this.el.querySelectorAll('.rte');
	   this.rtes = [];
   
	   for (var i = 0; i < this.rteEls.length; i++) {
		 this.rtes.push(new RTE_RTE(this.rteEls[i]));
	   }
	 }
   
	 StaticBlog_createClass(StaticBlog, [{
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 this.rtes.forEach(function (rte) {
		   return rte.unload();
		 });
	   }
	 }]);
   
	 return StaticBlog;
   }();
   
   
   // CONCATENATED MODULE: ./node_modules/morphdom/dist/morphdom-esm.js
   function morphAttrs(fromNode, toNode) {
	   var attrs = toNode.attributes;
	   var i;
	   var attr;
	   var attrName;
	   var attrNamespaceURI;
	   var attrValue;
	   var fromValue;
   
	   // update attributes on original DOM element
	   for (i = attrs.length - 1; i >= 0; --i) {
		   attr = attrs[i];
		   attrName = attr.name;
		   attrNamespaceURI = attr.namespaceURI;
		   attrValue = attr.value;
   
		   if (attrNamespaceURI) {
			   attrName = attr.localName || attrName;
			   fromValue = fromNode.getAttributeNS(attrNamespaceURI, attrName);
   
			   if (fromValue !== attrValue) {
				   fromNode.setAttributeNS(attrNamespaceURI, attrName, attrValue);
			   }
		   } else {
			   fromValue = fromNode.getAttribute(attrName);
   
			   if (fromValue !== attrValue) {
				   fromNode.setAttribute(attrName, attrValue);
			   }
		   }
	   }
   
	   // Remove any extra attributes found on the original DOM element that
	   // weren't found on the target element.
	   attrs = fromNode.attributes;
   
	   for (i = attrs.length - 1; i >= 0; --i) {
		   attr = attrs[i];
		   if (attr.specified !== false) {
			   attrName = attr.name;
			   attrNamespaceURI = attr.namespaceURI;
   
			   if (attrNamespaceURI) {
				   attrName = attr.localName || attrName;
   
				   if (!toNode.hasAttributeNS(attrNamespaceURI, attrName)) {
					   fromNode.removeAttributeNS(attrNamespaceURI, attrName);
				   }
			   } else {
				   if (!toNode.hasAttribute(attrName)) {
					   fromNode.removeAttribute(attrName);
				   }
			   }
		   }
	   }
   }
   
   var range; // Create a range object for efficently rendering strings to elements.
   var NS_XHTML = 'http://www.w3.org/1999/xhtml';
   
   var doc = typeof document === 'undefined' ? undefined : document;
   
   /**
	* This is about the same
	* var html = new DOMParser().parseFromString(str, 'text/html');
	* return html.body.firstChild;
	*
	* @method toElement
	* @param {String} str
	*/
   function toElement(str) {
	   if (!range && doc.createRange) {
		   range = doc.createRange();
		   range.selectNode(doc.body);
	   }
   
	   var fragment;
	   if (range && range.createContextualFragment) {
		   fragment = range.createContextualFragment(str);
	   } else {
		   fragment = doc.createElement('body');
		   fragment.innerHTML = str;
	   }
	   return fragment.childNodes[0];
   }
   
   /**
	* Returns true if two node's names are the same.
	*
	* NOTE: We don't bother checking `namespaceURI` because you will never find two HTML elements with the same
	*       nodeName and different namespace URIs.
	*
	* @param {Element} a
	* @param {Element} b The target element
	* @return {boolean}
	*/
   function compareNodeNames(fromEl, toEl) {
	   var fromNodeName = fromEl.nodeName;
	   var toNodeName = toEl.nodeName;
   
	   if (fromNodeName === toNodeName) {
		   return true;
	   }
   
	   if (toEl.actualize &&
		   fromNodeName.charCodeAt(0) < 91 && /* from tag name is upper case */
		   toNodeName.charCodeAt(0) > 90 /* target tag name is lower case */) {
		   // If the target element is a virtual DOM node then we may need to normalize the tag name
		   // before comparing. Normal HTML elements that are in the "http://www.w3.org/1999/xhtml"
		   // are converted to upper case
		   return fromNodeName === toNodeName.toUpperCase();
	   } else {
		   return false;
	   }
   }
   
   /**
	* Create an element, optionally with a known namespace URI.
	*
	* @param {string} name the element name, e.g. 'div' or 'svg'
	* @param {string} [namespaceURI] the element's namespace URI, i.e. the value of
	* its `xmlns` attribute or its inferred namespace.
	*
	* @return {Element}
	*/
   function createElementNS(name, namespaceURI) {
	   return !namespaceURI || namespaceURI === NS_XHTML ?
		   doc.createElement(name) :
		   doc.createElementNS(namespaceURI, name);
   }
   
   /**
	* Copies the children of one DOM element to another DOM element
	*/
   function moveChildren(fromEl, toEl) {
	   var curChild = fromEl.firstChild;
	   while (curChild) {
		   var nextChild = curChild.nextSibling;
		   toEl.appendChild(curChild);
		   curChild = nextChild;
	   }
	   return toEl;
   }
   
   function syncBooleanAttrProp(fromEl, toEl, name) {
	   if (fromEl[name] !== toEl[name]) {
		   fromEl[name] = toEl[name];
		   if (fromEl[name]) {
			   fromEl.setAttribute(name, '');
		   } else {
			   fromEl.removeAttribute(name);
		   }
	   }
   }
   
   var specialElHandlers = {
	   OPTION: function(fromEl, toEl) {
		   var parentNode = fromEl.parentNode;
		   if (parentNode) {
			   var parentName = parentNode.nodeName.toUpperCase();
			   if (parentName === 'OPTGROUP') {
				   parentNode = parentNode.parentNode;
				   parentName = parentNode && parentNode.nodeName.toUpperCase();
			   }
			   if (parentName === 'SELECT' && !parentNode.hasAttribute('multiple')) {
				   if (fromEl.hasAttribute('selected') && !toEl.selected) {
					   // Workaround for MS Edge bug where the 'selected' attribute can only be
					   // removed if set to a non-empty value:
					   // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12087679/
					   fromEl.setAttribute('selected', 'selected');
					   fromEl.removeAttribute('selected');
				   }
				   // We have to reset select element's selectedIndex to -1, otherwise setting
				   // fromEl.selected using the syncBooleanAttrProp below has no effect.
				   // The correct selectedIndex will be set in the SELECT special handler below.
				   parentNode.selectedIndex = -1;
			   }
		   }
		   syncBooleanAttrProp(fromEl, toEl, 'selected');
	   },
	   /**
		* The "value" attribute is special for the <input> element since it sets
		* the initial value. Changing the "value" attribute without changing the
		* "value" property will have no effect since it is only used to the set the
		* initial value.  Similar for the "checked" attribute, and "disabled".
		*/
	   INPUT: function(fromEl, toEl) {
		   syncBooleanAttrProp(fromEl, toEl, 'checked');
		   syncBooleanAttrProp(fromEl, toEl, 'disabled');
   
		   if (fromEl.value !== toEl.value) {
			   fromEl.value = toEl.value;
		   }
   
		   if (!toEl.hasAttribute('value')) {
			   fromEl.removeAttribute('value');
		   }
	   },
   
	   TEXTAREA: function(fromEl, toEl) {
		   var newValue = toEl.value;
		   if (fromEl.value !== newValue) {
			   fromEl.value = newValue;
		   }
   
		   var firstChild = fromEl.firstChild;
		   if (firstChild) {
			   // Needed for IE. Apparently IE sets the placeholder as the
			   // node value and vise versa. This ignores an empty update.
			   var oldValue = firstChild.nodeValue;
   
			   if (oldValue == newValue || (!newValue && oldValue == fromEl.placeholder)) {
				   return;
			   }
   
			   firstChild.nodeValue = newValue;
		   }
	   },
	   SELECT: function(fromEl, toEl) {
		   if (!toEl.hasAttribute('multiple')) {
			   var selectedIndex = -1;
			   var i = 0;
			   // We have to loop through children of fromEl, not toEl since nodes can be moved
			   // from toEl to fromEl directly when morphing.
			   // At the time this special handler is invoked, all children have already been morphed
			   // and appended to / removed from fromEl, so using fromEl here is safe and correct.
			   var curChild = fromEl.firstChild;
			   var optgroup;
			   var nodeName;
			   while(curChild) {
				   nodeName = curChild.nodeName && curChild.nodeName.toUpperCase();
				   if (nodeName === 'OPTGROUP') {
					   optgroup = curChild;
					   curChild = optgroup.firstChild;
				   } else {
					   if (nodeName === 'OPTION') {
						   if (curChild.hasAttribute('selected')) {
							   selectedIndex = i;
							   break;
						   }
						   i++;
					   }
					   curChild = curChild.nextSibling;
					   if (!curChild && optgroup) {
						   curChild = optgroup.nextSibling;
						   optgroup = null;
					   }
				   }
			   }
   
			   fromEl.selectedIndex = selectedIndex;
		   }
	   }
   };
   
   var ELEMENT_NODE = 1;
   var DOCUMENT_FRAGMENT_NODE = 11;
   var TEXT_NODE = 3;
   var COMMENT_NODE = 8;
   
   function noop() {}
   
   function defaultGetNodeKey(node) {
	   return node.id;
   }
   
   function morphdomFactory(morphAttrs) {
   
	   return function morphdom(fromNode, toNode, options) {
		   if (!options) {
			   options = {};
		   }
   
		   if (typeof toNode === 'string') {
			   if (fromNode.nodeName === '#document' || fromNode.nodeName === 'HTML') {
				   var toNodeHtml = toNode;
				   toNode = doc.createElement('html');
				   toNode.innerHTML = toNodeHtml;
			   } else {
				   toNode = toElement(toNode);
			   }
		   }
   
		   var getNodeKey = options.getNodeKey || defaultGetNodeKey;
		   var onBeforeNodeAdded = options.onBeforeNodeAdded || noop;
		   var onNodeAdded = options.onNodeAdded || noop;
		   var onBeforeElUpdated = options.onBeforeElUpdated || noop;
		   var onElUpdated = options.onElUpdated || noop;
		   var onBeforeNodeDiscarded = options.onBeforeNodeDiscarded || noop;
		   var onNodeDiscarded = options.onNodeDiscarded || noop;
		   var onBeforeElChildrenUpdated = options.onBeforeElChildrenUpdated || noop;
		   var childrenOnly = options.childrenOnly === true;
   
		   // This object is used as a lookup to quickly find all keyed elements in the original DOM tree.
		   var fromNodesLookup = {};
		   var keyedRemovalList;
   
		   function addKeyedRemoval(key) {
			   if (keyedRemovalList) {
				   keyedRemovalList.push(key);
			   } else {
				   keyedRemovalList = [key];
			   }
		   }
   
		   function walkDiscardedChildNodes(node, skipKeyedNodes) {
			   if (node.nodeType === ELEMENT_NODE) {
				   var curChild = node.firstChild;
				   while (curChild) {
   
					   var key = undefined;
   
					   if (skipKeyedNodes && (key = getNodeKey(curChild))) {
						   // If we are skipping keyed nodes then we add the key
						   // to a list so that it can be handled at the very end.
						   addKeyedRemoval(key);
					   } else {
						   // Only report the node as discarded if it is not keyed. We do this because
						   // at the end we loop through all keyed elements that were unmatched
						   // and then discard them in one final pass.
						   onNodeDiscarded(curChild);
						   if (curChild.firstChild) {
							   walkDiscardedChildNodes(curChild, skipKeyedNodes);
						   }
					   }
   
					   curChild = curChild.nextSibling;
				   }
			   }
		   }
   
		   /**
			* Removes a DOM node out of the original DOM
			*
			* @param  {Node} node The node to remove
			* @param  {Node} parentNode The nodes parent
			* @param  {Boolean} skipKeyedNodes If true then elements with keys will be skipped and not discarded.
			* @return {undefined}
			*/
		   function removeNode(node, parentNode, skipKeyedNodes) {
			   if (onBeforeNodeDiscarded(node) === false) {
				   return;
			   }
   
			   if (parentNode) {
				   parentNode.removeChild(node);
			   }
   
			   onNodeDiscarded(node);
			   walkDiscardedChildNodes(node, skipKeyedNodes);
		   }
   
		   // // TreeWalker implementation is no faster, but keeping this around in case this changes in the future
		   // function indexTree(root) {
		   //     var treeWalker = document.createTreeWalker(
		   //         root,
		   //         NodeFilter.SHOW_ELEMENT);
		   //
		   //     var el;
		   //     while((el = treeWalker.nextNode())) {
		   //         var key = getNodeKey(el);
		   //         if (key) {
		   //             fromNodesLookup[key] = el;
		   //         }
		   //     }
		   // }
   
		   // // NodeIterator implementation is no faster, but keeping this around in case this changes in the future
		   //
		   // function indexTree(node) {
		   //     var nodeIterator = document.createNodeIterator(node, NodeFilter.SHOW_ELEMENT);
		   //     var el;
		   //     while((el = nodeIterator.nextNode())) {
		   //         var key = getNodeKey(el);
		   //         if (key) {
		   //             fromNodesLookup[key] = el;
		   //         }
		   //     }
		   // }
   
		   function indexTree(node) {
			   if (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE) {
				   var curChild = node.firstChild;
				   while (curChild) {
					   var key = getNodeKey(curChild);
					   if (key) {
						   fromNodesLookup[key] = curChild;
					   }
   
					   // Walk recursively
					   indexTree(curChild);
   
					   curChild = curChild.nextSibling;
				   }
			   }
		   }
   
		   indexTree(fromNode);
   
		   function handleNodeAdded(el) {
			   onNodeAdded(el);
   
			   var curChild = el.firstChild;
			   while (curChild) {
				   var nextSibling = curChild.nextSibling;
   
				   var key = getNodeKey(curChild);
				   if (key) {
					   var unmatchedFromEl = fromNodesLookup[key];
					   if (unmatchedFromEl && compareNodeNames(curChild, unmatchedFromEl)) {
						   curChild.parentNode.replaceChild(unmatchedFromEl, curChild);
						   morphEl(unmatchedFromEl, curChild);
					   }
				   }
   
				   handleNodeAdded(curChild);
				   curChild = nextSibling;
			   }
		   }
   
		   function cleanupFromEl(fromEl, curFromNodeChild, curFromNodeKey) {
			   // We have processed all of the "to nodes". If curFromNodeChild is
			   // non-null then we still have some from nodes left over that need
			   // to be removed
			   while (curFromNodeChild) {
				   var fromNextSibling = curFromNodeChild.nextSibling;
				   if ((curFromNodeKey = getNodeKey(curFromNodeChild))) {
					   // Since the node is keyed it might be matched up later so we defer
					   // the actual removal to later
					   addKeyedRemoval(curFromNodeKey);
				   } else {
					   // NOTE: we skip nested keyed nodes from being removed since there is
					   //       still a chance they will be matched up later
					   removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
				   }
				   curFromNodeChild = fromNextSibling;
			   }
		   }
   
		   function morphEl(fromEl, toEl, childrenOnly) {
			   var toElKey = getNodeKey(toEl);
   
			   if (toElKey) {
				   // If an element with an ID is being morphed then it will be in the final
				   // DOM so clear it out of the saved elements collection
				   delete fromNodesLookup[toElKey];
			   }
   
			   if (toNode.isSameNode && toNode.isSameNode(fromNode)) {
				   return;
			   }
   
			   if (!childrenOnly) {
				   // optional
				   if (onBeforeElUpdated(fromEl, toEl) === false) {
					   return;
				   }
   
				   // update attributes on original DOM element first
				   morphAttrs(fromEl, toEl);
				   // optional
				   onElUpdated(fromEl);
   
				   if (onBeforeElChildrenUpdated(fromEl, toEl) === false) {
					   return;
				   }
			   }
			   if (fromEl.nodeName !== 'TEXTAREA') {
				 morphChildren(fromEl, toEl);
			   } else {
				 specialElHandlers.TEXTAREA(fromEl, toEl);
			   }
		   }
   
		   function morphChildren(fromEl, toEl) {
			   var curToNodeChild = toEl.firstChild;
			   var curFromNodeChild = fromEl.firstChild;
			   var curToNodeKey;
			   var curFromNodeKey;
   
			   var fromNextSibling;
			   var toNextSibling;
			   var matchingFromEl;
   
			   // walk the children
			   outer: while (curToNodeChild) {
				   toNextSibling = curToNodeChild.nextSibling;
				   curToNodeKey = getNodeKey(curToNodeChild);
   
				   // walk the fromNode children all the way through
				   while (curFromNodeChild) {
					   fromNextSibling = curFromNodeChild.nextSibling;
   
					   if (curToNodeChild.isSameNode && curToNodeChild.isSameNode(curFromNodeChild)) {
						   curToNodeChild = toNextSibling;
						   curFromNodeChild = fromNextSibling;
						   continue outer;
					   }
   
					   curFromNodeKey = getNodeKey(curFromNodeChild);
   
					   var curFromNodeType = curFromNodeChild.nodeType;
   
					   // this means if the curFromNodeChild doesnt have a match with the curToNodeChild
					   var isCompatible = undefined;
   
					   if (curFromNodeType === curToNodeChild.nodeType) {
						   if (curFromNodeType === ELEMENT_NODE) {
							   // Both nodes being compared are Element nodes
   
							   if (curToNodeKey) {
								   // The target node has a key so we want to match it up with the correct element
								   // in the original DOM tree
								   if (curToNodeKey !== curFromNodeKey) {
									   // The current element in the original DOM tree does not have a matching key so
									   // let's check our lookup to see if there is a matching element in the original
									   // DOM tree
									   if ((matchingFromEl = fromNodesLookup[curToNodeKey])) {
										   if (fromNextSibling === matchingFromEl) {
											   // Special case for single element removals. To avoid removing the original
											   // DOM node out of the tree (since that can break CSS transitions, etc.),
											   // we will instead discard the current node and wait until the next
											   // iteration to properly match up the keyed target element with its matching
											   // element in the original tree
											   isCompatible = false;
										   } else {
											   // We found a matching keyed element somewhere in the original DOM tree.
											   // Let's move the original DOM node into the current position and morph
											   // it.
   
											   // NOTE: We use insertBefore instead of replaceChild because we want to go through
											   // the `removeNode()` function for the node that is being discarded so that
											   // all lifecycle hooks are correctly invoked
											   fromEl.insertBefore(matchingFromEl, curFromNodeChild);
   
											   // fromNextSibling = curFromNodeChild.nextSibling;
   
											   if (curFromNodeKey) {
												   // Since the node is keyed it might be matched up later so we defer
												   // the actual removal to later
												   addKeyedRemoval(curFromNodeKey);
											   } else {
												   // NOTE: we skip nested keyed nodes from being removed since there is
												   //       still a chance they will be matched up later
												   removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
											   }
   
											   curFromNodeChild = matchingFromEl;
										   }
									   } else {
										   // The nodes are not compatible since the "to" node has a key and there
										   // is no matching keyed node in the source tree
										   isCompatible = false;
									   }
								   }
							   } else if (curFromNodeKey) {
								   // The original has a key
								   isCompatible = false;
							   }
   
							   isCompatible = isCompatible !== false && compareNodeNames(curFromNodeChild, curToNodeChild);
							   if (isCompatible) {
								   // We found compatible DOM elements so transform
								   // the current "from" node to match the current
								   // target DOM node.
								   // MORPH
								   morphEl(curFromNodeChild, curToNodeChild);
							   }
   
						   } else if (curFromNodeType === TEXT_NODE || curFromNodeType == COMMENT_NODE) {
							   // Both nodes being compared are Text or Comment nodes
							   isCompatible = true;
							   // Simply update nodeValue on the original node to
							   // change the text value
							   if (curFromNodeChild.nodeValue !== curToNodeChild.nodeValue) {
								   curFromNodeChild.nodeValue = curToNodeChild.nodeValue;
							   }
   
						   }
					   }
   
					   if (isCompatible) {
						   // Advance both the "to" child and the "from" child since we found a match
						   // Nothing else to do as we already recursively called morphChildren above
						   curToNodeChild = toNextSibling;
						   curFromNodeChild = fromNextSibling;
						   continue outer;
					   }
   
					   // No compatible match so remove the old node from the DOM and continue trying to find a
					   // match in the original DOM. However, we only do this if the from node is not keyed
					   // since it is possible that a keyed node might match up with a node somewhere else in the
					   // target tree and we don't want to discard it just yet since it still might find a
					   // home in the final DOM tree. After everything is done we will remove any keyed nodes
					   // that didn't find a home
					   if (curFromNodeKey) {
						   // Since the node is keyed it might be matched up later so we defer
						   // the actual removal to later
						   addKeyedRemoval(curFromNodeKey);
					   } else {
						   // NOTE: we skip nested keyed nodes from being removed since there is
						   //       still a chance they will be matched up later
						   removeNode(curFromNodeChild, fromEl, true /* skip keyed nodes */);
					   }
   
					   curFromNodeChild = fromNextSibling;
				   } // END: while(curFromNodeChild) {}
   
				   // If we got this far then we did not find a candidate match for
				   // our "to node" and we exhausted all of the children "from"
				   // nodes. Therefore, we will just append the current "to" node
				   // to the end
				   if (curToNodeKey && (matchingFromEl = fromNodesLookup[curToNodeKey]) && compareNodeNames(matchingFromEl, curToNodeChild)) {
					   fromEl.appendChild(matchingFromEl);
					   // MORPH
					   morphEl(matchingFromEl, curToNodeChild);
				   } else {
					   var onBeforeNodeAddedResult = onBeforeNodeAdded(curToNodeChild);
					   if (onBeforeNodeAddedResult !== false) {
						   if (onBeforeNodeAddedResult) {
							   curToNodeChild = onBeforeNodeAddedResult;
						   }
   
						   if (curToNodeChild.actualize) {
							   curToNodeChild = curToNodeChild.actualize(fromEl.ownerDocument || doc);
						   }
						   fromEl.appendChild(curToNodeChild);
						   handleNodeAdded(curToNodeChild);
					   }
				   }
   
				   curToNodeChild = toNextSibling;
				   curFromNodeChild = fromNextSibling;
			   }
   
			   cleanupFromEl(fromEl, curFromNodeChild, curFromNodeKey);
   
			   var specialElHandler = specialElHandlers[fromEl.nodeName];
			   if (specialElHandler) {
				   specialElHandler(fromEl, toEl);
			   }
		   } // END: morphChildren(...)
   
		   var morphedNode = fromNode;
		   var morphedNodeType = morphedNode.nodeType;
		   var toNodeType = toNode.nodeType;
   
		   if (!childrenOnly) {
			   // Handle the case where we are given two DOM nodes that are not
			   // compatible (e.g. <div> --> <span> or <div> --> TEXT)
			   if (morphedNodeType === ELEMENT_NODE) {
				   if (toNodeType === ELEMENT_NODE) {
					   if (!compareNodeNames(fromNode, toNode)) {
						   onNodeDiscarded(fromNode);
						   morphedNode = moveChildren(fromNode, createElementNS(toNode.nodeName, toNode.namespaceURI));
					   }
				   } else {
					   // Going from an element node to a text node
					   morphedNode = toNode;
				   }
			   } else if (morphedNodeType === TEXT_NODE || morphedNodeType === COMMENT_NODE) { // Text or comment node
				   if (toNodeType === morphedNodeType) {
					   if (morphedNode.nodeValue !== toNode.nodeValue) {
						   morphedNode.nodeValue = toNode.nodeValue;
					   }
   
					   return morphedNode;
				   } else {
					   // Text node to something else
					   morphedNode = toNode;
				   }
			   }
		   }
   
		   if (morphedNode === toNode) {
			   // The "to node" was not compatible with the "from node" so we had to
			   // toss out the "from node" and use the "to node"
			   onNodeDiscarded(fromNode);
		   } else {
			   morphEl(morphedNode, toNode, childrenOnly);
   
			   // We now need to loop over any keyed nodes that might need to be
			   // removed. We only do the removal if we know that the keyed node
			   // never found a match. When a keyed node is matched up we remove
			   // it out of fromNodesLookup and we use fromNodesLookup to determine
			   // if a keyed node has been matched up or not
			   if (keyedRemovalList) {
				   for (var i=0, len=keyedRemovalList.length; i<len; i++) {
					   var elToRemove = fromNodesLookup[keyedRemovalList[i]];
					   if (elToRemove) {
						   removeNode(elToRemove, elToRemove.parentNode, false);
					   }
				   }
			   }
		   }
   
		   if (!childrenOnly && morphedNode !== fromNode && fromNode.parentNode) {
			   if (morphedNode.actualize) {
				   morphedNode = morphedNode.actualize(fromNode.ownerDocument || doc);
			   }
			   // If we had to swap out the from node with a new node because the old
			   // node was not compatible with the target node then we need to
			   // replace the old DOM node in the original DOM tree. This is only
			   // possible if the original DOM node was part of a DOM tree which
			   // we know is the case if it has a parent node.
			   fromNode.parentNode.replaceChild(morphedNode, fromNode);
		   }
   
		   return morphedNode;
	   };
   }
   
   var morphdom = morphdomFactory(morphAttrs);
   
   /* harmony default export */ var morphdom_esm = (morphdom);
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticCart.js
   function StaticCart_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticCart_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticCart_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticCart_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticCart_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   
   
   /**
	* _getItemKey
	*
	* Checks a target and recursively checks parents until an element with a data-cart-item-key
	* is found, when the value of that attribute is returned.
	*
	* @param {HTMLElement} target Element from which to start search for item key (inclusive)
	*/
   
   function _getItemKey(target) {
	 if (!target) {
	   return null;
	 }
   
	 if (target.hasAttribute('data-cart-item-key')) {
	   return target.dataset.cartItemKey;
	 }
   
	 return _getItemKey(target.parentNode);
   }
   
   var StaticCart_StaticCart =
   /*#__PURE__*/
   function () {
	 function StaticCart(section) {
	   var _this = this;
   
	   StaticCart_classCallCheck(this, StaticCart);
   
	   this.el = section.el;
	   this.$el = jquery_default()(this.el);
	   this.settings = section.data.settings;
	   this.events = [];
	   this.cartForm = section.el.querySelector('[data-cart-form]');
	   this.$shippingStrings = jquery_default()('[data-shipping-calculator-strings]', this.el);
	   this.shippingContext = {};
	   this.cartMini = new CartMini_CartMini();
	   var $scripts = jquery_default()('[data-scripts]');
	   script_default()([$scripts.data('shopify-common'), $scripts.data('shopify-api-url')], function () {
		 script_default()($scripts.data('shopify-countries'), function () {
		   script_default()($scripts.data('shopify-cart'), function () {
			 Shopify.onError = function (XMLHttpRequest) {
			   return _this.handleErrors(XMLHttpRequest);
			 };
   
			 _this.events.push(jquery_default()('.instructions textarea', _this.el).on('change.cart', _this.saveNote.bind(_this)));
   
			 if (_this.cartForm) {
			   _this.cartTable = _this.cartForm.querySelector('[data-cart-table]');
			   _this.cartDiscounts = _this.cartForm.querySelector('[data-cart-discounts]');
			   _this.totalPrice = _this.cartForm.querySelector('[data-cart-total]');
			   _this._handleClick = _this._handleClick.bind(_this);
			   _this._handleQtyChange = _this._handleQtyChange.bind(_this);
			   _this._handleQtyKeydown = _this._handleQtyKeydown.bind(_this);
   
			   _this.cartForm.addEventListener('click', _this._handleClick);
   
			   _this.cartForm.addEventListener('change', _this._handleQtyChange);
   
			   _this.cartForm.addEventListener('keydown', _this._handleQtyKeydown);
   
			   _this.updateTimeout = null;
			 }
   
			 if (_this.settings.shipping && _this.$shippingStrings.length) {
			   _this.countryProvinceSelector = new Shopify.CountryProvinceSelector('address_country', 'address_province', {
				 hideElement: 'address_province_container'
			   });
   
			   try {
				 _this.shippingContext = JSON.parse(_this.$shippingStrings.text());
			   } catch (error) {
				 console.log('No shipping localisations found, unable to continue.');
			   }
   
			   if (_this.shippingContext == null) {
				 return;
			   }
   
			   _this.events.push(jquery_default()('.get-rates', _this.el).on('click.cart', _this.calculateShipping.bind(_this)), jquery_default()('#address_zip', _this.el).on('keydown.cart', _this.calculateShipping.bind(_this)));
   
			   if (jquery_default()('[data-cart-item]', _this.el).length) {
				 _this.shippingCalculator();
			   }
			 }
		   });
		 });
	   });
	 }
	 /**
	  * Gets the current value of the quantity input box for a given line item key
	  *
	  * @param {string} key
	  */
   
   
	 StaticCart_createClass(StaticCart, [{
	   key: "_getItemQuantity",
	   value: function _getItemQuantity(key) {
		 return parseInt(this.cartForm.querySelector("[data-cart-item-key=\"".concat(key, "\"] [data-cart-item-quantity]")).value, 10);
	   }
	   /**
		* Sets a value for the quantity input box for a given line item key
		*
		* @param {string} key
		*
		* @param {integer} quantity
		*/
   
	 }, {
	   key: "_setItemQuantity",
	   value: function _setItemQuantity(key, quantity) {
		 this.cartForm.querySelector("[data-cart-item-key=\"".concat(key, "\"] [data-cart-item-quantity]")).value = quantity;
	   }
	 }, {
	   key: "_handleClick",
	   value: function _handleClick(event) {
		 if (!event.target.hasAttribute('data-cart-action')) {
		   return;
		 }
   
		 var cartAction = event.target.dataset.cartAction;
   
		 var key = _getItemKey(event.target); // Switch is a bit redundant, but leaving as is to match other themes and make
		 // future additions easy.
   
   
		 switch (cartAction) {
		   case 'remove':
			 event.preventDefault();
   
			 this._setItemQuantity(key, 0);
   
			 this._updateItem(key, 0);
   
			 break;
   
		   default:
			 // do nothing
			 break;
		 }
	   }
	 }, {
	   key: "_handleQtyChange",
	   value: function _handleQtyChange(event) {
		 if (!event.target.hasAttribute('data-cart-item-quantity')) {
		   return;
		 }
   
		 var key = _getItemKey(event.target);
   
		 var quantity = this._getItemQuantity(key);
   
		 this._updateItem(key, quantity);
	   }
	 }, {
	   key: "_handleQtyKeydown",
	   value: function _handleQtyKeydown(event) {
		 if (event.target.hasAttribute('data-cart-item-quantity') && event.key === 'Enter') {
		   event.preventDefault();
   
		   this._handleQtyChange(event);
		 }
	   }
	   /**
		* Sends a request to the server to update a single product
		*
		* @param {string} key Shopify line item key (or product ID)
		*
		* @param {integer} quantity New quantity for item. If 0, item will be removed from cart.
		* @private
		*/
   
	 }, {
	   key: "_updateItem",
	   value: function _updateItem(key, quantity) {
		 var _this2 = this;
   
		 // cancel any pending requests
		 if (this.updateTimeout !== null) {
		   clearTimeout(this.updateTimeout);
		 }
   
		 this.updateTimeout = setTimeout(function () {
		   if (_this2._getItemQuantity(key) !== quantity) {
			 _this2.updateTimeout = null;
			 return;
		   }
   
		   var thisTimeoutId = _this2.updateTimeout;
		   jquery_default.a.ajax({
			 type: 'POST',
			 url: '/cart/change.js',
			 dataType: 'json',
			 data: {
			   quantity: quantity,
			   id: key
			 },
			 success: function success(cart) {
			   if (_this2.updateTimeout !== thisTimeoutId) {
				 return;
			   }
   
			   if (cart.item_count === 0) {
				 // reload to show empty cart state
				 window.location.reload();
				 return;
			   }
   
			   _this2._updateCart(thisTimeoutId);
			 }
		   });
		 }, 300);
	   }
	   /**
		* _updateCart
		*
		* Fetches new cart contents and swaps into page
		*
		* @param {integer} thisTimeoutId Id of timeout for this request. If no longer current, update is cancelled.
		*/
   
	 }, {
	   key: "_updateCart",
	   value: function _updateCart(thisTimeoutId) {
		 var _this3 = this;
   
		 shopify_asyncview_dist_index_es.load('/cart', '_ajax').done(function (_ref) {
		   var options = _ref.options,
			   html = _ref.html;
   
		   // If another request is in progress, discard this update
		   if (_this3.updateTimeout !== thisTimeoutId) {
			 return;
		   }
   
		   _this3.cartMini.refresh(); // Inject new cart table contents
   
   
		   var newTableContainer = document.createElement('div');
		   newTableContainer.innerHTML = html.table;
		   morphdom_esm(_this3.cartTable, newTableContainer.querySelector('table'), {
			 onBeforeElUpdated: function onBeforeElUpdated(fromEl, toEl) {
			   // Skip images if src matches
			   // - we don't want to reload lazy loaded images
			   if (fromEl.tagName === 'IMG' && fromEl.src === toEl.src) {
				 return false;
			   }
   
			   return true;
			 }
		   });
   
		   _this3.cartTable.querySelectorAll('.money').forEach(function (money) {
			 return dist_default.a.update(money);
		   });
   
		   rimg_shopify_dist_index_es.watch(_this3.cartTable); // Inject new cart level discounts
   
		   _this3.cartDiscounts.innerHTML = html.discounts;
   
		   _this3.cartDiscounts.querySelectorAll('.money').forEach(function (money) {
			 return dist_default.a.update(money);
		   }); // Update total
   
   
		   _this3.totalPrice.innerHTML = options.totalPrice;
		   dist_default.a.update(_this3.totalPrice);
		 }).fail(function () {
		   return window.location.reload();
		 });
	   }
	 }, {
	   key: "saveNote",
	   value: function saveNote() {
		 var newNote = jquery_default()('.instructions textarea', this.el).val(); // empty function so that Shopify's callback isn't invoked
   
		 Shopify.updateCartNote(newNote, function () {});
	   }
	 }, {
	   key: "shippingCalculator",
	   value: function shippingCalculator() {
		 Shopify.Cart.ShippingCalculator.show({
		   submitButton: this.shippingContext.submitButton,
		   submitButtonDisabled: this.shippingContext.submitButtonDisabled,
		   customerIsLoggedIn: this.shippingContext.customerIsLoggedIn,
		   moneyFormat: this.shippingContext.moneyFormat
		 });
	   }
	 }, {
	   key: "calculateShipping",
	   value: function calculateShipping(e) {
		 var _this4 = this;
   
		 if (e && e.type === 'keydown') {
		   if (e.keyCode === 13) {
			 e.preventDefault();
			 jquery_default()('.wrapper-response', this.el).empty();
		   } else {
			 return;
		   }
		 }
   
		 var shippingAddress = {};
		 shippingAddress.zip = jquery_default()('.address-zip', this.el).val() || '';
		 shippingAddress.country = jquery_default()('.address-country', this.el).val() || '';
		 shippingAddress.province = jquery_default()('.address-province', this.el).val() || '';
		 Shopify.getCartShippingRatesForDestination(shippingAddress, function (rates) {
		   var address = "".concat(shippingAddress.zip, ", ").concat(shippingAddress.province, ", ").concat(shippingAddress.country);
   
		   if (!shippingAddress.province.length) {
			 address = "".concat(shippingAddress.zip, ", ").concat(shippingAddress.country);
		   }
   
		   if (!shippingAddress.zip.length) {
			 address = "".concat(shippingAddress.province, ", ").concat(shippingAddress.country);
		   }
   
		   if (!shippingAddress.province.length || !shippingAddress.zip.length) {
			 address = shippingAddress.country;
		   }
   
		   jquery_default()('.wrapper-response', _this4.el).empty().append("<p class='shipping-calculator-response message'/><ul class='shipping-rates'/>");
		   var ratesFeedback = jquery_default()('.shipping-calculator-response', _this4.el);
   
		   if (rates.length > 1) {
			 var firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
			 var multipleShippingRates = Theme.shippingCalcMultiRates.replace('--address--', address).replace('--number_of_rates--', rates.length).replace('--rate--', "<span class='money'>".concat(firstRate, "</span>"));
			 ratesFeedback.html(multipleShippingRates);
		   } else if (rates.length === 1) {
			 var oneShippingRate = Theme.shippingCalcOneRate.replace('--address--', address);
			 ratesFeedback.html(oneShippingRate);
		   } else {
			 ratesFeedback.html(Theme.shippingCalcNoRates);
		   }
   
		   for (var i = 0; i < rates.length; i++) {
			 var rate = rates[i];
			 var price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
			 var rateValues = Theme.shippingCalcRateValues.replace('--rate_title--', rate.name).replace('--rate--', "<span class='money'>".concat(price, "</span>"));
			 jquery_default()('.shipping-rates', _this4.el).append("<li>".concat(rateValues, "</li>"));
		   }
   
		   _this4.el.querySelectorAll('.cart-shipping-calculator .money').forEach(function (money) {
			 return dist_default.a.update(money);
		   });
		 });
	   }
	 }, {
	   key: "handleErrors",
	   value: function handleErrors(errors) {
		 var errorMessage = jquery_default.a.parseJSON(errors.responseText);
		 errorMessage = Theme.shippingCalcErrorMessage.replace('--error_message--', errorMessage.zip);
		 return jquery_default()('.wrapper-response', this.el).html("<p class='message'>".concat(errorMessage, "</p>"));
	   }
	 }, {
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 this.events.forEach(function (event) {
		   return jquery_default()(event).off('.cart');
		 });
		 this.cartForm.removeEventListener('click', this._handleClick);
		 this.cartForm.removeEventListener('change', this._handleQtyChange);
		 this.cartForm.removeEventListener('keydown', this._handleQtyKeydown);
	   }
	 }]);
   
	 return StaticCart;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticCollection.js
   function StaticCollection_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticCollection_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticCollection_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticCollection_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticCollection_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   var StaticCollection_StaticCollection =
   /*#__PURE__*/
   function () {
	 function StaticCollection(section) {
	   StaticCollection_classCallCheck(this, StaticCollection);
   
	   this.el = section.el;
	   this.$tagsFilter = jquery_default()('#tags-filter', this.el);
	   this.$sortBy = jquery_default()('#sort-by', this.el);
	   this.productEls = this.el.querySelectorAll('[data-product-item]');
	   this.products = [];
	   this.rteEls = this.el.querySelectorAll('.rte');
	   this.rtes = [];
   
	   for (var i = 0; i < this.productEls.length; i++) {
		 this.products.push(new ProductItem_ProductItem(this.productEls[i]));
	   }
   
	   for (var _i = 0; _i < this.rteEls.length; _i++) {
		 this.rtes.push(new RTE_RTE(this.rteEls[_i]));
	   }
   
	   this.initFilters();
	   this.initSort();
	 }
   
	 StaticCollection_createClass(StaticCollection, [{
	   key: "sortDropDown",
	   value: function sortDropDown(e) {
		 Shopify.queryParams = {};
   
		 if (location.search.length) {
		   var aKeyValue;
		   var i = 0;
		   var aCouples = location.search.substr(1).split('&');
   
		   while (i < aCouples.length) {
			 aKeyValue = aCouples[i].split('=');
   
			 if (aKeyValue.length > 1) {
			   Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
			 }
   
			 i++;
		   }
		 }
   
		 Shopify.queryParams.sort_by = jquery_default()(e.currentTarget, this.el).val();
		 location.search = jquery_default.a.param(Shopify.queryParams).replace(/\+/g, '%20');
	   }
	 }, {
	   key: "initSort",
	   value: function initSort() {
		 var urlParam = new RegExp('[?&]sort_by=([^&#]*)').exec(window.location.href);
   
		 if (urlParam && urlParam[1]) {
		   this.$sortBy.val(urlParam[1]);
		 }
   
		 this.$sortBy.on('change.sorting', this.sortDropDown.bind(this));
	   }
	 }, {
	   key: "initFilters",
	   value: function initFilters() {
		 var _this = this;
   
		 jquery_default()('.tags-wrap', this.el).removeClass('preload');
		 this.$tagsFilter.on('change.filtering', function (event) {
		   var newTags = [];
		   var dataUrl = jquery_default()(event.currentTarget).data('window-href');
   
		   _this.$tagsFilter.each(function (index, el) {
			 var $el = jquery_default()(el);
   
			 if ($el.val()) {
			   newTags.push($el.val());
			 }
		   });
   
		   if (newTags.length) {
			 var query = newTags.join('+');
			 window.location.href = "".concat(dataUrl, "/").concat(query);
		   } else {
			 window.location.href = dataUrl;
		   }
		 });
	   }
	 }, {
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 this.products.forEach(function (product) {
		   return product.unload();
		 });
		 this.rtes.forEach(function (rte) {
		   return rte.unload();
		 });
		 this.$sortBy.off('.sorting');
		 this.$tagsFilter.off('.filtering');
	   }
	 }]);
   
	 return StaticCollection;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticCollectionList.js
   function StaticCollectionList_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticCollectionList_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticCollectionList_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticCollectionList_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticCollectionList_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var StaticCollectionList_StaticCollectionList =
   /*#__PURE__*/
   function () {
	 function StaticCollectionList(section) {
	   StaticCollectionList_classCallCheck(this, StaticCollectionList);
   
	   this.el = section.el;
	   this.rteEls = this.el.querySelectorAll('.rte');
	   this.rtes = [];
   
	   for (var i = 0; i < this.rteEls.length; i++) {
		 this.rtes.push(new RTE_RTE(this.rteEls[i]));
	   }
	 }
   
	 StaticCollectionList_createClass(StaticCollectionList, [{
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 this.rtes.forEach(function (rte) {
		   return rte.unload();
		 });
	   }
	 }]);
   
	 return StaticCollectionList;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticFaq.js
   function StaticFaq_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticFaq_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticFaq_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticFaq_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticFaq_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var StaticFaq_StaticFaq =
   /*#__PURE__*/
   function () {
	 function StaticFaq(section) {
	   StaticFaq_classCallCheck(this, StaticFaq);
   
	   this.faq = section.el ? new RTE_RTE(section.el) : false;
	   this.toggles = jquery_default()('[data-faq-toggle]', section.el);
   
	   this._bindEvents();
	 }
   
	 StaticFaq_createClass(StaticFaq, [{
	   key: "_bindEvents",
	   value: function _bindEvents() {
		 this.toggles.on('click', function (event) {
		   jquery_default()(event.currentTarget).toggleClass('active');
		   jquery_default()(event.currentTarget).next().stop().slideToggle(150);
		 });
	   }
	 }, {
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 if (this.faq) {
		   this.faq.unload();
		 }
	   }
	 }, {
	   key: "onSectionBlockSelect",
	   value: function onSectionBlockSelect(block) {
		 var $trigger = jquery_default()(block.el);
   
		 if (!$trigger.hasClass('active')) {
		   $trigger.trigger('click');
		 }
	   }
	 }]);
   
	 return StaticFaq;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/MobileNavigation.js
   function MobileNavigation_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function MobileNavigation_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function MobileNavigation_createClass(Constructor, protoProps, staticProps) { if (protoProps) MobileNavigation_defineProperties(Constructor.prototype, protoProps); if (staticProps) MobileNavigation_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var MobileNavigation_html = document.querySelector('html');
   
   var MobileNavigation_MobileNavigation =
   /*#__PURE__*/
   function () {
	 function MobileNavigation(component) {
	   var _this = this;
   
	   MobileNavigation_classCallCheck(this, MobileNavigation);
   
	   this.el = component.el;
	   this.$el = jquery_default()(this.el);
	   this.mobileDropdownButton = jquery_default()('.nav-item.dropdown', this.el);
	   this.mobileDropdown = jquery_default()('.mobile-dropdown', this.el);
	   this.sidebar = jquery_default()('.mobile-dropdown--wrapper', this.el);
	   this.mobileDropdownClose = jquery_default()('[data-mobile-nav-close]', this.el);
	   this.mobileDropdown.on('click.mobile-navigation', function () {
		 return _this.closeMobileNav();
	   });
	   this.sidebar.on('click.mobile-navigation', function (e) {
		 return e.stopPropagation();
	   });
	   this.windowWidth = jquery_default()(window).width();
	   jquery_default()('.dropdown > a .icon', this.el).on('click.mobile-navigation', this.toggleExpand.bind(this));
	   jquery_default()('.menu', this.el).on('click.mobile-navigation', function () {
		 return _this.toggleMobileNav();
	   });
	   jquery_default()(document).on('close-mobile-nav', this.closeMobileNav.bind(this));
	   jquery_default()(window).on('resize.mobile-navigation', function () {
		 var isWidthIncrease = _this.windowWidth !== jquery_default()(window).width();
   
		 if (jquery_default()(window).width() > 720 && _this.mobileDropdownButton.hasClass('active') && isWidthIncrease) {
		   _this.closeMobileNav();
		 }
   
		 _this.windowWidth = jquery_default()(window).width();
	   });
	   this.mobileDropdownClose.on('click', function () {
		 _this.closeMobileNav();
	   });
	 }
   
	 MobileNavigation_createClass(MobileNavigation, [{
	   key: "openMobileNav",
	   value: function openMobileNav() {
		 this.mobileDropdownButton.addClass('active');
		 this.mobileDropdownButton.attr('aria-expanded', true);
		 this.mobileDropdown.addClass('active');
		 jquery_default()('.list.primary', this.mobileDropdown).css('overflow-y', 'hidden');
		 jquery_default()('.list.primary', this.mobileDropdown).css('overflow-y', 'auto');
		 ScrollLock.lock();
	   }
	 }, {
	   key: "closeMobileNav",
	   value: function closeMobileNav() {
		 this.mobileDropdownButton.removeClass('active');
		 this.mobileDropdownButton.attr('aria-expanded', false);
		 this.mobileDropdown.removeClass('active');
		 ScrollLock.unlock();
	   }
	 }, {
	   key: "toggleMobileNav",
	   value: function toggleMobileNav() {
		 if (this.mobileDropdownButton.hasClass('active')) {
		   this.closeMobileNav();
		 } else {
		   this.openMobileNav();
		 }
		 return false;
	   }
	 }, {
	   key: "toggleExpand",
	   value: function toggleExpand(e) {
		 var _this2 = this;
   
		 var button = jquery_default()(e.currentTarget, this.el).parent().parent();
		 var listItem = button.closest('li.list-item');
		 var childList = button.find('> .list');
		 e.preventDefault();
		 listItem.toggleClass('expanded');
		 childList.slideToggle(250);
		 listItem.attr('aria-expanded', listItem.hasClass('expanded'));
		 setTimeout(function () {
		   jquery_default()('.list.primary', _this2.mobileDropdown).css('overflow-y', 'hidden');
		   jquery_default()('.list.primary', _this2.mobileDropdown).css('overflow-y', 'auto');
		 }, 350);
	   }
	 }, {
	   key: "unload",
	   value: function unload() {
		 this.closeMobileNav();
		 jquery_default()('.dropdown > a', this.el).off('click.mobile-navigation');
		 jquery_default()('.nav-item.dropdown', this.el).off('click.mobile-navigation');
		 jquery_default()(document).off('close-mobile-nav');
		 jquery_default()(window).off('resize.mobile-navigation');
	   }
	 }]);
   
	 return MobileNavigation;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/MegaNavigation.js
   function MegaNavigation_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function MegaNavigation_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function MegaNavigation_createClass(Constructor, protoProps, staticProps) { if (protoProps) MegaNavigation_defineProperties(Constructor.prototype, protoProps); if (staticProps) MegaNavigation_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var MegaNavigation_MegaNavigation =
   /*#__PURE__*/
   function () {
	 function MegaNavigation(component) {
	   var _this = this;
   
	   MegaNavigation_classCallCheck(this, MegaNavigation);
   
	   this.el = component.el;
	   this.$el = jquery_default()(this.el);
	   this.navContainer = jquery_default()('nav.full');
	   this.nav = this.$el;
	   this.trigger = this.nav.attr('id');
	   this.megaNavWrap = this.nav.find('.mega-nav-wrap');
	   this.navTrigger = jquery_default()("[aria-controls=".concat(this.trigger, "]"));
	   this.mainList = this.$el.find('.main-list');
	   this.expandedList = this.$el.find('.expanded-list');
	   this.categoriesList = this.$el.find('.category-list');
	   this.backButton = this.$el.find('.back'); // Add class for styling based on number of chosen lists
   
	   var listCount = this.mainList.find('.list').length;
   
	   if (listCount === 1) {
		 listCount = 'one-col';
	   }
   
	   if (listCount === 2) {
		 listCount = 'two-col';
	   }
   
	   if (listCount === 3) {
		 listCount = 'three-col';
	   }
   
	   this.mainList.find('.list').addClass(listCount); // Set mega-nav height
   
	   this.nav.css({
		 height: this.megaNavWrap.height()
	   });
	   jquery_default()(window).on('resize.mega-navigation', function () {
		 return _this.resize();
	   });
	   jquery_default()('.has-mega-nav, .mega-nav').on('mouseleave.mega-navigation', function (e) {
		 return _this.closeMegaNav(e);
	   });
	   jquery_default()('.show-more', this.el).on('click.mega-navigation', this.goDeepWithin.bind(this));
	   jquery_default()('.back', this.el).on('click.mega-navigation', this.reset.bind(this));
	   jquery_default()(document).on('toggleMegaNav.mega-navigation', this.toggle.bind(this));
	   jquery_default()(document).on('dismissMegaNav.mega-navigation', this.dismiss.bind(this));
	 }
   
	 MegaNavigation_createClass(MegaNavigation, [{
	   key: "resize",
	   value: function resize() {
		 this.nav.css({
		   height: this.megaNavWrap.height()
		 });
   
		 if (jquery_default()(window).width() < 720) {
		   this.dismiss();
		 } else if (this.navTrigger.hasClass('active')) {
		   this.invoke();
		 }
	   }
	 }, {
	   key: "toggle",
	   value: function toggle() {
		 if (this.navTrigger.hasClass('active')) {
		   this.dismiss();
		 } else {
		   this.invoke();
		 }
	   }
	 }, {
	   key: "invoke",
	   value: function invoke() {
		 var offset = Math.floor(this.navContainer.position().top + this.navTrigger.position().top + this.navTrigger.outerHeight());
		 this.navTrigger.addClass('active');
		 this.nav.css('top', offset);
		 this.nav.addClass('visible');
	   }
	 }, {
	   key: "dismiss",
	   value: function dismiss() {
		 this.navTrigger.removeClass('active');
		 this.nav.removeClass('visible');
		 this.$el.trigger('closeMegaNav');
	   }
	 }, {
	   key: "closeMegaNav",
	   value: function closeMegaNav(e) {
		 if (jquery_default()(e.currentTarget).hasClass('has-mega-nav')) {
		   // leaving nav item
		   if (!jquery_default()(e.relatedTarget).hasClass('.mega-nav') && !jquery_default()(e.relatedTarget).closest('.mega-nav').length) {
			 this.dismiss();
		   }
		 } else if (jquery_default()(e.currentTarget).hasClass('mega-nav')) {
		   // leaving mega nav
		   if (!jquery_default()(e.currentTarget).hasClass('has-mega-nav') && !jquery_default()(e.relatedTarget).parent().hasClass('has-mega-nav')) {
			 this.dismiss();
		   }
		 }
	   }
	 }, {
	   key: "goDeepWithin",
	   value: function goDeepWithin(e) {
		 var target;
		 var targetList;
		 var link = jquery_default()(e.currentTarget);
		 var origin = link.closest('ul.mega-nav-list'); // //////////////////////////////////
   
		 if (link.hasClass('show-more')) {
		   var list = link.closest('ul.list-wrap').data('list');
		   target = this.expandedList;
		   targetList = target.find("li[data-list='".concat(list, "']"));
		   this.categoriesList.hide();
		   this.expandedList.show().find('.list').removeClass('active');
		   target.find('.back').data('target', 'main-list');
		 }
   
		 targetList.addClass('active'); // //////////////////////////////////
   
		 if (target.hasClass('expanded-list')) {
		   target.find('.back').data('origin', 'expanded-list');
		 } else {
		   target.find('.back').data('origin', 'category-list');
		 } // //////////////////////////////////
   
   
		 var newHeight = target.height();
   
		 if (newHeight > origin.height()) {
		   this.nav.animate({
			 height: target.height()
		   });
		 }
   
		 this.megaNavWrap.animate({
		   top: "-=".concat(origin.height())
		 }, function () {
		   return target.find('.back').fadeIn(150);
		 });
	   }
	 }, {
	   key: "reset",
	   value: function reset(e) {
		 var backButton = jquery_default()(e.currentTarget);
		 var target = backButton.parents('.mega-nav').find(".".concat(backButton.data('target')));
		 backButton.fadeOut(150);
		 this.nav.animate({
		   height: target.height()
		 });
		 this.megaNavWrap.animate({
		   top: "+=".concat(target.height())
		 });
   
		 if (backButton.data('origin') === 'category-list') {
		   backButton.data('target', 'main-list');
		   backButton.data('origin', 'expanded-list');
		 }
	   }
	 }, {
	   key: "unload",
	   value: function unload() {
		 jquery_default()(window).off('resize.mega-navigation');
		 jquery_default()('.has-mega-nav, .mega-nav', this.el).off('mouseleave.mega-navigation');
		 jquery_default()('.show-more', this.el).off('click.mega-navigation');
		 jquery_default()('.back', this.el).off('click.mega-navigation');
		 jquery_default()(document).off('toggleMegaNav.mega-navigation');
		 jquery_default()(document).off('dismissMegaNav.mega-navigation');
	   }
	 }]);
   
	 return MegaNavigation;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/components/Navigation.js
   function Navigation_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function Navigation_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function Navigation_createClass(Constructor, protoProps, staticProps) { if (protoProps) Navigation_defineProperties(Constructor.prototype, protoProps); if (staticProps) Navigation_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   var Navigation_Navigation =
   /*#__PURE__*/
   function () {
	 function Navigation(component) {
	   Navigation_classCallCheck(this, Navigation);
   
	   this.el = component.el;
	   this.$el = jquery_default()(this.el);
	   jquery_default()('.dropdown', this.el).on('mouseenter.navigation', this.establishTierDirection.bind(this));
	   jquery_default()('.has-mega-nav', this.el).on('mouseenter.navigation', this.toggleMegaNav.bind(this));
	   jquery_default()('[aria-haspopup]', this.el).on('mouseenter.navigation', this.setExpanded.bind(this));
	   jquery_default()('[aria-haspopup]', this.el).on('mouseleave.navigation', this.unsetExpanded.bind(this));
	   jquery_default()(document).on('format-full-navigation.navigation', this.formatFullNavigation.bind(this));
	   return this._validate();
	 }
   
	 Navigation_createClass(Navigation, [{
	   key: "setExpanded",
	   value: function setExpanded(e) {
		 var $link = jquery_default()(e.currentTarget, this.el);
		 $link.attr('aria-expanded', true);
	   }
	 }, {
	   key: "unsetExpanded",
	   value: function unsetExpanded(e) {
		 var $link = jquery_default()(e.currentTarget, this.el);
   
		 if ($link.hasClass('has-mega-nav')) {
		   return;
		 }
   
		 $link.attr('aria-expanded', false);
	   }
	 }, {
	   key: "_validate",
	   value: function _validate() {
		 var _this = this;
   
		 this.$mainHeader = jquery_default()('.main-header', this.el);
		 this.navigation = this.$mainHeader.find('nav.full');
		 this.megaNavButton = this.navigation.find('.has-mega-nav');
		 this.mainMenuNavItems = this.navigation.find('> ul > .nav-item');
		 this.multiLine = false;
		 this.checkIfFontsLoaded();
		 this.requiredRoom = 0;
   
		 for (var i = 0; i < this.mainMenuNavItems.length; i++) {
		   var $navItem = jquery_default()(this.mainMenuNavItems[i]);
		   this.requiredRoom += $navItem.outerWidth();
		 }
   
		 this.mobileNavigation = new MobileNavigation_MobileNavigation({
		   el: '.main-header'
		 }); // Create meganavs
   
		 this.megaNavs = [];
		 jquery_default()('.mega-nav').each(function (index, el) {
		   var $el = jquery_default()(el);
		   var megaNav = new MegaNavigation_MegaNavigation({
			 el: $el
		   });
   
		   _this.megaNavs.push({
			 $el: $el,
			 object: megaNav,
			 id: $el.attr('id')
		   });
		 });
		 this.megaNavs.forEach(function (nav) {
		   nav.$el.on('closeMegaNav.nav', function () {
			 jquery_default()(".dropdown[aria-controls='".concat(nav.id, "']")).attr('aria-expanded', false);
		   });
		 });
		 jquery_default()(window).resize(function () {
		   return _this.resize();
		 });
	   }
	 }, {
	   key: "checkIfFontsLoaded",
	   value: function checkIfFontsLoaded() {
		 var _this2 = this;
   
		 var hasRun = 0;
		 this.checker = setInterval(function () {
		   hasRun += 1;
   
		   if (jquery_default()('html').hasClass('wf-active') || hasRun === 10) {
			 _this2.formatFullNavigation();
   
			 clearInterval(_this2.checker);
		   }
		 }, 500);
	   }
	 }, {
	   key: "resize",
	   value: function resize() {
		 return this.formatFullNavigation();
	   }
	 }, {
	   key: "formatFullNavigation",
	   value: function formatFullNavigation() {
		 if (this.navigation.hasClass('main-header--nav-compressed')) {
		   return;
		 }
   
		 var availableRoom = this.navigation.width();
   
		 if (this.requiredRoom >= availableRoom) {
		   this.navigation.addClass('compress');
   
		   if (this.navigation.height() > 100) {
			 this.multiLine = true;
			 this.navigation.addClass('multi-line');
		   } else {
			 this.navigation.removeClass('multi-line');
			 this.multiLine = false;
		   }
		 } else {
		   this.navigation.removeClass('compress');
		   this.navigation.removeClass('multi-line');
		   this.multiLine = false;
		 }
   
		 jquery_default()(document).trigger('navigation-resize');
	   }
	 }, {
	   key: "establishTierDirection",
	   value: function establishTierDirection(e) {
		 this.mainHeaderWrap = jquery_default()('.main-header-wrap', this.el);
		 var dropdown = jquery_default()(e.currentTarget);
		 var children = dropdown.find('.child');
		 var tertiaryChildren = children.filter('.tertiary');
		 var childWidth = dropdown.find('.dropdown-wrap').outerWidth();
		 var positionLeft = dropdown.position().left;
		 var requiredRoom = tertiaryChildren.length > 0 ? 3 * childWidth : 2 * childWidth;
		 var availableRoom = jquery_default()(window).width() - positionLeft - dropdown.outerWidth();
   
		 if (requiredRoom > availableRoom) {
		   children.removeClass('right').addClass('left');
		 } else {
		   children.removeClass('left').addClass('right');
		 } // Close other meganavs
   
   
		 return this.megaNavs.filter(function (nav) {
		   return dropdown.attr('aria-controls') !== nav.$el.attr('id');
		 }).forEach(function (nav) {
		   return nav.$el.trigger('dismissMegaNav');
		 });
	   }
	 }, {
	   key: "toggleMegaNav",
	   value: function toggleMegaNav(e) {
		 var $target = jquery_default()(e.currentTarget);
   
		 if ($target.hasClass('active')) {
		   return;
		 }
   
		 this.megaNavs.filter(function (nav) {
		   return $target.attr('aria-controls') === nav.$el.attr('id');
		 }).forEach(function (nav) {
		   return nav.object.toggle();
		 });
	   }
	 }, {
	   key: "unload",
	   value: function unload() {
		 this.mobileNavigation.unload();
		 this.megaNavs.forEach(function (nav) {
		   nav.$el.off('.nav');
		   nav.object.unload();
		 });
		 clearInterval(this.checker);
		 jquery_default()('.dropdown', this.el).off('mouseenter.navigation');
		 jquery_default()('.has-mega-nav', this.el).off('mouseenter.navigation');
		 jquery_default()('[aria-haspopup]', this.el).off('mouseenter.navigation');
		 jquery_default()('[aria-haspopup]', this.el).off('mouseleave.navigation');
		 jquery_default()(document).off('format-full-navigation.navigation');
	   }
	 }]);
   
	 return Navigation;
   }();
   
   
   // EXTERNAL MODULE: ./node_modules/just-debounce/index.js
   var just_debounce = __webpack_require__(7);
   var just_debounce_default = /*#__PURE__*/__webpack_require__.n(just_debounce);
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticHeader.js
   function StaticHeader_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticHeader_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticHeader_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticHeader_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticHeader_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   
   var StaticHeader_StaticHeader =
   /*#__PURE__*/
   function () {
	 function StaticHeader(section) {
	   var _this = this;
   
	   StaticHeader_classCallCheck(this, StaticHeader);
   
	   this.el = section.el;
	   this.$el = jquery_default()(this.el);
	   this.data = section.data;
	   var currencySettings = this.data.currencySettings;
	   this.toggleStickyDesktopNav = this.toggleStickyDesktopNav.bind(this);
	   this.toggleStickyMobileNav = this.toggleStickyMobileNav.bind(this); // Header
   
	   this.headerSettings = window.headerJSON;
	   this.window = jquery_default()(window);
	   this.body = jquery_default()('body');
	   this.mainHeader = jquery_default()('.main-header');
	   this.minimalHeader = jquery_default()('.header-minimal', this.el);
	   this.mainHeaderWrap = jquery_default()('.main-header-wrap', this.el);
	   this.fullNav = jquery_default()('nav.full', this.$el);
	   this.compactNav = jquery_default()('nav.compact', this.$el);
	   this.slideshow = jquery_default()('.slideshow', this.$el);
	   this.actionLinks = jquery_default()('.main-header .action-links', this.el);
	   this.tools = jquery_default()('.tools', this.el);
	   this.toolsGroup = jquery_default()('.main-header--tools-group', this.el);
	   this.branding = jquery_default()('.store-title, .logo', this.el);
	   this.bodyContent = jquery_default()('.page-body-content');
	   this.dropdowns = this.el.querySelectorAll('.dropdown-wrap');
	   this.checkDropdown();
	   this._initializeCurrency = this._initializeCurrency.bind(this);
	   var $scripts = jquery_default()('[data-scripts]');
   
	   if (!this.body.hasClass( true && this.slideshow.length && this.slideshow.attr('data-full-width') === 'true')) {
		 if (this.compactNav.length) {
		   this.compactNav.addClass('bordered');
		 } else {
		   this.compactNav.removeClass('bordered');
		 }
   
		 if (this.fullNav.length) {
		   this.fullNav.addClass('bordered');
		 } else {
		   this.fullNav.removeClass('bordered');
		 }
	   }
   
	   if (this.mainHeaderWrap.attr('data-header-alignment') === 'true') {
		 this.tools = jquery_default()('.main-header--tools-left', this.el);
	   }
   
	   this.positionBodyOffset();
   
	   if (!(jquery_default()(window).width() < 720)) {
		 this.toggleStickyDesktopNav();
	   } else {
		 this.toggleStickyMobileNav();
	   }
   
	   this.navigation = new Navigation_Navigation({
		 el: 'nav.full'
	   });
	   script_default()([$scripts.data('shopify-api-url'), $scripts.data('shopify-currencies')], function () {
		 if (!_this.body.hasClass('template-password') && currencySettings.enable) {
		   _this._initializeCurrency(currencySettings);
		 }
   
	   });
	   jquery_default()('.mini-cart-wrap', this.el).on('click.header', this.toggleMiniCart.bind(this));
	   jquery_default()('.mini-cart.active', this.el).on('click.header', function (event) {
		 return event.stopPropagation();
	   });
	   jquery_default()(document).on('navigation-resize.header', function () {
		 return _this.positionBodyOffset();
	   });
	   this.window.on('resize.header', function () {
		 return _this.checkDropdown();
	   });
	   this.window.on('scroll.header', this.toggleStickyMobileNav);
	   this.window.on('scroll.header', this.toggleStickyDesktopNav);
   
	   if (this.mainHeaderWrap.attr('data-header-layout') === 'minimal' || this.mainHeaderWrap.attr('data-header-layout') === 'minimal-sticky') {
		 document.documentElement.classList.add('header-layout-minimal');
	   } else {
		 document.documentElement.classList.remove('header-layout-minimal');
	   }
   
	   this.window.on('resize.header', function () {
		 if (_this.mainHeaderWrap.attr('data-header-layout') === 'minimal') {
		   _this.positionBodyOffset();
   
		   _this.toggleStickyMobileNav();
   
		   _this.toggleStickyDesktopNav();
		 }
	   });
	   this.cartMini = new CartMini_CartMini();
	 }
   
	 StaticHeader_createClass(StaticHeader, [{
	   key: "_initializeCurrency",
	   value: function _initializeCurrency(currencySettings) {
		 var _this2 = this;
   
		 dist_default.a.init({
		   switcherSelector: '[data-currency-converter]',
		   priceSelector: '.money',
		   shopCurrency: currencySettings.shopCurrency,
		   defaultCurrency: currencySettings.defaultCurrency,
		   displayFormat: currencySettings.displayFormat,
		   moneyFormat: currencySettings.moneyFormat,
		   moneyFormatNoCurrency: currencySettings.moneyFormatNoCurrency,
		   moneyFormatCurrency: currencySettings.moneyFormatCurrency
		 });
		 this.$currencyWrappers = jquery_default()('.selected-currency'); // update currency dropdown wrappers
   
		 this.$currencyWrappers.text(this.$el.find('[data-currency-converter]').first().val());
		 jquery_default()('[data-currency-converter]').on('change.header', function (event) {
		   _this2.$currencyWrappers.text(event.currentTarget.value);
   
		   jquery_default()('[data-currency-converter]').val(event.currentTarget.value);
		   dist_default.a.setCurrency(event.currentTarget.value);
		 });
	   }
	 }, {
	   key: "positionBodyOffset",
	   value: function positionBodyOffset() {
		 if (this.mainHeaderWrap.hasClass('main-header--minimal-sticky')) {
		   if (this.window.width() < 720) {
			 return;
		   }
   
		   this.bodyContent.css({
			 marginTop: this.mainHeader.outerHeight()
		   });
		 } else {
		   this.bodyContent.css({
			 marginTop: ''
		   });
		 }
	   }
	 }, {
	   key: "toggleStickyDesktopNav",
	   value: function toggleStickyDesktopNav() {
		 if (jquery_default()('.pxs-announcement-bar').length !== 0) {
		   if (!(jquery_default()(window).width() > 720)) {
			 return;
		   }
   
		   if (!this.mainHeaderWrap.hasClass('main-header--minimal-sticky')) {
			 return;
		   }
   
		   if (!jquery_default()('.pxs-announcement-bar').length || jquery_default()('.pxs-announcement-bar').length && jquery_default()(window).scrollTop() > jquery_default()('.pxs-announcement-bar').outerHeight()) {
			 this.mainHeaderWrap.css({
			   position: 'fixed',
			   top: 0
			 });
			 this.bodyContent.css({
			   marginTop: this.mainHeaderWrap.outerHeight()
			 });
		   } else {
			 this.mainHeaderWrap.css({
			   position: 'absolute',
			   top: jquery_default()('.pxs-announcement-bar').outerHeight()
			 });
			 this.bodyContent.css({
			   marginTop: this.mainHeaderWrap.outerHeight()
			 });
		   }
		 }
	   }
	 }, {
	   key: "toggleStickyMobileNav",
	   value: function toggleStickyMobileNav() {
		 if (!(jquery_default()(window).width() < 720)) {
		   return;
		 }
   
		 if (!this.mainHeaderWrap.hasClass('main-header--minimal-sticky')) {
		   return;
		 }
   
		 if (!jquery_default()('.pxs-announcement-bar').length || jquery_default()('.pxs-announcement-bar').length && jquery_default()(window).scrollTop() > jquery_default()('.pxs-announcement-bar').outerHeight()) {
		   this.mainHeaderWrap.addClass('header-mobile-stick').css({
			 position: '',
			 top: 0
		   });
		   this.bodyContent.css({
			 marginTop: this.mainHeaderWrap.outerHeight()
		   });
		 } else {
		   this.mainHeaderWrap.removeClass('header-mobile-stick').css({
			 position: 'absolute',
			 top: jquery_default()('.pxs-announcement-bar').outerHeight()
		   });
		   this.bodyContent.css({
			 marginTop: this.mainHeaderWrap.outerHeight()
		   });
		 }
	   }
	 }, {
	   key: "toggleMiniCart",
	   value: function toggleMiniCart(e) {
		 e.preventDefault();
		 e.stopPropagation();
		 this.cartMini.open();
	   }
	 }, {
	   key: "checkDropdown",
	   value: function checkDropdown() {
		 for (var i = 0; i < this.dropdowns.length; i++) {
		   this.dropdowns[i].classList.remove('dropdown-right');
		 }
   
		 for (var _i = 0; _i < this.dropdowns.length; _i++) {
		   if (this.dropdowns[_i].getBoundingClientRect().right + this.dropdowns[_i].offsetWidth > window.innerWidth) {
			 this.dropdowns[_i].classList.add('dropdown-right');
		   } else {
			 this.dropdowns[_i].classList.remove('dropdown-right');
		   }
		 }
	   }
	 }, {
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 this.navigation.unload();
		 jquery_default()('[data-cart-mini-toggle]', this.el).off('click.header');
		 jquery_default()('[data-currency-converter]').off('change.header');
		 jquery_default()(document).off('navigation-resize.header');
		 jquery_default()('#currencies', this.$el).off('change');
		 jquery_default()('body').off('click.header');
		 this.window.off('scroll.header');
		 this.window.off('scroll.header');
		 this.window.off('resize.header');
		 this.window.off('load.header');
		 document.documentElement.classList.remove('header-layout-minimal');
	   }
	 }]);
   
	 return StaticHeader;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticPage.js
   function StaticPage_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticPage_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticPage_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticPage_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticPage_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var StaticPage_StaticPage =
   /*#__PURE__*/
   function () {
	 function StaticPage(section) {
	   StaticPage_classCallCheck(this, StaticPage);
   
	   this.el = section.el;
	   this.rteEls = this.el.querySelectorAll('.rte');
	   this.rtes = [];
   
	   for (var i = 0; i < this.rteEls.length; i++) {
		 this.rtes.push(new RTE_RTE(this.rteEls[i]));
	   }
	 }
   
	 StaticPage_createClass(StaticPage, [{
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 this.rtes.forEach(function (rte) {
		   return rte.unload();
		 });
	   }
	 }]);
   
	 return StaticPage;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticPageContact.js
   function StaticPageContact_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticPageContact_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticPageContact_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticPageContact_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticPageContact_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   var StaticPageContact_StaticPageContact =
   /*#__PURE__*/
   function () {
	 function StaticPageContact(section) {
	   StaticPageContact_classCallCheck(this, StaticPageContact);
   
	   this.el = section.el;
	   this.rteEls = this.el.querySelectorAll('.rte');
	   this.rtes = [];
   
	   for (var i = 0; i < this.rteEls.length; i++) {
		 this.rtes.push(new RTE_RTE(this.rteEls[i]));
	   }
	 }
   
	 StaticPageContact_createClass(StaticPageContact, [{
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 this.rtes.forEach(function (rte) {
		   return rte.unload();
		 });
	   }
	 }]);
   
	 return StaticPageContact;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticProduct.js
   function StaticProduct_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticProduct_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticProduct_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticProduct_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticProduct_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   var StaticProduct_StaticProduct =
   /*#__PURE__*/
   function () {
	 function StaticProduct(section) {
	   var _this = this;
   
	   StaticProduct_classCallCheck(this, StaticProduct);
   
	   this.el = section.el;
	   this.productEls = this.el.querySelectorAll('[data-product-item]');
	   this.products = [];
	   var $scripts = $('[data-scripts]');
	   script_default()($scripts.data('shopify-api-url'), function () {
		 _this.product = new Product_Product({
		   el: _this.el,
		   data: section.data
		 });
   
		 for (var i = 0; i < _this.productEls.length; i++) {
		   _this.products.push(new ProductItem_ProductItem(_this.productEls[i]));
		 }
	   });
	 }
   
	 StaticProduct_createClass(StaticProduct, [{
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 this.product.unload();
		 this.products.forEach(function (product) {
		   return product.unload();
		 });
	   }
	 }]);
   
	 return StaticProduct;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticProductRecommendations.js
   function StaticProductRecommendations_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticProductRecommendations_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticProductRecommendations_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticProductRecommendations_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticProductRecommendations_defineProperties(Constructor, staticProps); return Constructor; }
   
	// eslint-disable-line
   
   
   
   
   var StaticProductRecommendations_StaticProductRecommendations =
   /*#__PURE__*/
   function () {
	 function StaticProductRecommendations(section) {
	   StaticProductRecommendations_classCallCheck(this, StaticProductRecommendations);
   
	   this.section = section;
	   this.productId = section.data.productId;
	   this.limit = section.data.settings.limit;
	   this.recommendationContainer = document.querySelector('[data-product-recommendations]');
	   this.recommendUrl = "/recommendations/products?section_id=static-product-recommendations&limit=".concat(this.limit, "&product_id=").concat(this.productId);
   
	   this._loadRecommendations();
	 }
   
	 StaticProductRecommendations_createClass(StaticProductRecommendations, [{
	   key: "_loadRecommendations",
	   value: function _loadRecommendations() {
		 var _this = this;
   
		 shopify_asyncview_dist_index_es.load(this.recommendUrl).done(function (_ref) {
		   var html = _ref.html;
		   _this.recommendationContainer.innerHTML = html;
		   rimg_shopify_dist_index_es.watch(_this.recommendationContainer);
   
		   var productEls = _this.recommendationContainer.querySelectorAll('[data-product-item]');
   
		   _this.productItems = [];
   
		   for (var i = 0; i < productEls.length; i++) {
			 _this.productItems.push(new ProductItem_ProductItem(productEls[i]));
		   }
   
		   if (window.Shopify && Shopify.PaymentButton) {
			 Shopify.PaymentButton.init();
		   }
		 });
	   }
	 }, {
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 this.productItems.forEach(function (product) {
		   return product.unload();
		 });
	   }
	 }]);
   
	 return StaticProductRecommendations;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/sections/StaticSubcollection.js
   function StaticSubcollection_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function StaticSubcollection_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function StaticSubcollection_createClass(Constructor, protoProps, staticProps) { if (protoProps) StaticSubcollection_defineProperties(Constructor.prototype, protoProps); if (staticProps) StaticSubcollection_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   var StaticSubcollection_StaticSubcollection =
   /*#__PURE__*/
   function () {
	 function StaticSubcollection(section) {
	   var _this = this;
   
	   StaticSubcollection_classCallCheck(this, StaticSubcollection);
   
	   this.el = section.el;
	   this.toggles = this.el.querySelectorAll('[data-menu-list-toggle]');
	   this.productEls = this.el.querySelectorAll('[data-product-item]');
	   this.products = [];
	   this.rteEls = this.el.querySelectorAll('.rte');
	   this.rtes = [];
   
	   for (var i = 0; i < this.productEls.length; i++) {
		 this.products.push(new ProductItem_ProductItem(this.productEls[i]));
	   }
   
	   for (var _i = 0; _i < this.rteEls.length; _i++) {
		 this.rtes.push(new RTE_RTE(this.rteEls[_i]));
	   }
   
	   for (var _i2 = 0; _i2 < this.toggles.length; _i2++) {
		 this.toggles[_i2].addEventListener('click', function (event) {
		   _this.toggle(event);
		 });
	   }
	 }
   
	 StaticSubcollection_createClass(StaticSubcollection, [{
	   key: "toggle",
	   value: function toggle(event) {
		 var links = event.currentTarget.parentNode.querySelectorAll('[data-menu-list-hidden]');
		 var text = event.currentTarget.querySelectorAll('.menu-list-link-text');
   
		 for (var i = 0; i < text.length; i++) {
		   text[i].classList.toggle('menu-list-link-hidden');
		 }
   
		 for (var _i3 = 0; _i3 < links.length; _i3++) {
		   links[_i3].classList.toggle('menu-list-link-hidden');
		 }
	   }
	 }, {
	   key: "onSectionUnload",
	   value: function onSectionUnload() {
		 var _this2 = this;
   
		 this.products.forEach(function (product) {
		   return product.unload();
		 });
		 this.rtes.forEach(function (rte) {
		   return rte.unload();
		 });
   
		 for (var i = 0; i < this.toggles.length; i++) {
		   this.toggles[i].removeEventListener('click', function (event) {
			 _this2.toggle(event);
		   });
		 }
	   }
	 }]);
   
	 return StaticSubcollection;
   }();
   
   
   // CONCATENATED MODULE: ./source/scripts/atlantic.js
   /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return atlantic_Atlantic; });
   function atlantic_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
   
   function atlantic_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
   
   function atlantic_createClass(Constructor, protoProps, staticProps) { if (protoProps) atlantic_defineProperties(Constructor.prototype, protoProps); if (staticProps) atlantic_defineProperties(Constructor, staticProps); return Constructor; }
   
   
   
   
   
   
   
   
	// Templates
   
   
   
   
	// Sections
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   
   var atlantic_Atlantic =
   /*#__PURE__*/
   function () {
	 function Atlantic() {
	   var _this = this;
   
	   atlantic_classCallCheck(this, Atlantic);
   
	   this.el = document.body;
	   rimg_shopify_dist_index_es.init();
	   var sections = new shopify_sections_manager_es();
	   var $scripts = jquery_default()('[data-scripts]');
	   sections.register('dynamic-blog', function (section) {
		 return new DynamicBlog_DynamicBlog(section);
	   });
	   sections.register('dynamic-collection', function (section) {
		 return new DynamicCollection_DynamicCollection(section);
	   });
	   sections.register('dynamic-image-block', function (section) {
		 return new DynamicImageBlock_DynamicImageBlock(section);
	   });
	   sections.register('dynamic-menu-list', function (section) {
		 return new DynamicMenuList(section);
	   });
	   sections.register('dynamic-product', function (section) {
		 return new DynamicProduct_DynamicProduct(section);
	   });
	   sections.register('static-404', function (section) {
		 return new Static404_Static404(section);
	   });
	   sections.register('static-article', function (section) {
		 return new StaticArticle_StaticArticle(section);
	   });
	   sections.register('static-blog', function (section) {
		 return new StaticBlog_StaticBlog(section);
	   });
	   sections.register('static-cart', function (section) {
		 return new StaticCart_StaticCart(section);
	   });
	   sections.register('static-collection', function (section) {
		 return new StaticCollection_StaticCollection(section);
	   });
	   sections.register('static-collection-list', function (section) {
		 return new StaticCollectionList_StaticCollectionList(section);
	   });
	   sections.register('static-faq', function (section) {
		 return new StaticFaq_StaticFaq(section);
	   });
	   sections.register('static-header', function (section) {
		 return new StaticHeader_StaticHeader(section);
	   });
	   sections.register('static-page', function (section) {
		 return new StaticPage_StaticPage(section);
	   });
	   sections.register('static-page-contact', function (section) {
		 return new StaticPageContact_StaticPageContact(section);
	   });
	   sections.register('static-product', function (section) {
		 return new StaticProduct_StaticProduct(section);
	   });
	   sections.register('static-product-recommendations', function (section) {
		 return new StaticProductRecommendations_StaticProductRecommendations(section);
	   });
	   sections.register('static-subcollection', function (section) {
		 return new StaticSubcollection_StaticSubcollection(section);
	   });
	   sections.register('pxs-map', function (section) {
		 return new index_es(section);
	   });
   
	   if (jquery_default()('body').hasClass('template-gift-card')) {
		 this.templateGiftCard = new TemplateGiftCard_TemplateGiftCard({
		   el: this.el
		 });
	   }
   
	   if (jquery_default()('body').hasClass('template-customers-login')) {
		 this.templateAccountLogin = new TemplateAccountLogin_TemplateAccountLogin({
		   el: this.el
		 });
	   }
   
	   if (jquery_default()('body').hasClass('template-customers-addresses')) {
		 script_default()([$scripts.data('shopify-common'), $scripts.data('shopify-api-url'), $scripts.data('customer-area')], function () {
		   script_default()($scripts.data('shopify-countries'), function () {
			 _this.templateAccountAddresses = new TemplateAccountAddresses_TemplateAccountAddresses({
			   el: _this.el
			 });
		   });
		 });
	   }
   
	   if (jquery_default()('body').hasClass('template-password')) {
		 this.templatePassword = new TemplatePassword_TemplatePassword({
		   el: this.el
		 });
	   }
   
	   jquery_default()('.field').on('focus', this.removeErrors.bind(this));
	 }
   
	 atlantic_createClass(Atlantic, [{
	   key: "removeErrors",
	   value: function removeErrors(e) {
		 var field = jquery_default()(e.currentTarget, this.el);
		 return field.removeClass('error');
	   }
	 }]);
   
	 return Atlantic;
   }();
   
   
   new atlantic_Atlantic();
   
   /***/ })
   /******/ ]);
   //# sourceMappingURL=atlantic.js.map?1573864992832